(function () {
  const STORAGE_KEY = "sticker-case-studio-custom-stickers";
  const FAVORITES_STORAGE_KEY = "sticker-case-studio-favorites";
  const MODEL_PHOTOS_STORAGE_KEY = "sticker-case-studio-model-photos";
  const DESIGN_DRAFT_STORAGE_KEY = "sticker-case-studio-saved-design";
  const BACKGROUND_PATTERNS_STORAGE_KEY = "sticker-case-studio-background-patterns";
  const MODEL_PHOTO_SCREEN_ZOOM = 1.52;
  const DEFAULT_STICKER_SIZE = 118;
  const PRINT_EXPORT_WIDTH = 3600;
  const PRINT_EXPORT_HEIGHT = 3600;
  const DEBUG_PREVIEW_EXPORT = true;
  const PRINT_QUALITY_SAFE_SCALE = 2;
  const PRINT_QUALITY_WARNING_SCALE = 3;
  const TEMPLATE_STICKER_SCALE = 1.22;
  const HISTORY_LIMIT = 60;
  const SNAP_THRESHOLD_PERCENT = 1.25;
  const BACKGROUND_PATTERN_PAN_OVERSCAN = 1.18;
  const TEXT_FONTS = [
    { label: "Arial", value: "Arial, Helvetica, sans-serif" },
    { label: "Archivo Black", value: "'Archivo Black', Arial, sans-serif" },
    { label: "Anton", value: "'Anton', Impact, sans-serif" },
    { label: "Inter", value: "'Inter', Arial, sans-serif" },
    { label: "DM Sans", value: "'DM Sans', Arial, sans-serif" },
    { label: "Raleway", value: "'Raleway', Arial, sans-serif" },
    { label: "Helvetica", value: "Helvetica, Arial, sans-serif" },
    { label: "Arial Black", value: "'Arial Black', Gadget, sans-serif" },
    { label: "Arial Narrow", value: "'Arial Narrow', Arial, sans-serif" },
    { label: "Verdana", value: "Verdana, Geneva, sans-serif" },
    { label: "Trebuchet", value: "'Trebuchet MS', Arial, sans-serif" },
    { label: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
    { label: "Calibri", value: "Calibri, Candara, Segoe, sans-serif" },
    { label: "Cambria", value: "Cambria, Georgia, serif" },
    { label: "Candara", value: "Candara, Calibri, sans-serif" },
    { label: "Century Gothic", value: "'Century Gothic', CenturyGothic, AppleGothic, sans-serif" },
    { label: "Consolas", value: "Consolas, Monaco, monospace" },
    { label: "Copperplate", value: "Copperplate, 'Copperplate Gothic Light', fantasy" },
    { label: "Didot", value: "Didot, 'Bodoni 72', serif" },
    { label: "Franklin Gothic", value: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif" },
    { label: "Gill Sans", value: "'Gill Sans', 'Gill Sans MT', Calibri, sans-serif" },
    { label: "Georgia", value: "Georgia, serif" },
    { label: "Times", value: "'Times New Roman', Times, serif" },
    { label: "Garamond", value: "Garamond, Georgia, serif" },
    { label: "Hoefler Text", value: "'Hoefler Text', Garamond, serif" },
    { label: "Courier", value: "'Courier New', Courier, monospace" },
    { label: "Impact", value: "Impact, Haettenschweiler, sans-serif" },
    { label: "Comic Sans", value: "'Comic Sans MS', cursive" },
    { label: "Brush Script", value: "'Brush Script MT', cursive" },
    { label: "Lucida Handwriting", value: "'Lucida Handwriting', cursive" },
    { label: "Lucida Sans", value: "'Lucida Sans Unicode', 'Lucida Grande', sans-serif" },
    { label: "Monaco", value: "Monaco, Consolas, monospace" },
    { label: "Papyrus", value: "Papyrus, fantasy" },
    { label: "Rockwell", value: "Rockwell, 'Courier Bold', serif" },
    { label: "Segoe UI", value: "'Segoe UI', Arial, sans-serif" },
    { label: "Segoe Script", value: "'Segoe Script', 'Brush Script MT', cursive" },
    { label: "Segoe Print", value: "'Segoe Print', 'Comic Sans MS', cursive" },
    { label: "Palatino", value: "'Palatino Linotype', Palatino, serif" },
    { label: "Optima", value: "Optima, Candara, sans-serif" },
    { label: "Futura", value: "Futura, 'Trebuchet MS', Arial, sans-serif" },
    { label: "Baskerville", value: "Baskerville, 'Times New Roman', serif" },
    { label: "Poppins", value: "'Poppins', Arial, sans-serif" },
    { label: "Montserrat", value: "'Montserrat', Arial, sans-serif" },
    { label: "Bebas Neue", value: "'Bebas Neue', Impact, sans-serif" },
    { label: "Bungee", value: "'Bungee', Impact, sans-serif" },
    { label: "Lilita One", value: "'Lilita One', Arial, sans-serif" },
    { label: "Luckiest Guy", value: "'Luckiest Guy', Arial, sans-serif" },
    { label: "Fredoka", value: "'Fredoka', Arial, sans-serif" },
    { label: "Chewy", value: "'Chewy', 'Comic Sans MS', cursive" },
    { label: "Rubik Bubbles", value: "'Rubik Bubbles', 'Arial Black', sans-serif" },
    { label: "Righteous", value: "'Righteous', Arial, sans-serif" },
    { label: "Audiowide", value: "'Audiowide', Arial, sans-serif" },
    { label: "Orbitron", value: "'Orbitron', Arial, sans-serif" },
    { label: "Monoton", value: "'Monoton', Impact, sans-serif" },
    { label: "Press Start 2P", value: "'Press Start 2P', monospace" },
    { label: "Permanent Marker", value: "'Permanent Marker', 'Comic Sans MS', cursive" },
    { label: "Pacifico", value: "'Pacifico', cursive" },
    { label: "Lobster", value: "'Lobster', cursive" },
    { label: "Satisfy", value: "'Satisfy', cursive" },
    { label: "Great Vibes", value: "'Great Vibes', cursive" },
    { label: "Caveat", value: "'Caveat', cursive" },
    { label: "Playfair Display", value: "'Playfair Display', Georgia, serif" },
    { label: "DM Serif Display", value: "'DM Serif Display', Georgia, serif" },
    { label: "Abril Fatface", value: "'Abril Fatface', Georgia, serif" },
    { label: "Cinzel", value: "'Cinzel', Georgia, serif" },
    { label: "Oswald", value: "'Oswald', Arial, sans-serif" },
    { label: "Comfortaa", value: "'Comfortaa', Arial, sans-serif" },
    { label: "Quicksand", value: "'Quicksand', Arial, sans-serif" },
    { label: "Rubik Glitch", value: "'Rubik Glitch', sans-serif" },
    { label: "Rubik Wet Paint", value: "'Rubik Wet Paint', sans-serif" },
    { label: "Rubik Moonrocks", value: "'Rubik Moonrocks', sans-serif" },
    { label: "Rubik Puddles", value: "'Rubik Puddles', sans-serif" },
    { label: "Rubik Vinyl", value: "'Rubik Vinyl', sans-serif" },
    { label: "Rubik Mono One", value: "'Rubik Mono One', monospace" },
    { label: "VT323", value: "'VT323', monospace" },
    { label: "Silkscreen", value: "'Silkscreen', monospace" },
    { label: "Black Ops One", value: "'Black Ops One', sans-serif" },
    { label: "Michroma", value: "'Michroma', sans-serif" },
    { label: "Chakra Petch", value: "'Chakra Petch', sans-serif" },
    { label: "Rajdhani", value: "'Rajdhani', sans-serif" },
    { label: "Space Grotesk", value: "'Space Grotesk', sans-serif" },
    { label: "Space Mono", value: "'Space Mono', monospace" },
    { label: "Dela Gothic One", value: "'Dela Gothic One', sans-serif" },
    { label: "Racing Sans One", value: "'Racing Sans One', sans-serif" },
    { label: "Oleo Script", value: "'Oleo Script', cursive" },
    { label: "Sacramento", value: "'Sacramento', cursive" },
    { label: "Dancing Script", value: "'Dancing Script', cursive" },
    { label: "Creepster", value: "'Creepster', sans-serif" },
    { label: "Titan One", value: "'Titan One', sans-serif" },
    { label: "Bangers", value: "'Bangers', sans-serif" },
    { label: "Alfa Slab One", value: "'Alfa Slab One', sans-serif" },
    { label: "Shadows Into Light", value: "'Shadows Into Light', cursive" },
  ];
  const TEXT_EFFECTS = [
    { label: "Be efekto", value: "none" },
    { label: "Lengvas šešėlis", value: "shadow" },
    { label: "Baltas konturas", value: "outline-white" },
    { label: "Juodas konturas", value: "outline-black" },
    { label: "Švelnus švytėjimas", value: "glow" },
    { label: "Neoninė žydra", value: "neon-cyan" },
    { label: "Neoninė rožinė", value: "neon-pink" },
    { label: "Neoninė žalia", value: "neon-green" },
    { label: "Neoninė auksinė", value: "neon-gold" },
  ];
  const TEXT_PRESETS = [
    {
      label: "Y2K Pop",
      sample: "POP",
      font: "'Bungee', Impact, sans-serif",
      color: "#ff477e",
      effect: "outline-white",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Chrome Club",
      sample: "CLUB",
      font: "'Bebas Neue', Impact, sans-serif",
      color: "#111111",
      effect: "outline-white",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Neoninė rožinė",
      sample: "NEON",
      font: "'Monoton', Impact, sans-serif",
      color: "#ff4fd8",
      effect: "neon-pink",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Kibernetinė žydra",
      sample: "CYBER",
      font: "'Orbitron', Arial, sans-serif",
      color: "#00d8ff",
      effect: "neon-cyan",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Švelnus raštas",
      sample: "cute",
      font: "'Pacifico', cursive",
      color: "#ff78b7",
      effect: "glow",
      bold: false,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Princesė",
      sample: "GLAM",
      font: "'Playfair Display', Georgia, serif",
      color: "#f4b942",
      effect: "neon-gold",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Minimalus",
      sample: "clean",
      font: "'Poppins', Arial, sans-serif",
      color: "#111111",
      effect: "none",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Alternatyvus",
      sample: "ALT",
      font: "'Permanent Marker', 'Comic Sans MS', cursive",
      color: "#ffffff",
      effect: "outline-black",
      bold: true,
      italic: true,
      underline: false,
      align: "center",
    },
    {
      label: "Mielas burbulas",
      sample: "BUBBLE",
      font: "'Rubik Bubbles', 'Arial Black', sans-serif",
      color: "#7b61ff",
      effect: "outline-white",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Gatvės markeris",
      sample: "TAG",
      font: "'Permanent Marker', 'Comic Sans MS', cursive",
      color: "#111111",
      effect: "shadow",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Pikselių žaidimas",
      sample: "8BIT",
      font: "'Press Start 2P', monospace",
      color: "#08a66d",
      effect: "outline-white",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
    {
      label: "Prabangus serifas",
      sample: "LUXE",
      font: "'DM Serif Display', Georgia, serif",
      color: "#111111",
      effect: "none",
      bold: true,
      italic: false,
      underline: false,
      align: "center",
    },
  ];
  const AI_PHOTO_PRESETS = [
    {
      key: "lego",
      label: "LEGO",
      prompt:
        "Transform the uploaded photo into a premium LEGO minifigure / LEGO brick toy style illustration. Keep the main subject recognizable, clean sharp edges, colorful playful lighting, high-detail plastic texture, centered composition, no background, transparent background if possible, suitable for printing on a phone case.",
    },
  ];
  const DESIGN_TEMPLATES = [
    {
      key: "vintage-green-collage",
      label: "Vintage žalias koliažas",
      tone: "Popierius, gamta, mistika",
      accent: "#0f4a36",
      background: { type: "color", color: "#0f4a36", pattern: "" },
      subcategories: ["Vintage", "Nature", "Flowers", "Animals", "Text", "Zodiac", "Decor & Objects"],
      terms: [
        "vintage",
        "green",
        "clover",
        "mushroom",
        "stamp",
        "paper",
        "torn",
        "cat",
        "tree",
        "leaf",
        "forest",
        "taurus",
        "gold",
        "wax",
        "seal",
      ],
      layout: [
        { role: "paper", terms: ["paper", "torn", "letter", "stamp", "receipt", "note"], x: 26, y: 14, size: 138, rotation: -13, outline: "none" },
        { role: "paper", terms: ["paper", "torn", "white", "texture", "note"], x: 58, y: 47, size: 172, rotation: 7, outline: "none" },
        { role: "hero", terms: ["cat", "girl", "woman", "fairy", "angel"], x: 69, y: 52, size: 132, rotation: 3, outline: "none" },
        { role: "hero", terms: ["tree", "forest", "plant", "leaf"], x: 23, y: 67, size: 132, rotation: -7, outline: "none" },
        { role: "accent", terms: ["clover", "wax", "seal", "mushroom", "stamp"], x: 43, y: 39, size: 76, rotation: -3, outline: "none" },
        { role: "text", terms: ["taurus", "beauty", "brains", "quote", "word", "text"], x: 43, y: 59, size: 78, rotation: -3, outline: "white" },
        { role: "accent", terms: ["leaf", "flower", "gold", "star"], x: 78, y: 33, size: 58, rotation: 11, outline: "none" },
        { role: "accent", terms: ["sparkle", "dot", "star", "gold"], x: 75, y: 18, size: 42, rotation: 0, outline: "none" },
      ],
    },
    {
      key: "ocean-blue-collage",
      label: "Mėlynas jūros koliažas",
      tone: "Jūra, žvaigždynai, mėlyna estetika",
      accent: "#15375d",
      background: { type: "color", color: "#173a60", pattern: "" },
      subcategories: ["Vintage", "Nature", "Flowers", "Animals", "Text", "Zodiac", "Decor & Objects"],
      terms: [
        "blue",
        "ocean",
        "sea",
        "wave",
        "shell",
        "anchor",
        "compass",
        "starfish",
        "bird",
        "flower",
        "aquarius",
        "map",
        "lighthouse",
        "bubble",
      ],
      layout: [
        { role: "paper", terms: ["map", "star", "chart", "paper", "blue"], x: 35, y: 16, size: 165, rotation: -4, outline: "none" },
        { role: "paper", terms: ["paper", "torn", "white", "note"], x: 58, y: 37, size: 170, rotation: 8, outline: "none" },
        { role: "hero", terms: ["wave", "ocean", "sea", "lighthouse"], x: 22, y: 64, size: 124, rotation: -8, outline: "none" },
        { role: "hero", terms: ["girl", "woman", "angel", "statue"], x: 69, y: 55, size: 128, rotation: 4, outline: "none" },
        { role: "accent", terms: ["anchor", "compass", "shell", "starfish"], x: 75, y: 28, size: 72, rotation: 9, outline: "none" },
        { role: "accent", terms: ["bird", "seagull", "flower", "bow"], x: 28, y: 42, size: 68, rotation: -10, outline: "none" },
        { role: "text", terms: ["aquarius", "sarcasm", "quote", "word", "text"], x: 49, y: 66, size: 82, rotation: -2, outline: "white" },
        { role: "accent", terms: ["bubble", "sparkle", "star", "blue"], x: 80, y: 76, size: 48, rotation: 0, outline: "none" },
      ],
    },
    {
      key: "gold-zodiac-collage",
      label: "Auksinis zodiako koliažas",
      tone: "Dramatiškas, auksinis, astrologinis",
      accent: "#b07a25",
      background: { type: "color", color: "#17120d", pattern: "" },
      subcategories: ["Vintage", "Nature", "Animals", "Text", "Zodiac", "Gold Foil", "Decor & Objects"],
      terms: [
        "gold",
        "leo",
        "lion",
        "sun",
        "crown",
        "key",
        "clock",
        "paper",
        "script",
        "star",
        "fairy",
        "flower",
        "vintage",
      ],
      layout: [
        { role: "paper", terms: ["script", "letter", "paper", "book", "vintage"], x: 66, y: 16, size: 160, rotation: 12, outline: "none" },
        { role: "paper", terms: ["paper", "torn", "white", "texture"], x: 43, y: 42, size: 174, rotation: -5, outline: "none" },
        { role: "hero", terms: ["lion", "leo"], x: 37, y: 74, size: 168, rotation: -4, outline: "none" },
        { role: "hero", terms: ["fairy", "angel", "girl", "woman"], x: 75, y: 47, size: 118, rotation: 6, outline: "none" },
        { role: "accent", terms: ["sun", "crown", "gold", "seal"], x: 55, y: 28, size: 74, rotation: 0, outline: "none" },
        { role: "accent", terms: ["key", "clock", "lantern", "star"], x: 74, y: 78, size: 72, rotation: 8, outline: "none" },
        { role: "text", terms: ["leo", "zodiac", "word", "text"], x: 72, y: 58, size: 86, rotation: -2, outline: "white" },
        { role: "accent", terms: ["flower", "gold", "sparkle", "foil"], x: 25, y: 46, size: 58, rotation: -12, outline: "none" },
      ],
    },
    {
      key: "girly-y2k",
      label: "Mergaitiškas Y2K",
      tone: "Glamūras, rožinė, blizgesys",
      accent: "#ff78b7",
      background: { type: "color", color: "#fff0f7", pattern: "" },
      subcategories: ["McBling Y2K", "Gold Foil", "Holographic Y2K", "Pastel Patches"],
      terms: ["pink", "glam", "girly", "butterfly", "heart", "cherry", "diamond", "lip", "sparkle", "crown", "cute"],
      layout: [
        { x: 24, y: 18, size: 76, rotation: -12 },
        { x: 70, y: 18, size: 64, rotation: 10 },
        { x: 44, y: 36, size: 86, rotation: 7 },
        { x: 78, y: 48, size: 58, rotation: -18 },
        { x: 26, y: 64, size: 62, rotation: 16 },
        { x: 60, y: 78, size: 74, rotation: -8 },
      ],
    },
    {
      key: "sticker-bomb",
      label: "Lipdukų bomba",
      tone: "Pilnas, chaotiškas, ryškus",
      accent: "#f4b942",
      background: { type: "none", color: "#ffffff", pattern: "" },
      subcategories: ["Y2K Bundle", "Y2K Mega", "Holographic Y2K", "Mall Rat Y2K", "90s", "80s"],
      terms: ["y2k", "retro", "star", "smile", "phone", "music", "flower", "heart", "pixel", "sticker"],
      layout: [
        { x: 20, y: 14, size: 70, rotation: -18 },
        { x: 52, y: 12, size: 60, rotation: 12 },
        { x: 80, y: 20, size: 74, rotation: -8 },
        { x: 34, y: 30, size: 82, rotation: 16 },
        { x: 66, y: 35, size: 72, rotation: -22 },
        { x: 18, y: 48, size: 66, rotation: 8 },
        { x: 48, y: 52, size: 88, rotation: -10 },
        { x: 80, y: 58, size: 62, rotation: 18 },
        { x: 28, y: 75, size: 78, rotation: -14 },
        { x: 58, y: 78, size: 64, rotation: 10 },
        { x: 84, y: 82, size: 72, rotation: -18 },
      ],
    },
    {
      key: "minimal",
      label: "Minimalus",
      tone: "Švarus, subalansuotas",
      accent: "#111111",
      background: { type: "none", color: "#ffffff", pattern: "" },
      subcategories: ["Y2K TECH", "Y2K Pixel", "Gold Foil", "Y2K Text"],
      terms: ["minimal", "star", "chrome", "icon", "tech", "pixel", "simple", "black", "white"],
      layout: [
        { x: 50, y: 28, size: 82, rotation: 0 },
        { x: 34, y: 62, size: 52, rotation: -8 },
        { x: 68, y: 72, size: 44, rotation: 8 },
      ],
    },
    {
      key: "cute",
      label: "Mielas",
      tone: "Švelnus, žaismingas",
      accent: "#7b61ff",
      background: { type: "color", color: "#f3efff", pattern: "" },
      subcategories: ["Pastel Patches", "Y2K Bundle", "70s Retro", "McBling Y2K"],
      terms: ["cute", "kawaii", "bear", "cloud", "flower", "smile", "heart", "pastel", "cherry", "star"],
      layout: [
        { x: 30, y: 22, size: 72, rotation: -8 },
        { x: 68, y: 28, size: 64, rotation: 12 },
        { x: 50, y: 50, size: 92, rotation: 0 },
        { x: 28, y: 74, size: 58, rotation: 10 },
        { x: 72, y: 76, size: 60, rotation: -12 },
      ],
    },
    {
      key: "dark-emo",
      label: "Tamsus emo",
      tone: "Juodas, aštrus, alternatyvus",
      accent: "#1f2937",
      background: { type: "color", color: "#111111", pattern: "" },
      subcategories: ["Neon Grunge", "Sarcastic", "Maximal Surreal", "Y2K Text"],
      terms: ["emo", "dark", "black", "skull", "flame", "spike", "punk", "sarcastic", "grunge", "alt"],
      layout: [
        { x: 26, y: 20, size: 82, rotation: -14 },
        { x: 72, y: 24, size: 70, rotation: 12 },
        { x: 48, y: 44, size: 88, rotation: -6 },
        { x: 30, y: 68, size: 64, rotation: 18 },
        { x: 70, y: 76, size: 76, rotation: -16 },
      ],
    },
  ];

  const PHOTO_COLLAGE_TEMPLATES = [
    {
      id: "one-photo",
      name: "Viena nuotrauka",
      description: "Didelė hero nuotrauka per visą saugią zoną.",
      background: { type: "color", color: "#f8f3ee", pattern: "" },
      colorVariants: ["#f8f3ee", "#f1f7ff", "#fff0f6", "#f4f8ef"],
      photoSlots: [
        { id: "photo-1", label: "Nuotrauka", x: 50, y: 51, width: 78, height: 72, shape: "rounded", radius: 20, rotation: 0, zIndex: 10 },
      ],
      textLayers: [],
      decorativeLayers: [
        { text: "MY CASE", x: 50, y: 14, size: 22, color: "#171717", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 20 },
      ],
    },
    {
      id: "three-photo",
      name: "3 nuotraukų koliažas",
      description: "Trys persidengiantys rėmeliai kaip scrapbook.",
      background: { type: "color", color: "#fff7d6", pattern: "" },
      colorVariants: ["#fff7d6", "#edf9f3", "#f6ecff", "#ffe9eb"],
      photoSlots: [
        { id: "photo-1", label: "Viršutinė", x: 42, y: 29, width: 58, height: 34, shape: "rounded", radius: 16, rotation: -7, zIndex: 10 },
        { id: "photo-2", label: "Dešinė", x: 63, y: 55, width: 48, height: 42, shape: "rounded", radius: 18, rotation: 8, zIndex: 12 },
        { id: "photo-3", label: "Apatinė", x: 35, y: 72, width: 48, height: 36, shape: "circle", radius: 999, rotation: -3, zIndex: 14 },
      ],
      textLayers: [
        { id: "text-1", text: "memories", x: 50, y: 17, size: 26, color: "#111111", font: "'Pacifico', cursive", rotation: -4, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "four-grid",
      name: "4 nuotraukų grid",
      description: "Švarus 2x2 išdėstymas.",
      background: { type: "color", color: "#ffffff", pattern: "" },
      colorVariants: ["#ffffff", "#eef8ff", "#fdf1f8", "#f3f5f7"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 34, y: 32, width: 34, height: 34, shape: "rounded", radius: 14, rotation: 0, zIndex: 10 },
        { id: "photo-2", label: "2", x: 66, y: 32, width: 34, height: 34, shape: "rounded", radius: 14, rotation: 0, zIndex: 10 },
        { id: "photo-3", label: "3", x: 34, y: 66, width: 34, height: 34, shape: "rounded", radius: 14, rotation: 0, zIndex: 10 },
        { id: "photo-4", label: "4", x: 66, y: 66, width: 34, height: 34, shape: "rounded", radius: 14, rotation: 0, zIndex: 10 },
      ],
      textLayers: [],
      decorativeLayers: [],
    },
    {
      id: "six-grid",
      name: "6 nuotraukų grid",
      description: "Tvarkingas 2x3 išdėstymas kaip telefono dėklo grid.",
      background: { type: "color", color: "#191919", pattern: "" },
      colorVariants: ["#191919", "#ffefe9", "#eef7ff", "#f4f1ff"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 33, y: 36, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
        { id: "photo-2", label: "2", x: 67, y: 36, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
        { id: "photo-3", label: "3", x: 33, y: 58, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
        { id: "photo-4", label: "4", x: 67, y: 58, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
        { id: "photo-5", label: "5", x: 33, y: 80, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
        { id: "photo-6", label: "6", x: 67, y: 80, width: 32, height: 22, shape: "rounded", radius: 12, rotation: 0, zIndex: 10 },
      ],
      textLayers: [],
      decorativeLayers: [],
    },
    {
      id: "vertical-strip",
      name: "Vertikali juosta",
      description: "Polaroid stiliaus nuotraukų juostelė.",
      background: { type: "color", color: "#16161a", pattern: "" },
      colorVariants: ["#16161a", "#1e3350", "#3f1d38", "#0f3b2e"],
      photoSlots: [
        { id: "photo-1", label: "Viršus", x: 50, y: 29, width: 56, height: 27, shape: "rounded", radius: 12, rotation: -2, zIndex: 10 },
        { id: "photo-2", label: "Vidurys", x: 50, y: 53, width: 56, height: 27, shape: "rounded", radius: 12, rotation: 2, zIndex: 10 },
        { id: "photo-3", label: "Apačia", x: 50, y: 77, width: 56, height: 27, shape: "rounded", radius: 12, rotation: -1, zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "photo strip", x: 50, y: 14, size: 21, color: "#ffffff", font: "'Space Grotesk', Arial, sans-serif", rotation: 0, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "photo-text",
      name: "Nuotrauka + tekstas",
      description: "Vienas portretas ir didelis redaguojamas tekstas.",
      background: { type: "color", color: "#fff0f4", pattern: "" },
      colorVariants: ["#fff0f4", "#f1f8ff", "#fff7df", "#eef8f1"],
      photoSlots: [
        { id: "photo-1", label: "Portretas", x: 50, y: 42, width: 66, height: 48, shape: "custom", radius: 22, rotation: -3, zIndex: 10, clipPath: "polygon(8% 0, 100% 0, 92% 100%, 0 92%)" },
      ],
      textLayers: [
        { id: "text-1", text: "good vibes", x: 50, y: 76, size: 34, color: "#ff477e", font: "'Bungee', Impact, sans-serif", rotation: -3, effect: "none", zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "love-collage",
      name: "LOVE koliažas",
      description: "Keturi nuotraukų rėmeliai ir LOVE kompozicija.",
      background: { type: "color", color: "#fff5f7", pattern: "" },
      colorVariants: ["#fff5f7", "#f7f0ff", "#ecfbff", "#fff5df"],
      photoSlots: [
        { id: "photo-l", label: "L", x: 29, y: 32, width: 30, height: 36, shape: "rounded", radius: 16, rotation: -7, zIndex: 10 },
        { id: "photo-o", label: "O", x: 66, y: 32, width: 31, height: 31, shape: "circle", radius: 999, rotation: 0, zIndex: 11 },
        { id: "photo-v", label: "V", x: 36, y: 67, width: 33, height: 36, shape: "custom", radius: 12, rotation: 8, zIndex: 12, clipPath: "polygon(50% 100%, 0 0, 100% 0)" },
        { id: "photo-e", label: "E", x: 68, y: 68, width: 32, height: 38, shape: "rounded", radius: 16, rotation: -4, zIndex: 13 },
      ],
      textLayers: [
        { id: "text-1", text: "LOVE", x: 50, y: 18, size: 36, color: "#171717", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "soft-story-photo",
      name: "Foto + tekstas viršuje",
      description: "Didelė nuotrauka apačioje ir švelnus tekstas viršuje.",
      background: { type: "color", color: "#f5dce3", pattern: "" },
      colorVariants: ["#f5dce3", "#dbe8ed", "#efe5d8", "#e6edf1"],
      photoSlots: [
        { id: "main", label: "Pagrindinė nuotrauka", x: 50, y: 64, width: 82, height: 62, shape: "rounded", radius: 18, rotation: 0, frameStyle: "clean", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "Your text here", x: 68, y: 16, size: 24, color: "#ffffff", font: "'Pacifico', cursive", rotation: 0, bold: false, zIndex: 22 },
      ],
      decorativeLayers: [],
    },
    {
      id: "teal-film-memories",
      name: "Film juosta Memories",
      description: "Įstrižas film-strip su keturiomis nuotraukomis.",
      background: { type: "color", color: "#08b7c9", pattern: "" },
      colorVariants: ["#08b7c9", "#6d8794", "#f48b92", "#111111"],
      photoSlots: [
        { id: "film-1", label: "Kadras 1", x: 62, y: 25, width: 38, height: 19, shape: "rect", radius: 0, rotation: 12, frameStyle: "black-film", zIndex: 10 },
        { id: "film-2", label: "Kadras 2", x: 57, y: 42, width: 38, height: 19, shape: "rect", radius: 0, rotation: 12, frameStyle: "black-film", zIndex: 11 },
        { id: "film-3", label: "Kadras 3", x: 52, y: 59, width: 38, height: 19, shape: "rect", radius: 0, rotation: 12, frameStyle: "black-film", zIndex: 12 },
        { id: "film-4", label: "Kadras 4", x: 47, y: 76, width: 38, height: 19, shape: "rect", radius: 0, rotation: 12, frameStyle: "black-film", zIndex: 13 },
      ],
      textLayers: [
        { id: "text-1", text: "Memories", x: 21, y: 53, size: 27, color: "#ffffff", font: "'Pacifico', cursive", rotation: -82, bold: false, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "love-you-photo",
      name: "Love You portretas",
      description: "Vienas didelis portretas ir tekstas kameros zonoje.",
      background: { type: "color", color: "#d7d7d7", pattern: "" },
      colorVariants: ["#d7d7d7", "#f4d8e2", "#dbe7f3", "#ece7dc"],
      photoSlots: [
        { id: "main", label: "Nuotrauka", x: 50, y: 61, width: 84, height: 62, shape: "rounded", radius: 14, rotation: 0, frameStyle: "clean", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "Love\nYou", x: 70, y: 18, size: 22, color: "#f8c8df", font: "'Pacifico', cursive", rotation: 0, bold: false, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "tilted-family-collage",
      name: "4 pasuktos nuotraukos",
      description: "Keturi pasukti rėmeliai ant spalvoto fono.",
      background: { type: "color", color: "#6f838b", pattern: "" },
      colorVariants: ["#6f838b", "#f28d8d", "#b9dbd2", "#f0d7a9"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 38, y: 35, width: 36, height: 28, shape: "rect", radius: 0, rotation: -9, frameStyle: "white-border", zIndex: 10 },
        { id: "photo-2", label: "2", x: 66, y: 41, width: 36, height: 28, shape: "rect", radius: 0, rotation: 8, frameStyle: "white-border", zIndex: 11 },
        { id: "photo-3", label: "3", x: 35, y: 67, width: 36, height: 30, shape: "rect", radius: 0, rotation: 7, frameStyle: "white-border", zIndex: 12 },
        { id: "photo-4", label: "4", x: 66, y: 71, width: 36, height: 30, shape: "rect", radius: 0, rotation: -7, frameStyle: "white-border", zIndex: 13 },
      ],
      textLayers: [],
      decorativeLayers: [],
    },
    {
      id: "moments-polaroids",
      name: "Moments polaroid",
      description: "Vertikali polaroid nuotraukų grandinė.",
      background: { type: "color", color: "#8a8a8a", pattern: "" },
      colorVariants: ["#8a8a8a", "#dcd7cf", "#f6e4e7", "#e7eef4"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 59, y: 26, width: 42, height: 24, shape: "rect", radius: 0, rotation: 7, frameStyle: "polaroid", zIndex: 10 },
        { id: "photo-2", label: "2", x: 59, y: 44, width: 42, height: 24, shape: "rect", radius: 0, rotation: -5, frameStyle: "polaroid", zIndex: 11 },
        { id: "photo-3", label: "3", x: 59, y: 62, width: 42, height: 24, shape: "rect", radius: 0, rotation: 6, frameStyle: "polaroid", zIndex: 12 },
        { id: "photo-4", label: "4", x: 59, y: 80, width: 42, height: 24, shape: "rect", radius: 0, rotation: -4, frameStyle: "polaroid", zIndex: 13 },
      ],
      textLayers: [
        { id: "text-1", text: "Moments", x: 22, y: 59, size: 28, color: "#ffffff", font: "'Pacifico', cursive", rotation: -84, bold: false, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "double-film-strip",
      name: "Dvi film juostos",
      description: "Dvi įstrižos film juostos kaip prisiminimų koliažas.",
      background: { type: "color", color: "#9d9d9d", pattern: "" },
      colorVariants: ["#9d9d9d", "#f7f7f7", "#e8d6ca", "#ccdce4"],
      photoSlots: [
        { id: "top-1", label: "Viršus 1", x: 32, y: 34, width: 27, height: 18, shape: "rect", radius: 0, rotation: 9, frameStyle: "black-film", zIndex: 10 },
        { id: "top-2", label: "Viršus 2", x: 58, y: 39, width: 27, height: 18, shape: "rect", radius: 0, rotation: 9, frameStyle: "black-film", zIndex: 11 },
        { id: "top-3", label: "Viršus 3", x: 82, y: 44, width: 27, height: 18, shape: "rect", radius: 0, rotation: 9, frameStyle: "black-film", zIndex: 12 },
        { id: "bottom-1", label: "Apačia 1", x: 29, y: 61, width: 27, height: 18, shape: "rect", radius: 0, rotation: -9, frameStyle: "black-film", zIndex: 13 },
        { id: "bottom-2", label: "Apačia 2", x: 56, y: 57, width: 27, height: 18, shape: "rect", radius: 0, rotation: -9, frameStyle: "black-film", zIndex: 14 },
        { id: "bottom-3", label: "Apačia 3", x: 82, y: 53, width: 27, height: 18, shape: "rect", radius: 0, rotation: -9, frameStyle: "black-film", zIndex: 15 },
      ],
      textLayers: [],
      decorativeLayers: [],
    },
    {
      id: "better-together-grid",
      name: "Better Together",
      description: "Keturių nuotraukų grid su pavadinimu viršuje.",
      background: { type: "color", color: "#a4a4a4", pattern: "" },
      colorVariants: ["#a4a4a4", "#f5c3c7", "#bad5e8", "#ebe5d6"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 36, y: 44, width: 31, height: 24, shape: "rect", radius: 0, rotation: 0, frameStyle: "clean", zIndex: 10 },
        { id: "photo-2", label: "2", x: 65, y: 44, width: 31, height: 24, shape: "rect", radius: 0, rotation: 0, frameStyle: "clean", zIndex: 11 },
        { id: "photo-3", label: "3", x: 36, y: 66, width: 31, height: 24, shape: "rect", radius: 0, rotation: 0, frameStyle: "clean", zIndex: 12 },
        { id: "photo-4", label: "4", x: 65, y: 66, width: 31, height: 24, shape: "rect", radius: 0, rotation: 0, frameStyle: "clean", zIndex: 13 },
      ],
      textLayers: [
        { id: "text-1", text: "Better", x: 66, y: 25, size: 19, color: "#ffffff", font: "'Pacifico', cursive", rotation: -3, bold: false, zIndex: 25 },
        { id: "text-2", text: "TOGETHER", x: 44, y: 31, size: 19, color: "#ffffff", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 26 },
      ],
      decorativeLayers: [],
    },
    {
      id: "best-dad",
      name: "Best Dad",
      description: "Šeimos nuotrauka su dviem teksto zonomis.",
      background: { type: "color", color: "#d6d6d6", pattern: "" },
      colorVariants: ["#d6d6d6", "#f1ece5", "#dceaf0", "#e8e1f0"],
      photoSlots: [
        { id: "family", label: "Šeimos nuotrauka", x: 50, y: 52, width: 83, height: 45, shape: "rect", radius: 0, rotation: 0, frameStyle: "clean", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "Best", x: 38, y: 77, size: 34, color: "#4e4e4e", font: "'Pacifico', cursive", rotation: -3, bold: false, zIndex: 25 },
        { id: "text-2", text: "DAD", x: 65, y: 87, size: 30, color: "#ffffff", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 26 },
      ],
      decorativeLayers: [],
    },
    {
      id: "full-photo-script",
      name: "Pilna foto + tekstas",
      description: "Nuotrauka per visą spaudos zoną su ryškiu užrašu.",
      background: { type: "color", color: "#ffffff", pattern: "" },
      colorVariants: ["#ffffff", "#f7edf3", "#edf4f7", "#f4efe7"],
      photoSlots: [
        { id: "main", label: "Pilna nuotrauka", x: 50, y: 55, width: 88, height: 86, shape: "rounded", radius: 18, rotation: 0, frameStyle: "clean", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "To the moon\nand back", x: 53, y: 78, size: 24, color: "#ff4f8a", font: "'Pacifico', cursive", rotation: -4, bold: false, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "heart-polaroid",
      name: "Širdelės + polaroid",
      description: "Romantiškas fonas su viena polaroid nuotrauka.",
      background: { type: "color", color: "#fff4f2", pattern: "" },
      colorVariants: ["#fff4f2", "#fde8ec", "#fff8e7", "#eef7f2"],
      photoSlots: [
        { id: "main", label: "Polaroid", x: 50, y: 58, width: 58, height: 44, shape: "rect", radius: 0, rotation: 0, frameStyle: "polaroid", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "Everlasting love", x: 50, y: 82, size: 20, color: "#222222", font: "'Pacifico', cursive", rotation: 0, bold: false, zIndex: 25 },
        { id: "text-2", text: "♥ ♥ ♥", x: 50, y: 27, size: 25, color: "#d91426", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 24 },
      ],
      decorativeLayers: [],
    },
    {
      id: "floral-polaroid",
      name: "Gėlės + polaroid",
      description: "Švelnus gėlių tipo išdėstymas su tekstu.",
      background: { type: "color", color: "#8c958b", pattern: "" },
      colorVariants: ["#8c958b", "#f5e5eb", "#fff7ef", "#edf4ff"],
      photoSlots: [
        { id: "main", label: "Polaroid", x: 51, y: 56, width: 48, height: 38, shape: "rect", radius: 0, rotation: -8, frameStyle: "polaroid", zIndex: 12 },
      ],
      textLayers: [
        { id: "text-1", text: "Your text here", x: 52, y: 74, size: 16, color: "#8d6c59", font: "'Pacifico', cursive", rotation: -8, bold: false, zIndex: 25 },
        { id: "text-2", text: "✿ ✿ ✿", x: 50, y: 27, size: 28, color: "#ffc6d8", font: "'Bungee', Impact, sans-serif", rotation: 0, zIndex: 9 },
      ],
      decorativeLayers: [],
    },
    {
      id: "pink-stripe-circle",
      name: "Dryžiai + apvali foto",
      description: "Apvali nuotrauka ir rankraštinis tekstas.",
      background: { type: "color", color: "#ffdfe5", pattern: "" },
      colorVariants: ["#ffdfe5", "#e8f3ff", "#fff1cf", "#ece6ff"],
      photoSlots: [
        { id: "circle", label: "Apvali nuotrauka", x: 50, y: 54, width: 42, height: 42, shape: "circle", radius: 999, rotation: 0, frameStyle: "white-border", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "his\nlove", x: 50, y: 54, size: 34, color: "#627486", font: "'Pacifico', cursive", rotation: -7, bold: false, zIndex: 25 },
        { id: "text-2", text: "||||||||", x: 50, y: 50, size: 56, color: "#fff5f6", font: "'Bungee', Impact, sans-serif", rotation: 90, opacity: 55, zIndex: 5 },
      ],
      decorativeLayers: [],
    },
    {
      id: "music-player",
      name: "Music player",
      description: "Albumo viršelis ir grotuvo tipo elementai.",
      background: { type: "color", color: "#9a9a9a", pattern: "" },
      colorVariants: ["#9a9a9a", "#f3f1ec", "#e5eef7", "#f8e3e9"],
      photoSlots: [
        { id: "album", label: "Albumo foto", x: 50, y: 49, width: 38, height: 28, shape: "rect", radius: 0, rotation: 0, frameStyle: "black-border", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "Your Text here", x: 50, y: 62, size: 15, color: "#111111", font: "'Space Grotesk', Arial, sans-serif", rotation: 0, zIndex: 24 },
        { id: "text-2", text: "‹   ◉   ›", x: 50, y: 74, size: 23, color: "#111111", font: "'Space Grotesk', Arial, sans-serif", rotation: 0, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "vertical-name-strip",
      name: "Vardas + 4 foto",
      description: "Kairėje vardas, dešinėje keturios nuotraukos.",
      background: { type: "color", color: "#f1efeb", pattern: "" },
      colorVariants: ["#f1efeb", "#f8e8ef", "#edf7f8", "#f7efdb"],
      photoSlots: [
        { id: "photo-1", label: "1", x: 66, y: 28, width: 38, height: 22, shape: "rect", radius: 0, rotation: 0, frameStyle: "pink-border", zIndex: 10 },
        { id: "photo-2", label: "2", x: 66, y: 45, width: 38, height: 22, shape: "rect", radius: 0, rotation: 0, frameStyle: "pink-border", zIndex: 11 },
        { id: "photo-3", label: "3", x: 66, y: 62, width: 38, height: 22, shape: "rect", radius: 0, rotation: 0, frameStyle: "pink-border", zIndex: 12 },
        { id: "photo-4", label: "4", x: 66, y: 79, width: 38, height: 22, shape: "rect", radius: 0, rotation: 0, frameStyle: "pink-border", zIndex: 13 },
      ],
      textLayers: [
        { id: "text-1", text: "Michelle", x: 27, y: 56, size: 37, color: "#1f1f1f", font: "'Pacifico', cursive", rotation: -83, bold: false, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "kraft-side-photo",
      name: "Torn edge foto",
      description: "Nuotrauka dešinėje ir vertikalus tekstas kairėje.",
      background: { type: "color", color: "#b98f66", pattern: "" },
      colorVariants: ["#b98f66", "#d0c0ad", "#86a7a4", "#e8ccd5"],
      photoSlots: [
        { id: "main", label: "Pilna nuotrauka", x: 59, y: 54, width: 76, height: 84, shape: "custom", radius: 18, rotation: 0, frameStyle: "clean", clipPath: "polygon(14% 0, 100% 0, 100% 100%, 12% 100%, 0 82%, 10% 63%, 0 43%, 12% 24%)", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "YOUR TEXT HERE", x: 21, y: 58, size: 19, color: "#ffffff", font: "'Bungee', Impact, sans-serif", rotation: -90, zIndex: 25 },
      ],
      decorativeLayers: [],
    },
    {
      id: "ginkgo-circle",
      name: "Pattern + apskritimas",
      description: "Apvali foto ant subtilaus rašto fono.",
      background: { type: "color", color: "#d7cec3", pattern: "" },
      colorVariants: ["#d7cec3", "#e9e3db", "#d9e5df", "#f3dee3"],
      photoSlots: [
        { id: "circle", label: "Apskritimas", x: 50, y: 52, width: 54, height: 54, shape: "circle", radius: 999, rotation: 0, frameStyle: "white-border", zIndex: 10 },
      ],
      textLayers: [
        { id: "text-1", text: "✦ ✦ ✦", x: 50, y: 25, size: 22, color: "#72685f", font: "'Bungee', Impact, sans-serif", rotation: 0, opacity: 55, zIndex: 8 },
      ],
      decorativeLayers: [],
    },
  ];

  const Y2K_STICKERS = Array.isArray(window.STICKER_CASE_Y2K_STICKERS)
    ? window.STICKER_CASE_Y2K_STICKERS
    : [];
  const STICKER_CATEGORY_ORDER = [
    "Tech & Gadgets",
    "Hearts & Love",
    "Stars & Space",
    "Bows & Butterflies",
    "Flowers & Nature",
    "Animals & Characters",
    "Food & Drinks",
    "Fashion & Beauty",
    "Decor & Objects",
    "Abstract & Chrome",
    "Text & Letters",
    "Retro & Y2K Mix",
    "Custom",
  ];
  const BUILT_IN_BACKGROUND_PATTERNS = Array.isArray(window.STICKER_CASE_BACKGROUND_PATTERNS)
    ? window.STICKER_CASE_BACKGROUND_PATTERNS
    : [];
  const COMPACT_PREVIEW_STICKER_IDS = new Set([
    "70s-retro-lava-lamp-6",
    "70s-retro-alarm-clock-1",
    "70s-retro-platform-shoes-9",
    "mall-rat-y2k-platform-shoes-11",
    "80s-80s-23-23",
    "80s-80s-24-24",
    "80s-80s-35-35",
    "80s-80s-toys-13-54",
    "80s-80s-toys-14-55",
    "80s-80s-toys-15-56",
    "80s-80s-toys-16-57",
    "80s-80s-toys-17-58",
    "80s-80s-toys-24-65",
    "80s-80s-toys-27-68",
    "90s-90s-07-7",
    "90s-90s-13-13",
    "90s-90s-17-17",
    "90s-90s-33-33",
    "90s-90s-toys-1-37",
    "90s-90s-toys-25-61",
    "90s-90s-toys-27-63",
    "90s-90s-toys-31-67",
    "90s-90s-toys-34-70",
    "holographic-y2k-crafty-arter-44-41",
    "y2k-bundle-03-y2k-3",
    "y2k-bundle-12-y2k-12",
  ]);

  const CAMERA_PRESETS = {
    iphonePro: {
      radius: 42,
      module: { xMm: 5.2, yMm: 5.7, wMm: 37.5, hMm: 37.5, rMm: 10.5, style: "iphone-square" },
      lenses: [
        { xMm: 16.3, yMm: 16.8, dMm: 12.8 },
        { xMm: 31.0, yMm: 16.8, dMm: 12.8 },
        { xMm: 23.6, yMm: 32.0, dMm: 12.8 },
      ],
      flash: { xMm: 33.2, yMm: 31.4, dMm: 4.2 },
      sensors: [{ xMm: 15.2, yMm: 31.2, dMm: 3.2 }],
    },
    iphoneDualDiagonal: {
      radius: 42,
      module: { xMm: 6.0, yMm: 6.0, wMm: 33.6, hMm: 34.6, rMm: 9.2, style: "iphone-square" },
      lenses: [
        { xMm: 16.8, yMm: 16.6, dMm: 12.0 },
        { xMm: 29.0, yMm: 30.0, dMm: 12.0 },
      ],
      flash: { xMm: 29.0, yMm: 16.6, dMm: 4.2 },
    },
    iphoneDualVertical: {
      radius: 40,
      module: { xMm: 7.0, yMm: 6.2, wMm: 22.5, hMm: 41.0, rMm: 11.0, style: "black-vertical-pill" },
      lenses: [
        { xMm: 18.25, yMm: 17.4, dMm: 13.0 },
        { xMm: 18.25, yMm: 36.0, dMm: 13.0 },
      ],
      flash: { xMm: 37.8, yMm: 23.2, dMm: 5.2 },
      sensors: [{ xMm: 27.0, yMm: 22.8, dMm: 2.0 }],
    },
    iphoneSingle: {
      radius: 38,
      module: { xMm: 7.0, yMm: 7.0, wMm: 18.0, hMm: 18.0, rMm: 8.5, style: "single-bump" },
      lenses: [{ xMm: 16.0, yMm: 16.0, dMm: 11.5 }],
      flash: { xMm: 10.0, yMm: 16.0, dMm: 3.8 },
    },
    iphoneAir: {
      radius: 43,
      module: { xMm: 5.8, yMm: 6.4, wMm: 63.0, hMm: 20.0, rMm: 10.0, style: "plateau" },
      lenses: [{ xMm: 17.2, yMm: 16.4, dMm: 11.6 }],
      flash: { xMm: 58.0, yMm: 16.4, dMm: 4.0 },
      sensors: [{ xMm: 48.0, yMm: 16.4, dMm: 3.2 }],
    },
    iphone17Pro: {
      radius: 43,
      module: { xMm: 5.8, yMm: 3.8, wMm: 67.0, hMm: 43.0, rMm: 10.8, style: "plateau" },
      lenses: [
        { xMm: 17.0, yMm: 16.0, dMm: 13.2 },
        { xMm: 17.0, yMm: 33.2, dMm: 13.2 },
        { xMm: 36.6, yMm: 24.5, dMm: 13.2 },
      ],
      flash: { xMm: 60.6, yMm: 14.8, dMm: 6.4 },
      sensors: [
        { xMm: 60.8, yMm: 24.4, dMm: 1.4 },
        { xMm: 60.6, yMm: 34.9, dMm: 7.0 },
      ],
    },
    samsungSUltra: {
      radius: 34,
      module: null,
      lenses: [
        { xMm: 12.8, yMm: 13.5, dMm: 12.0 },
        { xMm: 12.8, yMm: 30.2, dMm: 12.0 },
        { xMm: 12.8, yMm: 46.9, dMm: 12.0 },
        { xMm: 28.2, yMm: 22.0, dMm: 8.0 },
        { xMm: 28.2, yMm: 39.0, dMm: 8.0 },
      ],
      flash: { xMm: 28.2, yMm: 12.8, dMm: 4.2 },
    },
    samsungS: {
      radius: 36,
      module: null,
      lenses: [
        { xMm: 12.4, yMm: 13.6, dMm: 11.5 },
        { xMm: 12.4, yMm: 30.0, dMm: 11.5 },
        { xMm: 12.4, yMm: 46.4, dMm: 11.5 },
      ],
      flash: { xMm: 25.0, yMm: 17.0, dMm: 4.0 },
    },
    samsungA: {
      radius: 34,
      module: null,
      lenses: [
        { xMm: 13.4, yMm: 14.4, dMm: 10.8 },
        { xMm: 13.4, yMm: 30.2, dMm: 10.8 },
        { xMm: 13.4, yMm: 46.0, dMm: 10.8 },
      ],
      flash: { xMm: 26.0, yMm: 26.0, dMm: 4.0 },
    },
    samsungFold: {
      radius: 30,
      module: { xMm: 7.0, yMm: 8.0, wMm: 18.0, hMm: 46.0, rMm: 7.0, style: "vertical-pill" },
      lenses: [
        { xMm: 16.0, yMm: 17.0, dMm: 9.0 },
        { xMm: 16.0, yMm: 31.0, dMm: 9.0 },
        { xMm: 16.0, yMm: 45.0, dMm: 9.0 },
      ],
      flash: { xMm: 21.0, yMm: 22.0, dMm: 3.4 },
    },
    samsungFlip: {
      radius: 38,
      module: { xMm: 7.0, yMm: 7.0, wMm: 35.0, hMm: 18.0, rMm: 8.0, style: "horizontal-pill" },
      lenses: [
        { xMm: 17.0, yMm: 16.0, dMm: 9.8 },
        { xMm: 32.0, yMm: 16.0, dMm: 9.8 },
      ],
      flash: { xMm: 39.5, yMm: 16.0, dMm: 3.6 },
    },
    samsungNote: {
      radius: 26,
      module: { xMm: 7.0, yMm: 8.0, wMm: 24.0, hMm: 42.0, rMm: 6.0, style: "soft-rect" },
      lenses: [
        { xMm: 15.0, yMm: 18.0, dMm: 9.8 },
        { xMm: 15.0, yMm: 31.0, dMm: 9.8 },
        { xMm: 15.0, yMm: 44.0, dMm: 9.8 },
      ],
      flash: { xMm: 25.5, yMm: 20.0, dMm: 3.6 },
    },
  };

  const MODEL_GROUPS = [
    {
      label: "iPhone",
      models: [
        ["iPhone 17 Pro Max", "iphone17Pro"],
        ["iPhone 17 Pro", "iphone17Pro"],
        ["iPhone Air", "iphoneAir"],
        ["iPhone 17", "iphoneDualVertical"],
        ["iPhone 16 Pro Max", "iphonePro"],
        ["iPhone 16 Pro", "iphonePro"],
        ["iPhone 16 Plus", "iphoneDualDiagonal"],
        ["iPhone 16", "iphoneDualVertical"],
        ["iPhone 15 Pro Max", "iphonePro"],
        ["iPhone 15 Pro", "iphonePro"],
        ["iPhone 15 Plus", "iphoneDualDiagonal"],
        ["iPhone 15", "iphoneDualDiagonal"],
        ["iPhone 14 Pro Max", "iphonePro"],
        ["iPhone 14 Pro", "iphonePro"],
        ["iPhone 14 Plus", "iphoneDualDiagonal"],
        ["iPhone 14", "iphoneDualDiagonal"],
        ["iPhone 13 Pro Max", "iphonePro"],
        ["iPhone 13 Pro", "iphonePro"],
        ["iPhone 13", "iphoneDualDiagonal"],
        ["iPhone 13 Mini", "iphoneDualDiagonal"],
        ["iPhone 12 Pro Max", "iphonePro"],
        ["iPhone 12 Pro", "iphonePro"],
        ["iPhone 12", "iphoneDualVertical"],
        ["iPhone 12 Mini", "iphoneDualVertical"],
        ["iPhone 11 Pro Max", "iphonePro"],
        ["iPhone 11 Pro", "iphonePro"],
        ["iPhone 11", "iphoneDualVertical"],
      ],
    },
    {
      label: "Samsung Galaxy",
      models: [
        ["Samsung Galaxy S26 Ultra", "samsungSUltra"],
        ["Samsung Galaxy S26 Plus", "samsungS"],
        ["Samsung Galaxy S26", "samsungS"],
        ["Samsung Galaxy S25 Ultra", "samsungSUltra"],
        ["Samsung Galaxy S25 Plus", "samsungS"],
        ["Samsung Galaxy S25", "samsungS"],
        ["Samsung Galaxy S24 Ultra", "samsungSUltra"],
        ["Samsung Galaxy S24 Plus", "samsungS"],
        ["Samsung Galaxy S24", "samsungS"],
        ["Samsung Galaxy S23 Ultra 5G", "samsungSUltra"],
        ["Samsung Galaxy S23 Plus 5G", "samsungS"],
        ["Samsung Galaxy S23 5G", "samsungS"],
        ["Samsung Galaxy S22 Ultra 5G", "samsungSUltra"],
        ["Samsung Galaxy S22 Plus 5G", "samsungS"],
        ["Samsung Galaxy S22 5G", "samsungS"],
      ],
    },
  ];

  const MODEL_PRESETS = Object.fromEntries(
    MODEL_GROUPS.flatMap((group) =>
      group.models.map(([name, preset]) => [
        name,
        {
          ...CAMERA_PRESETS[preset],
          ...phoneDimensions(name),
        },
      ]),
    ),
  );

  const MODEL_IMAGES = {
    "iPhone 17 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-17-pro-max.jpg"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 17 Pro": {
      src: window.StrayzyAsset("./assets/iphone-17-pro-max.jpg"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone Air": {
      src: window.StrayzyAsset("./assets/iphone-17-air.jpg"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 17": {
      src: window.StrayzyAsset("./assets/iphone-17.webp"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 16 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-16-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 16 Pro": {
      src: window.StrayzyAsset("./assets/iphone-16-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 16 Plus": {
      src: window.StrayzyAsset("./assets/iphone-16-plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 16": {
      src: window.StrayzyAsset("./assets/iphone-16.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 15 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-15-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 15 Pro": {
      src: window.StrayzyAsset("./assets/iphone-15-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 15 Plus": {
      src: window.StrayzyAsset("./assets/iphone-15-plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 15": {
      src: window.StrayzyAsset("./assets/iphone-15.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 14 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-14-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 14 Pro": {
      src: window.StrayzyAsset("./assets/iphone-14-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 14 Plus": {
      src: window.StrayzyAsset("./assets/iphone-14-plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 14": {
      src: window.StrayzyAsset("./assets/iphone-14-case-new.png?v=1"),
      aspect: "5 / 6",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
      safeArea: {
        left: 32.28,
        top: 19.03,
        width: 35.4,
        height: 61.93,
      },
      maskSrc: window.StrayzyAsset("./assets/iphone-14-mask-new.svg?v=1"),
      clipPath: "",
      safeAreaVersion: 66,
    },
    "iPhone 13 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-13-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 13 Pro": {
      src: window.StrayzyAsset("./assets/iphone-13-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 13": {
      src: window.StrayzyAsset("./assets/iphone-13.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 13 Mini": {
      src: window.StrayzyAsset("./assets/iphone-13-mini.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 12 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-12-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 12 Pro": {
      src: window.StrayzyAsset("./assets/iphone-12-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 12": {
      src: window.StrayzyAsset("./assets/iphone-12.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 12 Mini": {
      src: window.StrayzyAsset("./assets/iphone-12-mini.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 11 Pro Max": {
      src: window.StrayzyAsset("./assets/iphone-11-pro-max.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 11 Pro": {
      src: window.StrayzyAsset("./assets/iphone-11-pro.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "iPhone 11": {
      src: window.StrayzyAsset("./assets/iphone-11.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S26 Ultra": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S26-Ultra.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S26 Plus": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S26-Plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S26": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S26.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S25 Ultra": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S25-Ultra.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S25 Plus": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S25-Plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S25": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S25.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S24 Ultra": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S24-Ultra.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S24 Plus": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S24-Plus.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S24": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S24.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S23 Ultra 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S23-Ultra-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S23 Plus 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S23-Plus-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S23 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S23-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S22 Ultra 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S22-Ultra-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S22 Plus 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S22-Plus-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
    "Samsung Galaxy S22 5G": {
      src: window.StrayzyAsset("./assets/Samsung-Galaxy-S22-5G.png?v=2"),
      aspect: "1 / 1",
      displayWidth: 520,
      stickerBounds: {
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      },
    },
  };

  const DEFAULT_SAFE_AREA = {
    left: 0,
    top: 0,
    width: 100,
    height: 100,
  };

  const MODEL_PHOTO_SAFE_AREAS = {
    "iPhone 17 Pro Max": {
      left: 31.7,
      top: 11.0,
      width: 36.7,
      height: 78.1,
    },
    "iPhone 17 Pro": {
      left: 31.7,
      top: 11.0,
      width: 36.7,
      height: 78.1,
    },
    "iPhone Air": {
      left: 31.8,
      top: 25.0,
      width: 36.4,
      height: 63.6,
    },
    "iPhone 17": {
      left: 32.0,
      top: 11.7,
      width: 36.0,
      height: 77.8,
    },
    "Samsung Galaxy S26 Ultra": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S26 Plus": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S26": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S25 Ultra": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S25 Plus": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S25": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S24 Ultra": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S24 Plus": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S24": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S23 Ultra 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S23 Plus 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S23 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S22 Ultra 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S22 Plus 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "Samsung Galaxy S22 5G": {
      left: 0,
      top: 0,
      width: 100,
      height: 100,
    },
    "iPhone 16 Pro Max": {
      left: 31.7,
      top: 10.8,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 16 Pro": {
      left: 31.7,
      top: 10.4,
      width: 36.7,
      height: 78.5,
    },
    "iPhone 15 Pro Max": {
      left: 31.6,
      top: 11.1,
      width: 36.9,
      height: 77.8,
    },
    "iPhone 16": {
      left: 34.1,
      top: 11.1,
      width: 34.3,
      height: 77.5,
    },
    "iPhone 16 Plus": {
      left: 34.1,
      top: 11.1,
      width: 34.3,
      height: 77.5,
    },
    "iPhone 15 Pro": {
      left: 31.6,
      top: 11.1,
      width: 36.9,
      height: 77.8,
    },
    "iPhone 15 Plus": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 15": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 14 Pro Max": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 14 Pro": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 14 Plus": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 14": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 13 Pro Max": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 13 Pro": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 13": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 13 Mini": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 12 Pro Max": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 12 Pro": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 12": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 12 Mini": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
    "iPhone 11 Pro Max": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 11 Pro": {
      left: 31.6,
      top: 11.0,
      width: 36.8,
      height: 78.0,
    },
    "iPhone 11": {
      left: 31.4,
      top: 11.1,
      width: 37.2,
      height: 78.0,
    },
  };

  const MODEL_PHOTO_CLIP_PATHS = {
    "iPhone 17 Pro Max":
      "url(#iphone17-pro-max-print-clip)",
    "iPhone 17 Pro":
      "url(#iphone17-pro-max-print-clip)",
    "iPhone Air":
      "url(#iphone17-air-print-clip)",
    "iPhone 17":
      "url(#iphone17-print-clip)",
    "iPhone 16 Pro Max":
      "url(#iphone16-pro-max-print-clip)",
    "iPhone 16 Pro":
      "url(#iphone16-pro-print-clip)",
    "iPhone 15 Pro Max":
      "url(#iphone15-pro-max-print-clip)",
    "iPhone 16":
      "url(#iphone16-print-clip)",
    "iPhone 16 Plus":
      "url(#iphone16-plus-print-clip)",
    "iPhone 15 Pro":
      "url(#iphone15-pro-max-print-clip)",
    "iPhone 15 Plus":
      "url(#iphone15-plus-print-clip)",
    "iPhone 15":
      "url(#iphone15-print-clip)",
    "iPhone 14 Pro Max":
      "url(#iphone14-pro-max-print-clip)",
    "iPhone 14 Pro":
      "url(#iphone14-pro-print-clip)",
    "iPhone 14 Plus":
      "url(#iphone14-plus-print-clip)",
    "iPhone 14": "",
    "iPhone 13 Pro Max":
      "url(#iphone13-pro-max-print-clip)",
    "iPhone 13 Pro":
      "url(#iphone13-pro-print-clip)",
    "iPhone 13":
      "url(#iphone13-print-clip)",
    "iPhone 13 Mini":
      "url(#iphone13-mini-print-clip)",
    "iPhone 12 Pro Max":
      "url(#iphone12-pro-max-print-clip)",
    "iPhone 12 Pro":
      "url(#iphone12-pro-print-clip)",
    "iPhone 12":
      "url(#iphone12-print-clip)",
    "iPhone 12 Mini":
      "url(#iphone12-mini-print-clip)",
    "iPhone 11 Pro Max":
      "url(#iphone11-pro-max-print-clip)",
    "iPhone 11 Pro":
      "url(#iphone11-pro-print-clip)",
    "iPhone 11":
      "url(#iphone11-print-clip)",
    "Samsung Galaxy S26 Ultra":
      "url(#samsung-ultra-print-clip)",
    "Samsung Galaxy S26 Plus":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S26":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S25 Ultra":
      "url(#samsung-ultra-print-clip)",
    "Samsung Galaxy S25 Plus":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S25":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S24 Ultra":
      "url(#samsung-ultra-print-clip)",
    "Samsung Galaxy S24 Plus":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S24":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S23 Ultra 5G":
      "url(#samsung-ultra-print-clip)",
    "Samsung Galaxy S23 Plus 5G":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S23 5G":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S22 Ultra 5G":
      "url(#samsung-ultra-print-clip)",
    "Samsung Galaxy S22 Plus 5G":
      "url(#samsung-s-print-clip)",
    "Samsung Galaxy S22 5G":
      "url(#samsung-s-print-clip)",
  };

  const MODEL_PHOTO_MASKS = {
    "iPhone 17 Pro Max": window.StrayzyAsset("./assets/iphone-17-pro-max.svg"),
    "iPhone 17 Pro": window.StrayzyAsset("./assets/iphone-17-pro-max.svg"),
    "iPhone Air": window.StrayzyAsset("./assets/iphone-17-air.svg"),
    "iPhone 17": window.StrayzyAsset("./assets/iphone-17.svg"),
    "iPhone 16 Pro Max": window.StrayzyAsset("./assets/iphone-16-pro-max.svg"),
    "iPhone 16 Pro": window.StrayzyAsset("./assets/iphone-16-pro-mask.svg"),
    "iPhone 15 Pro Max": window.StrayzyAsset("./assets/iphone-15-pro-max.svg"),
    "iPhone 15 Pro": window.StrayzyAsset("./assets/iphone-15-pro-max.svg"),
    "iPhone 15 Plus": window.StrayzyAsset("./assets/iphone-15-plus.svg"),
    "iPhone 15": window.StrayzyAsset("./assets/iphone-15.svg"),
    "iPhone 14 Pro Max": window.StrayzyAsset("./assets/iphone-14-pro-max.svg"),
    "iPhone 14 Pro": window.StrayzyAsset("./assets/iphone-14-pro.svg"),
    "iPhone 14 Plus": window.StrayzyAsset("./assets/iphone-14-plus.svg"),
    "iPhone 14": window.StrayzyAsset("./assets/iphone-14-mask-new.svg?v=1"),
    "iPhone 13 Pro Max": window.StrayzyAsset("./assets/iphone-13-pro-max.svg"),
    "iPhone 13 Pro": window.StrayzyAsset("./assets/iphone-13-pro.svg"),
    "iPhone 13": window.StrayzyAsset("./assets/iphone-13.svg"),
    "iPhone 13 Mini": window.StrayzyAsset("./assets/iphone-13-mini.svg"),
    "iPhone 12 Pro Max": window.StrayzyAsset("./assets/iphone-12-pro-max.svg"),
    "iPhone 12 Pro": window.StrayzyAsset("./assets/iphone-12-pro.svg"),
    "iPhone 12": window.StrayzyAsset("./assets/iphone-12.svg"),
    "iPhone 12 Mini": window.StrayzyAsset("./assets/iphone-12-mini.svg"),
    "iPhone 11 Pro Max": window.StrayzyAsset("./assets/iphone-11-pro-max.svg"),
    "iPhone 11 Pro": window.StrayzyAsset("./assets/iphone-11-pro.svg"),
    "iPhone 11": window.StrayzyAsset("./assets/iphone-11.svg"),
    "iPhone 16": window.StrayzyAsset("./assets/iphone-16-mask.svg"),
    "iPhone 16 Plus": window.StrayzyAsset("./assets/iphone-16-plus.svg"),
    "Samsung Galaxy S26 Ultra": window.StrayzyAsset("./assets/Samsung-Galaxy-S26-Ultra.svg"),
    "Samsung Galaxy S26 Plus": window.StrayzyAsset("./assets/Samsung-Galaxy-S26-Plus.svg"),
    "Samsung Galaxy S26": window.StrayzyAsset("./assets/Samsung-Galaxy-S26.svg"),
    "Samsung Galaxy S25 Ultra": window.StrayzyAsset("./assets/Samsung-Galaxy-S25-Ultra.svg"),
    "Samsung Galaxy S25 Plus": window.StrayzyAsset("./assets/Samsung-Galaxy-S25-Plus.svg"),
    "Samsung Galaxy S25": window.StrayzyAsset("./assets/Samsung-Galaxy-S25.svg"),
    "Samsung Galaxy S24 Ultra": window.StrayzyAsset("./assets/Samsung-Galaxy-S24-Ultra.svg"),
    "Samsung Galaxy S24 Plus": window.StrayzyAsset("./assets/Samsung-Galaxy-S24-Plus.svg"),
    "Samsung Galaxy S24": window.StrayzyAsset("./assets/Samsung-Galaxy-S24.svg"),
    "Samsung Galaxy S23 Ultra 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S23-Ultra-5G.svg"),
    "Samsung Galaxy S23 Plus 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S23-Plus-5G.svg"),
    "Samsung Galaxy S23 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S23-5G.svg"),
    "Samsung Galaxy S22 Ultra 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S22-Ultra-5G.svg"),
    "Samsung Galaxy S22 Plus 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S22-Plus-5G.svg"),
    "Samsung Galaxy S22 5G": window.StrayzyAsset("./assets/Samsung-Galaxy-S22-5G.svg"),
  };

  const UPDATED_PHONE_MODEL_ASSETS = {
    "iPhone 17 Pro Max": { slug: "iphone-17-pro-max", ext: "jpg", aspect: "2500 / 3000", supplierPrintSize: { width: 915, height: 1966 }, supplierBleedMm: 5, supplierPrintDpi: 300, supplierPrintCalibration: { scale: 1.03, offsetYmm: -2 }, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-max-full-print-mask.svg?v=1"), supplierPrintItemMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-max-mask.svg?v=2"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-max-mask.svg?v=2"), supplierOutputFromPreviewMask: true, supplierApplyMask: false, supplierClipBleedOutput: true, safeArea: { left: 31.7, top: 11.0, width: 36.7, height: 78.1 } },
    "iPhone 17 Pro": { slug: "iphone-17-pro", ext: "png", aspect: "2500 / 3000", version: 6, backgroundMask: true, printMask: true, supplierPrintSize: { width: 915, height: 1958 }, supplierBleedMm: 5, supplierPrintDpi: 300, supplierPrintCalibration: { scale: 1.02, offsetYmm: -2 }, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-full-print-mask.svg?v=1"), supplierPrintItemMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-mask.svg?v=6"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-pro-mask.svg?v=6"), supplierOutputFromPreviewMask: true, supplierApplyMask: false, supplierClipBleedOutput: true, safeArea: { left: 31.7, top: 11.0, width: 36.7, height: 78.1 } },
    "iPhone Air": { slug: "iphone-17-air", ext: "png", aspect: "2500 / 3000", version: 3, supplierPrintSize: { width: 915, height: 1962 }, supplierBleedMm: 3, supplierPrintDpi: 300, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-air-print-mask.svg?v=3"), supplierPrintItemMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-air-mask.svg?v=4"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-air-mask.svg?v=4"), supplierOutputFromPreviewMask: true, supplierApplyMask: false, supplierClipBleedOutput: true, safeArea: { left: 31.8, top: 25.0, width: 36.4, height: 63.6 } },
    "iPhone 17": { slug: "iphone-17", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 915, height: 1969 }, supplierBleedMm: 5, supplierPrintDpi: 300, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-17-preview-mask.svg?v=4"), supplierApplyMask: false, supplierClipBleedOutput: false, safeArea: { left: 25.12, top: 13.4, width: 45.24, height: 73.0 } },
    "iPhone 16 Pro Max": { slug: "iphone-16-pro-max", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 1132, height: 2393 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-16-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 27.32, top: 9.37, width: 45.28, height: 79.77 } },
    "iPhone 16 Pro": { slug: "iphone-16-pro", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 1037, height: 2180 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-16-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 29.2, top: 12.9, width: 41.48, height: 72.67 } },
    "iPhone 16 Plus": { slug: "iphone-16-plus", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 1129, height: 2348 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-16-plus-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 27.36, top: 10.1, width: 45.16, height: 78.27 } },
    "iPhone 16": { slug: "iphone-16", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 1045, height: 2163 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-16-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 29.04, top: 13.17, width: 41.8, height: 72.1 } },
    "iPhone 15 Pro Max": { slug: "iphone-15-pro-max", ext: "png", aspect: "2500 / 3132", supplierPrintSize: { width: 1116, height: 2327 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-15-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 27.36, top: 10.95, width: 44.64, height: 74.3 } },
    "iPhone 15 Pro": { slug: "iphone-15-pro", ext: "png", aspect: "2500 / 3132", supplierPrintSize: { width: 1036, height: 2128 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-15-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 28.8, top: 13.95, width: 42.2, height: 69.22 } },
    "iPhone 15 Plus": { slug: "iphone-15-plus", ext: "png", aspect: "2500 / 3132", supplierPrintSize: { width: 1136, height: 2344 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-15-plus-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 27.2, top: 11.05, width: 45.44, height: 74.84 } },
    "iPhone 15": { slug: "iphone-15", ext: "png", aspect: "2500 / 3132", supplierPrintSize: { width: 1036, height: 2095 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-15-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 29.16, top: 15.01, width: 41.44, height: 66.89 } },
    "iPhone 14 Pro Max": { slug: "iphone-14-pro-max", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 952, height: 2037 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-14-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 30.96, top: 16.13, width: 38.08, height: 67.9 } },
    "iPhone 14 Pro": { slug: "iphone-14-pro", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 885, height: 1866 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-14-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.28, top: 18.87, width: 35.4, height: 62.2 } },
    "iPhone 14 Plus": { slug: "iphone-14-plus", ext: "png", aspect: "2500 / 3000", version: 4, printMask: true, printMaskViewBox: true, printItemMask: true, fitPrintDesignToMaskBounds: true, supplierPrintSize: { width: 972, height: 2025 }, supplierBleedX: 32, supplierBleedY: 90, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/iphone-14-plus-print-mask.svg?v=4"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-14-plus-mask.svg?v=4"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.0, top: 16.3, width: 38.88, height: 67.5 } },
    "iPhone 14": { slug: "iphone-14", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 885, height: 1858 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-14-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.28, top: 19.03, width: 35.4, height: 61.93 } },
    "iPhone 13 Pro Max": { slug: "iphone-13-pro-max", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 952, height: 1997 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-13-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.0, top: 16.7, width: 38.08, height: 66.57 } },
    "iPhone 13 Pro": { slug: "iphone-13-pro", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 871, height: 1821 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-13-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.64, top: 19.63, width: 34.84, height: 60.7 } },
    "iPhone 13 Mini": { slug: "iphone-13-mini", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 772, height: 1616 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-13-mini-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 34.6, top: 23.03, width: 30.88, height: 53.87 } },
    "iPhone 13": { slug: "iphone-13", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 871, height: 1821 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-13-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.64, top: 19.63, width: 34.84, height: 60.7 } },
    "iPhone 12 Pro Max": { slug: "iphone-12-pro-max", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 956, height: 2004 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-12-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 30.92, top: 16.67, width: 38.24, height: 66.8 } },
    "iPhone 12 Pro": { slug: "iphone-12-pro", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 863, height: 1808 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-12-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.76, top: 19.77, width: 34.52, height: 60.27 } },
    "iPhone 12 Mini": { slug: "iphone-12-mini", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 768, height: 1619 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-12-mini-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 34.68, top: 23.0, width: 30.72, height: 53.97 } },
    "iPhone 12": { slug: "iphone-12", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 863, height: 1808 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-12-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.76, top: 19.77, width: 34.52, height: 60.27 } },
    "iPhone 11 Pro Max": { slug: "iphone-11-pro-max", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 926, height: 1924 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-11-pro-max-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.12, top: 17.4, width: 37.04, height: 64.13 } },
    "iPhone 11 Pro": { slug: "iphone-11-pro", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 843, height: 1749 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-11-pro-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.96, top: 20.43, width: 33.72, height: 58.3 } },
    "iPhone 11": { slug: "iphone-11", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 890, height: 1829 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/iphone-11-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.16, top: 19.27, width: 35.6, height: 60.97 } },
    "Samsung Galaxy S26 Ultra": { slug: "samsung-galaxy-s26-ultra", ext: "png", aspect: "2500 / 2500", supplierPrintSize: { width: 870, height: 1856 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s26-ultra-mask.svg?v=2"), supplierOutputBounds: { x: 815, y: 322, width: 870, height: 1856 }, supplierUseSvgContentMask: true, supplierClipBleedOutput: false, backgroundSafeArea: { left: 32.6, top: 12.88, width: 34.8, height: 74.24 }, safeArea: { left: 13.76, top: 0, width: 72.48, height: 100 } },
    "Samsung Galaxy S26 Plus": { slug: "samsung-galaxy-s26-plus", ext: "png", aspect: "2500 / 2500", supplierPrintSize: { width: 850, height: 1806 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s26-plus-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, backgroundSafeArea: { left: 32.96, top: 13.84, width: 34, height: 72.24 }, safeArea: { left: 32.96, top: 13.84, width: 34, height: 72.24 } },
    "Samsung Galaxy S26": { slug: "samsung-galaxy-s26", ext: "png", aspect: "2500 / 2500", supplierPrintSize: { width: 790, height: 1675 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s26-mask.svg?v=2"), supplierOutputBounds: { x: 855, y: 413, width: 790, height: 1675 }, supplierUseSvgContentMask: true, supplierClipBleedOutput: false, backgroundSafeArea: { left: 34.2, top: 16.52, width: 31.6, height: 67 }, safeArea: { left: 13.68, top: 0, width: 72.64, height: 100 } },
    "Samsung Galaxy S25 Ultra": { slug: "samsung-galaxy-s25-ultra-fit", ext: "png", aspect: "883 / 1787", screenScale: 0.82, supplierPrintSize: { width: 835, height: 1744 }, supplierBleedX: 32, supplierBleedY: 90, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-ultra-fit-mask.svg?v=2"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-ultra-fit-mask.svg?v=2"), supplierOutputBounds: { x: 24, y: 22, width: 835, height: 1744, viewBox: { x: 0, y: 0, width: 883, height: 1787 } }, supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 0, top: 0, width: 100, height: 100 } },
    "Samsung Galaxy S25 Plus": { slug: "samsung-galaxy-s25-plus-fit", ext: "png", aspect: "867 / 1739", screenScale: 0.82, supplierPrintSize: { width: 815, height: 1696 }, supplierBleedX: 32, supplierBleedY: 90, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-plus-fit-mask.svg?v=2"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-plus-fit-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 0, top: 0, width: 100, height: 100 } },
    "Samsung Galaxy S25": { slug: "samsung-galaxy-s25-fit", ext: "png", aspect: "867 / 1739", screenScale: 0.82, supplierPrintSize: { width: 815, height: 1696 }, supplierBleedX: 32, supplierBleedY: 90, supplierPrintMaskSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-fit-mask.svg?v=2"), supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s25-fit-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 0, top: 0, width: 100, height: 100 } },
    "Samsung Galaxy S24 Ultra": { slug: "samsung-galaxy-s24-ultra", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 918, height: 2035 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s24-ultra-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.92, top: 15.97, width: 36.72, height: 67.83 } },
    "Samsung Galaxy S24 Plus": { slug: "samsung-galaxy-s24-plus", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 924, height: 1972 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s24-plus-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.68, top: 16.43, width: 36.96, height: 65.73 } },
    "Samsung Galaxy S24": { slug: "samsung-galaxy-s24", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 863, height: 1830 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s24-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.76, top: 18.07, width: 34.52, height: 61.0 } },
    "Samsung Galaxy S23 Ultra 5G": { slug: "samsung-galaxy-s23-ultra-5g", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 913, height: 2018 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s23-ultra-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.88, top: 16.37, width: 36.52, height: 67.27 } },
    "Samsung Galaxy S23 Plus 5G": { slug: "samsung-galaxy-s23-plus-5g", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 903, height: 1942 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s23-plus-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.0, top: 17.67, width: 36.12, height: 64.73 } },
    "Samsung Galaxy S23 5G": { slug: "samsung-galaxy-s23-5g", ext: "png", src: window.StrayzyAsset("./assets/Samsung-Galaxy-S23-5G.png?v=2"), maskSrc: window.StrayzyAsset("./assets/samsung-galaxy-s23-5g-mask.svg?v=2"), aspect: "2500 / 3000", supplierPrintSize: { width: 903, height: 1942 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/samsung-galaxy-s23-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.88, top: 16.37, width: 36.52, height: 67.27 } },
    "Samsung Galaxy S22 Ultra 5G": { slug: "samsung-galaxy-s22-ultra-5g", ext: "jpg", aspect: "2500 / 3000", supplierPrintSize: { width: 925, height: 2060 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s22-ultra-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 31.48, top: 16.07, width: 37.0, height: 68.67 } },
    "Samsung Galaxy S22 Plus 5G": { slug: "samsung-galaxy-s22-plus-5g", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 894, height: 1925 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s22-plus-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 32.32, top: 18.03, width: 35.76, height: 64.17 } },
    "Samsung Galaxy S22 5G": { slug: "samsung-galaxy-s22-5g", ext: "png", aspect: "2500 / 3000", supplierPrintSize: { width: 834, height: 1783 }, supplierBleedX: 32, supplierBleedY: 90, supplierOutputBoundsSrc: window.StrayzyAsset("./assets/phone-models/samsung-galaxy-s22-5g-mask.svg?v=2"), supplierUseSvgContentMask: true, supplierClipBleedOutput: false, safeArea: { left: 33.36, top: 20.27, width: 33.36, height: 59.43 } },
  };

  Object.entries(UPDATED_PHONE_MODEL_ASSETS).forEach(([model, asset]) => {
    const assetVersion = asset.version || 2;
    const maskSrc = asset.maskSrc || window.StrayzyAsset(`./assets/phone-models/${asset.slug}-mask.svg?v=${assetVersion}`);
    const backgroundMaskSrc = asset.backgroundMask
      ? window.StrayzyAsset(`./assets/phone-models/${asset.slug}-background-mask.svg?v=${assetVersion}`)
      : "";
    const printMaskSrc = asset.printMask
      ? window.StrayzyAsset(`./assets/phone-models/${asset.slug}-print-mask.svg?v=${assetVersion}`)
      : "";
    const printItemMaskSrc = asset.printItemMask
      ? window.StrayzyAsset(`./assets/phone-models/${asset.slug}-print-item-mask.svg?v=${assetVersion}`)
      : "";
    MODEL_IMAGES[model] = {
      src: asset.src || window.StrayzyAsset(`./assets/phone-models/${asset.slug}.${asset.ext}?v=${assetVersion}`),
      aspect: asset.aspect,
      displayWidth: 520,
      screenScale: asset.screenScale || 1,
      stickerBounds: { left: 0, top: 0, width: 100, height: 100 },
      safeArea: asset.safeArea,
      backgroundSafeArea: asset.backgroundSafeArea || null,
      maskSrc,
      backgroundMaskSrc,
      printMaskSrc,
      printItemMaskSrc,
      supplierPrintSize: asset.supplierPrintSize || null,
      supplierBleedMm: asset.supplierBleedMm || 0,
      supplierPrintDpi: asset.supplierPrintDpi || 0,
      supplierPrintCalibration: asset.supplierPrintCalibration || null,
      supplierBleedX: Number.isFinite(asset.supplierBleedX) ? asset.supplierBleedX : Number.isFinite(asset.supplierBleedPx) ? asset.supplierBleedPx : 0,
      supplierBleedY: Number.isFinite(asset.supplierBleedY) ? asset.supplierBleedY : Number.isFinite(asset.supplierBleedPx) ? asset.supplierBleedPx : 0,
      supplierPrintMaskSrc: asset.supplierPrintMaskSrc || "",
      supplierPrintItemMaskSrc: asset.supplierPrintItemMaskSrc || "",
      supplierOutputBoundsSrc: asset.supplierOutputBoundsSrc || "",
      supplierOutputBounds: asset.supplierOutputBounds || null,
      supplierOutputFromPreviewMask: Boolean(asset.supplierOutputFromPreviewMask),
      supplierFitOutputBoundsToCanvas: Boolean(asset.supplierFitOutputBoundsToCanvas),
      supplierClipBleedOutput: asset.supplierClipBleedOutput !== false,
      supplierApplyMask: asset.supplierApplyMask !== false,
      supplierUseColorMask: Boolean(asset.supplierUseColorMask),
      supplierUseSvgContentMask: Boolean(asset.supplierUseSvgContentMask),
      supplierFitMaskContent: Boolean(asset.supplierFitMaskContent),
      supplierPrintMaskContentBounds: asset.supplierPrintMaskContentBounds || null,
      preferSvgPreviewMask: asset.previewMask !== false,
      fillPrintMaskHoles: Boolean(asset.fillPrintMaskHoles),
      printMaskViewBox: Boolean(asset.printMaskViewBox),
      fitPrintDesignToMaskBounds: Boolean(asset.fitPrintDesignToMaskBounds),
      clipPath: MODEL_PHOTO_CLIP_PATHS[model] || "",
      safeAreaVersion: 66,
    };
    MODEL_PHOTO_MASKS[model] = maskSrc;
    MODEL_PHOTO_SAFE_AREAS[model] = asset.safeArea;
    MODEL_PHOTO_CLIP_PATHS[model] = MODEL_PHOTO_CLIP_PATHS[model] || "";
  });

  const MODEL_PHOTO_SAFE_AREA_VERSION = 66;
  const FORCE_STANDARD_MODEL_PHOTOS = new Set([
    "iPhone 17",
    "iPhone 16 Pro Max",
    "iPhone 16 Pro",
    "iPhone 16 Plus",
    "iPhone 16",
    "iPhone 15 Pro Max",
    "iPhone 15 Pro",
    "iPhone 15 Plus",
    "iPhone 15",
    "iPhone 14 Pro Max",
    "iPhone 14 Pro",
    "iPhone 14 Plus",
    "iPhone 14",
    "iPhone 13 Pro Max",
    "iPhone 13 Pro",
    "iPhone 13 Mini",
    "iPhone 13",
    "iPhone 12 Pro Max",
    "iPhone 12 Pro",
    "iPhone 12 Mini",
    "iPhone 12",
    "iPhone 11 Pro Max",
    "iPhone 11 Pro",
    "iPhone 11",
    "Samsung Galaxy S22 5G",
    "Samsung Galaxy S22 Plus 5G",
    "Samsung Galaxy S22 Ultra 5G",
    "Samsung Galaxy S23 5G",
    "Samsung Galaxy S23 Plus 5G",
    "Samsung Galaxy S23 Ultra 5G",
    "Samsung Galaxy S24",
    "Samsung Galaxy S24 Plus",
    "Samsung Galaxy S24 Ultra",
    "Samsung Galaxy S25",
    "Samsung Galaxy S25 Plus",
    "Samsung Galaxy S25 Ultra",
    "Samsung Galaxy S26",
    "Samsung Galaxy S26 Plus",
    "Samsung Galaxy S26 Ultra",
  ]);

  function phoneDimensions(name) {
    const exact = {
      "iPhone 17 Pro Max": [78.0, 163.4],
      "iPhone 17 Pro": [71.9, 150.0],
      "iPhone Air": [74.7, 156.2],
      "iPhone 17": [71.5, 149.6],
      "iPhone 16 Pro Max": [77.6, 163.0],
      "iPhone 16 Pro": [71.5, 149.6],
      "iPhone 16 Plus": [77.8, 160.9],
      "iPhone 16": [71.6, 147.6],
      "iPhone 15 Pro Max": [76.7, 159.9],
      "iPhone 15 Pro": [70.6, 146.6],
      "iPhone 15 Plus": [77.8, 160.9],
      "iPhone 15": [71.6, 147.6],
      "iPhone 14 Pro Max": [77.6, 160.7],
      "iPhone 14 Pro": [71.5, 147.5],
      "iPhone 14 Plus": [78.1, 160.8],
      "iPhone 14": [71.5, 146.7],
      "Samsung Galaxy S26 Ultra": [77.6, 162.8],
      "Samsung Galaxy S26 Plus": [75.8, 158.4],
      "Samsung Galaxy S26": [70.5, 146.9],
      "Samsung Galaxy S25 Ultra": [77.6, 162.8],
      "Samsung Galaxy S25 Plus": [75.8, 158.4],
      "Samsung Galaxy S25": [70.5, 146.9],
      "Samsung Galaxy S24 Ultra": [79.0, 162.3],
      "Samsung Galaxy S24 Plus": [75.9, 158.5],
      "Samsung Galaxy S24": [70.6, 147.0],
      "Samsung Galaxy S23 Ultra 5G": [78.1, 163.4],
      "Samsung Galaxy S23 Plus 5G": [76.2, 157.8],
      "Samsung Galaxy S23 5G": [70.9, 146.3],
      "Samsung Galaxy S22 Ultra 5G": [77.9, 163.3],
      "Samsung Galaxy S22 Plus 5G": [75.8, 157.4],
      "Samsung Galaxy S22 5G": [70.6, 146.0],
    };

    if (exact[name]) return { widthMm: exact[name][0], heightMm: exact[name][1] };
    if (/Pro Max|Max|Plus|Ultra/.test(name)) return { widthMm: 77.2, heightMm: 160.8 };
    if (/Mini/.test(name)) return { widthMm: 64.2, heightMm: 131.5 };
    if (/SE|iPhone 8$|iPhone 7$/.test(name)) return { widthMm: 67.3, heightMm: 138.4 };
    if (/Note/.test(name)) return { widthMm: 75.2, heightMm: 161.6 };
    return { widthMm: 71.5, heightMm: 147.5 };
  }

  class StickerCaseStudio {
    constructor(root) {
      this.root = root;
      this.brandName = root.dataset.brandName || "Sticker Studio";
      this.defaultModel = "iPhone 15 Pro";
      this.missingModelImages = new Set();
      this.items = [];
      this.selectedId = null;
      this.activeDrag = null;
      this.livePreviewEnabled = false;
      this.previewRefreshTimer = null;
      this.previewRefreshToken = 0;
      this.previewRefreshInFlight = false;
      this.previewRefreshQueued = false;
      this.undoStack = [];
      this.redoStack = [];
      this.historySnapshotBeforeDrag = null;
      this.activeStickerCategory = "All";
      this.activeStickerSubcategory = "All";
      this.stickerSearch = "";
      this.stickerView = "browse";
      this.activeToolPanel = "stickers";
      this.activeCollageTemplateId = "";
      this.pendingTemplateSlotId = "";
      this.pendingReplacePhotoId = "";
      this.pendingTemplateApply = null;
      this.textDraft = "Tavo tekstas";
      this.textFont = TEXT_FONTS[0].value;
      this.textColor = "#111111";
      this.textEffect = "none";
      this.textBold = true;
      this.textItalic = false;
      this.textUnderline = false;
      this.textAlign = "center";
      this.aiPhotoPrompt = AI_PHOTO_PRESETS[0]?.prompt || "";
      this.caseBackground = {
        type: "none",
        color: "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
      };
      this.backgroundImageCache = new Map();
      this.backgroundCategory = "All";
      this.backgroundSearch = "";
      this.backgroundVisibleCount = 60;
      this.favoriteStickerIds = loadFavorites();
      this.customStickers = loadCustomStickers();
      this.customBackgroundPatterns = loadBackgroundPatterns();
      this.customModelPhotos = loadModelPhotos();
      this.model = document.querySelector("[data-sticker-case-model]")?.value || this.defaultModel;
      this.fields = {
        model: document.querySelector("[data-sticker-case-model]"),
        json: document.querySelector("[data-sticker-case-json]"),
        preview: document.querySelector("[data-sticker-case-preview]"),
        print: document.querySelector("[data-sticker-case-print]"),
        printQuality: document.querySelector("[data-sticker-case-print-quality]"),
        designId: document.querySelector("[data-sticker-case-design-id]"),
        finishedAt: document.querySelector("[data-sticker-case-finished-at]"),
      };

      this.render();
      this.bindExternalOpenButton();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.updateHistoryButtons();
    }

    get stickers() {
      return [...Y2K_STICKERS, ...this.customStickers];
    }

    get backgroundPatterns() {
      return [...BUILT_IN_BACKGROUND_PATTERNS, ...this.customBackgroundPatterns];
    }

    render() {
      this.root.innerHTML = `
        <svg class="studio-clip-defs" aria-hidden="true" focusable="false">
          <defs>
            <clipPath id="iphone17-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M6626.07 8942.21c59.94,-65.49 288.21,-77.52 297.27,-657.89 4.91,-314 -1.26,-633.52 -1.25,-948.26l-8.65 -5694.17c-20.99,-16.9 -31.47,-108.72 -46.34,-148.95 -147.18,-398.33 -563.99,-379.98 -957.09,-375.44 -254.74,2.94 -507.28,2.51 -762,1.14 -65.2,-0.35 -635.72,-7.1 -698.38,12.76 -35.21,11.16 -8.69,-3.31 -31.13,15.52 -5.91,75.91 35.39,90.26 69.16,126.87 26.8,29.06 52.51,67.76 78.85,115.63 54.71,99.42 60.34,174.75 91.5,288.65 30.1,110.05 180.9,68.05 292.12,98.2 268.1,72.69 448.83,436.93 258.28,743.05 -50.67,81.4 -111.45,136.36 -211,178.82 -56.26,23.99 -167.01,39.02 -239.16,46.92 -16.51,1.81 -32.2,2.79 -45.42,5.4 -8.64,1.7 -12.51,3.09 -20.41,5.42 -1.61,0.48 -5.48,4.46 -6.64,2.47 -14.04,-24.23 -61.87,215.02 -71.22,241.12 -134.25,374.42 -580.26,597.72 -963.72,465.27 -73.13,-25.26 -130.96,-54.66 -201.18,-102.78 -34.67,-23.76 -129.48,-103.25 -156.9,-106.31 -60.73,-6.77 49.17,-3.01 -13.91,0.85l-14.09 4.06c-51.51,44.42 -21.53,459.56 -19.24,553.65 4.71,193.16 1.5,390.31 2.12,583.91 3.71,1158.63 -6.15,2313.08 -6.89,3471.34 -0.23,356.42 -30.4,763.64 179.55,982.65 203.72,212.5 626.46,200 968.98,184.11 522.27,-24.23 1581.07,27.46 2003.39,-29.96 145.66,-19.8 149.42,-45.06 233.4,-64.05z"></path>
            </clipPath>
            <clipPath id="iphone17-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3225.36 3586.31c0,1003.53 14.34,2009.44 18.19,3012.98l11.19 1889.07c0.95,145.51 11.65,199.24 72.33,308.69 22.36,40.35 52.28,91.32 79.48,112.58 100.76,78.78 297.65,145.01 421.43,145.01l2512.99 0c86.45,0 183.72,-28 254.59,-55.31 85.62,-32.99 129.69,-71.6 175.96,-127.43 84.68,-102.16 154.98,-276.22 154.98,-451.92l0 -5226.86c0,-35.85 -12.87,-54.87 -38.06,-64.87 -34.62,-13.75 -48.5,16.51 -60.14,30.88 -15.29,18.89 -89.28,77.73 -109.12,91.61 -19.64,13.74 -43.02,27.05 -62.11,40.55 -55.97,39.57 -131.01,87.74 -204.98,87.74l-2658.3 0c-63.48,0 -132.93,-13.38 -190.67,-29.6 -65.92,-18.51 -224.77,-117.95 -259.11,-172.42 -16.96,-26.89 -27.36,-43.3 -71.57,-35.94 -32.47,5.4 -47.08,25.91 -47.08,60.6l0 384.64z"></path>
            </clipPath>
            <clipPath id="iphone17-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3225.36 3777.03c0,961.61 14.34,1925.5 18.19,2887.13l11.19 1810.15c0.95,139.44 11.65,190.92 72.33,295.8 22.36,38.66 52.28,87.5 79.48,107.88 100.76,75.48 297.65,138.95 421.43,138.95l2512.99 0c86.45,0 183.72,-26.83 254.59,-53 85.62,-31.61 129.69,-68.61 175.96,-122.1 84.68,-97.9 154.98,-264.69 154.98,-433.05l0 -5008.52c0,-34.36 -12.87,-52.58 -38.06,-62.17 -34.62,-13.17 -48.5,15.83 -60.14,29.6 -15.29,18.09 -89.28,74.48 -109.12,87.78 -19.64,13.16 -43.02,25.92 -62.11,38.85 -55.97,37.92 -131.01,84.08 -204.98,84.08l-2658.3 0c-63.48,0 -132.93,-12.83 -190.67,-28.36 -65.92,-17.74 -224.77,-113.03 -259.11,-165.22 -16.96,-25.77 -27.36,-41.5 -71.57,-34.44 -32.47,5.18 -47.08,24.83 -47.08,58.07l0 368.57z"></path>
            </clipPath>
            <clipPath id="iphone17-air-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M5660.17 9029.3c198.3,0.84 500.48,9.67 688.71,-18.57 230.17,-34.52 368.91,-79.48 467.51,-234.14 106.97,-167.8 100.33,-381.19 102.25,-605.14 14.44,-1680.18 1.6,-3344.56 4.49,-5020.73 1.23,-708.4 25.75,-660.71 -224.37,-511.35 -211.27,126.17 -490.61,112.53 -759.19,110.36l-1862.66 -5.7c-215.25,-0.04 -431.51,13.97 -611.15,-100.06 -116.1,-73.7 -234.98,-217.45 -231.32,83.41l2.42 973.67c0.03,1463.7 6.47,2932.84 -0.15,4394.2 -0.99,216.47 -14.56,457.06 78.05,634.94 67.6,129.84 183.33,224.04 355.34,263.05 308.01,69.86 850.82,32.24 1194.21,32.82l795.86 3.24z"></path>
            </clipPath>
            <clipPath id="samsung-ultra-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3803.41 4125.36c-152.97,0.01 -186.44,-22.85 -293.28,-83.59 -30.87,-17.55 -87.8,-62.52 -117.66,-70.75 -51.44,-14.18 -106.28,22.22 -122.75,54.23 -20.46,39.77 -10.86,298.55 -10.86,364.43l4.29 4484.84c-0.02,30.29 -3.5,59.73 8.93,84.88 35.67,72.19 130.58,73 205.45,72.87l3005.73 -0.02c58.97,0 339.25,7.13 370.01,-7.39 32.27,-15.24 66.67,-68.04 67.43,-120.35 0.9,-62.26 -0.08,-125.37 -0.08,-187.73l0 -7102.42c0,-119.65 6.49,-257.97 -0.24,-375.3 -2.7,-47.12 -41.05,-103.39 -63.25,-124.29 -37.26,-35.07 -91.68,-33.3 -155.19,-33.3l-1123.4 0c-51.26,0 -534.22,-5.49 -561.15,4.86 -33.71,12.95 -69.16,70.42 -58.83,123.03 6.29,32.06 48.28,58.85 82.66,103.7 27.73,36.19 48.64,71.45 72.82,115.17 70.93,128.24 57.17,155.14 57.17,318.29 0,248.69 0,497.37 0,746.05 0,123.77 13.14,234.88 -45.78,329.65 -33.53,53.93 -28.99,58.04 -79.09,108.95 -28.15,28.6 -64.45,57.34 -106.28,81.88 -30.25,17.73 -94.62,44.53 -133.06,55.25 -54.63,15.23 -116.03,12.59 -176.05,12.59 -202.73,0 -162.94,-30.76 -162.94,208.89 0,227.72 41.1,465.77 -124.87,626.14 -74.31,71.8 -101.93,113.74 -212.07,164.52 -94.77,43.7 -212.16,44.92 -327.66,44.92z"></path>
            </clipPath>
            <clipPath id="samsung-s-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3507.98 3950.55c-35.43,-24.84 -23.15,-18.91 -51.4,-46.45 -75.51,-73.63 -182.39,-39.27 -202.37,2.8 -12.2,25.69 -6.54,146.82 -6.54,184.84l3.72 3856.02c0,128.6 -1.76,258.44 0.31,386.88 1.04,64.96 0.22,130.53 0.22,195.56 0,143.31 -21.92,224.28 61.69,325.13 129.64,156.37 229.37,159.53 418.72,159.53 901.3,0 1802.59,0 2703.89,0 84.88,0 204.33,12.53 265.36,-28 18.76,-12.46 38.59,-26.6 53.93,-39.69 210.06,-179.34 165.37,-300.56 165.37,-608.28l0 -6572.66c0,-250.89 43.13,-443.56 -173.98,-595.69 -97.83,-68.56 -199.15,-54.77 -331.94,-54.77 -515.83,0 -1031.67,0 -1547.51,0 -66.27,0 -526.15,-6.56 -570.75,7.43 -33.17,10.41 -82.9,58.24 -71.34,120.11 7.44,39.8 57.31,90.49 77.78,117.94 28.95,38.83 48.52,70.53 71.3,119.92 29.28,63.5 29.62,87.69 29.61,166.02 -0.02,235.75 -11.44,127.42 210.76,175.9 75.78,16.54 186.83,85.16 221.66,165.59 15.06,34.76 11.3,137.03 9.58,181.6 -2.78,72 -12.46,100.93 -48.26,146.88 -57.6,73.92 -153.94,121.1 -257.48,129.45 -120.66,9.72 -135.41,-13.28 -136.33,54.92 -3.45,256.97 0.07,516.66 0.07,773.95 0,113.18 15.15,264.69 -28.85,357.87 -84.4,178.68 -215.58,314.81 -403.75,370.3 -170.46,50.26 -316.35,50.08 -463.47,-53.1z"></path>
            </clipPath>
            <clipPath id="iphone16-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M6225.58 9012.69c146.76,0 216.23,5.9 336.58,-51 46.38,-21.93 88,-36.01 130.66,-62.58 107.63,-67.02 206.45,-201.98 244.5,-328.37 28.96,-96.23 17.54,-255.87 17.54,-365.05l0 -6489.76c0,-147.4 9.85,-212.12 -66.19,-317.09 -109.34,-150.93 -263.75,-298.11 -468.87,-298.82l-970.94 0.04c-43.8,0 -85.62,-8.36 -111.07,30.69 -7.84,12.03 -9.29,26.33 -4.91,41.53 5.29,18.36 32.64,42.6 43.77,54.1 15.63,16.16 29.69,34.44 45.4,48.78l47.72 50.62c13.05,16.42 27.67,34.3 40.63,53.5 26.92,39.88 118.41,213.24 129.99,254.27 16.34,57.95 6.95,297.94 6.95,375.43l0 764.51c0,141.37 14.25,220.26 -49.72,333.36 -85.47,151.12 -226.44,304.46 -390.03,376.24 -97.3,42.7 -203.07,63.48 -324.01,63.39l-776.72 -0.01c-105.76,0 -277.25,8.52 -371.82,-16.16 -116.43,-30.38 -183.63,-63.32 -264.34,-122.18 -19.45,-14.19 -40.2,-28.25 -54.45,-44.04 -15.35,-17.01 -32.14,-28.13 -45.85,-48.33 -22.22,-32.72 -62.17,-90.76 -110.63,-76.47 -57.05,16.83 -41.84,92.29 -41.84,150.04 0,1202.76 17.55,2405.26 17.24,3605.9 -0.01,50.24 3.37,1448.49 11.3,1514.59 23.16,192.93 166.23,348.85 325.31,443.41 99.81,59.33 195.63,59.46 327.95,59.46l2325.85 0z"></path>
            </clipPath>
            <clipPath id="iphone16-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M6945.31 1698.67c0,-341.5 -269.07,-618.54 -600.72,-618.54l-776.62 -18.39c-55.22,0 -245.45,-9.07 -245.45,47.82 -12.55,95.65 302.74,350.96 295.38,662.51l0 1233.55c-18.1,234.18 -289.19,486.61 -536.77,543.44l-1247.13 -4.48c-187.44,-15.34 -355.4,-96.72 -488.85,-296.61 -17.29,-42.54 -41.04,-98.8 -83.1,-87.07 -41.82,22.45 -42.74,332 -41.77,364.58l0 4881.19c0,341.51 269.07,618.55 600.71,618.55l2523.24 0c331.65,0 600.71,-277.04 600.71,-618.55l0 -6708 0.37 0z"></path>
            </clipPath>
            <clipPath id="iphone15-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M6572.56 8992.83c51.56,-17.68 88.84,-38.39 125.76,-66.15l99.36 -88.18c172.43,-189.33 162.96,-341.65 158.62,-586.6l-18.72 -1111.58c-8.31,-497.37 -3.37,-999.61 -3.37,-1498.23l0 -3768.94c0,-273.49 27.29,-343.18 -130.85,-528.16l-47.13 -46.48c-195.18,-162.85 -347.79,-168.12 -587.93,-168.12l-569.08 0c-70.12,0 -123.03,-12 -115.14,72.16 4.01,42.8 53.61,84.53 74.13,117.08 24.2,38.38 50.15,72.71 71.78,115.69 57.53,114.3 54.8,184.61 54.8,323.23l0 1128.98c0,120.25 9.63,238.59 -44,334.18 -32.8,58.46 -118.42,151.5 -167.58,211.59 -47.33,57.85 -139.02,129.35 -205.97,168.97 -183,108.28 -436.14,91.68 -669.27,91.68 -252.45,0 -504.9,-0.04 -757.35,0 -407.7,0.08 -392.86,-245.34 -533.28,-218.64 -43.09,8.2 -84.97,53.2 -97.9,93.41 -11.45,35.57 -6.36,136.91 -6.36,180.41l0 4520.18c0,118.14 -0.84,233.5 31.66,342.21 55.52,185.64 184.04,333.67 362.84,391.19 111.64,35.92 231.57,26.33 354.29,26.33l2276.33 0c113.9,0 242.31,-1.24 344.36,-36.21z"></path>
            </clipPath>
            <clipPath id="iphone15-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M6945.31 1698.67c0,-341.5 -269.07,-618.54 -600.72,-618.54l-776.62 -18.39c-55.22,0 -245.45,-9.07 -245.45,47.82 -12.55,95.65 302.74,350.96 295.38,662.51l0 1233.55c-18.1,234.18 -289.19,486.61 -536.77,543.44l-1247.13 -4.48c-187.44,-15.34 -355.4,-96.72 -488.85,-296.61 -17.29,-42.54 -41.04,-98.8 -83.1,-87.07 -41.82,22.45 -42.74,332 -41.77,364.58l0 4881.19c0,341.51 269.07,618.55 600.71,618.55l2523.24 0c331.65,0 600.71,-277.04 600.71,-618.55l0 -6708 0.37 0z"></path>
            </clipPath>
            <clipPath id="iphone15-plus-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone15-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone14-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone14-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone14-plus-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone14-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone13-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone13-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone13-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone13-mini-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone12-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone12-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone11-pro-max-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone11-pro-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3919.93 9042.37c759.22,0 1518.43,0 2277.65,0 117.7,0 249.09,12.1 353.61,-25.87 76.89,-27.94 182.36,-100.18 233.75,-145.17 54.08,-47.36 121.46,-134.62 146.79,-231.91 22.41,-86.05 12.27,-266.55 12.27,-365.71l0 -6616.34c0,-83.54 0.3,-89.87 -25.48,-161.44 -29.12,-80.8 -96.3,-190.9 -143.09,-235.51 -61.78,-58.91 -142.44,-98.27 -250.04,-129.16 -82.05,-23.56 -269.77,-13.22 -366.2,-13.22l-571.57 -0.05c-50.92,-0.24 -114.34,20.89 -100.47,84.98 11.47,53.01 38.62,86.14 65.52,124.01 28.89,40.66 48.92,63.52 73.72,113.64 61.42,124.07 85,159.86 84.95,293.19l0 1133.86c0,181.44 -11.79,306.64 -120.12,449.55 -87.51,115.45 -167.61,193.51 -297.15,268.76 -63.97,37.16 -197.28,85.53 -282.98,96.51 -106.08,13.58 -262.61,4.8 -374.59,4.8 -251.53,0 -504.49,3.46 -754.95,-4.45 -136.45,-4.31 -207.49,-3.58 -313.37,-65.83 -40.65,-23.89 -83.66,-45.81 -118.91,-72.56 -68.26,-51.78 -121.14,-116.61 -180.17,-76.25 -72.75,49.75 -52.93,67.65 -52.93,227.58 0,1131.13 9.05,2262.54 8.53,3393.11 -0.24,501.79 5.02,1005.03 4.26,1507.57 -0.12,81.82 11.75,87.34 44.58,146.84 67.87,123 158.8,207.68 298.73,267.24 24.67,10.51 45.91,22.04 74.58,24.43 29.28,2.45 59.48,3.8 89.47,5.63 59.25,3.63 123.17,1.77 183.61,1.77z"></path>
            </clipPath>
            <clipPath id="iphone12-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone12-mini-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone11-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3378.69 3054.45c-39.3,-41.44 -71.61,-60.25 -125.88,-34.06 -46.86,22.63 -60.54,58.01 -60.44,126.77l4.29 5262.08c0,176.73 29.3,302.17 139.82,425.39l94.66 92.33c200.61,143.86 351.14,119.84 632.62,119.84l2261.23 0c113.76,0.02 230.02,-13.5 315.48,-62.92 81.67,-47.22 140.7,-106.78 195.17,-178.75 136.62,-180.51 131.17,-235.86 131.17,-434.14l0 -6583.94c0,-171.81 14.65,-256.57 -79.22,-392.58 -34.53,-50.03 -39.46,-61.09 -80.09,-106.81 -17.34,-19.51 -25.61,-29.97 -46.89,-46.82 -206.07,-163.16 -370.71,-125.37 -626.89,-125.37 -100.36,0 -902.75,-4.35 -938.21,1.53 -49.19,8.14 -78.81,62.23 -63.7,121.74l66.44 123.73c22.15,39.09 41.94,82.76 62.73,124.19 31.62,63 26.91,88.38 26.9,164.37l0 565.31c0,121.86 4.79,253.57 -0.27,374.2 -5.81,138.59 -131.68,290.49 -235.61,375.95 -8.2,6.74 -16.33,12.41 -26.37,20.45 -271.48,217.47 -327.42,198.5 -647.34,198.5 -126.1,0 -252.19,0 -378.29,0 -156.76,0 -378.38,22.77 -511.76,-53.65 -25.87,-14.82 -88.79,-55.45 -109.55,-77.34z"></path>
            </clipPath>
            <clipPath id="iphone16-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3899.16 9001.24l2386.3 0c235.22,0 420.97,-38.26 561.29,-234.08 133.28,-186 98.02,-454.74 98.02,-696.89l0 -5964.21c0,-207.67 17.65,-522.21 -85.54,-709.56 -24.29,-44.1 -60.66,-81.9 -88.34,-111.42 -108.68,-115.91 -270.4,-156.09 -438.64,-156.78l-1790.79 0.03c-27.73,0 -159.1,-12.54 -143.03,51.01 2.05,8.12 35.64,46.96 43.39,57.17 57.89,76.21 125.96,254.74 149.78,347.52 10.15,39.56 17.81,132.43 38.08,157.56 31.48,39.05 109.33,28.77 164.36,35.09 139.46,16 181.12,33.82 281.48,118.62 72.86,61.57 117.38,156.24 145.19,250.3 22.11,74.8 22.2,91.12 7.89,171.8 -9.32,52.53 -28.96,104.77 -53.36,145.78 -32.79,55.09 -38.25,50.89 -64.78,84 -19.52,24.36 -31.74,28.5 -50.18,47.76 -17.83,18.62 -60.57,56.94 -81.5,67.16 -38.68,18.88 -117.39,30.12 -163.41,35.66 -96.04,11.58 -179.79,-16.55 -201.8,96.54 -5.83,29.94 -11.29,53.45 -12.57,85.41 -3.74,93.52 -69.04,224.55 -111.45,288.27 -15.47,23.24 -26.16,39.96 -42.16,59.87 -9.74,12.13 -15.01,20.38 -22.51,28.63 -100.09,110.11 -267.77,206.31 -406.81,235.09 -99.27,20.54 -267.94,22.96 -358.91,-10.64 -55.94,-20.66 -87.33,-42.28 -133.7,-66.31 -102.51,-53.12 -149.7,-95.92 -225.99,-173.47 -11.37,-11.56 -40.32,-39.94 -63.27,-16.59 -14.41,14.66 -9.12,64.05 -9.12,88.8l0 4769.66c0,131.96 -3.39,268.39 0.17,399.79 2.27,84.09 28.12,159.79 72.28,224.94 69.07,101.9 77.25,171.85 252.01,245.51 122.4,51.59 204.87,47.98 347.62,47.98z"></path>
            </clipPath>
            <clipPath id="iphone16-plus-print-clip" clipPathUnits="objectBoundingBox">
              <path transform="scale(0.0000984252)" clip-rule="evenodd" d="M3899.16 9001.24l2386.3 0c235.22,0 420.97,-38.26 561.29,-234.08 133.28,-186 98.02,-454.74 98.02,-696.89l0 -5964.21c0,-207.67 17.65,-522.21 -85.54,-709.56 -24.29,-44.1 -60.66,-81.9 -88.34,-111.42 -108.68,-115.91 -270.4,-156.09 -438.64,-156.78l-1790.79 0.03c-27.73,0 -159.1,-12.54 -143.03,51.01 2.05,8.12 35.64,46.96 43.39,57.17 57.89,76.21 125.96,254.74 149.78,347.52 10.15,39.56 17.81,132.43 38.08,157.56 31.48,39.05 109.33,28.77 164.36,35.09 139.46,16 181.12,33.82 281.48,118.62 72.86,61.57 117.38,156.24 145.19,250.3 22.11,74.8 22.2,91.12 7.89,171.8 -9.32,52.53 -28.96,104.77 -53.36,145.78 -32.79,55.09 -38.25,50.89 -64.78,84 -19.52,24.36 -31.74,28.5 -50.18,47.76 -17.83,18.62 -60.57,56.94 -81.5,67.16 -38.68,18.88 -117.39,30.12 -163.41,35.66 -96.04,11.58 -179.79,-16.55 -201.8,96.54 -5.83,29.94 -11.29,53.45 -12.57,85.41 -3.74,93.52 -69.04,224.55 -111.45,288.27 -15.47,23.24 -26.16,39.96 -42.16,59.87 -9.74,12.13 -15.01,20.38 -22.51,28.63 -100.09,110.11 -267.77,206.31 -406.81,235.09 -99.27,20.54 -267.94,22.96 -358.91,-10.64 -55.94,-20.66 -87.33,-42.28 -133.7,-66.31 -102.51,-53.12 -149.7,-95.92 -225.99,-173.47 -11.37,-11.56 -40.32,-39.94 -63.27,-16.59 -14.41,14.66 -9.12,64.05 -9.12,88.8l0 4769.66c0,131.96 -3.39,268.39 0.17,399.79 2.27,84.09 28.12,159.79 72.28,224.94 69.07,101.9 77.25,171.85 252.01,245.51 122.4,51.59 204.87,47.98 347.62,47.98z"></path>
            </clipPath>
          </defs>
        </svg>
        <section class="sticker-studio" aria-label="Dėkliuko dizaino studija">
          <aside class="studio-layers">
            <div class="studio-panel layers-panel">
              <div class="panel-heading">
                <h2>Sluoksniai</h2>
                <span data-layer-count>0</span>
              </div>
              <div class="layer-list" data-layer-list></div>
            </div>
          </aside>

          <div class="studio-preview">
            <header class="studio-topbar">
              <div class="studio-title">
                <strong>${escapeHtml(this.brandName)} dėklio studija</strong>
                <span data-current-model></span>
              </div>
              <div class="topbar-actions">
                <button class="history-button" type="button" data-undo title="Atgal" aria-label="Atgal" disabled>&#8630;</button>
                <button class="history-button" type="button" data-redo title="Pirmyn" aria-label="Pirmyn" disabled>&#8631;</button>
                <button class="studio-button is-quiet is-compact" type="button" data-save-draft>Išsaugoti dizainą</button>
                <button class="studio-button is-quiet is-compact" type="button" data-load-draft>Tęsti vėliau</button>
                <button class="studio-button is-quiet" type="button" data-reset>Valyti</button>
              </div>
            </header>

            <div class="studio-canvas-wrap">
              <div class="phone-stage" data-stage>
                <div class="phone-case" data-phone-case>
                  <img class="model-photo" data-model-photo alt="" />
                  <div class="case-background-layer" data-case-background-layer></div>
                  <div class="sticker-layer sticker-art-layer" data-art-layer></div>
                  <div class="sticker-layer sticker-control-layer" data-layer></div>
                  <div class="snap-guide-layer" data-snap-guides aria-hidden="true"></div>
                  <div class="camera-layer" data-camera-layer></div>
                </div>
              </div>
            </div>

            <footer class="studio-footer">
              <span class="studio-status" data-status>Pasirink lipduką, tekstą arba foną ir kurk tiesiai ant dėklio.</span>
              <span class="print-quality-warning" data-print-quality-warning aria-live="polite" hidden></span>
              <button class="studio-button is-primary" type="button" data-save>Įdėti į krepšelį</button>
            </footer>
          </div>

          <aside class="studio-sidebar">
            <div class="sidebar-sticky-tools">
              <label class="sidebar-model-field">
                <span>Telefono modelis</span>
                <select class="model-select sidebar-model-select" data-model-select aria-label="Telefono modelis">
                  ${this.modelOptionsHtml()}
                </select>
              </label>
              <nav class="tool-tabs" aria-label="Dizaino įrankiai">
                <button class="tool-tab" type="button" data-tool-tab="design">Dizainas</button>
                <button class="tool-tab" type="button" data-tool-tab="templates">Šablonai</button>
                <button class="tool-tab is-active" type="button" data-tool-tab="stickers">Lipdukai</button>
                <button class="tool-tab" type="button" data-tool-tab="photo">Nuotrauka</button>
                <button class="tool-tab" type="button" data-tool-tab="edit">Koreguoti</button>
                <button class="tool-tab" type="button" data-tool-tab="export">Failai</button>
              </nav>
            </div>

            <div class="tool-panel-group" data-tool-panel="design">
            <div class="studio-panel background-panel">
              <h2>Fonas</h2>
              <div class="background-choice-row" role="group" aria-label="Dėkliuko fonas">
                <button class="background-choice is-active" type="button" data-case-bg-mode="none">Skaidrus</button>
                <button class="background-choice" type="button" data-case-bg-mode="color">Spalva</button>
                <button class="background-choice" type="button" data-case-bg-mode="pattern">Paveikslėlis</button>
              </div>
              <label class="color-field">
                <span>Spalva</span>
                <input type="color" value="${escapeHtml(this.caseBackground.color)}" data-case-bg-color />
              </label>
              <div class="swatch-row" aria-label="Greitos fono spalvos">
                ${["#ffffff", "#f7d7e8", "#d8ecff", "#dff7ea", "#fff0bd", "#111111"].map((color) => `
                  <button type="button" data-bg-swatch="${color}" style="--swatch:${color}" aria-label="${color}"></button>
                `).join("")}
              </div>
              <label class="range-field background-scale-field">
                <span>Fono dydis <strong data-bg-scale-value>${Math.round(this.caseBackground.patternScale || 100)}%</strong></span>
                <input type="range" min="10" max="350" step="1" value="${escapeHtml(this.caseBackground.patternScale || 100)}" data-bg-scale />
              </label>
              <button class="studio-button" type="button" data-bg-resize-toggle aria-pressed="false">Keisti dydį ant dėkliuko</button>
              <p class="background-resize-hint">Šonai keičia plotį, viršus ir apačia – aukštį. Kampai keičia dydį proporcingai.</p>
              <div class="background-library-filters">
                <label>Kategorija<select data-bg-category aria-label="Fono kategorija"></select></label>
                <label>Paieška<input type="search" data-bg-search placeholder="Ieškoti fonų: flowers, cherries…" /></label>
              </div>
              <p class="background-result-count" data-bg-result-count aria-live="polite"></p>
              <div class="pattern-grid" data-pattern-grid></div>
              <button class="studio-button background-load-more" type="button" data-bg-load-more hidden>Rodyti daugiau</button>
            </div>

            <div class="studio-panel text-panel">
              <h2>Tekstas</h2>
              <textarea class="text-input" rows="3" data-text-content placeholder="Įvesk tekstą">${escapeHtml(this.textDraft)}</textarea>
              <div class="text-preset-grid" aria-label="Teksto stiliai">
                ${this.textPresetHtml()}
              </div>
              <select class="font-select" data-text-font style="font-family:${safeTextFont(this.textFont)}">
                ${this.textFontOptionsHtml()}
              </select>
              <div class="effect-preview-grid" data-effect-preview-grid>
                ${this.textEffectPreviewHtml()}
              </div>
              <div class="text-format-row" aria-label="Teksto formatavimas">
                <button class="format-button is-active" type="button" data-text-toggle="bold" title="Paryškinti" aria-label="Paryškinti">B</button>
                <button class="format-button" type="button" data-text-toggle="italic" title="Pakreipti" aria-label="Pakreipti">I</button>
                <button class="format-button" type="button" data-text-toggle="underline" title="Pabraukti" aria-label="Pabraukti">U</button>
                <button class="format-button align-icon is-left" type="button" data-text-align="left" title="Kairėje" aria-label="Kairėje"><span></span></button>
                <button class="format-button align-icon is-center is-active" type="button" data-text-align="center" title="Centruoti" aria-label="Centruoti"><span></span></button>
                <button class="format-button align-icon is-right" type="button" data-text-align="right" title="Dešinėje" aria-label="Dešinėje"><span></span></button>
              </div>
              <div class="text-tools-row">
                <label class="color-field">
                  <span>Spalva</span>
                  <input type="color" value="${escapeHtml(this.textColor)}" data-text-color />
                </label>
                <button class="studio-button is-primary" type="button" data-add-text>Pridėti</button>
              </div>
              <div class="swatch-row" aria-label="Greitos teksto spalvos">
                ${["#111111", "#ffffff", "#ff477e", "#116bff", "#08a66d", "#ffb000"].map((color) => `
                  <button type="button" data-text-swatch="${color}" style="--swatch:${color}" aria-label="${color}"></button>
                `).join("")}
              </div>
            </div>
            </div>

            <div class="tool-panel-group" data-tool-panel="templates">
            <div class="studio-panel collage-template-panel">
              <div class="template-section-head">
                <div>
                  <h2>Pasirink išdėstymą</h2>
                  <p>Pasirink nuotraukų gridą savo dėkliui.</p>
                </div>
              </div>
              <div class="collage-template-grid" data-collage-template-grid>
                ${this.collageTemplateHtml()}
              </div>
            </div>
            <div class="studio-panel template-slot-panel">
              <div class="template-section-head">
                <div>
                  <h2>Nuotraukos rėmeliuose</h2>
                  <p>Įkelk, keisk ir priartink kiekvieną nuotrauką.</p>
                </div>
              </div>
              <div class="template-color-variants" data-template-color-variants></div>
              <div class="template-slot-list" data-template-slot-list>
                <p class="template-empty">Pirma pasirink šabloną.</p>
              </div>
              <input type="file" accept="image/png,image/jpeg,image/webp" data-template-photo-upload hidden />
            </div>
            </div>

            <div class="tool-panel-group is-active" data-tool-panel="stickers">
            <div class="studio-panel sticker-library-panel">
              <div class="library-heading">
                <div>
                  <h2>Lipdukų biblioteka</h2>
                  <p>Pasirink, ieškok arba įkelk savo lipdukus</p>
                </div>
                <span data-sticker-count>0</span>
              </div>
              <div class="sticker-view-tabs">
                <button class="view-tab is-active" type="button" data-sticker-view="browse">Visi lipdukai</button>
                <button class="view-tab" type="button" data-sticker-view="favorites">Mėgstami</button>
                <button class="view-tab" type="button" data-sticker-view="mine">Mano įkelti</button>
              </div>
              <label class="sticker-search">
                <span>Paieška</span>
                <input type="search" placeholder="Ieškoti pagal pavadinimą ar raktažodį" data-sticker-search />
              </label>
              <div class="library-actions">
                <button class="browse-categories-button" type="button" data-open-categories>
                  <span>Kategorijos</span>
                  <small>Temos ir subkategorijos</small>
                </button>
                <button class="upload-library-button" type="button" data-trigger-upload>
                  <span>Įkelti PNG</span>
                  <small>Savo lipdukai</small>
                </button>
              </div>
              <div class="sticker-filter-bar">
                <span data-sticker-filter-summary>Rodomi visi lipdukai</span>
                <button type="button" data-clear-sticker-filter>Visi</button>
              </div>
              <div class="sticker-grid" data-sticker-grid></div>
              <input type="file" accept="image/svg+xml,image/png,image/jpeg,image/webp" multiple data-upload-stickers hidden />
              <button class="studio-button studio-clear-custom" type="button" data-clear-custom>
                Išvalyti įkeltus lipdukus
              </button>
            </div>
            </div>

            <div class="tool-panel-group" data-tool-panel="photo">
            <div class="studio-panel photo-print-panel">
              <div class="photo-print-hero">
                <span class="photo-print-icon" aria-hidden="true">+</span>
                <div>
                  <h2>Savo nuotrauka</h2>
                  <p>Įkelk nuotrauką ir pritaikyk ją ant dėkliuko. Naudokite aukštos raiškos nuotrauką geriausiai spaudos kokybei.</p>
                </div>
              </div>
              <div class="photo-upload-selected" data-photo-upload-selected></div>
              <button class="photo-upload-button" type="button" data-trigger-photo-upload>
                <span>Įkelti nuotrauką</span>
                <small>JPG, PNG arba WEBP</small>
              </button>
              <input type="file" accept="image/png,image/jpeg,image/webp" multiple data-upload-case-photo hidden />
              <div class="photo-print-tips">
                <span>Po įkėlimo galėsi:</span>
                <ul>
                  <li>didinti ir mažinti nuotrauką</li>
                  <li>pasukti arba apversti</li>
                  <li>keisti sluoksnių tvarką</li>
                  <li>derinti su lipdukais ir tekstu</li>
                </ul>
              </div>
            </div>
            </div>

            <div class="tool-panel-group" data-tool-panel="edit">
            <div class="studio-panel edit-panel">
              <h2>Koreguoti</h2>
              <div class="selected-summary" data-selected-summary>
                Pasirink elementą ant dėklio arba sluoksniuose.
              </div>
              <button class="studio-button" type="button" data-tool-tab="design">Teksto ir fono nustatymai</button>
              <div class="control-row">
                <label>Dydis <span data-size-value>72px</span></label>
                <input type="range" min="12" max="500" value="72" data-size />
              </div>
              <div class="control-row">
                <label>Sukimas <span data-rotation-value>0°</span></label>
                <input type="range" min="-180" max="180" value="0" data-rotation />
              </div>
              <div class="control-row">
                <label>Permatomumas <span data-opacity-value>100%</span></label>
                <input type="range" min="10" max="100" value="100" data-opacity />
              </div>
              <div class="control-row">
                <label>Apversti</label>
                <div class="flip-toggle" role="group" aria-label="Apversti elementą">
                  <button class="flip-choice" type="button" data-flip="x">Horizontaliai</button>
                  <button class="flip-choice" type="button" data-flip="y">Vertikaliai</button>
                </div>
              </div>
              <div class="control-row" data-outline-control>
                <label>Lipduko apvadas</label>
                <div class="outline-toggle" role="group" aria-label="Lipduko apvadas">
                  <button class="outline-choice is-active" type="button" data-sticker-outline="none">Be</button>
                  <button class="outline-choice" type="button" data-sticker-outline="white">Baltas</button>
                </div>
              </div>
              <div class="button-row control-row">
                <button class="studio-button" type="button" data-duplicate disabled>Kopijuoti</button>
                <button class="studio-button" type="button" data-delete disabled>Trinti</button>
              </div>
            </div>
            </div>

            <div class="tool-panel-group" data-tool-panel="export">
              <div class="final-preview-panel">
                <div class="final-status-card" data-final-status-card>
                  <span class="final-status-kicker">Galutinis patikrinimas</span>
                  <strong data-final-status-title>Paruošta spaudai</strong>
                  <p data-final-status-detail>Prieš užbaigiant atsisiųskite ir patikrinkite spaudos failą.</p>
                </div>
                <div class="final-summary-grid" data-final-summary aria-label="Dizaino santrauka"></div>
                <div class="studio-actions final-actions">
                  <div class="print-quality-warning" data-print-quality-export-warning aria-live="polite" hidden></div>
                  <button class="studio-button is-primary" type="button" data-print-export>Atsisiųsti spaudos failą</button>
                  <button class="studio-button is-primary" type="button" data-final-save>Įdėti į krepšelį</button>
                  <button class="studio-button" type="button" data-open-template-slots hidden>Užpildyti nuotraukas</button>
                  <a class="studio-button print-download-link" data-print-download hidden>Atsisiųsti failą</a>
                  <a class="studio-button print-download-link" data-print-open target="_blank" rel="noopener" hidden>Atidaryti PNG</a>
                </div>
              </div>
            </div>
          </aside>
        </section>
        <div class="category-modal" data-category-modal aria-hidden="true">
          <div class="category-dialog" role="dialog" aria-modal="true" aria-label="Lipdukų kategorijos">
            <div class="category-dialog-head">
              <strong>Kategorijos</strong>
              <button class="icon-button" type="button" data-close-categories aria-label="Uždaryti">x</button>
            </div>
            <div class="category-list" data-category-list></div>
          </div>
        </div>
        <div class="template-apply-modal" data-template-apply-modal aria-hidden="true">
          <div class="template-apply-dialog" role="dialog" aria-modal="true" aria-labelledby="template-apply-title" aria-describedby="template-apply-message">
            <h2 id="template-apply-title">Pakeisti dabartinį dizainą?</h2>
            <p id="template-apply-message">Pritaikius šį šabloną, dabartinis dizainas bus pakeistas. Šio veiksmo nebus galima atšaukti.</p>
            <div class="template-apply-actions">
              <button class="studio-button" type="button" data-template-apply-cancel>Atšaukti</button>
              <button class="studio-button is-primary" type="button" data-template-apply-confirm>Pakeisti dizainą</button>
            </div>
          </div>
        </div>
      `;

      this.ui = window.StrayzyStudioUI ? new window.StrayzyStudioUI(this) : null;
      this.nodes = {
        artLayer: this.root.querySelector("[data-art-layer]"),
        layer: this.root.querySelector("[data-layer]"),
        snapGuides: this.root.querySelector("[data-snap-guides]"),
        backgroundLayer: this.root.querySelector("[data-case-background-layer]"),
        phoneStage: this.root.querySelector("[data-stage]"),
        phoneCase: this.root.querySelector("[data-phone-case]"),
        modelPhoto: this.root.querySelector("[data-model-photo]"),
        cameraLayer: this.root.querySelector("[data-camera-layer]"),
        modelText: this.root.querySelector("[data-current-model]"),
        status: this.root.querySelector("[data-status]"),
        footer: this.root.querySelector(".studio-footer"),
        save: this.root.querySelector("[data-save]"),
        printQualityWarning: this.root.querySelector("[data-print-quality-warning]"),
        printQualityExportWarning: this.root.querySelector("[data-print-quality-export-warning]"),
        finalStatusCard: this.root.querySelector("[data-final-status-card]"),
        finalStatusTitle: this.root.querySelector("[data-final-status-title]"),
        finalStatusDetail: this.root.querySelector("[data-final-status-detail]"),
        finalSummary: this.root.querySelector("[data-final-summary]"),
        finalPreviewEmpty: this.root.querySelector("[data-final-preview-empty]"),
        openTemplateSlots: this.root.querySelector("[data-open-template-slots]"),
        modelSelect: this.root.querySelector("[data-model-select]"),
        topbarModelSelect: this.root.querySelector("[data-model-select-top]"),
        stickerGrid: this.root.querySelector("[data-sticker-grid]"),
        stickerSearch: this.root.querySelector("[data-sticker-search]"),
        stickerCount: this.root.querySelector("[data-sticker-count]"),
        stickerFilterSummary: this.root.querySelector("[data-sticker-filter-summary]"),
        categoryModal: this.root.querySelector("[data-category-modal]"),
        categoryList: this.root.querySelector("[data-category-list]"),
        templateApplyModal: this.root.querySelector("[data-template-apply-modal]"),
        upload: this.root.querySelector("[data-upload-stickers]"),
        uploadCasePhoto: this.root.querySelector("[data-upload-case-photo]"),
        templatePhotoUpload: this.root.querySelector("[data-template-photo-upload]"),
        templateSlotList: this.root.querySelector("[data-template-slot-list]"),
        templateColorVariants: this.root.querySelector("[data-template-color-variants]"),
        collageTemplateGrid: this.root.querySelector("[data-collage-template-grid]"),
        photoUploadSelected: this.root.querySelector("[data-photo-upload-selected]"),
        aiPhotoPrompt: this.root.querySelector("[data-ai-photo-prompt]"),
        uploadModelPhoto: this.root.querySelector("[data-upload-model-photo]"),
        size: this.root.querySelector("[data-size]"),
        sizeValue: this.root.querySelector("[data-size-value]"),
        rotation: this.root.querySelector("[data-rotation]"),
        rotationValue: this.root.querySelector("[data-rotation-value]"),
        opacity: this.root.querySelector("[data-opacity]"),
        opacityValue: this.root.querySelector("[data-opacity-value]"),
        flipButtons: this.root.querySelectorAll("[data-flip]"),
        outlineControl: this.root.querySelector("[data-outline-control]"),
        outlineButtons: this.root.querySelectorAll("[data-sticker-outline]"),
        backgroundModeButtons: this.root.querySelectorAll("[data-case-bg-mode]"),
        backgroundColor: this.root.querySelector("[data-case-bg-color]"),
        backgroundScale: this.root.querySelector("[data-bg-scale]"),
        backgroundScaleValue: this.root.querySelector("[data-bg-scale-value]"),
        uploadPatterns: this.root.querySelector("[data-upload-patterns]"),
        patternGrid: this.root.querySelector("[data-pattern-grid]"),
        backgroundCategory: this.root.querySelector("[data-bg-category]"),
        backgroundSearch: this.root.querySelector("[data-bg-search]"),
        backgroundResultCount: this.root.querySelector("[data-bg-result-count]"),
        backgroundLoadMore: this.root.querySelector("[data-bg-load-more]"),
        textContent: this.root.querySelector("[data-text-content]"),
        textFont: this.root.querySelector("[data-text-font]"),
        textColor: this.root.querySelector("[data-text-color]"),
        textFormatButtons: this.root.querySelectorAll("[data-text-toggle], [data-text-align]"),
        effectPreviewButtons: this.root.querySelectorAll("[data-text-effect-choice]"),
        duplicate: this.root.querySelector("[data-duplicate]"),
        delete: this.root.querySelector("[data-delete]"),
        output: this.root.querySelector("[data-output]"),
        printDownload: this.root.querySelector("[data-print-download]"),
        printOpen: this.root.querySelector("[data-print-open]"),
        undo: this.root.querySelector("[data-undo]"),
        redo: this.root.querySelector("[data-redo]"),
        saveDraft: this.root.querySelector("[data-save-draft]"),
        loadDraft: this.root.querySelector("[data-load-draft]"),
        layerList: this.root.querySelector("[data-layer-list]"),
        layerCount: this.root.querySelector("[data-layer-count]"),
        toolTabs: this.root.querySelectorAll("[data-tool-tab]"),
        toolPanels: this.root.querySelectorAll("[data-tool-panel]"),
        selectedSummary: this.root.querySelector("[data-selected-summary]"),
      };

      this.mobileFooterHome = {
        parent: this.nodes.footer?.parentNode || null,
        nextSibling: this.nodes.footer?.nextSibling || null,
      };
      this.syncMobileFooterPlacement();

      this.root.addEventListener("click", (event) => this.handleClick(event));
      this.nodes.save?.addEventListener("click", (event) => {
        if (this.root.contains(event.currentTarget)) return;
        event.preventDefault();
        if (!this.ensurePhotoTemplateReadyForExport()) return;
        this.saveDesign();
      });
      this.root.addEventListener("input", (event) => this.handleInput(event));
      this.root.addEventListener("change", (event) => {
        if (event.target.matches("[data-bg-scale]")) this.handleInput(event);
      });
      this.nodes.textFont.addEventListener("change", (event) => this.handleInput(event));
      this.nodes.textColor.addEventListener("change", (event) => this.handleInput(event));
      this.nodes.effectPreviewButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.setTextEffect(button.dataset.textEffectChoice);
        });
      });
      this.root.querySelectorAll("[data-text-align]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.setTextAlign(button.dataset.textAlign);
        });
      });
      this.root.querySelectorAll("[data-template]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.requestTemplateApply("design", button.dataset.template);
        });
      });
      this.nodes.modelSelect.addEventListener("change", () => this.setModel(this.nodes.modelSelect.value));
      this.nodes.topbarModelSelect?.addEventListener("change", () => this.setModel(this.nodes.topbarModelSelect.value));
      this.nodes.upload.addEventListener("change", (event) => this.uploadStickers(event));
      this.nodes.uploadCasePhoto?.addEventListener("change", (event) => this.uploadCasePhotos(event));
      this.nodes.templatePhotoUpload?.addEventListener("change", (event) => this.uploadTemplateSlotPhoto(event));
      this.nodes.uploadModelPhoto?.addEventListener("change", (event) => this.uploadModelPhoto(event));
      this.nodes.uploadPatterns?.addEventListener("change", (event) => this.uploadPatterns(event));
      this.nodes.backgroundCategory?.addEventListener("change", () => {
        this.backgroundCategory = this.nodes.backgroundCategory.value;
        this.backgroundVisibleCount = 60;
        this.renderPatternGrid();
        this.nodes.patternGrid.scrollTop = 0;
      });
      this.nodes.phoneCase.addEventListener("pointerdown", (event) => this.startBackgroundPan(event));
      // Track fingers before an object's drag handler can replace the gesture.
      this.touchPointers = new Map();
      const gestureSurface = this.root.querySelector('.studio-canvas-wrap');
      gestureSurface.style.touchAction = 'none';
      gestureSurface.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch') return;
        this.touchPointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
        if (this.touchPointers.size < 2) return;
        event.preventDefault();
        event.stopPropagation();
        const drag = this.activeDrag;
        if (this.touchPointers.size !== 2 || !drag || !['move','resize','rotate'].includes(drag.mode) || !this.selected || this.selected.locked || this.selected.type === 'photo-slot') return;
        const points = [...this.touchPointers.values()];
        if (this.ui?.textTap) this.ui.textTap.moved = true;
        this.activeDrag = {mode:'pinch',uid:this.selectedId,ids:[...this.touchPointers.keys()],
          distance:Math.max(1,Math.hypot(points[1].x-points[0].x,points[1].y-points[0].y)),itemSize:this.selected.size};
        gestureSurface.setPointerCapture(event.pointerId);
      }, true);
      window.addEventListener('pointermove', event => {
        if (this.touchPointers.has(event.pointerId)) this.touchPointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      }, true);
      const forgetTouch = event => this.touchPointers.delete(event.pointerId);
      window.addEventListener('pointerup', forgetTouch, true);
      window.addEventListener('pointercancel', forgetTouch, true);

      window.addEventListener("resize", () => {
        this.updateCaseBackground();
        this.syncMobileFooterPlacement();
      });
      this.renderCategoryTabs();
      this.renderStickerGrid();
      this.renderPatternGrid();
      this.renderViewTabs();
      this.renderToolPanels();
      this.renderTemplateTools();
      this.setModel(this.model);
      this.updateDraftButtons();
      if (hasSavedDesignDraft()) {
        this.nodes.status.textContent = "Yra išsaugotas dizainas. Spausk „Tęsti vėliau“, jei nori jį pratęsti.";
      }
    }

    syncMobileFooterPlacement() {
      if (this.ui) return;
      if (!this.nodes?.footer || !this.mobileFooterHome?.parent) return;
      const shouldUseMobileFooter = window.matchMedia("(max-width: 560px)").matches;
      if (shouldUseMobileFooter) {
        if (this.nodes.footer.parentNode !== document.body) {
          document.body.appendChild(this.nodes.footer);
        }
        this.nodes.footer.classList.add("is-mobile-floating");
        return;
      }

      if (this.nodes.footer.parentNode !== this.mobileFooterHome.parent) {
        this.mobileFooterHome.parent.insertBefore(this.nodes.footer, this.mobileFooterHome.nextSibling);
      }
      this.nodes.footer.classList.remove("is-mobile-floating");
    }

    modelOptionsHtml() {
      return MODEL_GROUPS.map((group) => {
        const options = group.models
          .map(([model]) => `<option ${model === this.model ? "selected" : ""}>${model}</option>`)
          .join("");
        return `<optgroup label="${group.label}">${options}</optgroup>`;
      }).join("");
    }

    textFontOptionsHtml() {
      return TEXT_FONTS.map((font) => {
        const selected = font.value === this.textFont ? "selected" : "";
        return `<option value="${escapeHtml(font.value)}" style="font-family:${font.value};" ${selected}>${escapeHtml(font.label)}</option>`;
      }).join("");
    }

    templateHtml() {
      return DESIGN_TEMPLATES.map((template) => `
        <button class="template-card" type="button" data-template="${escapeHtml(template.key)}" style="--template-accent:${escapeHtml(template.accent)}">
          <span class="template-mini">
            <i></i><i></i><i></i><i></i>
          </span>
          <span>
            <strong>${escapeHtml(template.label)}</strong>
            <small>${escapeHtml(template.tone)}</small>
          </span>
        </button>
      `).join("");
    }

    textPresetHtml() {
      return TEXT_PRESETS.map((preset) => {
        const effect = safeTextEffect(preset.effect);
        const color = safeTextColor(preset.color);
        const effectColor = textEffectColor(effect, color);
        return `
          <button class="text-preset" type="button" data-text-preset="${escapeHtml(preset.label)}">
            <span
              class="case-text text-effect-${escapeHtml(effect)}"
              style="--size:18px; --text-glow:${escapeHtml(effectColor)}; color:${escapeHtml(effectColor)}; font-family:${safeTextFont(preset.font)}; font-weight:${preset.bold ? 800 : 500}; font-style:${preset.italic ? "italic" : "normal"};"
            >${escapeHtml(preset.sample)}</span>
            <small>${escapeHtml(preset.label)}</small>
          </button>
        `;
      }).join("");
    }

    textEffectPreviewHtml() {
      return TEXT_EFFECTS.map((effect) => {
        const selected = effect.value === this.textEffect ? "is-active" : "";
        const sampleColor = textEffectColor(effect.value, this.textColor);
        return `
          <button class="effect-preview ${selected}" type="button" data-text-effect-choice="${escapeHtml(effect.value)}">
            <span class="case-text text-effect-${escapeHtml(effect.value)}" style="--size:18px; --text-glow:${escapeHtml(sampleColor)}; color:${escapeHtml(sampleColor)};">Aa</span>
            <small>${escapeHtml(effect.label)}</small>
          </button>
        `;
      }).join("");
    }

    aiPhotoPresetHtml() {
      return AI_PHOTO_PRESETS.map((preset) => `
        <button class="ai-preset-button ${this.aiPhotoPrompt === preset.prompt ? "is-active" : ""}" type="button" data-ai-photo-preset="${escapeHtml(preset.key)}">
          ${escapeHtml(preset.label)}
        </button>
      `).join("");
    }

    collageTemplateHtml() {
      return PHOTO_COLLAGE_TEMPLATES.map((template) => `
        <button class="collage-template-card ${this.activeCollageTemplateId === template.id ? "is-active" : ""}" type="button" data-collage-template="${escapeHtml(template.id)}">
          <span class="collage-template-preview" style="--template-bg:${escapeHtml(template.background?.color || "#ffffff")}">
            ${this.collageTemplatePreviewSlots(template)}
          </span>
          <span class="collage-template-copy">
            <strong>${escapeHtml(template.name)}</strong>
          </span>
        </button>
      `).join("");
    }

    collageTemplatePreviewSlots(template) {
      return (template.photoSlots || []).map((slot) => `
        <i
          class="preview-slot is-${escapeHtml(slot.shape || "rounded")} is-frame-${escapeHtml(safePhotoFrameStyle(slot.frameStyle))}"
          style="left:${slot.x}%; top:${slot.y}%; width:${slot.width}%; height:${slot.height}%; transform:translate(-50%, -50%) rotate(${slot.rotation || 0}deg); border-radius:${slot.shape === "circle" ? "50%" : `${slot.radius || 12}px`}; ${slot.clipPath ? `clip-path:${escapeAttribute(slot.clipPath)};` : ""}"
        ></i>
      `).join("");
    }

    renderTemplateTools() {
      if (this.nodes.collageTemplateGrid) this.nodes.collageTemplateGrid.innerHTML = this.collageTemplateHtml();
      if (!this.nodes.templateSlotList) return;
      const template = PHOTO_COLLAGE_TEMPLATES.find((item) => item.id === this.activeCollageTemplateId);
      if (!template) {
        this.nodes.templateSlotList.innerHTML = `<p class="template-empty">Pirma pasirink šabloną.</p>`;
        if (this.nodes.templateColorVariants) this.nodes.templateColorVariants.innerHTML = "";
        return;
      }
      const missingRequiredSlots = new Set(this.getMissingRequiredPhotoSlots(template).map((item) => item.uid));
      const slots = this.items.filter((item) => item.type === "photo-slot" && item.templateId === template.id);
      this.nodes.templateSlotList.innerHTML = slots.map((item, index) => `
        <div class="template-slot-row ${item.uid === this.selectedId ? "is-active" : ""} ${missingRequiredSlots.has(item.uid) ? "is-missing-required" : ""}">
          <button class="template-slot-main" type="button" data-select-layer="${escapeHtml(item.uid)}">
            <span class="template-slot-thumb">${this.itemMarkup(item, { preview: true })}</span>
            <span>
              <strong>${escapeHtml(item.name || `Nuotrauka ${index + 1}`)}</strong>
              <small>${item.imageSrc ? "Nuotrauka įkelta" : missingRequiredSlots.has(item.uid) ? "Privaloma nuotrauka" : "Laukiama nuotraukos"}</small>
            </span>
          </button>
          <div class="template-slot-actions">
            <button type="button" data-template-slot-upload="${escapeHtml(item.uid)}">${item.imageSrc ? "Keisti" : "Įkelti"}</button>
            <button type="button" data-template-slot-remove="${escapeHtml(item.uid)}" ${item.imageSrc ? "" : "disabled"}>X</button>
          </div>
          <label class="template-slot-zoom">
            <span>Priartinimas <b>${Math.round(item.imageZoom || 100)}%</b></span>
            <input type="range" min="100" max="300" value="${Math.round(item.imageZoom || 100)}" data-template-slot-zoom="${escapeHtml(item.uid)}">
          </label>
        </div>
      `).join("");
      if (this.nodes.templateColorVariants) {
        this.nodes.templateColorVariants.innerHTML = (template.colorVariants || []).map((color) => `
          <button class="${this.caseBackground.type === "color" && this.caseBackground.color?.toLowerCase() === color.toLowerCase() ? "is-active" : ""}" type="button" data-template-color="${escapeHtml(color)}" style="--template-color:${escapeHtml(color)}" aria-label="${escapeHtml(color)}"></button>
        `).join("");
      }
    }

    getFilteredStickers() {
      const baseStickers =
        this.activeStickerCategory === "All"
          ? this.stickers
          : this.stickers.filter((sticker) => stickerBelongsToCategory(sticker, this.activeStickerCategory));
      return uniqueStickersBySource(baseStickers.filter((sticker) => {
        if (sticker.duplicateOf) return false;
        if (this.stickerView === "favorites") return this.favoriteStickerIds.includes(sticker.id);
        if (this.stickerView === "mine") return sticker.category === "Custom";
        if (
          this.activeStickerSubcategory !== "All" &&
          !stickerBelongsToSubcategory(sticker, this.activeStickerCategory, this.activeStickerSubcategory)
        ) return false;
        if (this.stickerSearch && !stickerMatchesSearch(sticker, this.stickerSearch)) return false;
        return true;
      }));
    }

    renderStickerGrid() {
      const stickers = this.getFilteredStickers();

      const stickerTiles = (batch) => batch
        .map(
          (sticker) => `
            <button class="sticker-tile" type="button" title="${escapeHtml(sticker.name)}" data-sticker-name="${escapeHtml(sticker.name)}" data-add-sticker="${sticker.id}">
              <span
                class="favorite-toggle ${this.favoriteStickerIds.includes(sticker.id) ? "is-favorite" : ""}"
                data-toggle-favorite="${sticker.id}"
                aria-label="Mėgstamas"
              >${this.favoriteStickerIds.includes(sticker.id) ? "&#9733;" : "&#9734;"}</span>
              <span class="sticker-preview-frame">${stickerMarkup(sticker, { thumbnail: true })}</span>
            </button>
          `,
        )
        .join("");

      const emptyState = stickers.length
        ? ""
        : `<p class="empty-stickers">Lipdukų nerasta</p>`;

      if (this.nodes.stickerFilterSummary) {
        const parts = [];
        if (this.stickerView === "favorites") parts.push("Mėgstami");
        if (this.stickerView === "mine") parts.push("Mano įkelti");
        if (this.activeStickerCategory !== "All") parts.push(categoryLabel(this.activeStickerCategory));
        if (this.activeStickerSubcategory !== "All") parts.push(subcategoryLabel(this.activeStickerSubcategory));
        if (this.stickerSearch) parts.push(`Paieška: ${this.stickerSearch}`);
        this.nodes.stickerFilterSummary.textContent = parts.length
          ? `${stickers.length} lipd. | ${parts.join(" / ")}`
          : `${stickers.length} lipd. | Visi`;
      }
      if (this.nodes.stickerCount) this.nodes.stickerCount.textContent = String(stickers.length);

      // Build only a small batch of library previews. Thousands of eager image
      // elements otherwise compete with editing for network, decoding and layout.
      this.stickerGridObserver?.disconnect();
      const grid = this.nodes.stickerGrid;
      const mobileLibrary = window.matchMedia('(max-width: 1100px)').matches;
      const batchSize = mobileLibrary ? 40 : 60;
      let rendered = Math.min(batchSize, stickers.length);
      grid.innerHTML = `${stickerTiles(stickers.slice(0, rendered))}${emptyState}`;
      grid.scrollTop = 0;
      // Bound decoded-image memory on phones instead of accumulating every page.
      if (mobileLibrary && rendered < stickers.length) {
        let page = 0;
        const pageCount = Math.ceil(stickers.length / batchSize);
        const renderPage = () => {
          grid.innerHTML = stickerTiles(stickers.slice(page * batchSize, (page + 1) * batchSize));
          const pager = document.createElement('div');
          pager.className = 'sz-library-pager';
          const previous = document.createElement('button');
          previous.type = 'button';
          previous.textContent = 'Ankstesni';
          previous.disabled = page === 0;
          const status = document.createElement('span');
          status.setAttribute('role', 'status');
          status.textContent = `${page + 1} / ${pageCount}`;
          const next = document.createElement('button');
          next.type = 'button';
          next.textContent = 'Kiti lipdukai';
          next.disabled = page === pageCount - 1;
          previous.addEventListener('click', event => { event.stopPropagation(); page--; renderPage(); });
          next.addEventListener('click', event => { event.stopPropagation(); page++; renderPage(); });
          pager.append(previous, status, next);
          grid.append(pager);
          grid.scrollTop = 0;
        };
        renderPage();
        this.ui?.syncCategories();
        return;
      }
      if (rendered < stickers.length) {
        const more = document.createElement("button");
        more.type = "button";
        more.className = "sz-library-more";
        more.textContent = "Rodyti daugiau lipdukų";
        grid.append(more);
        const appendBatch = () => {
          if (!more.isConnected) return;
          const next = Math.min(rendered + batchSize, stickers.length);
          more.insertAdjacentHTML("beforebegin", stickerTiles(stickers.slice(rendered, next)));
          rendered = next;
          if (rendered >= stickers.length) {
            this.stickerGridObserver?.disconnect();
            more.remove();
          }
        };
        more.addEventListener("click", event => { event.stopPropagation(); appendBatch(); });
        // The button remains a keyboard-accessible fallback for automatic loading.
        if ("IntersectionObserver" in window) {
          this.stickerGridObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) appendBatch();
          }, { root: grid, rootMargin: "0px 0px 240px 0px" });
          this.stickerGridObserver.observe(more);
        }
      }
      this.ui?.syncCategories();
    }

    renderLayerList() {
      this.ui?.updateSelectionControls();
      const hasBackgroundLayer = this.hasCaseBackgroundLayer();
      this.nodes.layerCount.textContent = String(this.items.length + (hasBackgroundLayer ? 1 : 0));
      if (!this.items.length && !hasBackgroundLayer) {
        this.nodes.layerList.innerHTML = `<p class="empty-layers">Dar nėra lipdukų</p>`;
        return;
      }

      const itemLayersHtml = [...this.items]
        .map((item, index) => ({ item, index }))
        .reverse()
        .map(({ item, index }) => {
          const name = this.getItemLabel(item);
          const isSelected = item.uid === this.selectedId;
          const quality = this.getPrintQualityForItem(item);
          const qualityLine = quality.state === "warning"
            ? `<span class="layer-warning-line is-warning" title="${escapeAttribute(quality.message)}">Įkelta nuotrauka gali būti neryški</span>`
            : quality.state === "low-quality"
              ? `<span class="layer-warning-line is-low-quality" title="${escapeAttribute(quality.message)}">Įkelta nuotrauka per mažos raiškos</span>`
              : "";
          const qualityBadge = quality.state === "warning" || quality.state === "low-quality"
            ? `<span class="layer-quality-badge is-${escapeAttribute(quality.state)}" title="${escapeAttribute(quality.message)}" aria-label="${escapeAttribute(quality.message)}">!</span>`
            : "";
          const stateText = [
            item.hidden ? "Paslėptas" : "",
            item.locked ? "Užrakintas" : "",
          ].filter(Boolean);
          return `
            <div class="layer-item ${isSelected ? "is-selected" : ""} ${item.hidden ? "is-hidden" : ""} ${item.locked ? "is-locked" : ""}" data-layer-order="${index}">
              <button
                class="layer-main"
                type="button"
                data-select-layer="${item.uid}"
                title="${escapeHtml(name)}"
              >
                <span class="layer-thumb">${this.itemMarkup(item, { preview: true })}</span>
                <span class="layer-text">
                  <strong>${escapeHtml(name)}${qualityBadge}</strong>
                  <small>${Math.round(item.size)}px / ${Math.round(item.rotation)}°${stateText.length ? ` / ${stateText.join(" / ")}` : ""}</small>
                  ${qualityLine}
                </span>
              </button>
              <div class="layer-actions">
                <button class="layer-icon ${item.hidden ? "is-muted" : ""}" type="button" data-layer-hide="${item.uid}" title="${item.hidden ? "Rodyti" : "Slepti"}" aria-label="${item.hidden ? "Rodyti" : "Slepti"}">&#128065;</button>
                <button class="layer-icon lock-icon ${item.locked ? "is-active" : ""}" type="button" data-layer-lock="${item.uid}" title="${item.locked ? "Atrakinti" : "Užrakinti"}" aria-label="${item.locked ? "Atrakinti" : "Užrakinti"}">
                  ${
                    item.locked
                      ? `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>`
                      : `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 7.5-1.9"></path></svg>`
                  }
                </button>
                <button class="layer-icon layer-order-button" type="button" data-layer-up="${item.uid}" ${index === this.items.length - 1 ? "disabled" : ""} title="Perkelti aukščiau" aria-label="Perkelti aukščiau">&uarr;</button>
                <button class="layer-icon layer-order-button" type="button" data-layer-down="${item.uid}" ${index === 0 ? "disabled" : ""} title="Perkelti žemiau" aria-label="Perkelti žemiau">&darr;</button>
                <button class="layer-icon is-danger" type="button" data-layer-delete="${item.uid}" title="Trinti">x</button>
              </div>
            </div>
          `;
        })
        .join("");
      const backgroundLayerHtml = hasBackgroundLayer ? this.renderBackgroundLayerItem() : "";
      this.nodes.layerList.innerHTML = `${itemLayersHtml}${backgroundLayerHtml}`;
    }

    hasCaseBackgroundLayer() {
      return this.caseBackground?.type === "color" || (this.caseBackground?.type === "pattern" && Boolean(this.caseBackground.pattern));
    }

    renderBackgroundLayerItem() {
      const isPattern = this.caseBackground?.type === "pattern" && Boolean(this.caseBackground.pattern);
      const pattern = isPattern ? this.backgroundPatterns.find((item) => item.src === this.caseBackground.pattern) : null;
      const detail = isPattern ? "Raštas" : "Spalva";
      const thumb = isPattern
        ? `<img src="${escapeAttribute(pattern?.thumb || pattern?.src || this.caseBackground.pattern)}" alt="">`
        : `<span class="layer-background-swatch" style="--layer-bg:${escapeHtml(safeHexColor(this.caseBackground.color, "#ffffff"))}"></span>`;
      return `
        <div class="layer-item is-background is-locked">
          <div class="layer-main is-static" title="Fonas">
            <span class="layer-thumb">${thumb}</span>
            <span class="layer-text">
              <strong>Fonas</strong>
              <small>${detail}</small>
            </span>
          </div>
          <div class="layer-actions">
            <button class="layer-icon is-muted" type="button" disabled title="Fonas visada matomas" aria-label="Fonas visada matomas">&#128065;</button>
            <button class="layer-icon lock-icon is-active" type="button" disabled title="Fonas užrakintas" aria-label="Fonas užrakintas">
              <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>
            </button>
            <button class="layer-icon" type="button" disabled title="Fonas visada apačioje" aria-label="Fonas visada apačioje">&uarr;</button>
            <button class="layer-icon" type="button" disabled title="Fonas visada apačioje" aria-label="Fonas visada apačioje">&darr;</button>
            <button class="layer-icon is-danger" type="button" data-clear-background-layer title="Pašalinti foną" aria-label="Pašalinti foną">x</button>
          </div>
        </div>
      `;
    }

    renderCategoryTabs() {
      const categories = [
        "All",
        ...[...new Set(this.stickers.flatMap((sticker) => stickerCategories(sticker)))].sort(sortStickerCategory),
      ];
      this.nodes.categoryList.innerHTML = categories
        .map((category) => {
          const categoryStickers = this.stickers.filter((sticker) => stickerBelongsToCategory(sticker, category));
          const subcategories =
            category === "All"
              ? []
              : [
                  "All",
                  ...[...new Set(categoryStickers.flatMap((sticker) => stickerSubcategoriesForCategory(sticker, category)).filter(Boolean))].sort((a, b) =>
                    sortStickerSubcategory(a, b, categoryStickers),
                  ),
                ];
          const subcategoryButtons = subcategories.length
            ? `<div class="subcategory-list">
                ${subcategories
                  .map(
                    (subcategory) => `
                      <button
                        class="subcategory-option ${
                          category === this.activeStickerCategory && subcategory === this.activeStickerSubcategory
                            ? "is-active"
                            : ""
                        }"
                        type="button"
                        data-sticker-category="${escapeHtml(category)}"
                        data-sticker-subcategory="${escapeHtml(subcategory)}"
                      >
                        ${escapeHtml(subcategory === "All" ? "Visos subkategorijos" : subcategoryLabel(subcategory))}
                      </button>
                    `,
                  )
                  .join("")}
              </div>`
            : "";

          return `
            <div class="category-group">
              <button
                class="category-option ${category === this.activeStickerCategory ? "is-active" : ""}"
                type="button"
                data-sticker-category="${escapeHtml(category)}"
                data-sticker-subcategory="All"
              >
                ${categoryLabel(category)}
              </button>
              ${subcategoryButtons}
            </div>
          `;
        })
        .join("");
    }

    renderViewTabs() {
      this.root.querySelectorAll("[data-sticker-view]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.stickerView === this.stickerView);
      });
    }

    renderPatternGrid() {
      if (!this.nodes.patternGrid) return;
      const patterns = this.backgroundPatterns;
      const categories = [...new Set(patterns.map(pattern => pattern.category || "Custom"))];
      const categoryOptions = `<option value="All">Visos kategorijos</option>` + categories.map(category =>
        `<option value="${escapeAttribute(category)}">${escapeHtml(category === "Custom" ? "Mano fonai" : category)}</option>`).join("");
      if (this.nodes.backgroundCategory.innerHTML !== categoryOptions) {
        this.nodes.backgroundCategory.innerHTML = categoryOptions;
      }
      if (this.backgroundCategory !== "All" && !categories.includes(this.backgroundCategory)) this.backgroundCategory = "All";
      this.nodes.backgroundCategory.value = this.backgroundCategory;
      const words = this.backgroundSearch.toLowerCase().split(/\s+/).filter(Boolean);
      const filtered = patterns.filter(pattern => {
        const category = pattern.category || "Custom";
        const searchable = `${pattern.name} ${category}`.toLowerCase();
        return (this.backgroundCategory === "All" || category === this.backgroundCategory) && words.every(word => searchable.includes(word));
      });
      this.nodes.backgroundResultCount.textContent = `Rasta fonų: ${filtered.length}`;
      this.nodes.backgroundLoadMore.hidden = filtered.length <= this.backgroundVisibleCount;
      this.nodes.patternGrid.innerHTML = filtered.slice(0, this.backgroundVisibleCount)
        .map((pattern) => `
          <button
            class="pattern-tile ${this.caseBackground.type === "pattern" && this.caseBackground.pattern === pattern.src ? "is-active" : ""}"
            type="button"
            data-bg-pattern="${escapeHtml(pattern.id)}"
            title="${escapeHtml(pattern.name)}"
            aria-label="${escapeHtml(pattern.name)}"
            aria-pressed="${this.caseBackground.type === "pattern" && this.caseBackground.pattern === pattern.src}"
          >
            <img src="${escapeAttribute(pattern.thumb || pattern.src)}" alt="" loading="lazy" decoding="async" />
          </button>
        `)
        .join("") || `<p class="pattern-empty">Fonų nerasta. Pakeisk paiešką arba kategoriją.</p>`;
      this.ui?.backgroundPanel?.sync();
    }

    renderToolPanels() {
      this.nodes.toolTabs?.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.toolTab === this.activeToolPanel);
      });
      this.nodes.toolPanels?.forEach((panel) => {
        const isActive = panel.dataset.toolPanel === this.activeToolPanel;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });
      this.renderPhotoUploadPanel();
      this.renderFinalSummary();
      this.ui?.sync();
    }

    setToolPanel(panel) {
      this.activeToolPanel = ["design", "templates", "stickers", "photo", "edit", "export"].includes(panel) ? panel : "stickers";
      this.renderToolPanels();
    }

    getVisibleDesignItems() {
      return this.items.filter((item) => item && !item.hidden);
    }

    getBackgroundSummaryLabel() {
      const background = this.caseBackground || {};
      if (background.type === "pattern" && background.pattern) {
        const pattern = this.backgroundPatterns.find((item) => item.src === background.pattern || item.id === background.pattern);
        return pattern?.name ? `Raštas: ${pattern.name}` : "Raštas";
      }
      if (background.type === "color") {
        return `Spalva ${safeHexColor(background.color, "#ffffff").toUpperCase()}`;
      }
      return "Be fono";
    }

    getFinalDesignSummary() {
      const visibleItems = this.getVisibleDesignItems();
      const textCount = visibleItems.filter((item) => item.type === "text").length;
      const photoCount = visibleItems.filter((item) => this.isCustomerPhotoItem(item)).length;
      const stickerCount = visibleItems.filter((item) => item.type !== "text" && !this.isCustomerPhotoItem(item) && item.type !== "photo-slot").length;
      const printReport = this.getPrintQualityReport();
      const photoReport = this.validatePhotoTemplateForExport();
      const missingCount = photoReport.missing?.length || 0;
      return {
        model: this.model || this.defaultModel,
        background: this.getBackgroundSummaryLabel(),
        stickerCount,
        photoCount,
        textCount,
        printReport,
        photoReport,
        missingCount,
      };
    }

    getFinalReadiness(summary = this.getFinalDesignSummary()) {
      if (summary.missingCount > 0) {
        return {
          state: "missing",
          title: "Trūksta privalomų nuotraukų",
          detail: `Įkelkite nuotraukas į visas privalomas šablono vietas (${summary.missingCount}), tada galėsite užbaigti dizainą.`,
        };
      }
      if (summary.printReport.state === "low-quality") {
        return {
          state: "low-quality",
          title: "Kai kurios įkeltos nuotraukos gali būti neryškios",
          detail: "Viena ar kelios jūsų įkeltos nuotraukos yra per mažos raiškos. Geriausiam rezultatui naudokite aukštesnės raiškos nuotrauką.",
        };
      }
      if (summary.printReport.state === "warning") {
        return {
          state: "warning",
          title: "Kai kurios įkeltos nuotraukos gali būti šiek tiek neryškios",
          detail: "Įkeltos nuotraukos spaudoje gali atrodyti minkštesnės, bet eksportas leidžiamas.",
        };
      }
      return {
        state: "ready",
        title: "Paruošta spaudai",
        detail: "Privalomi elementai užpildyti, o spaudos kokybės įspėjimų nėra.",
      };
    }

    renderFinalSummary() {
      if (!this.nodes.finalSummary) return;
      const summary = this.getFinalDesignSummary();
      const readiness = this.getFinalReadiness(summary);
      const qualityLabel = summary.printReport.state === "safe"
        ? "Be įspėjimų"
        : summary.printReport.state === "warning"
          ? `Nuotraukų įspėjimai (${summary.printReport.warning.length})`
          : `Žema nuotraukų raiška (${summary.printReport.lowQuality.length})`;
      const photoSlotLabel = !summary.photoReport.template
        ? "Netaikoma"
        : summary.missingCount
          ? `Trūksta ${summary.missingCount}`
          : "Užpildyta";

      if (this.nodes.finalStatusCard) {
        this.nodes.finalStatusCard.dataset.finalStatus = readiness.state;
      }
      if (this.nodes.finalStatusTitle) this.nodes.finalStatusTitle.textContent = readiness.title;
      if (this.nodes.finalStatusDetail) this.nodes.finalStatusDetail.textContent = readiness.detail;
      if (this.nodes.openTemplateSlots) this.nodes.openTemplateSlots.hidden = summary.missingCount === 0;

      const rows = [
        ["Telefono modelis", summary.model],
        ["Fonas", summary.background],
        ["Lipdukai", summary.stickerCount],
        ["Nuotraukos", summary.photoCount],
        ["Tekstai", summary.textCount],
        ["Spaudos kokybė", qualityLabel],
        ["Privalomos nuotraukos", photoSlotLabel],
      ];

      this.nodes.finalSummary.innerHTML = rows
        .map(([label, value]) => `
          <div class="final-summary-item">
            <span>${escapeHtml(label)}</span>
            <strong>${escapeHtml(value)}</strong>
          </div>
        `)
        .join("");
      this.updateFinalPreviewPlaceholder();
    }

    updateFinalPreviewPlaceholder() {
      if (!this.nodes.finalPreviewEmpty || !this.nodes.output) return;
      const hasPreview = Boolean(this.nodes.output.getAttribute("src")) && this.nodes.output.classList.contains("is-visible");
      this.nodes.finalPreviewEmpty.hidden = hasPreview;
    }

    setStickerCategory(category, subcategory = "All") {
      this.activeStickerCategory = category || "All";
      this.activeStickerSubcategory = subcategory || "All";
      this.renderCategoryTabs();
      this.renderStickerGrid();
      this.closeCategories();
    }

    clearStickerFilter() {
      this.activeStickerCategory = "All";
      this.activeStickerSubcategory = "All";
      this.stickerView = "browse";
      this.stickerSearch = "";
      if (this.nodes.stickerSearch) this.nodes.stickerSearch.value = "";
      this.renderViewTabs();
      this.renderCategoryTabs();
      this.renderStickerGrid();
    }

    bindExternalOpenButton() {
      document.querySelector("[data-open-sticker-case-studio]")?.addEventListener("click", () => {
        this.root.scrollIntoView({ behavior: "smooth", block: "center" });
        this.nodes.status.textContent = "Studija paruošta. Pridėk lipdukus ir susidėliok kompoziciją.";
      });

      this.fields.model?.addEventListener("change", () => {
        this.setModel(this.fields.model.value);
      });
    }

    handleClick(event) {
      if (event.target.closest("[data-undo]")) {
        this.undo();
        return;
      }
      if (event.target.closest("[data-redo]")) {
        this.redo();
        return;
      }
      if (event.target.closest("[data-save-draft]")) {
        this.saveDraft();
        return;
      }
      if (event.target.closest("[data-load-draft]")) {
        this.loadDraft();
        return;
      }
      const toolTab = event.target.closest("[data-tool-tab]");
      if (toolTab) {
        this.setToolPanel(toolTab.dataset.toolTab);
        return;
      }
      const favoriteButton = event.target.closest("[data-toggle-favorite]");
      if (favoriteButton) {
        event.stopPropagation();
        this.toggleFavorite(favoriteButton.dataset.toggleFavorite);
        return;
      }
      const layerSelect = event.target.closest("[data-select-layer]");
      if (layerSelect) {
        this.select(layerSelect.dataset.selectLayer);
        return;
      }
      const layerDelete = event.target.closest("[data-layer-delete]");
      if (layerDelete) {
        this.deleteItem(layerDelete.dataset.layerDelete);
        return;
      }
      const layerHide = event.target.closest("[data-layer-hide]");
      if (layerHide) {
        this.toggleLayerHidden(layerHide.dataset.layerHide);
        return;
      }
      const layerLock = event.target.closest("[data-layer-lock]");
      if (layerLock) {
        this.toggleLayerLocked(layerLock.dataset.layerLock);
        return;
      }
      if (event.target.closest("[data-add-text]")) {
        this.addText();
        return;
      }
      const aiPreset = event.target.closest("[data-ai-photo-preset]");
      if (aiPreset) {
        this.applyAiPhotoPreset(aiPreset.dataset.aiPhotoPreset);
        return;
      }
      if (event.target.closest("[data-ai-photo-generate]")) {
        this.applyAiPhotoPrompt();
        return;
      }
      const collageTemplate = event.target.closest("[data-collage-template]");
      if (collageTemplate) {
        this.requestTemplateApply("collage", collageTemplate.dataset.collageTemplate);
        return;
      }
      const slotUpload = event.target.closest("[data-template-slot-upload]");
      if (slotUpload) {
        this.pendingTemplateSlotId = slotUpload.dataset.templateSlotUpload;
        this.nodes.templatePhotoUpload?.click();
        return;
      }
      const slotRemove = event.target.closest("[data-template-slot-remove]");
      if (slotRemove) {
        this.removeTemplateSlotPhoto(slotRemove.dataset.templateSlotRemove);
        return;
      }
      const templateColor = event.target.closest("[data-template-color]");
      if (templateColor) {
        this.setTemplateColor(templateColor.dataset.templateColor);
        return;
      }
      const templateButton = event.target.closest("[data-template]");
      if (templateButton) {
        this.requestTemplateApply("design", templateButton.dataset.template);
        return;
      }
      if (event.target.closest("[data-template-apply-cancel]")) {
        this.cancelTemplateApply();
        return;
      }
      if (event.target.closest("[data-template-apply-confirm]")) {
        this.confirmTemplateApply();
        return;
      }
      if (event.target === this.nodes.templateApplyModal) {
        this.cancelTemplateApply();
        return;
      }
      const textPreset = event.target.closest("[data-text-preset]");
      if (textPreset) {
        this.applyTextPreset(textPreset.dataset.textPreset);
        return;
      }
      const effectChoice = event.target.closest("[data-text-effect-choice]");
      if (effectChoice) {
        this.setTextEffect(effectChoice.dataset.textEffectChoice);
        return;
      }
      const textToggle = event.target.closest("[data-text-toggle]");
      if (textToggle) {
        this.toggleTextFormat(textToggle.dataset.textToggle);
        return;
      }
      const textAlign = event.target.closest("[data-text-align]");
      if (textAlign) {
        this.setTextAlign(textAlign.dataset.textAlign);
        return;
      }
      const stickerOutline = event.target.closest("[data-sticker-outline]");
      if (stickerOutline) {
        this.setStickerOutline(stickerOutline.dataset.stickerOutline);
        return;
      }
      const flipButton = event.target.closest("[data-flip]");
      if (flipButton) {
        this.toggleFlip(flipButton.dataset.flip);
        return;
      }
      const backgroundMode = event.target.closest("[data-case-bg-mode]");
      if (backgroundMode) {
        this.setCaseBackgroundMode(backgroundMode.dataset.caseBgMode);
        return;
      }
      if (event.target.closest("[data-clear-background-layer]")) {
        this.clearCaseBackground();
        return;
      }
      const patternButton = event.target.closest("[data-bg-pattern]");
      if (patternButton) {
        this.setBackgroundPattern(patternButton.dataset.bgPattern);
        return;
      }
      if (event.target.closest("[data-bg-resize-toggle]")) {
        this.backgroundResizeEnabled = !this.backgroundResizeEnabled;
        this.updateBackgroundResizeControls();
        if (this.backgroundResizeEnabled && this.ui?.mobile.matches) {
          this.ui.sheetOpen = false;
          this.ui.sync();
        }
        return;
      }
      if (event.target.closest("[data-bg-load-more]")) {
        this.backgroundVisibleCount += 60;
        this.renderPatternGrid();
        return;
      }
      const backgroundSwatch = event.target.closest("[data-bg-swatch]");
      if (backgroundSwatch) {
        const nextColor = safeHexColor(backgroundSwatch.dataset.bgSwatch, this.caseBackground.color);
        if (this.caseBackground.type === "color" && this.caseBackground.color.toLowerCase() === nextColor.toLowerCase()) return;
        this.pushHistorySnapshot();
        this.caseBackground.color = nextColor;
        this.caseBackground.type = "color";
        this.updateCaseBackground();
        this.renderLayerList();
        this.syncOutput();
        return;
      }
      const textSwatch = event.target.closest("[data-text-swatch]");
      if (textSwatch) {
        if (this.selected?.locked) return;
        const nextColor = safeHexColor(textSwatch.dataset.textSwatch, this.textColor);
        if (this.textColor.toLowerCase() === nextColor.toLowerCase() && (!this.selected || this.selected.color?.toLowerCase() === nextColor.toLowerCase())) return;
        this.pushHistorySnapshot();
        this.textColor = nextColor;
        if (this.nodes.textColor) this.nodes.textColor.value = this.textColor;
        if (this.selected?.type === "text") this.selected.color = this.textColor;
        this.updateTextToolState();
        this.paint();
        this.updateControls();
        this.renderLayerList();
        this.syncOutput();
        return;
      }
      const layerUp = event.target.closest("[data-layer-up]");
      if (layerUp) {
        this.moveLayer(layerUp.dataset.layerUp, 1);
        return;
      }
      const layerDown = event.target.closest("[data-layer-down]");
      if (layerDown) {
        this.moveLayer(layerDown.dataset.layerDown, -1);
        return;
      }
      const addButton = event.target.closest("[data-add-sticker]");
      if (addButton) {
        event.preventDefault();
        addButton.blur();
        this.addSticker(addButton.dataset.addSticker);
        return;
      }
      const categoryButton = event.target.closest("[data-sticker-category]");
      if (categoryButton) this.setStickerCategory(categoryButton.dataset.stickerCategory, categoryButton.dataset.stickerSubcategory);
      const viewButton = event.target.closest("[data-sticker-view]");
      if (viewButton) this.setStickerView(viewButton.dataset.stickerView);
      if (event.target.closest("[data-trigger-upload]")) this.nodes.upload.click();
      const replacePhoto = event.target.closest("[data-replace-photo]");
      if (replacePhoto) {
        this.pendingReplacePhotoId = replacePhoto.dataset.replacePhoto || "";
        this.nodes.uploadCasePhoto?.click();
        return;
      }
      const removePhoto = event.target.closest("[data-remove-photo]");
      if (removePhoto) {
        this.removeUploadedPhoto(removePhoto.dataset.removePhoto);
        return;
      }
      if (event.target.closest("[data-trigger-photo-upload]")) {
        this.pendingReplacePhotoId = "";
        this.nodes.uploadCasePhoto?.click();
      }
      if (event.target.closest("[data-open-categories]")) this.openCategories();
      if (event.target.closest("[data-clear-sticker-filter]")) {
        this.clearStickerFilter();
        return;
      }
      if (
        event.target.closest("[data-close-categories]") ||
        event.target.matches("[data-category-modal]")
      ) {
        this.closeCategories();
      }
      if (this.shouldClearSelection(event.target)) {
        this.clearSelection();
      }
      if (event.target.closest("[data-reset]")) this.reset();
      if (event.target.closest("[data-delete]")) this.deleteSelected();
      if (event.target.closest("[data-duplicate]")) this.duplicateSelected();
      if (event.target.closest("[data-open-template-slots]")) {
        this.setToolPanel("templates");
        this.nodes.templateSlotList?.scrollIntoView({ behavior: "smooth", block: "nearest" });
        return;
      }
      if (event.target.closest("[data-final-preview]")) {
        this.nodes.status.textContent = "Peržiūra išjungta. Tikrinkite spaudos failą.";
        return;
      }
      if (event.target.closest("[data-export]")) {
        this.nodes.status.textContent = "Peržiūros PNG išjungtas. Naudokite spaudos failą.";
        return;
      }
      if (event.target.closest("[data-print-export]")) {
        if (!this.ensurePhotoTemplateReadyForExport()) return;
        this.downloadPrintFile();
      }
      if (event.target.closest("[data-save]")) {
        if (!this.ensurePhotoTemplateReadyForExport()) return;
        this.saveDesign();
      }
      if (event.target.closest("[data-final-save]")) {
        if (!this.ensurePhotoTemplateReadyForExport()) {
          this.renderFinalSummary();
          return;
        }
        this.saveDesign();
        return;
      }
      if (event.target.closest("[data-clear-custom]")) this.clearCustomStickers();
      if (event.target.closest("[data-clear-model-photo]")) this.clearModelPhoto();
      if (event.target.closest("[data-clear-patterns]")) this.clearBackgroundPatterns();
    }

    handleInput(event) {
      if (event.target.matches("[data-bg-search]")) {
        this.backgroundSearch = event.target.value.trim();
        this.backgroundVisibleCount = 60;
        this.renderPatternGrid();
        this.nodes.patternGrid.scrollTop = 0;
        return;
      }
      if (event.target.matches("[data-text-content]")) {
        if (this.selected?.locked) return;
        if (this.textDraft === event.target.value && (!this.selected || this.selected.text === event.target.value)) return;
        this.pushHistorySnapshot();
        this.textDraft = event.target.value;
        if (this.selected?.type === "text") {
          this.selected.text = this.textDraft || "Tekstas";
        }
      }

      if (event.target.matches("[data-ai-photo-prompt]")) {
        this.aiPhotoPrompt = event.target.value;
      }

      if (event.target.matches("[data-sticker-search]")) {
        this.stickerSearch = event.target.value.trim();
        this.renderStickerGrid();
      }

      if (event.target.matches("[data-case-bg-color]")) {
        const nextColor = safeHexColor(event.target.value, this.caseBackground.color);
        if (this.caseBackground.type === "color" && this.caseBackground.color.toLowerCase() === nextColor.toLowerCase()) return;
        this.pushHistorySnapshot();
        this.caseBackground.color = nextColor;
        this.caseBackground.type = "color";
        this.updateCaseBackground();
        this.renderLayerList();
        this.syncOutput();
        return;
      }

      if (event.target.matches("[data-bg-scale]")) {
        const nextScale = safeBackgroundScale(event.target.value);
        if (safeBackgroundScale(this.caseBackground.patternScale) === nextScale) return;
        this.caseBackground.patternScale = nextScale;
        if (this.caseBackground.pattern) this.caseBackground.type = "pattern";
        const offset = this.clampBackgroundOffset({
          x: this.caseBackground.patternOffsetX,
          y: this.caseBackground.patternOffsetY,
        });
        this.caseBackground.patternOffsetX = offset.x;
        this.caseBackground.patternOffsetY = offset.y;
        this.updateCaseBackground();
        this.syncOutput();
        this.nodes.status.textContent = `Fono dydis pakeistas į ${nextScale}%. Dabar gali tempti foną ant dėklio.`;
        return;
      }

      if (event.target.matches("[data-text-font]")) {
        if (this.selected?.locked) return;
        if (this.textFont === event.target.value && (!this.selected || this.selected.font === event.target.value)) return;
        this.pushHistorySnapshot();
        this.textFont = event.target.value;
        event.target.style.fontFamily = safeTextFont(this.textFont);
        if (this.selected?.type === "text") {
          this.selected.font = this.textFont;
        }
      }

      if (event.target.matches("[data-text-color]")) {
        if (this.selected?.locked) return;
        if (this.textColor.toLowerCase() === event.target.value.toLowerCase() && (!this.selected || this.selected.color?.toLowerCase() === event.target.value.toLowerCase())) return;
        this.pushHistorySnapshot();
        this.textColor = event.target.value;
        if (this.selected?.type === "text") {
          this.selected.color = this.textColor;
        }
      }

      if (event.target.matches("[data-text-content], [data-text-font], [data-text-color]")) {
        if (event.target.matches("[data-text-color]")) this.updateTextToolState();
        this.paint();
        this.updateControls();
        this.renderLayerList();
        this.syncOutput();
        return;
      }

      if (event.target.matches("[data-template-slot-zoom]")) {
        const item = this.items.find((entry) => entry.uid === event.target.dataset.templateSlotZoom);
        if (!item || item.type !== "photo-slot") return;
        const nextZoom = clamp(Number(event.target.value) || 100, 100, 300);
        if (Math.round(item.imageZoom || 100) === nextZoom) return;
        this.pushHistorySnapshot();
        item.imageZoom = nextZoom;
        this.selectedId = item.uid;
        this.updateStickerNode(item);
        this.renderTemplateTools();
        this.renderLayerList();
        this.syncOutput();
        return;
      }

      if (!this.selected) return;
      if (this.selected.locked) return;

      if (event.target.matches("[data-size]")) {
        if (this.selected.size === Number(event.target.value)) return;
        this.pushHistorySnapshot();
        this.selected.size = Number(event.target.value);
        this.clampItemToSafeArea(this.selected);
      }

      if (event.target.matches("[data-rotation]")) {
        if (this.selected.rotation === Number(event.target.value)) return;
        this.pushHistorySnapshot();
        this.selected.rotation = Number(event.target.value);
      }

      if (event.target.matches("[data-opacity]")) {
        const nextOpacity = Number(event.target.value);
        if (safeItemOpacity(this.selected.opacity) === nextOpacity) return;
        this.pushHistorySnapshot();
        this.selected.opacity = nextOpacity;
      }

      this.updateControls();
      this.updateStickerNode(this.selected);
      this.renderLayerList();
      this.syncOutput();
    }

    get selected() {
      return this.items.find((item) => item.uid === this.selectedId);
    }

    getSticker(stickerId) {
      return this.stickers.find((item) => item.id === stickerId);
    }

    getItemLabel(item) {
      if (item.type === "text") return item.text || "Tekstas";
      if (item.type === "photo-slot") return item.name || "Nuotraukos rėmelis";
      return this.getSticker(item.stickerId)?.name || "Lipdukas";
    }

    getHistorySnapshot() {
      return {
        items: this.items.map((item) => ({ ...item })),
        selectedId: this.selectedId,
        caseBackground: { ...(this.caseBackground || {}) },
        activeToolPanel: this.activeToolPanel,
        activeCollageTemplateId: this.activeCollageTemplateId,
        textDraft: this.textDraft,
        textFont: this.textFont,
        textColor: this.textColor,
        textEffect: this.textEffect,
        textBold: this.textBold,
        textItalic: this.textItalic,
        textUnderline: this.textUnderline,
        textAlign: this.textAlign,
      };
    }

    historyKey(snapshot) {
      return JSON.stringify(snapshot);
    }

    pushHistorySnapshot(snapshot = this.getHistorySnapshot(), { clearRedo = true } = {}) {
      if (!snapshot) return;
      const previous = lastItem(this.undoStack);
      if (previous && this.historyKey(previous) === this.historyKey(snapshot)) return;
      this.undoStack.push(snapshot);
      if (this.undoStack.length > HISTORY_LIMIT) this.undoStack.shift();
      if (clearRedo) this.redoStack = [];
      this.updateHistoryButtons();
    }

    restoreHistorySnapshot(snapshot) {
      if (!snapshot) return;
      this.items = (snapshot.items || []).map((item) => ({ ...item }));
      this.selectedId = snapshot.selectedId || null;
      this.caseBackground = {
        type: "none",
        color: "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
        ...(snapshot.caseBackground || {}),
      };
      this.activeToolPanel = snapshot.activeToolPanel || (this.selectedId ? "edit" : "stickers");
      this.activeCollageTemplateId = snapshot.activeCollageTemplateId || this.items.find((item) => item.type === "photo-slot")?.templateId || "";
      this.getActivePhotoTemplate();
      this.textDraft = snapshot.textDraft || "";
      this.textFont = snapshot.textFont || TEXT_FONTS[0].value;
      this.textColor = snapshot.textColor || "#111111";
      this.textEffect = safeTextEffect(snapshot.textEffect);
      this.textBold = snapshot.textBold !== false;
      this.textItalic = Boolean(snapshot.textItalic);
      this.textUnderline = Boolean(snapshot.textUnderline);
      this.textAlign = safeTextAlign(snapshot.textAlign);
      if (this.nodes.textContent) this.nodes.textContent.value = this.textDraft;
      if (this.nodes.textFont) {
        this.nodes.textFont.value = this.textFont;
        this.nodes.textFont.style.fontFamily = safeTextFont(this.textFont);
      }
      if (this.nodes.textColor) this.nodes.textColor.value = this.textColor;
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.paint();
      this.updateTextToolState();
      this.updateControls();
      this.renderLayerList();
      this.renderToolPanels();
      this.renderTemplateTools();
      this.syncOutput();
    }

    undo() {
      if (!this.undoStack.length) return;
      const current = this.getHistorySnapshot();
      const previous = this.undoStack.pop();
      this.redoStack.push(current);
      this.restoreHistorySnapshot(previous);
      this.updateHistoryButtons();
      this.nodes.status.textContent = "Grąžintas ankstesnis veiksmas.";
    }

    redo() {
      if (!this.redoStack.length) return;
      const current = this.getHistorySnapshot();
      const next = this.redoStack.pop();
      this.undoStack.push(current);
      this.restoreHistorySnapshot(next);
      this.updateHistoryButtons();
      this.nodes.status.textContent = "Pakartotas veiksmas.";
    }

    updateHistoryButtons() {
      if (this.nodes?.undo) this.nodes.undo.disabled = !this.undoStack.length;
      if (this.nodes?.redo) this.nodes.redo.disabled = !this.redoStack.length;
    }

    getDraftSnapshot() {
      return {
        version: 1,
        savedAt: new Date().toISOString(),
        model: this.model,
        items: this.items.map((item) => ({ ...item })),
        selectedId: this.selectedId,
        caseBackground: { ...(this.caseBackground || {}) },
        activeToolPanel: this.activeToolPanel,
        activeCollageTemplateId: this.activeCollageTemplateId,
        textDraft: this.textDraft,
        textFont: this.textFont,
        textColor: this.textColor,
        textEffect: this.textEffect,
        textBold: this.textBold,
        textItalic: this.textItalic,
        textUnderline: this.textUnderline,
        textAlign: this.textAlign,
      };
    }

    saveDraft() {
      try {
        saveDesignDraft(this.getDraftSnapshot());
        this.updateDraftButtons();
        this.nodes.status.textContent = "Dizainas išsaugotas. Galėsi grįžti ir tęsti vėliau tame pačiame įrenginyje.";
      } catch {
        this.nodes.status.textContent = "Nepavyko išsaugoti dizaino. Greičiausiai naršyklės saugykla pilna.";
      }
    }

    loadDraft() {
      const draft = loadDesignDraft();
      if (!draft) {
        this.nodes.status.textContent = "Išsaugoto dizaino neradau.";
        this.updateDraftButtons();
        return;
      }

      const model = MODEL_PRESETS[draft.model] ? draft.model : this.defaultModel;
      this.pushHistorySnapshot();
      this.model = model;
      if (this.nodes.modelSelect) this.nodes.modelSelect.value = model;
      this.items = Array.isArray(draft.items) ? draft.items.map((item) => ({ ...item })) : [];
      this.selectedId = draft.selectedId || null;
      this.caseBackground = {
        type: "none",
        color: "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
        ...(draft.caseBackground || {}),
      };
      this.activeToolPanel = draft.activeToolPanel || (this.selectedId ? "edit" : "stickers");
      this.activeCollageTemplateId = draft.activeCollageTemplateId || this.items.find((item) => item.type === "photo-slot")?.templateId || "";
      this.getActivePhotoTemplate();
      this.textDraft = draft.textDraft || "";
      this.textFont = draft.textFont || TEXT_FONTS[0].value;
      this.textColor = draft.textColor || "#111111";
      this.textEffect = safeTextEffect(draft.textEffect);
      this.textBold = draft.textBold !== false;
      this.textItalic = Boolean(draft.textItalic);
      this.textUnderline = Boolean(draft.textUnderline);
      this.textAlign = safeTextAlign(draft.textAlign);
      this.setModel(this.model);
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.paint();
      this.updateTextToolState();
      this.updateControls();
      this.renderLayerList();
      this.renderToolPanels();
      this.renderTemplateTools();
      this.syncOutput();
      this.updateDraftButtons();
      this.nodes.status.textContent = "Išsaugotas dizainas įkeltas. Gali tęsti darbą.";
    }

    updateDraftButtons() {
      if (this.nodes?.loadDraft) this.nodes.loadDraft.disabled = !hasSavedDesignDraft();
    }

    itemMarkup(item, options = {}) {
      if (item.type === "text") {
        return textMarkup(item, options);
      }
      if (item.type === "photo-slot") {
        return photoSlotMarkup(item, options);
      }
      const sticker = this.getSticker(item.stickerId);
      return sticker ? stickerMarkup(sticker) : "";
    }

    applyTextPreset(label) {
      const preset = TEXT_PRESETS.find((item) => item.label === label);
      if (!preset || this.selected?.locked) return;
      this.pushHistorySnapshot();
      this.textFont = safeTextFont(preset.font);
      this.textColor = safeTextColor(preset.color);
      this.textEffect = safeTextEffect(preset.effect);
      this.textBold = preset.bold !== false;
      this.textItalic = Boolean(preset.italic);
      this.textUnderline = Boolean(preset.underline);
      this.textAlign = safeTextAlign(preset.align);

      if (this.nodes.textFont) {
        this.nodes.textFont.value = this.textFont;
        this.nodes.textFont.style.fontFamily = this.textFont;
      }
      if (this.nodes.textColor) this.nodes.textColor.value = this.textColor;

      if (this.selected?.type === "text") {
        this.selected.font = this.textFont;
        this.selected.color = this.textColor;
        this.selected.effect = this.textEffect;
        this.selected.bold = this.textBold;
        this.selected.italic = this.textItalic;
        this.selected.underline = this.textUnderline;
        this.selected.align = this.textAlign;
      }

      this.updateTextToolState();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = `Teksto stilius pritaikytas: ${preset.label}.`;
    }

    setTextEffect(effect) {
      if (this.selected?.locked) return;
      const nextEffect = safeTextEffect(effect);
      if (this.textEffect === nextEffect && (!this.selected || this.selected.effect === nextEffect)) return;
      this.pushHistorySnapshot();
      this.textEffect = nextEffect;
      if (this.selected?.type === "text") this.selected.effect = this.textEffect;
      this.updateTextToolState();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    toggleTextFormat(kind) {
      if (this.selected?.locked) return;
      this.pushHistorySnapshot();
      if (kind === "bold") this.textBold = !this.textBold;
      if (kind === "italic") this.textItalic = !this.textItalic;
      if (kind === "underline") this.textUnderline = !this.textUnderline;
      if (this.selected?.type === "text") {
        this.selected.bold = this.textBold;
        this.selected.italic = this.textItalic;
        this.selected.underline = this.textUnderline;
      }
      this.updateTextToolState();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    setTextAlign(align) {
      if (this.selected?.locked) return;
      const nextAlign = safeTextAlign(align);
      if (this.textAlign === nextAlign && (!this.selected || this.selected.align === nextAlign)) return;
      this.pushHistorySnapshot();
      this.textAlign = nextAlign;
      if (this.selected?.type === "text") this.selected.align = this.textAlign;
      this.updateTextToolState();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    setStickerOutline(outline) {
      if (!this.selected || this.selected.type === "text") return;
      if (this.selected.locked) return;
      const nextOutline = safeStickerOutline(outline);
      if (safeStickerOutline(this.selected.outline) === nextOutline) return;
      this.pushHistorySnapshot();
      this.selected.outline = nextOutline;
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    toggleFlip(axis) {
      if (!this.selected || this.selected.locked) return;
      if (axis !== "x" && axis !== "y") return;
      this.pushHistorySnapshot();
      if (axis === "x") this.selected.flipX = !this.selected.flipX;
      if (axis === "y") this.selected.flipY = !this.selected.flipY;
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    setCaseBackgroundMode(mode) {
      const nextType = mode === "pattern" ? "pattern" : mode === "color" ? "color" : "none";
      if (nextType === "pattern" && !this.caseBackground.pattern && this.backgroundPatterns[0]) {
        this.caseBackground.pattern = this.backgroundPatterns[0].src;
      }
      if (nextType === "pattern" && !this.caseBackground.pattern) {
        this.nodes.status.textContent = "Pirma įkelk bent vieną rašto paveikslėlį.";
        return;
      }

      if (this.caseBackground.type === nextType) return;
      this.pushHistorySnapshot();
      this.caseBackground.type = nextType;
      if (nextType === "pattern") this.caseBackground.patternScale = safeBackgroundScale(this.caseBackground.patternScale);
      this.updateCaseBackground();
      this.renderLayerList();
      this.syncOutput();
    }

    setBackgroundPattern(patternId) {
      const pattern = this.backgroundPatterns.find((item) => item.id === patternId);
      if (!pattern) return;
      this.backgroundResizeEnabled = true;
      if (this.caseBackground.type === "pattern" && this.caseBackground.pattern === pattern.src) {
        this.updateBackgroundResizeControls();
        return;
      }
      this.pushHistorySnapshot();
      this.caseBackground.type = "pattern";
      this.caseBackground.pattern = pattern.src;
      this.caseBackground.patternStretchX = 1;
      this.caseBackground.patternStretchY = 1;
      this.caseBackground.patternX = 50;
      this.caseBackground.patternY = 50;
      this.caseBackground.patternOffsetX = 0;
      this.caseBackground.patternOffsetY = 0;
      this.caseBackground.patternScale = safeBackgroundScale(this.caseBackground.patternScale);
      this.updateCaseBackground();
      this.renderPatternGrid();
      this.renderLayerList();
      this.syncOutput();
    }

    updateCaseBackground() {
      const background = this.caseBackground || {};
      const isColor = background.type === "color";
      const isPattern = background.type === "pattern" && Boolean(background.pattern);
      this.nodes.backgroundLayer.hidden = !isColor && !isPattern;
      this.nodes.phoneCase.classList.toggle("has-pattern-background", isPattern);
      if (isColor) {
        this.clearBackgroundImageNode();
        this.nodes.backgroundLayer.style.background = backgroundColorPaint(background);
        this.nodes.backgroundLayer.style.removeProperty("background-image");
        this.nodes.backgroundLayer.style.removeProperty("background-size");
        this.nodes.backgroundLayer.style.removeProperty("background-repeat");
      } else if (isPattern) {
        this.ensureBackgroundImageLoaded(background.pattern);
        const patternLayout = this.getPatternBackgroundLayout(background);
        this.nodes.backgroundLayer.style.background = "transparent";
        this.nodes.backgroundLayer.style.removeProperty("background-image");
        this.nodes.backgroundLayer.style.removeProperty("background-position");
        this.nodes.backgroundLayer.style.removeProperty("background-size");
        this.nodes.backgroundLayer.style.removeProperty("background-repeat");
        const imageNode = this.ensureBackgroundImageNode();
        imageNode.dataset.patternSrc = background.pattern;
        if (imageNode.getAttribute("src") !== background.pattern) imageNode.setAttribute("src", background.pattern);
        imageNode.style.left = patternLayout.left;
        imageNode.style.top = patternLayout.top;
        imageNode.style.width = patternLayout.width;
        imageNode.style.height = patternLayout.height;
      } else {
        this.clearBackgroundImageNode();
        this.nodes.backgroundLayer.style.background = "transparent";
        this.nodes.backgroundLayer.style.removeProperty("background-image");
        this.nodes.backgroundLayer.style.removeProperty("background-position");
      }
      this.nodes.backgroundModeButtons?.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.caseBgMode === (isPattern ? "pattern" : isColor ? "color" : "none"));
      });
      const patternScale = safeBackgroundScale(background.patternScale);
      if (this.nodes.backgroundScale) {
        this.nodes.backgroundScale.value = String(patternScale);
        this.nodes.backgroundScale.disabled = !isPattern;
      }
      if (this.nodes.backgroundScaleValue) {
        this.nodes.backgroundScaleValue.textContent = `${patternScale}%`;
      }
      if (this.nodes.backgroundColor) {
        this.nodes.backgroundColor.value = safeHexColor(background.color, "#ffffff");
      }
      this.root.querySelectorAll("[data-bg-swatch]").forEach((button) => {
        button.classList.toggle("is-active", isColor && button.dataset.bgSwatch.toLowerCase() === safeHexColor(background.color, "#ffffff").toLowerCase());
      });
      this.renderPatternGrid();
      this.updateBackgroundResizeControls();
    }

    updateBackgroundResizeControls() {
      if (this.backgroundResizeEnabled === undefined) this.backgroundResizeEnabled = true;
      this.ui?.syncZoomControls();
      const isPattern = this.caseBackground?.type === "pattern" && Boolean(this.caseBackground.pattern);
      const toggle = this.root.querySelector("[data-bg-resize-toggle]");
      if (toggle) {
        toggle.disabled = !isPattern;
        toggle.setAttribute("aria-pressed", String(Boolean(isPattern && this.backgroundResizeEnabled)));
        toggle.textContent = isPattern && this.backgroundResizeEnabled ? "Baigti dydžio keitimą" : "Keisti dydį ant dėkliuko";
      }
      if (!this.backgroundResizeControls) {
        const controls = document.createElement("div");
        controls.className = "background-resize-controls";
        controls.innerHTML = ["nw", "n", "ne", "e", "se", "s", "sw", "w"].map(direction =>
          `<button type="button" data-bg-resize="${direction}" aria-label="Keisti fono dydį: ${direction}"></button>`).join("");
        controls.addEventListener("pointerdown", event => this.startBackgroundResize(event));
        controls.addEventListener("keydown", event => {
          if (!event.target.matches("[data-bg-resize]") || !["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"].includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();
          this.pushHistorySnapshot();
          const direction = event.target.dataset.bgResize;
          const sign = ["ArrowUp", "ArrowRight"].includes(event.key) ? 1 : -1;
          if (direction.length === 1) {
            const axis = direction === "e" || direction === "w" ? "patternStretchX" : "patternStretchY";
            this.caseBackground[axis] = safeBackgroundStretch(safeBackgroundStretch(this.caseBackground[axis]) + sign * 0.05);
          } else {
            this.caseBackground.patternScale = safeBackgroundScale(this.caseBackground.patternScale + sign * 5);
          }
          this.updateCaseBackground();
          this.syncOutput();
        });
        this.nodes.phoneCase.appendChild(controls);
        this.backgroundResizeControls = controls;
      }
      const metrics = isPattern ? this.getPatternBackgroundMetrics(this.caseBackground) : null;
      this.backgroundResizeControls.hidden = !this.backgroundResizeEnabled || !metrics;
      if (!metrics) return;
      // The selection follows the entire image, including the parts clipped by the case.
      Object.assign(this.backgroundResizeControls.style, {left:`${metrics.left}px`,top:`${metrics.top}px`,width:`${metrics.drawWidth}px`,height:`${metrics.drawHeight}px`});
      this.backgroundResizeControls.style.setProperty("--bg-handle-scale", String(1 / (this.ui?.displayScale || 1)));
    }

    startBackgroundResize(event) {
      const handle = event.target.closest("[data-bg-resize]");
      if (!handle || (event.button !== undefined && event.button !== 0) || this.caseBackground.type !== "pattern") return;
      const metrics = this.getPatternBackgroundMetrics(this.caseBackground);
      if (!metrics) return;
      event.preventDefault();
      event.stopPropagation();
      const bounds = this.backgroundResizeControls.getBoundingClientRect();
      this.historySnapshotBeforeDrag = this.getHistorySnapshot();
      this.activeDrag = {mode:"background-resize",pointerId:event.pointerId,startX:event.clientX,startY:event.clientY,direction:handle.dataset.bgResize,startScale:safeBackgroundScale(this.caseBackground.patternScale),width:bounds.width,height:bounds.height};
      this.activeDrag.stretchX = safeBackgroundStretch(this.caseBackground.patternStretchX);
      this.activeDrag.stretchY = safeBackgroundStretch(this.caseBackground.patternStretchY);
      this.nodes.phoneCase.setPointerCapture?.(event.pointerId);
      window.addEventListener("pointermove", this.onDrag);
      window.addEventListener("pointerup", this.endDrag, {once:true});
      window.addEventListener("pointercancel", this.endDrag, {once:true});
    }

    ensureBackgroundImageNode() {
      let imageNode = this.nodes.backgroundLayer.querySelector("[data-background-image]");
      if (imageNode) return imageNode;
      imageNode = document.createElement("img");
      imageNode.className = "case-background-image";
      imageNode.dataset.backgroundImage = "true";
      imageNode.alt = "";
      imageNode.decoding = "async";
      imageNode.draggable = false;
      imageNode.addEventListener("load", () => {
        const key = imageNode.dataset.patternSrc || imageNode.getAttribute("src");
        if (!key) return;
        this.backgroundImageCache.set(key, {
          width: imageNode.naturalWidth || imageNode.width,
          height: imageNode.naturalHeight || imageNode.height,
        });
        if (this.caseBackground?.pattern === key) this.updateCaseBackground();
      });
      this.nodes.backgroundLayer.appendChild(imageNode);
      return imageNode;
    }

    clearBackgroundImageNode() {
      this.nodes.backgroundLayer.querySelector("[data-background-image]")?.remove();
    }

    startBackgroundPan(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest("[data-uid], [data-resize-handle], [data-rotate-handle], button, input, select, textarea")) return;
      if (this.caseBackground?.type !== "pattern" || !this.caseBackground.pattern) return;
      const imageRect = this.nodes.backgroundLayer.querySelector('[data-background-image]')?.getBoundingClientRect();
      if (!imageRect || event.clientX < imageRect.left || event.clientX > imageRect.right || event.clientY < imageRect.top || event.clientY > imageRect.bottom) {
        this.clearSelection();
        return;
      }
      event.preventDefault();
      this.backgroundResizeEnabled = true;
      this.updateBackgroundResizeControls();
      this.selectedId = null;
      this.paint();
      this.updateControls();
      this.historySnapshotBeforeDrag = this.getHistorySnapshot();
      this.activeDrag = {
        mode: "background-pan",
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startOffsetX: Number(this.caseBackground.patternOffsetX) || 0,
        startOffsetY: Number(this.caseBackground.patternOffsetY) || 0,
      };
      this.nodes.phoneCase.setPointerCapture?.(event.pointerId);
      window.addEventListener("pointermove", this.onDrag);
      window.addEventListener("pointerup", this.endDrag);
      window.addEventListener("pointercancel", this.endDrag);
    }

    clampBackgroundOffset(offset) {
      // Background placement is free; only reject non-finite coordinates.
      return {
        x: Number.isFinite(Number(offset.x)) ? Number(offset.x) : 0,
        y: Number.isFinite(Number(offset.y)) ? Number(offset.y) : 0,
      };
    }

    getPatternBackgroundLayout(background) {
      const metrics = this.getPatternBackgroundMetrics(background);
      if (!metrics) {
        const safeArea = this.getBackgroundLayoutSafeArea();
        return {
          left: `${safeArea.left}%`,
          top: `${safeArea.top}%`,
          width: `${safeArea.width}%`,
          height: `${safeArea.height}%`,
        };
      }
      return {
        left: `${metrics.left}px`,
        top: `${metrics.top}px`,
        width: `${metrics.drawWidth}px`,
        height: `${metrics.drawHeight}px`,
      };
    }

    getPatternBackgroundMetrics(background) {
      const safeArea = this.getBackgroundLayoutSafeArea();
      const image = this.getBackgroundPatternSize(background);
      const rect = this.getEditorLayoutRect(this.nodes.backgroundLayer);
      if (!image?.width || !image?.height || !rect.width || !rect.height) return null;
      const safeWidth = (rect.width * safeArea.width) / 100;
      const safeHeight = (rect.height * safeArea.height) / 100;
      const scale = patternBackgroundScale(
        safeWidth,
        safeHeight,
        image.width,
        image.height,
        background.patternScale,
      );
      const drawWidth = image.width * scale * safeBackgroundStretch(background.patternStretchX);
      const drawHeight = image.height * scale * safeBackgroundStretch(background.patternStretchY);
      const overflowX = Math.max(0, drawWidth - safeWidth);
      const overflowY = Math.max(0, drawHeight - safeHeight);
      const { x: offsetX, y: offsetY } = this.clampBackgroundOffset({x: background.patternOffsetX, y: background.patternOffsetY});
      const safeLeft = (rect.width * safeArea.left) / 100;
      const safeTop = (rect.height * safeArea.top) / 100;
      const left = safeLeft + (safeWidth - drawWidth) / 2 + offsetX;
      const top = safeTop + (safeHeight - drawHeight) / 2 + offsetY;
      return {
        drawWidth,
        drawHeight,
        layerWidth: rect.width,
        layerHeight: rect.height,
        overflowX,
        overflowY,
        left,
        top,
      };
    }

    getBackgroundLayoutSafeArea() {
      const modelImage = this.getModelImage();
      if (isValidBounds(modelImage?.backgroundSafeArea)) return modelImage.backgroundSafeArea;
      return this.getLayoutSafeArea();
    }

    getBackgroundPatternSize(background) {
      if (!background?.pattern) return null;
      const cached = this.backgroundImageCache.get(background.pattern);
      if (cached?.width && cached?.height) return cached;
      const imageNode = this.nodes.backgroundLayer?.querySelector("[data-background-image]");
      if (
        imageNode?.dataset.patternSrc === background.pattern &&
        imageNode.naturalWidth &&
        imageNode.naturalHeight
      ) {
        const size = { width: imageNode.naturalWidth, height: imageNode.naturalHeight };
        this.backgroundImageCache.set(background.pattern, size);
        return size;
      }
      return null;
    }

    ensureBackgroundImageLoaded(src) {
      if (!src || this.backgroundImageCache.has(src)) return;
      const image = new Image();
      image.onload = () => {
        this.backgroundImageCache.set(src, {
          width: image.naturalWidth || image.width,
          height: image.naturalHeight || image.height,
        });
        if (this.caseBackground?.pattern === src) this.updateCaseBackground();
      };
      image.src = src;
    }

    updateTextToolState() {
      this.root.querySelectorAll("[data-text-effect-choice]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.textEffectChoice === this.textEffect);
        const sample = button.querySelector(".case-text");
        if (sample) {
          const sampleColor = textEffectColor(button.dataset.textEffectChoice, this.textColor);
          sample.style.color = sampleColor;
          sample.style.setProperty("--text-glow", sampleColor);
        }
      });
      this.root.querySelectorAll("[data-text-toggle]").forEach((button) => {
        const kind = button.dataset.textToggle;
        const active =
          (kind === "bold" && this.textBold) ||
          (kind === "italic" && this.textItalic) ||
          (kind === "underline" && this.textUnderline);
        button.classList.toggle("is-active", active);
      });
      this.root.querySelectorAll("[data-text-align]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.textAlign === this.textAlign);
      });
      this.root.querySelectorAll("[data-text-swatch]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.textSwatch.toLowerCase() === safeHexColor(this.textColor, "#111111").toLowerCase());
      });
    }

    setModel(model) {
      this.model = MODEL_PRESETS[model] ? model : this.defaultModel;
      const preset = MODEL_PRESETS[this.model];
      const modelImage = this.getModelImage();
      const maxWidth = 380;
      const baseDisplayWidth = modelImage?.displayWidth || Math.round((preset.widthMm / 79) * maxWidth);
      const screenScale = modelImage?.screenScale || 1;
      const displayWidth = modelImage
        ? Math.round(baseDisplayWidth * MODEL_PHOTO_SCREEN_ZOOM * screenScale)
        : baseDisplayWidth;
      const aspectRatio = parseAspectRatio(modelImage?.aspect || `${preset.widthMm} / ${preset.heightMm}`) || 1;
      const desktopFitHeight = Math.max(260, window.innerHeight - 230);
      const mobileFitHeight = Math.max(220, window.innerHeight * 0.46 - 16);
      this.nodes.phoneStage.style.setProperty("--phone-display-width", `${displayWidth}px`);
      this.nodes.phoneStage.style.setProperty("--phone-aspect-ratio", `${aspectRatio}`);
      this.nodes.phoneStage.style.setProperty("--phone-height-fit-width", `${Math.round(desktopFitHeight * aspectRatio * screenScale)}px`);
      this.nodes.phoneStage.style.setProperty("--phone-mobile-height-fit-width", `${Math.round(mobileFitHeight * aspectRatio * screenScale)}px`);
      this.nodes.phoneStage.style.setProperty(
        "--phone-aspect",
        modelImage?.aspect || `${preset.widthMm} / ${preset.heightMm}`,
      );
      this.nodes.phoneCase.style.borderRadius = `${preset.radius}px`;
      this.nodes.phoneCase.classList.toggle("has-model-photo", Boolean(modelImage));
      this.nodes.modelText.textContent = this.model;
      this.setModelPhoto(modelImage);
      this.renderCamera(preset);
      if (this.nodes.modelSelect && this.nodes.modelSelect.value !== this.model) this.nodes.modelSelect.value = this.model;
      if (this.nodes.topbarModelSelect && this.nodes.topbarModelSelect.value !== this.model) this.nodes.topbarModelSelect.value = this.model;
      if (this.fields.model && this.fields.model.value !== this.model) this.fields.model.value = this.model;
      this.syncOutput();
    }

    setModelPhoto(modelImage) {
      if (!modelImage) {
        this.nodes.modelPhoto.removeAttribute("src");
        this.nodes.modelPhoto.hidden = true;
        this.nodes.backgroundLayer.removeAttribute("style");
        this.nodes.layer.removeAttribute("style");
        this.nodes.artLayer.removeAttribute("style");
        this.nodes.backgroundLayer.classList.remove("has-case-mask");
        this.nodes.backgroundLayer.classList.remove("has-case-clip");
        this.nodes.layer.classList.remove("has-case-mask");
        this.nodes.layer.classList.remove("has-case-clip");
        this.nodes.artLayer.classList.remove("has-case-mask");
        this.nodes.artLayer.classList.remove("has-case-clip");
        this.updateCaseBackground();
        return;
      }

      if (
        MODEL_PHOTO_SAFE_AREAS[this.model] &&
        modelImage.safeAreaVersion !== MODEL_PHOTO_SAFE_AREA_VERSION
      ) {
        modelImage.safeArea = MODEL_PHOTO_SAFE_AREAS[this.model];
        modelImage.safeAreaVersion = MODEL_PHOTO_SAFE_AREA_VERSION;
        if (this.customModelPhotos[this.model]) {
          this.customModelPhotos[this.model].safeArea = modelImage.safeArea;
          this.customModelPhotos[this.model].clipPath = MODEL_PHOTO_CLIP_PATHS[this.model];
          this.customModelPhotos[this.model].maskSrc = MODEL_PHOTO_MASKS[this.model];
          this.customModelPhotos[this.model].safeAreaVersion = MODEL_PHOTO_SAFE_AREA_VERSION;
          saveModelPhotos(this.customModelPhotos);
        }
      } else if (modelImage.src?.startsWith("data:") && modelImage.safeAreaVersion !== 2) {
        detectSafeArea(modelImage.src).then((safeArea) => {
          if (!this.customModelPhotos[this.model]) return;
          this.customModelPhotos[this.model].safeArea = safeArea;
          this.customModelPhotos[this.model].safeAreaVersion = 2;
          saveModelPhotos(this.customModelPhotos);
          if (this.getModelImage()?.src === modelImage.src) this.setModel(this.model);
        });
      }

      this.nodes.modelPhoto.onerror = () => {
        this.missingModelImages.add(this.model);
        this.nodes.status.textContent =
          `Telefono nuotrauka nerasta. Įdėk ${this.model} nuotrauką į assets aplanką arba kol kas rodysiu piešinį.`;
        this.setModel(this.model);
      };
      this.nodes.modelPhoto.onload = () => {
        this.nodes.status.textContent = "Telefono nuotrauka įkelta. Gali dėti lipdukus ant modelio.";
      };
      this.nodes.modelPhoto.src = modelImage.src;
      this.nodes.modelPhoto.hidden = false;
      const safeArea = modelImage.safeArea || modelImage.stickerBounds || DEFAULT_SAFE_AREA;
      const maskSrc = modelImage.maskSrc || MODEL_PHOTO_MASKS[this.model];
      const backgroundMaskSrc = modelImage.backgroundMaskSrc || maskSrc;
      const preferSvgPreviewMask = Boolean(modelImage.preferSvgPreviewMask);
      const clipPath = preferSvgPreviewMask ? "" : (modelImage.clipPath || MODEL_PHOTO_CLIP_PATHS[this.model]);
      this.nodes.backgroundLayer.style.setProperty("--mask-left", `${safeArea.left}%`);
      this.nodes.backgroundLayer.style.setProperty("--mask-top", `${safeArea.top}%`);
      this.nodes.backgroundLayer.style.setProperty("--mask-width", `${safeArea.width}%`);
      this.nodes.backgroundLayer.style.setProperty("--mask-height", `${safeArea.height}%`);
      this.nodes.artLayer.style.setProperty("--mask-left", `${safeArea.left}%`);
      this.nodes.artLayer.style.setProperty("--mask-top", `${safeArea.top}%`);
      this.nodes.artLayer.style.setProperty("--mask-width", `${safeArea.width}%`);
      this.nodes.artLayer.style.setProperty("--mask-height", `${safeArea.height}%`);
      this.nodes.layer.style.setProperty("--mask-left", `${safeArea.left}%`);
      this.nodes.layer.style.setProperty("--mask-top", `${safeArea.top}%`);
      this.nodes.layer.style.setProperty("--mask-width", `${safeArea.width}%`);
      this.nodes.layer.style.setProperty("--mask-height", `${safeArea.height}%`);
      this.nodes.layer.classList.remove("has-case-mask");
      this.nodes.layer.style.removeProperty("--case-mask");
      this.nodes.backgroundLayer.classList.remove("has-case-mask");
      this.nodes.backgroundLayer.style.removeProperty("--case-mask");
      this.nodes.artLayer.classList.remove("has-case-mask");
      this.nodes.artLayer.style.removeProperty("--case-mask");
      if (clipPath) {
        this.nodes.backgroundLayer.style.setProperty("--case-clip", clipPath);
        this.nodes.backgroundLayer.classList.add("has-case-clip");
        this.nodes.artLayer.style.setProperty("--case-clip", clipPath);
        this.nodes.artLayer.classList.add("has-case-clip");
        this.nodes.layer.style.setProperty("--case-clip", clipPath);
      } else if (maskSrc) {
        this.nodes.backgroundLayer.style.setProperty("--case-mask", `url("${backgroundMaskSrc}")`);
        this.nodes.backgroundLayer.classList.add("has-case-mask");
        this.nodes.artLayer.style.setProperty("--case-mask", `url("${maskSrc}")`);
        this.nodes.artLayer.classList.add("has-case-mask");
        this.nodes.backgroundLayer.style.removeProperty("--case-clip");
        this.nodes.backgroundLayer.classList.remove("has-case-clip");
        this.nodes.layer.style.removeProperty("--case-clip");
        this.nodes.artLayer.style.removeProperty("--case-clip");
        this.nodes.artLayer.classList.remove("has-case-clip");
      } else {
        this.nodes.backgroundLayer.style.removeProperty("--case-clip");
        this.nodes.backgroundLayer.classList.remove("has-case-clip");
        this.nodes.layer.style.removeProperty("--case-clip");
        this.nodes.artLayer.style.removeProperty("--case-clip");
        this.nodes.artLayer.classList.remove("has-case-clip");
      }
      this.updateCaseBackground();
      requestAnimationFrame(() => this.clampAllItemsToSafeArea());
    }

    getModelImage() {
      if (FORCE_STANDARD_MODEL_PHOTOS.has(this.model) && MODEL_IMAGES[this.model]) {
        if (this.customModelPhotos[this.model]) {
          delete this.customModelPhotos[this.model];
          saveModelPhotos(this.customModelPhotos);
        }
        return MODEL_IMAGES[this.model];
      }
      if (this.customModelPhotos[this.model]) return this.customModelPhotos[this.model];
      if (this.missingModelImages.has(this.model)) return null;
      return MODEL_IMAGES[this.model] || null;
    }

    getSafeAreaBounds(size) {
      const modelImage = this.getModelImage();
      if (!modelImage) return null;
      const safeArea = modelImage.safeArea || modelImage.stickerBounds || DEFAULT_SAFE_AREA;
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const layerWidth = Math.max(1, layerRect.width || 0);
      const layerHeight = Math.max(1, layerRect.height || 0);
      const sizeX = (size / layerWidth) * 100;
      const sizeY = (size / layerHeight) * 100;
      return {
        minX: safeArea.left,
        minY: safeArea.top,
        maxX: safeArea.left + safeArea.width - sizeX,
        maxY: safeArea.top + safeArea.height - sizeY,
      };
    }

    getItemSafeAreaBounds(item) {
      const modelImage = this.getModelImage();
      if (!modelImage) return null;
      const safeArea = modelImage.safeArea || modelImage.stickerBounds || DEFAULT_SAFE_AREA;
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const box = itemBoxSize(item, this.getSticker(item.stickerId));
      const layerWidth = Math.max(1, layerRect.width);
      const layerHeight = Math.max(1, layerRect.height);
      const halfX = ((box.width / 2) / layerWidth) * 100;
      const halfY = ((box.height / 2) / layerHeight) * 100;
      const safeMinX = safeArea.left;
      const safeMinY = safeArea.top;
      const safeMaxX = safeArea.left + safeArea.width;
      const safeMaxY = safeArea.top + safeArea.height;
      const minX = safeMinX + halfX;
      const minY = safeMinY + halfY;
      const maxX = safeMaxX - halfX;
      const maxY = safeMaxY - halfY;
      if (item.type !== "text") {
        const keepVisibleX = Math.min(Math.max(2, halfX * 0.28), 7);
        const keepVisibleY = Math.min(Math.max(2, halfY * 0.28), 7);
        return {
          minX: safeMinX - halfX + keepVisibleX,
          minY: safeMinY - halfY + keepVisibleY,
          maxX: safeMaxX + halfX - keepVisibleX,
          maxY: safeMaxY + halfY - keepVisibleY,
        };
      }
      return {
        minX: minX <= maxX ? minX : safeMinX,
        minY: minY <= maxY ? minY : safeMinY,
        maxX: minX <= maxX ? maxX : safeMaxX,
        maxY: minY <= maxY ? maxY : safeMaxY,
      };
    }

    renderCamera(preset) {
      if (this.getModelImage()) {
        this.nodes.cameraLayer.innerHTML = "";
        return;
      }

      const camera = cameraToPercent(preset);
      const moduleHtml = camera.module
        ? `<div class="camera-module is-${camera.module.style || "iphone-square"}" style="${cameraStyle(camera.module)}"></div>`
        : "";
      const lensHtml = camera.lenses
        .map((lens) => `<div class="camera-lens" style="${lensStyle(lens)}"></div>`)
        .join("");
      const flashHtml = camera.flash
        ? `<div class="camera-flash" style="${lensStyle(camera.flash)}"></div>`
        : "";
      const sensorHtml = camera.sensors
        .map((sensor) => `<div class="camera-sensor" style="${lensStyle(sensor)}"></div>`)
        .join("");

      this.nodes.cameraLayer.innerHTML = `${moduleHtml}${lensHtml}${flashHtml}${sensorHtml}`;
    }

    addSticker(stickerId) {
      const sticker = this.getSticker(stickerId);
      if (!sticker) return;

      const item = this.createStickerItem(sticker);

      this.pushHistorySnapshot();
      this.items.push(item);
      this.selectedId = item.uid;
      this.clampItemToSafeArea(item);
      this.paint();
      this.updateControls();
      this.syncOutput();
      this.setToolPanel("edit");
      this.nodes.status.textContent = `Lipdukas pridėtas ant telefono. Iš viso: ${this.items.length}.`;
      this.renderLayerList();
      this.schedulePreviewRefresh({ immediate: true, force: this.livePreviewEnabled });
    }

    createStickerItem(sticker, index = this.items.length) {
      const bounds = this.getSafeAreaBounds(0);
      const startX = bounds ? (bounds.minX + bounds.maxX) / 2 : 36;
      const startY = bounds ? (bounds.minY + bounds.maxY) / 2 : 38;
      const spread = index * 3;
      const item = {
        uid: `${sticker.id}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        stickerId: sticker.id,
        x: clamp(startX + spread, 0, 90),
        y: clamp(startY + spread, 0, 90),
        size: DEFAULT_STICKER_SIZE,
        rotation: 0,
        opacity: 100,
        flipX: false,
        flipY: false,
        outline: "none",
      };
      if (isCustomerPhotoSticker(sticker)) {
        this.applyUploadedPhotoMetadata(item, sticker);
      }
      return item;
    }

    applyUploadedPhotoMetadata(item, sticker) {
      if (!item || !sticker) return item;
      const imageWidth = Number(sticker.width || sticker.imageWidth) || 0;
      const imageHeight = Number(sticker.height || sticker.imageHeight) || 0;
      item.imageWidth = imageWidth;
      item.imageHeight = imageHeight;
      item.aspectRatio = imageWidth && imageHeight ? Number((imageWidth / imageHeight).toFixed(4)) : Number(sticker.aspectRatio) || 1;
      item.printSourceStatus = "uploaded";
      item.printQualityRole = "photo";
      item.uploadedFileName = sticker.originalFileName || sticker.name || "Nuotrauka";
      return item;
    }

    isCustomerPhotoItem(item) {
      if (!item) return false;
      if (item.type === "photo-slot") return Boolean(item.imageSrc);
      if (item.printQualityRole === "photo" || item.printSourceStatus === "uploaded") return true;
      const sticker = this.getSticker(item.stickerId);
      return isCustomerPhotoSticker(sticker) || sticker?.printSourceStatus === "uploaded";
    }

    isPrintQualityPhotoItem(item) {
      if (!item) return false;
      if (item.type === "photo-slot") return Boolean(item.imageSrc);
      if (item.type === "text") return false;
      const sticker = this.getSticker(item.stickerId);
      if (!sticker) return false;

      return item.printQualityRole === "photo" ||
        item.printSourceStatus === "uploaded" ||
        sticker.printSourceStatus === "uploaded" ||
        isCustomerPhotoSticker(sticker);
    }

    isPrintQualityThumbnailStickerItem(item) {
      if (!item || item.type === "text" || item.type === "photo-slot") return false;
      const sticker = this.getSticker(item.stickerId);
      if (!sticker || sticker.type !== "image") return false;
      if (this.isPrintQualityPhotoItem(item)) return false;
      return (item.printSourceStatus || sticker.printSourceStatus || "") === "thumbnail-only";
    }

    getPhotoUploadItems() {
      return this.items.filter((item) => this.isCustomerPhotoItem(item) && item.type !== "photo-slot");
    }

    getActiveUploadedPhotoItem() {
      const photos = this.getPhotoUploadItems();
      if (!photos.length) return null;
      const selectedPhoto = photos.find((item) => item.uid === this.selectedId);
      return selectedPhoto || photos[photos.length - 1];
    }

    renderPhotoUploadPanel() {
      if (!this.nodes?.photoUploadSelected) return;
      const item = this.getActiveUploadedPhotoItem();
      if (!item) {
        this.nodes.photoUploadSelected.innerHTML = "";
        return;
      }
      const sticker = this.getSticker(item.stickerId);
      const src = sticker?.thumb || sticker?.src || "";
      const width = Number(item.imageWidth) || Number(sticker?.width) || 0;
      const height = Number(item.imageHeight) || Number(sticker?.height) || 0;
      const dimensions = width && height ? `${Math.round(width)} x ${Math.round(height)} px` : "Raiška nepatikrinta";
      const quality = this.getPrintQualityForItem(item);
      const qualityText = quality.state === "safe"
        ? "Kokybė spaudai atrodo gera"
        : quality.message || "Nuotraukos kokybę verta peržiūrėti";
      const qualityClass = quality.state === "low-quality" ? "is-low" : quality.state === "warning" ? "is-warning" : "is-safe";
      this.nodes.photoUploadSelected.innerHTML = `
        <div class="photo-selected-card">
          <div class="photo-selected-thumb">
            ${src ? `<img src="${escapeAttribute(src)}" alt="" />` : `<span>Foto</span>`}
          </div>
          <div class="photo-selected-info">
            <strong>${escapeHtml(cleanPhotoLabel(item.uploadedFileName || sticker?.name || "Nuotrauka"))}</strong>
            <span>${escapeHtml(dimensions)}</span>
            <small class="${qualityClass}">${escapeHtml(qualityText)}</small>
          </div>
          <div class="photo-selected-actions">
            <button type="button" data-replace-photo="${escapeAttribute(item.uid)}">Pakeisti</button>
            <button type="button" data-remove-photo="${escapeAttribute(item.uid)}">Pašalinti</button>
          </div>
        </div>
      `;
    }

    isDesignEmptyForTemplateApply() {
      const hasLayers = this.items.some((item) => {
        if (!item) return false;
        if (item.type === "photo-slot") return true;
        if (item.type === "text") return Boolean(String(item.text || "").trim());
        return true;
      });
      if (hasLayers) return false;

      const background = this.caseBackground || {};
      if (background.type === "pattern" && background.pattern) return false;
      if (background.type === "color") {
        const color = String(background.color || "#ffffff").trim().toLowerCase();
        if (color && color !== "#ffffff") return false;
      }

      return true;
    }

    requestTemplateApply(type, id) {
      if (!id) return;
      if (this.isDesignEmptyForTemplateApply()) {
        this.applyRequestedTemplate(type, id);
        return;
      }
      this.pendingTemplateApply = { type, id };
      this.openTemplateApplyModal();
    }

    applyRequestedTemplate(type, id) {
      if (type === "collage") {
        this.applyPhotoCollageTemplate(id);
        return;
      }
      this.applyTemplate(id);
    }

    openTemplateApplyModal() {
      if (!this.nodes.templateApplyModal) return;
      this.nodes.templateApplyModal.classList.add("is-open");
      this.nodes.templateApplyModal.setAttribute("aria-hidden", "false");
      this.nodes.templateApplyModal.querySelector("[data-template-apply-cancel]")?.focus();
    }

    closeTemplateApplyModal() {
      if (!this.nodes.templateApplyModal) return;
      this.nodes.templateApplyModal.classList.remove("is-open");
      this.nodes.templateApplyModal.setAttribute("aria-hidden", "true");
    }

    cancelTemplateApply() {
      this.pendingTemplateApply = null;
      this.closeTemplateApplyModal();
      this.nodes.status.textContent = "Šablonas nepritaikytas. Dabartinis dizainas išsaugotas.";
    }

    confirmTemplateApply() {
      const pending = this.pendingTemplateApply;
      this.pendingTemplateApply = null;
      this.closeTemplateApplyModal();
      if (!pending) return;
      this.applyRequestedTemplate(pending.type, pending.id);
    }

    applyTemplate(key) {
      const template = DESIGN_TEMPLATES.find((item) => item.key === key);
      if (!template) return;
      const stickerSource = this.stickers.length ? this.stickers : Y2K_STICKERS;
      const chosen = pickTemplateStickers(stickerSource, template, template.layout.length);
      if (!chosen.length) {
        this.nodes.status.textContent = "Šablonui neradau tinkamų lipdukų.";
        this.setToolPanel("stickers");
        return;
      }

      this.activeCollageTemplateId = "";
      this.pushHistorySnapshot();
      const safe = this.getLayoutSafeArea();
      const minX = safe.left + 1.5;
      const maxX = safe.left + safe.width - 1.5;
      const minY = safe.top + 1.5;
      const maxY = safe.top + safe.height - 1.5;
      this.caseBackground = {
        type: "none",
        color: "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
        ...(template.background || {}),
      };
      this.items = chosen.map((choice, index) => {
        const sticker = choice?.sticker || choice;
        const layout = choice?.slot || template.layout[index % template.layout.length];
        const item = this.createStickerItem(sticker, index);
        item.x = clamp(safe.left + (safe.width * layout.x) / 100, minX, maxX);
        item.y = clamp(safe.top + (safe.height * layout.y) / 100, minY, maxY);
        const sizeScale = layout.scale ?? (layout.role ? 1 : TEMPLATE_STICKER_SCALE);
        item.size = Math.round(layout.size * sizeScale);
        item.rotation = layout.rotation || 0;
        item.outline = layout.outline || (layout.role === "paper" || layout.role === "hero" ? "none" : "white");
        item.opacity = layout.opacity ?? 100;
        item.layoutWeight = template.layout.length - index;
        return item;
      });
      this.selectedId = lastItem(this.items)?.uid || null;
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.setToolPanel("edit");
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.focusPreviewOnMobile();
      this.nodes.status.textContent = `Šablonas pritaikytas: ${template.label} (${this.items.length} lipd.).`;
    }

    applyPhotoCollageTemplate(templateId) {
      const template = PHOTO_COLLAGE_TEMPLATES.find((item) => item.id === templateId);
      if (!template) return;
      this.pushHistorySnapshot();
      this.activeCollageTemplateId = template.id;
      this.caseBackground = {
        type: "none",
        color: "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
        ...(template.background || {}),
      };
      const safe = this.getLayoutSafeArea();
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const layerWidth = Math.max(1, layerRect.width || 360);
      const layerHeight = Math.max(1, layerRect.height || 720);
      const newItems = [];

      (template.photoSlots || []).forEach((slot, index) => {
        const frameWidth = Math.max(36, (layerWidth * safe.width * slot.width) / 10000);
        const frameHeight = Math.max(36, (layerHeight * safe.height * slot.height) / 10000);
        newItems.push({
          uid: `photo-slot-${template.id}-${slot.id}-${Date.now()}-${index}`,
          type: "photo-slot",
          templateId: template.id,
          slotId: slot.id,
          required: slot.required !== false,
          name: slot.label || `Nuotrauka ${index + 1}`,
          x: safe.left + (safe.width * slot.x) / 100,
          y: safe.top + (safe.height * slot.y) / 100,
          size: Math.max(frameWidth, frameHeight),
          frameWidth,
          frameHeight,
          shape: slot.shape || "rounded",
          radius: slot.radius ?? 14,
          clipPath: slot.clipPath || "",
          frameStyle: safePhotoFrameStyle(slot.frameStyle),
          frameColor: safeHexColor(slot.frameColor, ""),
          frameBg: safeHexColor(slot.frameBg, ""),
          frameWidthPx: Number.isFinite(Number(slot.frameWidthPx)) ? Number(slot.frameWidthPx) : null,
          imageSrc: "",
          imageWidth: 0,
          imageHeight: 0,
          imageX: 50,
          imageY: 50,
          imageZoom: 100,
          rotation: slot.rotation || 0,
          opacity: 100,
          layoutWeight: slot.zIndex || index,
        });
      });

      (template.textLayers || []).forEach((layer, index) => {
        newItems.push({
          uid: `template-text-${template.id}-${layer.id || index}-${Date.now()}`,
          type: "text",
          text: layer.text || "Tekstas",
          font: safeTextFont(layer.font),
          color: safeTextColor(layer.color),
          effect: safeTextEffect(layer.effect),
          bold: layer.bold !== false,
          italic: Boolean(layer.italic),
          underline: Boolean(layer.underline),
          align: safeTextAlign(layer.align),
          x: safe.left + (safe.width * layer.x) / 100,
          y: safe.top + (safe.height * layer.y) / 100,
          size: layer.size || 28,
          rotation: layer.rotation || 0,
          opacity: layer.opacity || 100,
          layoutWeight: layer.zIndex || 30 + index,
        });
      });

      this.items = newItems.sort((a, b) => (a.layoutWeight || 0) - (b.layoutWeight || 0));
      this.selectedId = this.items.find((item) => item.type === "photo-slot")?.uid || this.items[0]?.uid || null;
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.paint();
      this.updateControls();
      this.renderTemplateTools();
      this.renderLayerList();
      this.syncOutput();
      this.setToolPanel("templates");
      this.focusPreviewOnMobile();
      this.nodes.status.textContent = `Nuotraukų šablonas pritaikytas: ${template.name}. Įkelk nuotraukas į rėmelius.`;
    }

    async uploadTemplateSlotPhoto(event) {
      const file = event.target.files?.[0];
      const item = this.items.find((entry) => entry.uid === this.pendingTemplateSlotId);
      event.target.value = "";
      this.pendingTemplateSlotId = "";
      if (!file || !item || item.type !== "photo-slot") return;
      const validation = validateCustomerPhotoFile(file);
      if (validation) {
        this.nodes.status.textContent = validation;
        return;
      }
      let src = "";
      let imageWidth = 0;
      let imageHeight = 0;
      try {
        src = await fileToDataUrl(file);
        const image = await imageFromSource(src);
        imageWidth = image.naturalWidth || image.width || 0;
        imageHeight = image.naturalHeight || image.height || 0;
      } catch (error) {
        this.nodes.status.textContent = uploadErrorMessage(error, "Nepavyko įkelti nuotraukos į rėmelį. Failas gali būti sugadintas.");
        return;
      }
      this.pushHistorySnapshot();
      item.imageSrc = src;
      item.imageWidth = imageWidth;
      item.imageHeight = imageHeight;
      item.aspectRatio = imageWidth && imageHeight ? Number((imageWidth / imageHeight).toFixed(4)) : 1;
      item.printSourceStatus = "uploaded";
      item.printQualityRole = "photo";
      item.imageX = 50;
      item.imageY = 50;
      item.imageZoom = 100;
      item.name = item.name || "Nuotrauka";
      this.selectedId = item.uid;
      this.clearPrintDownload();
      this.paint();
      this.updateControls();
      this.renderTemplateTools();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = "Nuotrauka įkelta į šablono rėmelį. Tempk ją rėmelio viduje arba priartink slideriu.";
    }

    removeTemplateSlotPhoto(uid) {
      const item = this.items.find((entry) => entry.uid === uid);
      if (!item || item.type !== "photo-slot" || !item.imageSrc) return;
      this.pushHistorySnapshot();
      item.imageSrc = "";
      item.imageWidth = 0;
      item.imageHeight = 0;
      item.aspectRatio = 1;
      item.printSourceStatus = "";
      item.printQualityRole = "";
      item.imageX = 50;
      item.imageY = 50;
      item.imageZoom = 100;
      this.selectedId = item.uid;
      this.clearPrintDownload();
      this.paint();
      this.updateControls();
      this.renderTemplateTools();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = "Nuotrauka pašalinta iš rėmelio.";
    }

    setTemplateColor(color) {
      const nextColor = safeHexColor(color, this.caseBackground.color || "#ffffff");
      this.pushHistorySnapshot();
      this.caseBackground.color = nextColor;
      this.caseBackground.type = "color";
      if (this.nodes.backgroundColor) this.nodes.backgroundColor.value = nextColor;
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.renderTemplateTools();
      this.renderLayerList();
      this.syncOutput();
    }

    focusPreviewOnMobile() {
      if (!window.matchMedia("(max-width: 960px)").matches) return;
      this.nodes.phoneStage?.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    async addText() {
      const text = (this.nodes.textContent?.value || this.textDraft || "").trim() || "Tekstas";
      this.textDraft = text;
      this.textFont = this.nodes.textFont?.value || this.textFont;
      this.textColor = this.nodes.textColor?.value || this.textColor;

      const bounds = this.getSafeAreaBounds(0);
      const startX = bounds ? (bounds.minX + bounds.maxX) / 2 : 50;
      const startY = bounds ? (bounds.minY + bounds.maxY) / 2 : 50;
      const spread = this.items.length * 3;
      const item = {
        uid: `text-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        type: "text",
        text,
        font: this.textFont,
        color: this.textColor,
        effect: this.textEffect,
        bold: this.textBold,
        italic: this.textItalic,
        underline: this.textUnderline,
        ...this.textExtras,
        align: this.textAlign,
        x: clamp(startX + spread, 0, 90),
        y: clamp(startY + spread, 0, 90),
        size: clamp(Number(this.textExtras?.size) || 46, 12, 500),
        rotation: 0,
        opacity: 100,
        flipX: false,
        flipY: false,
      };

      // Fit newly inserted text using its loaded font and the model's safe width.
      if (document.fonts) {
        try { await document.fonts.load((item.italic ? "italic" : "normal") + " " + (item.bold === false ? 500 : 800) + " " + item.size + "px " + safeTextFont(item.font), text); } catch {}
      }
      const insertBounds = this.getSafeAreaBounds(0);
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const availableWidth = layerRect.width * (insertBounds ? insertBounds.maxX - insertBounds.minX : 100) / 100 * 0.78;
      const availableHeight = layerRect.height * (insertBounds ? insertBounds.maxY - insertBounds.minY : 100) / 100 * 0.7;
      if (availableWidth > 32 && availableHeight > 32) {
        for (let attempt = 0; attempt < 8; attempt++) {
          const box = textBoxSize(item);
          const fit = Math.min(availableWidth / box.width, availableHeight / box.height);
          if (fit >= 1 || item.size <= 1) break;
          item.size = Math.max(1, Math.floor(item.size * fit * 0.98));
        }
      }

      this.pushHistorySnapshot();
      this.items.push(item);
      this.selectedId = item.uid;
      this.clampItemToSafeArea(item);
      this.paint();
      this.updateControls();
      this.syncOutput();
      this.setToolPanel("edit");
      this.nodes.status.textContent = "Tekstas pridėtas ant dėkliuko.";
      this.renderLayerList();
    }

    paint() {
      this.nodes.artLayer.innerHTML = this.items
        .filter((item) => !item.hidden)
        .map((item) => {
          return `
            <div
              class="placed-sticker sticker-art ${item.type === "text" ? "text-sticker" : ""} ${item.type === "photo-slot" ? "photo-slot-sticker" : ""}"
              data-outline="${safeStickerOutline(item.outline)}"
              style="${stickerPositionStyle(item, this.getSticker(item.stickerId))}"
              data-art-uid="${item.uid}"
              aria-hidden="true"
            >
              ${this.itemMarkup(item)}
            </div>
          `;
        })
        .join("");

      this.nodes.layer.innerHTML = this.items
        .filter((item) => !item.hidden)
        .map((item) => {
          return `
            <button
              class="placed-sticker ${item.type === "text" ? "text-sticker" : ""} ${item.type === "photo-slot" ? "photo-slot-sticker" : ""} ${item.uid === this.selectedId ? "is-selected" : ""} ${item.locked ? "is-locked" : ""}"
              data-outline="${safeStickerOutline(item.outline)}"
              data-locked="${item.locked ? "true" : "false"}"
              type="button"
              style="${stickerPositionStyle(item, this.getSticker(item.stickerId))}"
              data-uid="${item.uid}"
              aria-label="${escapeHtml(this.getItemLabel(item))}"
            >
              ${item.type === "text" || item.type === "photo-slot" ? this.itemMarkup(item, { control: true }) : ""}
              <span class="sticker-handle" data-rotate-handle aria-hidden="true"></span>
              <span class="sticker-handle" data-resize-handle aria-hidden="true"></span>
            </button>
          `;
        })
        .join("");

      this.nodes.layer.querySelectorAll("[data-uid]").forEach((node) => {
        node.addEventListener("pointerdown", (event) => this.startDrag(event, node.dataset.uid));
        node.addEventListener("click", () => {
          this.select(node.dataset.uid);
          if (this.selected?.type === "text") this.editTextItem(node.dataset.uid);
        });
        node.addEventListener("dblclick", () => this.editTextItem(node.dataset.uid));
      });
      this.syncRenderedStickerDimensions();
      this.renderLayerList();
      this.renderTemplateTools();
    }

    syncRenderedStickerDimensions() {
      this.nodes.artLayer.querySelectorAll("[data-art-uid] img").forEach((image) => {
        const artNode = image.closest("[data-art-uid]");
        const uid = artNode?.dataset.artUid;
        const item = this.items.find((layerItem) => layerItem.uid === uid);
        if (!item || item.type === "text" || item.type === "photo-slot") return;

        const applyDimensions = () => {
          this.fitStickerSelection(image, item);
          const width = image.naturalWidth || image.width || 0;
          const height = image.naturalHeight || image.height || 0;
          if (!width || !height) return;
          const sticker = this.getSticker(item.stickerId);
          if (!sticker) return;
          if (Number(sticker.width) === width && Number(sticker.height) === height) return;
          sticker.width = width;
          sticker.height = height;
          sticker.naturalWidth = width;
          sticker.naturalHeight = height;
          this.renderLayerList();
          this.updateStickerNode(item);
          this.syncOutput();
        };

        if (image.complete) {
          applyDimensions();
        } else {
          image.addEventListener("load", applyDimensions, { once: true });
        }
      });
    }

    fitStickerSelection(image, item) {
      // UI-only alpha bounds. Keep the artwork, export and transform box intact.
      const node = this.nodes.layer.querySelector(`[data-uid="${cssEscape(item.uid)}"]`);
      if (!node || !image.naturalWidth || !image.naturalHeight) return;
      this.selectionBounds ||= new Map();
      const key = image.currentSrc || image.src;
      let bounds = this.selectionBounds.get(key);
      if (bounds === undefined) {
        try {
          const canvas = document.createElement('canvas');
          const scale = Math.min(1,256 / Math.max(image.naturalWidth,image.naturalHeight));
          canvas.width = Math.max(1,Math.round(image.naturalWidth*scale));
          canvas.height = Math.max(1,Math.round(image.naturalHeight*scale));
          const ctx = canvas.getContext('2d',{willReadFrequently:true});
          ctx.drawImage(image,0,0,canvas.width,canvas.height);
          const pixels = ctx.getImageData(0,0,canvas.width,canvas.height).data;
          let left=canvas.width,top=canvas.height,right=-1,bottom=-1;
          for(let y=0;y<canvas.height;y++) for(let x=0;x<canvas.width;x++) {
            if(pixels[(y*canvas.width+x)*4+3]<12) continue;
            left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);
          }
          bounds = right<0 ? null : {left:left/canvas.width,top:top/canvas.height,width:(right-left+1)/canvas.width,height:(bottom-top+1)/canvas.height};
        } catch { bounds = null; }
        this.selectionBounds.set(key,bounds);
      }
      if (!bounds) return;
      let frame = node.querySelector('.sticker-selection-frame');
      if (!frame) {
        frame = document.createElement('span');
        frame.className = 'sticker-selection-frame';
        frame.setAttribute('aria-hidden','true');
        node.querySelectorAll('.sticker-handle').forEach(handle=>frame.append(handle));
        node.append(frame);
        node.dataset.tightSelection = '';
      }
      frame.style.cssText = `left:calc(${bounds.left*100}% - 3px);top:calc(${bounds.top*100}% - 3px);width:calc(${bounds.width*100}% + 6px);height:calc(${bounds.height*100}% + 6px)`;
    }

    editTextItem(uid) {
      this.select(uid);
      if (this.selected?.type !== "text" || !this.nodes.textContent) return;
      this.nodes.textContent.focus();
      this.nodes.textContent.setSelectionRange(this.nodes.textContent.value.length, this.nodes.textContent.value.length);
    }

    startDrag(event, uid) {
      event.preventDefault();
      if (this.activeDrag) return;
      const handle = event.target.closest("[data-resize-handle], [data-rotate-handle]");
      if (handle?.matches("[data-resize-handle]")) {
        this.startResize(event, uid);
        return;
      }
      if (handle?.matches("[data-rotate-handle]")) {
        this.startRotate(event, uid);
        return;
      }
      this.select(uid);
      const item = this.selected;
      if (item?.locked) return;
      const layerRect = this.nodes.layer.getBoundingClientRect();
      this.historySnapshotBeforeDrag = this.getHistorySnapshot();
      if (item?.type === "photo-slot" && item.imageSrc) {
        this.activeDrag = {
          mode: "photo-pan",
          uid,
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          imageX: item.imageX ?? 50,
          imageY: item.imageY ?? 50,
          frameWidth: Math.max(1, item.frameWidth || itemBoxSize(item).width || layerRect.width),
          frameHeight: Math.max(1, item.frameHeight || itemBoxSize(item).height || layerRect.height),
        };
        event.currentTarget.setPointerCapture(event.pointerId);
        window.addEventListener("pointermove", this.onDrag);
        window.addEventListener("pointerup", this.endDrag);
        window.addEventListener("pointercancel", this.endDrag);
        return;
      }
      this.activeDrag = {
        mode: "move",
        uid,
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        itemX: item.x,
        itemY: item.y,
        layerWidth: layerRect.width,
        layerHeight: layerRect.height,
      };
      event.currentTarget.setPointerCapture(event.pointerId);
      window.addEventListener("pointermove", this.onDrag);
      window.addEventListener("pointerup", this.endDrag);
      window.addEventListener("pointercancel", this.endDrag);
    }

    onDrag = (event) => {
      if (!this.activeDrag) return;
      if (this.activeDrag.mode === 'pinch') {
        const drag = this.activeDrag;
        if (!drag.ids.includes(event.pointerId) || this.selectedId !== drag.uid) return;
        const [a,b] = drag.ids.map(id => this.touchPointers.get(id));
        if (!a || !b) return;
        this.selected.size = Math.max(12,drag.itemSize * Math.hypot(b.x-a.x,b.y-a.y) / drag.distance);
        this.clampItemToSafeArea(this.selected);
        this.updateControls();
        this.updateStickerNode(this.selected);
        this.syncOutput();
        return;
      }
      if (event.pointerId !== this.activeDrag.pointerId) return;
      if (this.activeDrag.mode === "background-resize") {
        const drag = this.activeDrag;
        if (event.pointerId !== drag.pointerId) return;
        const sx = drag.direction.includes("e") ? 1 : drag.direction.includes("w") ? -1 : 0;
        const sy = drag.direction.includes("s") ? 1 : drag.direction.includes("n") ? -1 : 0;
        const vx = sx * drag.width / 2;
        const vy = sy * drag.height / 2;
        const factor = Math.max(0.01, 1 + ((event.clientX-drag.startX)*vx + (event.clientY-drag.startY)*vy) / Math.max(1,vx*vx+vy*vy));
        if (drag.direction.length === 1) {
          if (sx) this.caseBackground.patternStretchX = safeBackgroundStretch(drag.stretchX * factor);
          else this.caseBackground.patternStretchY = safeBackgroundStretch(drag.stretchY * factor);
        } else {
          const overscan = BACKGROUND_PATTERN_PAN_OVERSCAN;
          const effective = (drag.startScale < 100 ? drag.startScale * overscan : Math.max(drag.startScale,100 * overscan)) * factor;
          this.caseBackground.patternScale = safeBackgroundScale(effective < 100 * overscan ? effective / overscan : effective);
        }
        const offset = this.clampBackgroundOffset({x:this.caseBackground.patternOffsetX,y:this.caseBackground.patternOffsetY});
        this.caseBackground.patternOffsetX = offset.x;
        this.caseBackground.patternOffsetY = offset.y;
        this.updateCaseBackground();
        this.syncOutput();
        return;
      }
      if (this.activeDrag.mode === "background-pan") {
        const dx = (event.clientX - this.activeDrag.startX) / (this.ui?.displayScale || 1);
        const dy = (event.clientY - this.activeDrag.startY) / (this.ui?.displayScale || 1);
        const nextOffset = this.clampBackgroundOffset({
          x: this.activeDrag.startOffsetX + dx,
          y: this.activeDrag.startOffsetY + dy,
        });
        this.caseBackground.patternOffsetX = nextOffset.x;
        this.caseBackground.patternOffsetY = nextOffset.y;
        this.updateCaseBackground();
        this.syncOutput();
        return;
      }
      if (!this.selected) return;
      if (this.activeDrag.mode === "photo-pan") {
        const dx = ((event.clientX - this.activeDrag.startX) / (this.activeDrag.frameWidth * (this.ui?.displayScale || 1))) * 100;
        const dy = ((event.clientY - this.activeDrag.startY) / (this.activeDrag.frameHeight * (this.ui?.displayScale || 1))) * 100;
        this.selected.imageX = clamp(this.activeDrag.imageX + dx, 0, 100);
        this.selected.imageY = clamp(this.activeDrag.imageY + dy, 0, 100);
        this.updateStickerNode(this.selected);
        this.renderTemplateTools();
        this.syncOutput();
        return;
      }
      if (this.activeDrag.mode === "resize") {
        const dx = (event.clientX - this.activeDrag.startX) / (this.ui?.displayScale || 1);
        const dy = (event.clientY - this.activeDrag.startY) / (this.ui?.displayScale || 1);
        const distance = Math.max(dx, dy);
        this.selected.size = Math.max(12, this.activeDrag.itemSize + distance);
        this.clampItemToSafeArea(this.selected);
        this.updateControls();
        this.updateStickerNode(this.selected);
        this.syncOutput();
        return;
      }
      if (this.activeDrag.mode === "rotate") {
        const angle = Math.atan2(
          event.clientY - this.activeDrag.centerY,
          event.clientX - this.activeDrag.centerX,
        );
        this.selected.rotation = Math.round(((angle - this.activeDrag.startAngle) * 180) / Math.PI + this.activeDrag.itemRotation);
        this.updateControls();
        this.updateStickerNode(this.selected);
        this.syncOutput();
        return;
      }
      const dx = ((event.clientX - this.activeDrag.startX) / this.activeDrag.layerWidth) * 100;
      const dy = ((event.clientY - this.activeDrag.startY) / this.activeDrag.layerHeight) * 100;
      this.selected.x = this.activeDrag.itemX + dx;
      this.selected.y = this.activeDrag.itemY + dy;
      this.clampItemToSafeArea(this.selected);
      this.applySnapGuides(this.selected);
      this.updateStickerNode(this.selected);
      this.syncOutput();
    };

    endDrag = (event) => {
      const drag = this.activeDrag;
      if (!drag) return;
      if (event && (drag.mode === 'pinch' ? !drag.ids.includes(event.pointerId) : event.pointerId !== drag.pointerId)) return;
      if (event?.type === 'pointerup' && drag.mode === 'pinch') {
        if (this.ui) this.ui.ignoreCanvasClickUntil = performance.now() + 200;
        const remainingId = drag.ids.find(id => this.touchPointers.has(id));
        if (remainingId !== undefined) {
          const point = this.touchPointers.get(remainingId);
          const rect = this.nodes.layer.getBoundingClientRect();
          this.activeDrag = {mode:'move',uid:drag.uid,pointerId:remainingId,startX:point.x,startY:point.y,itemX:this.selected.x,itemY:this.selected.y,layerWidth:rect.width,layerHeight:rect.height};
          return;
        }
      }
      window.removeEventListener("pointermove", this.onDrag);
      window.removeEventListener("pointerup", this.endDrag);
      window.removeEventListener("pointercancel", this.endDrag);
      this.clearSnapGuides();
      const before = this.historySnapshotBeforeDrag;
      const after = this.getHistorySnapshot();
      if (before && this.historyKey(before) !== this.historyKey(after)) {
        this.pushHistorySnapshot(before);
      }
      this.historySnapshotBeforeDrag = null;
      this.activeDrag = null;
      this.renderLayerList();
    };

    startResize(event, uid) {
      event.stopPropagation();
      this.select(uid);
      if (this.selected?.locked) return;
      this.historySnapshotBeforeDrag = this.getHistorySnapshot();
      this.activeDrag = {
        mode: "resize",
        pointerId: event.pointerId,
        uid,
        startX: event.clientX,
        startY: event.clientY,
        itemSize: this.selected.size,
      };
      window.addEventListener("pointermove", this.onDrag);
      window.addEventListener("pointerup", this.endDrag);
      window.addEventListener("pointercancel", this.endDrag);
    }

    startRotate(event, uid) {
      event.stopPropagation();
      this.select(uid);
      if (this.selected?.locked) return;
      this.historySnapshotBeforeDrag = this.getHistorySnapshot();
      const node = this.nodes.layer.querySelector(`[data-uid="${cssEscape(uid)}"]`);
      const rect = node.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      this.activeDrag = {
        mode: "rotate",
        pointerId: event.pointerId,
        uid,
        centerX,
        centerY,
        startAngle: Math.atan2(event.clientY - centerY, event.clientX - centerX),
        itemRotation: this.selected.rotation,
      };
      window.addEventListener("pointermove", this.onDrag);
      window.addEventListener("pointerup", this.endDrag);
      window.addEventListener("pointercancel", this.endDrag);
    }

    select(uid) {
      this.selectedId = uid;
      this.backgroundResizeEnabled = false;
      this.updateBackgroundResizeControls();
      if (this.selected) this.activeToolPanel = "edit";
      if (this.selected?.type === "text") {
        this.textDraft = this.selected.text || "";
        this.textFont = this.selected.font || this.textFont;
        this.textEffect = this.selected.effect || this.textEffect;
        this.textColor = this.selected.color || this.textColor;
        this.textBold = this.selected.bold !== false;
        this.textItalic = Boolean(this.selected.italic);
        this.textUnderline = Boolean(this.selected.underline);
        this.textAlign = safeTextAlign(this.selected.align);
        if (this.nodes.textContent) this.nodes.textContent.value = this.textDraft;
        if (this.nodes.textFont) {
          this.nodes.textFont.value = this.textFont;
          this.nodes.textFont.style.fontFamily = safeTextFont(this.textFont);
        }
        if (this.nodes.textColor) this.nodes.textColor.value = this.textColor;
      }
      this.nodes.layer.querySelectorAll("[data-uid]").forEach((node) => {
        node.classList.toggle("is-selected", node.dataset.uid === uid);
      });
      this.updateTextToolState();
      this.updateControls();
      this.renderToolPanels();
      this.renderTemplateTools();
      this.renderLayerList();
    }

    clearSelection() {
      this.selectedId = null;
      this.backgroundResizeEnabled = false;
      this.updateBackgroundResizeControls();
      this.nodes.layer.querySelectorAll("[data-uid]").forEach((node) => {
        node.classList.remove("is-selected");
      });
      this.updateControls();
      this.renderLayerList();
    }

    shouldClearSelection(target) {
      if (!this.selectedId) return false;
      if (target.closest("[data-uid]")) return false;
      if (target.closest(".sticker-handle")) return false;
      if (target.closest("[data-add-sticker]")) return false;
      if (target.closest("[data-add-text], [data-text-content], [data-text-font], [data-text-color], [data-ai-photo-prompt], [data-ai-photo-preset], [data-ai-photo-generate], [data-bg-swatch], [data-bg-pattern], [data-upload-patterns], [data-trigger-photo-upload], [data-upload-case-photo], [data-collage-template], [data-template-slot-upload], [data-template-slot-remove], [data-template-slot-zoom], [data-template-color], [data-text-swatch], [data-text-preset], [data-text-effect-choice], [data-text-toggle], [data-text-align]")) return false;
      if (target.closest("[data-tool-tab], [data-tool-panel]")) return false;
      if (target.closest("[data-toggle-favorite]")) return false;
      if (target.closest("[data-sticker-category]")) return false;
      if (target.closest("[data-sticker-view], [data-open-categories], [data-trigger-upload]")) return false;
      if (target.closest("[data-select-layer], [data-layer-hide], [data-layer-lock], [data-layer-up], [data-layer-down], [data-layer-delete]")) return false;
      if (target.closest("[data-upload-model-photo], [data-clear-model-photo]")) return false;
      if (target.closest("[data-size], [data-rotation], [data-opacity], [data-flip], [data-sticker-outline]")) return false;
      if (target.closest("[data-undo], [data-redo], [data-duplicate], [data-delete], [data-export], [data-print-export], [data-print-download], [data-print-open], [data-save]")) return false;
      return true;
    }

    setStickerView(view) {
      this.stickerView = view || "browse";
      this.renderViewTabs();
      this.renderStickerGrid();
    }

    toggleFavorite(stickerId) {
      if (this.favoriteStickerIds.includes(stickerId)) {
        this.favoriteStickerIds = this.favoriteStickerIds.filter((id) => id !== stickerId);
      } else {
        this.favoriteStickerIds = [...this.favoriteStickerIds, stickerId];
      }
      saveFavorites(this.favoriteStickerIds);
      this.renderStickerGrid();
    }

    setStickerSearch(query) {
      this.stickerSearch = query.trim();
      this.renderStickerGrid();
    }

    openCategories() {
      this.nodes.categoryModal.classList.add("is-open");
      this.nodes.categoryModal.setAttribute("aria-hidden", "false");
    }

    closeCategories() {
      this.nodes.categoryModal.classList.remove("is-open");
      this.nodes.categoryModal.setAttribute("aria-hidden", "true");
    }

    updateStickerNode(item) {
      const node = this.nodes.layer.querySelector(`[data-uid="${cssEscape(item.uid)}"]`);
      const artNode = this.nodes.artLayer.querySelector(`[data-art-uid="${cssEscape(item.uid)}"]`);
      const sticker = this.getSticker(item.stickerId);
      if (node) node.setAttribute("style", stickerPositionStyle(item, sticker));
      if (artNode) artNode.setAttribute("style", stickerPositionStyle(item, sticker));
      if (node) node.dataset.outline = safeStickerOutline(item.outline);
      if (artNode) artNode.dataset.outline = safeStickerOutline(item.outline);
      if (item.type === "text") {
        const nodeText = node?.querySelector(".case-text");
        const artText = artNode?.querySelector(".case-text");
        if (nodeText) nodeText.outerHTML = this.itemMarkup(item, { control: true });
        if (artText) artText.outerHTML = this.itemMarkup(item);
      }
      if (item.type === "photo-slot") {
        const nodeFrame = node?.querySelector(".photo-slot-frame");
        const artFrame = artNode?.querySelector(".photo-slot-frame");
        if (nodeFrame) nodeFrame.outerHTML = this.itemMarkup(item, { control: true });
        if (artFrame) artFrame.outerHTML = this.itemMarkup(item);
      }
    }

    toggleLayerHidden(uid) {
      const item = this.items.find((layerItem) => layerItem.uid === uid);
      if (!item) return;
      this.pushHistorySnapshot();
      item.hidden = !item.hidden;
      if (item.hidden && this.selectedId === uid) {
        this.selectedId = uid;
      }
      this.clearSnapGuides();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = item.hidden ? "Sluoksnis paslėptas." : "Sluoksnis vėl rodomas.";
    }

    toggleLayerLocked(uid) {
      const item = this.items.find((layerItem) => layerItem.uid === uid);
      if (!item) return;
      this.pushHistorySnapshot();
      item.locked = !item.locked;
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = item.locked ? "Sluoksnis užrakintas." : "Sluoksnis atrakintas.";
    }

    applySnapGuides(item) {
      if (!item || this.activeDrag?.mode !== "move") return;
      const snap = this.getSnapAdjustment(item);
      if (!snap.x && !snap.y) {
        this.clearSnapGuides();
        return;
      }
      if (snap.x) item.x = snap.x.value;
      if (snap.y) item.y = snap.y.value;
      this.renderSnapGuides(snap);
    }

    getSnapAdjustment(item) {
      const targets = this.getSnapTargets(item);
      return {
        x: this.closestSnap(item.x, targets.x),
        y: this.closestSnap(item.y, targets.y),
      };
    }

    closestSnap(current, targets) {
      return targets.reduce((best, target) => {
        const distance = Math.abs(current - target.value);
        if (distance > SNAP_THRESHOLD_PERCENT) return best;
        if (best && distance >= best.distance) return best;
        return { ...target, distance };
      }, null);
    }

    getSnapTargets(item) {
      const safe = this.getLayoutSafeArea();
      const box = this.getItemBoxPercent(item);
      const x = [
        { value: safe.left + box.width / 2, line: safe.left, kind: "edge" },
        { value: safe.left + safe.width / 2, line: safe.left + safe.width / 2, kind: "center" },
        { value: safe.left + safe.width - box.width / 2, line: safe.left + safe.width, kind: "edge" },
        { value: safe.left + safe.width / 3, line: safe.left + safe.width / 3, kind: "third" },
        { value: safe.left + (safe.width * 2) / 3, line: safe.left + (safe.width * 2) / 3, kind: "third" },
      ];
      const y = [
        { value: safe.top + box.height / 2, line: safe.top, kind: "edge" },
        { value: safe.top + safe.height / 2, line: safe.top + safe.height / 2, kind: "center" },
        { value: safe.top + safe.height - box.height / 2, line: safe.top + safe.height, kind: "edge" },
        { value: safe.top + safe.height / 3, line: safe.top + safe.height / 3, kind: "third" },
        { value: safe.top + (safe.height * 2) / 3, line: safe.top + (safe.height * 2) / 3, kind: "third" },
      ];

      this.items.forEach((other) => {
        if (other.uid === item.uid) return;
        if (other.hidden) return;
        x.push({ value: other.x, line: other.x, kind: "item" });
        y.push({ value: other.y, line: other.y, kind: "item" });
      });

      return { x, y };
    }

    getItemBoxPercent(item) {
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const box = itemBoxSize(item, this.getSticker(item.stickerId));
      return {
        width: layerRect.width ? (box.width / layerRect.width) * 100 : 0,
        height: layerRect.height ? (box.height / layerRect.height) * 100 : 0,
      };
    }

    renderSnapGuides(snap) {
      if (!this.nodes.snapGuides) return;
      const lines = [];
      if (snap.x) {
        lines.push(`<span class="snap-guide is-vertical is-${snap.x.kind}" style="left:${clamp(snap.x.line, -10, 110)}%"></span>`);
      }
      if (snap.y) {
        lines.push(`<span class="snap-guide is-horizontal is-${snap.y.kind}" style="top:${clamp(snap.y.line, -10, 110)}%"></span>`);
      }
      this.nodes.snapGuides.innerHTML = lines.join("");
      this.nodes.snapGuides.classList.toggle("is-visible", Boolean(lines.length));
    }

    clearSnapGuides() {
      if (!this.nodes?.snapGuides) return;
      this.nodes.snapGuides.innerHTML = "";
      this.nodes.snapGuides.classList.remove("is-visible");
    }

    clampItemToSafeArea(item) {
      const bounds = this.getItemSafeAreaBounds(item) || this.getSafeAreaBounds(0);
      if (!bounds) return;
      item.x = clamp(item.x, Math.min(bounds.minX, bounds.maxX), Math.max(bounds.minX, bounds.maxX));
      item.y = clamp(item.y, Math.min(bounds.minY, bounds.maxY), Math.max(bounds.minY, bounds.maxY));
      if (!Number.isFinite(item.x) || !Number.isFinite(item.y)) {
        item.x = (bounds.minX + bounds.maxX) / 2;
        item.y = (bounds.minY + bounds.maxY) / 2;
      }
    }

    clampItemToLayoutArea(item, safe) {
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const box = itemBoxSize(item, this.getSticker(item.stickerId));
      const halfX = ((box.width / 2) / Math.max(1, layerRect.width)) * 100;
      const halfY = ((box.height / 2) / Math.max(1, layerRect.height)) * 100;
      const bleedX = item.type === "text" ? 0 : Math.min(halfX * 0.32, 3.5);
      const bleedY = item.type === "text" ? 0 : Math.min(halfY * 0.32, 3.5);
      const minX = safe.left + halfX - bleedX;
      const maxX = safe.left + safe.width - halfX + bleedX;
      const minY = safe.top + halfY - bleedY;
      const maxY = safe.top + safe.height - halfY + bleedY;
      item.x = clamp(item.x, Math.min(minX, maxX), Math.max(minX, maxX));
      item.y = clamp(item.y, Math.min(minY, maxY), Math.max(minY, maxY));
    }

    clampAllItemsToSafeArea() {
      this.items.forEach((item) => this.clampItemToSafeArea(item));
      this.paint();
      this.syncOutput();
    }

    getLayoutSafeArea() {
      const modelImage = this.getModelImage();
      if (modelImage) return modelImage.safeArea || modelImage.stickerBounds || DEFAULT_SAFE_AREA;
      return { left: 9, top: 9, width: 82, height: 82 };
    }

    applySmartAutoLayout(style = "balanced") {
      const normalizedStyle = ["balanced", "bomb", "center", "minimal", "edges"].includes(style) ? style : "balanced";
      const shouldGenerateFresh = !this.items.length || this.items.every((item) => item.stickerId);
      if (shouldGenerateFresh) {
        const sourceStickers = this.getFilteredStickers().length ? this.getFilteredStickers() : this.stickers;
        const targetCount = smartLayoutGeneratedCount(normalizedStyle, sourceStickers.length);
        const chosen = pickSmartLayoutStickers(sourceStickers, targetCount, {
          category: this.activeStickerCategory,
          subcategory: this.activeStickerSubcategory,
        });
        if (!chosen.length) {
          this.nodes.status.textContent = "Neradau lipdukų automatiniam išdėstymui. Įkelk arba pasirink lipdukų kategoriją.";
          this.setToolPanel("stickers");
          return;
        }
        this.items = chosen.map((sticker, index) => this.createStickerItem(sticker, index));
        this.selectedId = this.items[0]?.uid || null;
      }

      const safe = this.getLayoutSafeArea();
      const count = this.items.length;
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const safeWidthPx = Math.max(1, (layerRect.width * safe.width) / 100);
      const safeHeightPx = Math.max(1, (layerRect.height * safe.height) / 100);
      const density = smartLayoutDensity(normalizedStyle, count);
      const baseSize = clamp(Math.min(safeWidthPx, safeHeightPx) / density, 56, 132);
      const centerX = safe.left + safe.width / 2;
      const centerY = safe.top + safe.height / 2;

      const layoutItems = [...this.items].sort((a, b) => (b.layoutWeight || 1) - (a.layoutWeight || 1));
      layoutItems.forEach((item, index) => {
        const position = smartLayoutPosition(normalizedStyle, index, count, safe, centerX, centerY);
        const scale = smartLayoutScale(normalizedStyle, index, count);
        const rotation = smartLayoutRotation(normalizedStyle, index);
        const sticker = this.getSticker(item.stickerId);
        const aspectScale = item.type === "text" ? 1 : smartAspectScale(sticker);
        item.layoutWeight = scale;
        item.x = position.x;
        item.y = position.y;
        item.rotation = item.type === "text" && normalizedStyle !== "bomb" ? 0 : rotation;
        item.size = Math.round((item.type === "text" ? baseSize * 0.58 : baseSize) * scale * aspectScale);
        if (item.type !== "text" && normalizedStyle !== "bomb") item.outline = "white";
        this.clampItemToLayoutArea(item, safe);
      });

      this.items.sort((a, b) => (a.layoutWeight || 1) - (b.layoutWeight || 1));
      this.selectedId = this.items[this.items.length - 1]?.uid || this.selectedId;

      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
      this.setToolPanel("edit");
      this.nodes.status.textContent = `Automatinis išdėstymas pritaikytas: ${autoLayoutLabel(normalizedStyle)} (${this.items.length} elementai).`;
    }

    updateControls() {
      this.updateHistoryButtons();
      const item = this.selected;
      const disabled = !item;
      const locked = Boolean(item?.locked);
      const fixedPhotoSlot = item?.type === "photo-slot";
      this.nodes.duplicate.disabled = disabled;
      this.nodes.delete.disabled = disabled;
      if (this.nodes.size) this.nodes.size.disabled = disabled || locked || fixedPhotoSlot;
      if (this.nodes.rotation) this.nodes.rotation.disabled = disabled || locked || fixedPhotoSlot;
      if (this.nodes.opacity) this.nodes.opacity.disabled = disabled || locked;
      this.nodes.flipButtons?.forEach((button) => {
        button.disabled = disabled || locked;
        button.classList.toggle("is-active", !disabled && (button.dataset.flip === "x" ? Boolean(item?.flipX) : Boolean(item?.flipY)));
      });
      if (this.nodes.textContent) this.nodes.textContent.disabled = locked;
      if (this.nodes.textFont) this.nodes.textFont.disabled = locked;
      if (this.nodes.textColor) this.nodes.textColor.disabled = locked;
      if (this.nodes.selectedSummary) {
        const itemKind = item?.type === "text" ? "Tekstas" : item?.type === "photo-slot" ? "Nuotraukos rėmelis" : "Lipdukas";
        this.nodes.selectedSummary.textContent = item
          ? `${itemKind}: ${this.getItemLabel(item)}${item.locked ? " / užrakinta" : ""}${item.hidden ? " / paslėpta" : ""}`
          : "Pasirink elementą ant dėklio arba sluoksniuose.";
        this.nodes.selectedSummary.classList.toggle("is-empty", disabled);
      }
      if (this.nodes.outlineControl) this.nodes.outlineControl.hidden = disabled || item?.type === "text" || fixedPhotoSlot;
      this.nodes.outlineButtons?.forEach((button) => {
        button.disabled = disabled || locked || item?.type === "text" || fixedPhotoSlot;
        button.classList.toggle("is-active", !disabled && safeStickerOutline(item?.outline) === button.dataset.stickerOutline);
      });

      if (!item) {
        if (this.nodes.sizeValue) this.nodes.sizeValue.textContent = "-";
        if (this.nodes.rotationValue) this.nodes.rotationValue.textContent = "-";
        if (this.nodes.opacityValue) this.nodes.opacityValue.textContent = "-";
        return;
      }
      this.nodes.size.value = item.size;
      this.nodes.rotation.value = item.rotation;
      if (this.nodes.opacity) this.nodes.opacity.value = safeItemOpacity(item.opacity);
      this.nodes.sizeValue.textContent = `${item.size}px`;
      this.nodes.rotationValue.textContent = `${item.rotation}°`;
      if (this.nodes.opacityValue) this.nodes.opacityValue.textContent = `${safeItemOpacity(item.opacity)}%`;
      if (item.type === "text") {
        this.textBold = item.bold !== false;
        this.textItalic = Boolean(item.italic);
        this.textUnderline = Boolean(item.underline);
        this.textAlign = safeTextAlign(item.align);
        if (this.nodes.textContent) this.nodes.textContent.value = item.text || "";
        if (this.nodes.textFont) {
          this.nodes.textFont.value = safeTextFont(item.font);
          this.nodes.textFont.style.fontFamily = safeTextFont(item.font);
        }
        if (this.nodes.textColor) this.nodes.textColor.value = safeTextColor(item.color);
        this.updateTextToolState();
      }
    }

    duplicateSelected() {
      if (!this.selected) return;
      this.pushHistorySnapshot();
      const copy = {
        ...this.selected,
        uid: `${this.selected.type === "text" ? "text" : this.selected.stickerId}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        x: this.selected.x + 8,
        y: this.selected.y + 8,
      };
      this.items.push(copy);
      this.selectedId = copy.uid;
      this.paint();
      this.updateControls();
      this.syncOutput();
      this.renderLayerList();
    }

    moveLayer(uid, direction) {
      const index = this.items.findIndex((item) => item.uid === uid);
      if (index < 0) return;
      const nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= this.items.length) return;
      this.pushHistorySnapshot();
      const [item] = this.items.splice(index, 1);
      this.items.splice(nextIndex, 0, item);
      this.selectedId = uid;
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.syncOutput();
    }

    deleteItem(uid) {
      const index = this.items.findIndex((item) => item.uid === uid);
      if (index < 0) return;
      this.pushHistorySnapshot();
      this.items.splice(index, 1);
      if (this.selectedId === uid) {
        this.selectedId = this.items[Math.min(index, this.items.length - 1)]?.uid || null;
      }
      this.clearPrintDownload();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.renderPhotoUploadPanel();
      this.syncOutput();
    }

    deleteSelected() {
      if (!this.selected) return;
      this.deleteItem(this.selectedId);
    }

    reset() {
      if (!this.items.length && this.caseBackground?.type === "none") return;
      this.pushHistorySnapshot();
      this.items = [];
      this.selectedId = null;
      this.activeCollageTemplateId = "";
      this.caseBackground = {
        type: "none",
        color: this.caseBackground?.color || "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
      };
      this.clearPrintDownload();
      this.updateCaseBackground();
      this.paint();
      this.updateControls();
      this.renderLayerList();
      this.renderTemplateTools();
      this.syncOutput();
      this.nodes.status.textContent = "Dizainas išvalytas.";
    }

    async uploadStickers(event) {
      const files = Array.from(event.target.files || []);
      const uploaded = await Promise.all(files.map(fileToSticker));
      this.customStickers = [...this.customStickers, ...uploaded.filter(Boolean)];
      saveCustomStickers(this.customStickers);
      this.renderCategoryTabs();
      this.renderStickerGrid();
      event.target.value = "";
      this.nodes.status.textContent = "Lipdukai įkelti. Jie liks šiame naršyklės lange.";
    }

    fitUploadedPhotoToCase(item, sticker) {
      const safe = this.getBackgroundLayoutSafeArea();
      const layer = this.getEditorLayoutRect(this.nodes.layer);
      const width = layer.width * safe.width / 100;
      const height = layer.height * safe.height / 100;
      const aspect = stickerAspect(sticker);
      if (!(width > 0 && height > 0 && aspect > 0)) return;
      // Cover the selected case without stretching the image; existing masks clip excess.
      item.size = aspect >= 1 ? Math.max(width, height * aspect) : Math.max(width / aspect, height);
      item.x = safe.left + safe.width / 2;
      item.y = safe.top + safe.height / 2;
    }

    async uploadCasePhotos(event) {
      const files = Array.from(event.target.files || []);
      const replaceId = this.pendingReplacePhotoId || "";
      this.pendingReplacePhotoId = "";
      event.target.value = "";
      if (!files.length) return;

      const sourceFiles = replaceId ? files.slice(0, 1) : files;
      const results = await Promise.allSettled(sourceFiles.map((file) => fileToCustomerPhotoSticker(file)));
      const uploaded = results
        .filter((result) => result.status === "fulfilled" && result.value)
        .map((result) => result.value);
      const errors = results
        .filter((result) => result.status === "rejected")
        .map((result) => uploadErrorMessage(result.reason));
      if (!uploaded.length) {
        this.nodes.status.textContent = errors[0] || "Nepavyko įkelti nuotraukos. Pabandykite kitą failą.";
        return;
      }

      this.pushHistorySnapshot();
      this.customStickers = [...this.customStickers, ...uploaded];
      let storageWarning = "";
      try {
        saveCustomStickers(this.customStickers);
      } catch {
        storageWarning = " Nuotrauka įkelta, bet naršyklė jos neišsaugojo vėlesniam naudojimui, nes failas per didelis.";
      }

      const replaceItem = replaceId ? this.items.find((entry) => entry.uid === replaceId) : null;
      if (replaceItem && replaceItem.type !== "text") {
        replaceItem.stickerId = uploaded[0].id;
        replaceItem.outline = "none";
        this.applyUploadedPhotoMetadata(replaceItem, uploaded[0]);
        this.selectedId = replaceItem.uid;
      } else {
        if (replaceId) this.nodes.status.textContent = "Nepavyko rasti keičiamos nuotraukos, todėl įkelta kaip nauja.";
        uploaded.forEach((sticker, index) => {
          const item = this.createStickerItem(sticker, this.items.length + index);
          this.fitUploadedPhotoToCase(item, sticker);
          item.outline = "none";
          item.rotation = 0;
          this.applyUploadedPhotoMetadata(item, sticker);
          this.clampItemToSafeArea(item);
          this.items.push(item);
          this.selectedId = item.uid;
        });
      }

      this.clearPrintDownload();
      this.renderCategoryTabs();
      this.renderStickerGrid();
      this.renderLayerList();
      this.renderPhotoUploadPanel();
      this.paint();
      this.updateControls();
      this.syncOutput();
      this.setToolPanel(replaceItem ? "photo" : "edit");
      const tinyWarning = uploaded.some((sticker) => Math.min(Number(sticker.width) || 0, Number(sticker.height) || 0) > 0 && Math.min(Number(sticker.width) || 0, Number(sticker.height) || 0) < 700);
      const partialWarning = errors.length ? ` ${errors.length} fail. nepavyko įkelti.` : "";
      const qualityHint = tinyWarning ? " Nuotrauka labai maža, todėl spaudoje gali atrodyti neryški." : "";
      this.nodes.status.textContent = replaceItem
        ? `Nuotrauka pakeista.${qualityHint}${partialWarning}${storageWarning}`
        : uploaded.length === 1
          ? `Nuotrauka įkelta ant dėkliuko. Gali ją didinti, slinkti arba pasukti.${qualityHint}${partialWarning}${storageWarning}`
          : `Įkeltos ${uploaded.length} nuotraukos ant dėkliuko.${qualityHint}${partialWarning}${storageWarning}`;
    }

    removeUploadedPhoto(uid) {
      const item = this.items.find((entry) => entry.uid === uid);
      if (!item || !this.isCustomerPhotoItem(item) || item.type === "photo-slot") return;
      this.deleteItem(uid);
      this.setToolPanel("photo");
      this.nodes.status.textContent = "Nuotrauka pašalinta.";
    }

    applyAiPhotoPreset(key) {
      const preset = AI_PHOTO_PRESETS.find((item) => item.key === key);
      if (!preset) return;
      this.aiPhotoPrompt = preset.prompt;
      if (this.nodes.aiPhotoPrompt) this.nodes.aiPhotoPrompt.value = preset.prompt;
      this.root.querySelectorAll("[data-ai-photo-preset]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.aiPhotoPreset === key);
      });
      this.nodes.status.textContent = `Pasirinktas AI stilius: ${preset.label}.`;
    }

    async applyAiPhotoPrompt() {
      const item = this.selected;
      const sticker = item?.type !== "text" ? this.getSticker(item?.stickerId) : null;
      if (!item || !sticker?.src) {
        this.nodes.status.textContent = "Pirma pasirink nuotrauką ar paveikslėlį ant dėkliuko.";
        this.setToolPanel("photo");
        return;
      }

      const prompt = (this.nodes.aiPhotoPrompt?.value || this.aiPhotoPrompt || "").trim();
      if (!prompt) {
        this.nodes.status.textContent = "Įrašyk promptą arba pasirink stiliaus mygtuką.";
        return;
      }

      const endpoint = this.root.dataset.aiImageEndpoint;
      if (!endpoint) {
        this.nodes.status.textContent = "AI keitimui dar reikia prijungti serverio endpointą. Frontendas jau paruoštas.";
        return;
      }

      try {
        this.nodes.status.textContent = "AI keičia nuotrauką pagal promptą...";
        const image = await imageSourceToPngDataUrl(sticker.src);
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            prompt,
            image,
            model: this.model,
            item: {
              name: sticker.name,
              width: sticker.width,
              height: sticker.height,
            },
          }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.error || `AI endpoint klaida: ${response.status}`);
        const outputSrc = result.image || result.src || result.dataUrl;
        if (!outputSrc) throw new Error("AI endpoint negrąžino paveikslėlio.");

        const outputImage = await imageFromSource(outputSrc);
        const generatedSticker = {
          id: `ai-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          name: result.name || `${sticker.name || "Nuotrauka"} AI`,
          category: "Custom",
          subcategory: "AI nuotraukos",
          type: "image",
          src: outputSrc,
          printSrc: outputSrc,
          printSourceStatus: "uploaded",
          printQualityRole: "photo",
          width: outputImage.naturalWidth || outputImage.width || sticker.width || 0,
          height: outputImage.naturalHeight || outputImage.height || sticker.height || 0,
          tags: ["AI", "photo", "generated", prompt],
          keywords: ["AI", "photo", "generated", prompt],
        };
        generatedSticker.aspectRatio = generatedSticker.width && generatedSticker.height
          ? Number((generatedSticker.width / generatedSticker.height).toFixed(4))
          : 1;

        this.pushHistorySnapshot();
        this.customStickers = [...this.customStickers, generatedSticker];
        item.stickerId = generatedSticker.id;
        item.rotation = item.rotation || 0;
        this.clearPrintDownload();
        this.paint();
        this.updateControls();
        this.renderLayerList();
        this.renderStickerGrid();
        this.syncOutput();
        this.nodes.status.textContent = "Nuotrauka pakeista pagal promptą.";
      } catch (error) {
        this.nodes.status.textContent = `Nepavyko pakeisti nuotraukos: ${error.message || "nežinoma klaida"}.`;
      }
    }

    async uploadPatterns(event) {
      const files = Array.from(event.target.files || []);
      const uploaded = (await Promise.all(files.map(fileToPattern))).filter(Boolean);
      if (!uploaded.length) return;
      this.customBackgroundPatterns = [...this.customBackgroundPatterns, ...uploaded].slice(-48);
      saveBackgroundPatterns(this.customBackgroundPatterns);
      if (!this.caseBackground.pattern) {
        this.caseBackground.pattern = uploaded[0].src;
        this.caseBackground.patternX = 50;
        this.caseBackground.patternY = 50;
        this.caseBackground.patternOffsetX = 0;
        this.caseBackground.patternOffsetY = 0;
        this.caseBackground.patternScale = 100;
      }
      this.caseBackground.type = "pattern";
      this.renderPatternGrid();
      this.updateCaseBackground();
      this.renderLayerList();
      this.syncOutput();
      event.target.value = "";
      this.nodes.status.textContent = "Raštai įkelti. Pasirink rašto miniatiūrą fonui.";
    }

    clearPrintDownload() {
      this.printFileUrl = "";
      if (this.nodes.printDownload) {
        this.nodes.printDownload.removeAttribute("href");
        this.nodes.printDownload.removeAttribute("download");
        this.nodes.printDownload.hidden = true;
      }
      if (this.nodes.printOpen) {
        this.nodes.printOpen.removeAttribute("href");
        this.nodes.printOpen.hidden = true;
      }
    }

    async uploadModelPhoto(event) {
      const file = event.target.files?.[0];
      if (!file || !file.type.startsWith("image/")) return;
      const src = await fileToDataUrl(file);
      const safeArea = MODEL_PHOTO_SAFE_AREAS[this.model] || (await detectSafeArea(src));
      this.customModelPhotos[this.model] = {
        src,
        aspect: "1 / 1",
        displayWidth: 520,
        stickerBounds: {
          left: 0,
          top: 0,
          width: 100,
          height: 100,
        },
        safeArea,
        clipPath: MODEL_PHOTO_CLIP_PATHS[this.model],
        maskSrc: MODEL_PHOTO_MASKS[this.model],
        safeAreaVersion: MODEL_PHOTO_SAFE_AREAS[this.model] ? MODEL_PHOTO_SAFE_AREA_VERSION : 2,
      };
      saveModelPhotos(this.customModelPhotos);
      this.missingModelImages.delete(this.model);
      event.target.value = "";
      this.setModel(this.model);
    }

    clearModelPhoto() {
      delete this.customModelPhotos[this.model];
      saveModelPhotos(this.customModelPhotos);
      this.setModel(this.model);
    }

    clearCustomStickers() {
      this.pushHistorySnapshot();
      this.customStickers = [];
      saveCustomStickers(this.customStickers);
      this.items = this.items.filter(
        (item) => item.type === "text" || item.type === "photo-slot" || this.stickers.some((sticker) => sticker.id === item.stickerId && sticker.category !== "Custom"),
      );
      this.selectedId = lastItem(this.items)?.uid || null;
      this.renderStickerGrid();
      this.renderCategoryTabs();
      this.paint();
      this.syncOutput();
      this.nodes.status.textContent = "Įkelti lipdukai išvalyti.";
    }

    clearBackgroundPatterns() {
      if (!this.customBackgroundPatterns.length) return;
      this.pushHistorySnapshot();
      this.customBackgroundPatterns = [];
      saveBackgroundPatterns(this.customBackgroundPatterns);
      if (this.caseBackground.type === "pattern" && !BUILT_IN_BACKGROUND_PATTERNS.some((pattern) => pattern.src === this.caseBackground.pattern)) {
        this.caseBackground.type = "none";
        this.caseBackground.pattern = "";
      }
      this.renderPatternGrid();
      this.updateCaseBackground();
      this.renderLayerList();
      this.syncOutput();
      this.nodes.status.textContent = "Įkelti raštai išvalyti.";
    }

    clearCaseBackground() {
      if (!this.hasCaseBackgroundLayer()) return;
      this.pushHistorySnapshot();
      this.caseBackground = {
        type: "none",
        color: this.caseBackground?.color || "#ffffff",
        pattern: "",
        patternX: 50,
        patternY: 50,
        patternOffsetX: 0,
        patternOffsetY: 0,
        patternScale: 100,
      };
      this.updateCaseBackground();
      this.renderLayerList();
      this.renderPatternGrid();
      this.syncOutput();
      this.nodes.status.textContent = "Fonas pašalintas.";
    }

    getDesignPayload() {
      return {
        version: 2,
        model: this.model,
        background: {
          type: this.caseBackground.type,
          color: safeHexColor(this.caseBackground.color, "#ffffff"),
          colorOpacity: clamp(this.caseBackground.colorOpacity ?? 100, 0, 100),
          pattern: this.caseBackground.pattern || "",
          patternX: clamp(this.caseBackground.patternX ?? 50, 0, 100),
          patternY: clamp(this.caseBackground.patternY ?? 50, 0, 100),
          patternOffsetX: Number(this.caseBackground.patternOffsetX) || 0,
          patternOffsetY: Number(this.caseBackground.patternOffsetY) || 0,
          patternScale: safeBackgroundScale(this.caseBackground.patternScale),
          patternStretchX: safeBackgroundStretch(this.caseBackground.patternStretchX),
          patternStretchY: safeBackgroundStretch(this.caseBackground.patternStretchY),
        },
        customFonts: (window.StrayzyStudioFonts || []).filter(f => this.items.some(item => item.font === f.family)),
        stickers: this.items.map(({ type, stickerId, templateId, slotId, required, name, frameWidth, frameHeight, shape, radius, clipPath, frameStyle, frameColor, frameBg, frameWidthPx, imageSrc, imageWidth, imageHeight, aspectRatio, printSourceStatus, printQualityRole, uploadedFileName, imageX, imageY, imageZoom, text, font, color, effect, bold, italic, underline, strike, letterSpacing, lineHeight, align, outline, x, y, size, rotation, opacity, flipX, flipY, hidden, locked }) => ({
          type: type || "sticker",
          stickerId,
          templateId,
          slotId,
          required: required !== false,
          name,
          frameWidth,
          frameHeight,
          shape,
          radius,
          clipPath,
          frameStyle: safePhotoFrameStyle(frameStyle),
          frameColor: safeHexColor(frameColor, ""),
          frameBg: safeHexColor(frameBg, ""),
          frameWidthPx: Number.isFinite(Number(frameWidthPx)) ? Number(frameWidthPx) : null,
          imageSrc,
          imageWidth: Number(imageWidth) || 0,
          imageHeight: Number(imageHeight) || 0,
          aspectRatio: Number(aspectRatio) || 1,
          printSourceStatus: printSourceStatus || "",
          printQualityRole: printQualityRole || "",
          uploadedFileName: uploadedFileName || "",
          imageX,
          imageY,
          imageZoom,
          text,
          font,
          color,
          effect,
          bold,
          italic,
          underline,
          strike: Boolean(strike),
          letterSpacing: clamp(Number(letterSpacing) || 0, -10, 50),
          lineHeight: lineHeight == null ? null : clamp(Number(lineHeight) || 100, 70, 200),
          align,
          outline: safeStickerOutline(outline),
          x: Number(x.toFixed(2)),
          y: Number(y.toFixed(2)),
          size,
          rotation,
          opacity,
          flipX,
          flipY,
          hidden,
          locked,
        })),
      };
    }

    getActivePhotoTemplate() {
      const activeTemplateId = this.activeCollageTemplateId || "";
      const slotTemplateId = this.items.find((item) => item.type === "photo-slot")?.templateId || "";
      const candidateIds = [];
      if (activeTemplateId) candidateIds.push(activeTemplateId);
      if (slotTemplateId && slotTemplateId !== activeTemplateId) candidateIds.push(slotTemplateId);

      for (const templateId of candidateIds) {
        const template = PHOTO_COLLAGE_TEMPLATES.find((item) => item.id === templateId);
        const hasTemplateSlots = this.items.some(
          (entry) => entry.type === "photo-slot" && entry.templateId === templateId,
        );
        if (template && hasTemplateSlots) {
          if (this.activeCollageTemplateId !== templateId) {
            this.activeCollageTemplateId = templateId;
          }
          return template;
        }
      }

      if (this.activeCollageTemplateId && !slotTemplateId) {
        this.activeCollageTemplateId = "";
      }
      return null;
    }

    getPhotoSlotItem(template, slot) {
      if (!template || !slot) return null;
      return this.items.find((item) => (
        item.type === "photo-slot" &&
        item.templateId === template.id &&
        item.slotId === slot.id
      )) || null;
    }

    isPhotoSlotRequired(slot) {
      return slot?.required !== false;
    }

    isPhotoSlotItemRequired(item) {
      if (!item || item.type !== "photo-slot") return false;
      const template = PHOTO_COLLAGE_TEMPLATES.find((entry) => entry.id === item.templateId);
      const slot = template?.photoSlots?.find((entry) => entry.id === item.slotId);
      if (slot) return this.isPhotoSlotRequired(slot);
      return item.required !== false;
    }

    hasValidPhotoSlotImage(item) {
      const src = String(item?.imageSrc || "").trim();
      if (!src) return false;
      const width = Number(item?.imageWidth) || 0;
      const height = Number(item?.imageHeight) || 0;
      if ((width > 0 || height > 0) && (width <= 0 || height <= 0)) return false;
      return true;
    }

    getMissingRequiredPhotoSlots(template = this.getActivePhotoTemplate()) {
      if (!template || !Array.isArray(template.photoSlots) || !template.photoSlots.length) return [];
      return template.photoSlots
        .filter((slot) => this.isPhotoSlotRequired(slot))
        .map((slot) => this.getPhotoSlotItem(template, slot) || {
          uid: `missing-${template.id}-${slot.id}`,
          type: "photo-slot",
          templateId: template.id,
          slotId: slot.id,
          name: slot.label || slot.id || "Nuotrauka",
          imageSrc: "",
        })
        .filter((item) => !this.hasValidPhotoSlotImage(item));
    }

    validatePhotoTemplateForExport() {
      const template = this.getActivePhotoTemplate();
      if (!template || !Array.isArray(template.photoSlots) || !template.photoSlots.length) {
        return { ok: true, template: null, missing: [] };
      }
      const missing = this.getMissingRequiredPhotoSlots(template);
      return { ok: missing.length === 0, template, missing };
    }

    showPhotoTemplateExportWarning(report = this.validatePhotoTemplateForExport()) {
      const count = report.missing?.length || 0;
      if (!count) return;
      const names = report.missing
        .map((item) => item.name || item.slotId || "Nuotrauka")
        .filter(Boolean)
        .slice(0, 4)
        .join(", ");
      const message = count === 1
        ? `Įkelkite nuotrauką į privalomą šablono vietą: ${names}.`
        : `Įkelkite nuotraukas į visas privalomas šablono vietas (${count}): ${names}${count > 4 ? "..." : ""}.`;
      if (this.nodes.printQualityWarning) {
        this.nodes.printQualityWarning.textContent = message;
        this.nodes.printQualityWarning.hidden = false;
        this.nodes.printQualityWarning.classList.add("is-low-quality");
      }
      if (this.nodes.printQualityExportWarning) {
        this.nodes.printQualityExportWarning.textContent = message;
        this.nodes.printQualityExportWarning.hidden = false;
        this.nodes.printQualityExportWarning.classList.add("is-low-quality");
      }
      this.renderTemplateTools();
      this.renderFinalSummary();
      this.nodes.status.textContent = "Prieš užbaigiant dizainą įkelkite nuotraukas į privalomas šablono vietas.";
    }

    clearPhotoTemplateExportWarning() {
      [this.nodes.printQualityWarning, this.nodes.printQualityExportWarning].forEach((node) => {
        if (!node) return;
        const text = node.textContent || "";
        if (/privalom/i.test(text) || /šablono viet/i.test(text)) {
          node.textContent = "";
          node.hidden = true;
          node.classList.remove("is-low-quality");
        }
      });
      this.renderFinalSummary();
    }

    ensurePhotoTemplateReadyForExport() {
      const report = this.validatePhotoTemplateForExport();
      if (report.ok) {
        this.clearPhotoTemplateExportWarning();
        return true;
      }
      this.showPhotoTemplateExportWarning(report);
      return false;
    }

    getPrintQualityForItem(item) {
      if (!item || item.hidden || item.type === "text") {
        return { state: "safe", message: "" };
      }

      const modelImage = this.getModelImage();
      const renderedPhoneWidth = this.getRenderedPhoneWidth(modelImage);
      const sizeScale = renderedPhoneWidth > 0 ? PRINT_EXPORT_WIDTH / renderedPhoneWidth : 1;
      let sourceWidth = 0;
      let sourceHeight = 0;
      let printedWidth = 0;
      let printedHeight = 0;
      let label = this.getItemLabel(item);
      let kind = "sticker";
      let sourceStatus = "";

      if (item.type === "photo-slot") {
        if (!item.imageSrc) return { state: "safe", message: "" };
        kind = "photo";
        sourceWidth = Number(item.imageWidth) || 0;
        sourceHeight = Number(item.imageHeight) || 0;
        sourceStatus = item.printSourceStatus || "uploaded";
        const box = itemBoxSize({
          ...item,
          frameWidth: (item.frameWidth || item.size) * sizeScale,
          frameHeight: (item.frameHeight || item.size) * sizeScale,
        });
        printedWidth = box.width;
        printedHeight = box.height;
      } else if (this.isPrintQualityPhotoItem(item)) {
        const sticker = this.getSticker(item.stickerId);
        if (!sticker || sticker.type !== "image") return { state: "safe", message: "" };
        sourceStatus = item.printSourceStatus || sticker.printSourceStatus || "";
        sourceWidth = Number(item.imageWidth) || Number(sticker.width) || 0;
        sourceHeight = Number(item.imageHeight) || Number(sticker.height) || 0;
        sourceStatus = sourceStatus || "";
        const isPhotoItem = this.isPrintQualityPhotoItem(item);
        if (!isPhotoItem) return { state: "safe", message: "" };
        kind = "photo";
        label = cleanPhotoLabel(item.uploadedFileName || sticker.name || label);
        if (!sourceWidth || !sourceHeight) {
          return {
            state: "safe",
            message: "",
            label,
            kind,
            sourceWidth,
            sourceHeight,
            printedWidth,
            printedHeight,
            effectiveScale: 0,
            sourceStatus,
          };
        }
        const box = itemBoxSize({ ...item, size: item.size * sizeScale }, sticker);
        printedWidth = box.width;
        printedHeight = box.height;
      } else {
        return {
          state: "safe",
          message: "",
          label,
          kind,
          sourceWidth: 0,
          sourceHeight: 0,
          printedWidth: 0,
          printedHeight: 0,
          effectiveScale: 0,
          sourceStatus,
        };
      }

      const sourceMax = Math.max(sourceWidth, sourceHeight);
      const printedMax = Math.max(printedWidth, printedHeight);
      if (!sourceMax || !printedMax) {
        return {
          state: "safe",
          message: "",
          label,
          kind,
          sourceWidth,
          sourceHeight,
          printedWidth,
          printedHeight,
          effectiveScale: 0,
          sourceStatus,
        };
      }

      const effectiveScale = printedMax / sourceMax;
      const safeScale = PRINT_QUALITY_SAFE_SCALE;
      const warningScale = PRINT_QUALITY_WARNING_SCALE;
      let state = "safe";
      if (effectiveScale > warningScale) {
        state = "low-quality";
      } else if (effectiveScale > safeScale) {
        state = "warning";
      }

      const roundedPrinted = Math.round(printedMax);
      const roundedSource = Math.round(sourceMax);
      let message = "";
      if (state === "warning") {
        message = `Įkelta nuotrauka gali atrodyti šiek tiek neryški spaudoje (${roundedSource}px šaltinis, ${roundedPrinted}px makete).`;
      } else if (state === "low-quality") {
        message = `Įkelta nuotrauka yra per mažos raiškos šiam dydžiui ir gali atrodyti neryški spaudoje (${roundedSource}px šaltinis, ${roundedPrinted}px makete).`;
      }

      return {
        state,
        message,
        label,
        kind,
        sourceWidth,
        sourceHeight,
        printedWidth,
        printedHeight,
        effectiveScale,
        sourceStatus,
      };
    }

    getPrintQualityReport() {
      const issues = this.items
        .map((item) => ({ item, quality: this.getPrintQualityForItem(item) }))
        .filter(({ quality }) => quality.state === "warning" || quality.state === "low-quality");
      const lowQuality = issues.filter(({ quality }) => quality.state === "low-quality");
      const warning = issues.filter(({ quality }) => quality.state === "warning");
      return {
        state: lowQuality.length ? "low-quality" : warning.length ? "warning" : "safe",
        issues,
        lowQuality,
        warning,
      };
    }

    printQualitySummary(report = this.getPrintQualityReport()) {
      if (report.state === "low-quality") {
        return `Kai kurios įkeltos nuotraukos yra per žemos raiškos ir gali atrodyti neryškios spaudoje (${report.lowQuality.length}).`;
      }
      if (report.state === "warning") {
        return `Kai kurios įkeltos nuotraukos gali atrodyti šiek tiek neryškios spaudoje (${report.warning.length}).`;
      }
      return "";
    }

    updatePrintQualityWarning() {
      const report = this.getPrintQualityReport();
      const message = this.printQualitySummary(report);
      this.ui?.updateQuality(report);
      [this.nodes.printQualityWarning, this.nodes.printQualityExportWarning].forEach((node) => {
        if (!node) return;
        node.hidden = report.state === "safe";
        node.textContent = message;
        node.classList.toggle("is-low-quality", report.state === "low-quality");
        node.classList.toggle("is-warning", report.state === "warning");
      });
      this.renderFinalSummary();
    }

    confirmPrintQualityIfNeeded() {
      const report = this.getPrintQualityReport();
      if (report.state !== "low-quality") return true;
      return window.confirm("Šiame dizaine yra įkeltų žemos raiškos nuotraukų, kurios gali atrodyti neryškios spaudoje. Tęsti vis tiek?");
    }

    getPrintQualityHandoff(report = this.getPrintQualityReport()) {
      return {
        state: report.state,
        warningCount: report.warning.length,
        lowQualityCount: report.lowQuality.length,
        issues: report.issues.map(({ item, quality }) => ({
          uid: item.uid,
          type: item.type || "sticker",
          label: quality.label || this.getItemLabel(item),
          state: quality.state,
          sourceWidth: Math.round(Number(quality.sourceWidth) || 0),
          sourceHeight: Math.round(Number(quality.sourceHeight) || 0),
          printedWidth: Math.round(Number(quality.printedWidth) || 0),
          printedHeight: Math.round(Number(quality.printedHeight) || 0),
          effectiveScale: Number((Number(quality.effectiveScale) || 0).toFixed(2)),
        })),
      };
    }

    createDesignHandoffId() {
      const random = Math.random().toString(36).slice(2, 8);
      return `case-${Date.now()}-${random}`;
    }

    requiredHandoffFieldsMissing() {
      return [
        ["telefono modelio", this.fields.model],
        ["dizaino JSON", this.fields.json],
        ["spaudos PNG", this.fields.print],
      ]
        .filter(([, field]) => !field)
        .map(([label]) => label);
    }

    syncOutput() {
      this.clearPrintDownload();
      const payload = this.getDesignPayload();
      if (this.fields.json) this.fields.json.value = JSON.stringify(payload);
      this.updatePrintQualityWarning();
      this.renderFinalSummary();
      this.schedulePreviewRefresh({ force: true });
    }

    schedulePreviewRefresh() {
      this.previewRefreshQueued = false;
      window.clearTimeout(this.previewRefreshTimer);
    }

    async refreshPreviewOutput() {
      if (this.previewRefreshInFlight) {
        this.previewRefreshQueued = true;
        return;
      }

      this.previewRefreshInFlight = true;
      try {
        do {
          this.previewRefreshQueued = false;
          const token = ++this.previewRefreshToken;
          await this.exportPng(false, { auto: true, token });
        } while (this.previewRefreshQueued);
      } catch (error) {
        console.warn("Preview refresh failed", error);
      } finally {
        this.previewRefreshInFlight = false;
        if (this.previewRefreshQueued) this.schedulePreviewRefresh({ immediate: true, force: true });
      }
    }

    async saveDesign() {
      if (this.savingDesign) return;
      if (!this.ensurePhotoTemplateReadyForExport()) return;
      if (!this.confirmPrintQualityIfNeeded()) return;

      const missingFields = this.requiredHandoffFieldsMissing();
      if (missingFields.length) {
        this.nodes.status.textContent = `Nepavyko paruošti užsakymo: produkto formoje trūksta laukų (${missingFields.join(", ")}).`;
        return;
      }

      this.savingDesign = true;
      try {
        this.nodes.status.textContent = "Ruošiamas dizainas užsakymui...";
        const print = await this.exportPrintFile();
        if (!print) {
          this.nodes.status.textContent = `Nepavyko paruošti ${PRINT_EXPORT_WIDTH} x ${PRINT_EXPORT_HEIGHT} spaudos PNG. Bandykite dar kartą.`;
          return;
        }

        const printQuality = this.getPrintQualityHandoff();
        const designId = this.createDesignHandoffId();
        const finishedAt = new Date().toISOString();
        const printSize = this.lastPrintExportSize || {
          width: PRINT_EXPORT_WIDTH,
          height: PRINT_EXPORT_HEIGHT,
        };
        const designPayload = {
          ...this.getDesignPayload(),
          handoff: {
            designId,
            finishedAt,
            printExportWidth: printSize.width,
            printExportHeight: printSize.height,
            printExportSize: `${printSize.width}x${printSize.height}`,
            previewPng: "disabled",
            printPng: "included",
            printQuality,
          },
        };
        if (this.root.dataset.shopifyCart === "true") {
          if (!window.StrayzyShopifyCart) throw new Error("Nepavyko įkelti krepšelio jungties. Atnaujinkite puslapį");
          const preview = await this.exportPng(false, { cartThumbnail: true });
          if (!preview) throw new Error("Nepavyko paruošti dėkliuko miniatiūros");
          designPayload.handoff.previewPng = "included";
          const cartResult = await window.StrayzyShopifyCart.add({ model: this.model, print, preview, design: designPayload, printQuality });
          this.nodes.status.textContent = "Dėkliukas įdėtas į krepšelį.";
          if (window.StrayzyStudioUpsell) {
            try { await window.StrayzyStudioUpsell.afterAdd(cartResult, { model: this.model, preview }); }
            catch (error) { window.location.assign(window.StrayzyShopifyCart.cartUrl); }
          }
          else window.location.assign(window.StrayzyShopifyCart.cartUrl);
          return;
        }
        const uploaded = await this.uploadDesignFiles("", print, designPayload, printQuality);

        this.fields.model.value = this.model;
        if (this.fields.preview) this.fields.preview.value = "";
        this.fields.print.value = uploaded.printUrl || print;
        this.fields.json.value = JSON.stringify(designPayload);
        if (this.fields.printQuality) this.fields.printQuality.value = JSON.stringify(printQuality);
        if (this.fields.designId) this.fields.designId.value = designId;
        if (this.fields.finishedAt) this.fields.finishedAt.value = finishedAt;

        this.nodes.status.textContent = "Dizainas paruoštas. Dabar galite pridėti prekę į krepšelį.";
      } catch (error) {
        console.error(error);
        this.nodes.status.textContent = `Nepavyko paruošti dizaino užsakymui: ${readableError(error)}.`;
      } finally {
        this.savingDesign = false;
      }
    }

    async uploadPreview(preview) {
      const endpoint = this.root.dataset.uploadEndpoint;
      if (!endpoint) return "";

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            preview,
            design: this.getDesignPayload(),
          }),
        });

        if (!response.ok) return "";
        const result = await response.json();
        return result.url || "";
      } catch {
        return "";
      }
    }

    async uploadDesignFiles(preview, print, design, printQuality) {
      const endpoint = this.root.dataset.uploadEndpoint;
      if (!endpoint) return { previewUrl: "", printUrl: "" };

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            preview,
            print,
            design,
            model: this.model,
            printQuality,
          }),
        });

        if (!response.ok) return { previewUrl: "", printUrl: "" };
        const result = await response.json().catch(() => ({}));
        return {
          previewUrl: result.previewUrl || result.preview || result.url || "",
          printUrl: result.printUrl || result.print || "",
        };
      } catch {
        return { previewUrl: "", printUrl: "" };
      }
    }

    async exportPng(shouldDownload, options = {}) {
      await window.StrayzyFontsReady;
      await document.fonts.ready;
      if (shouldDownload && !this.confirmPrintQualityIfNeeded()) return "";
      const skipPhotoTemplateValidation = Boolean(options.skipPhotoTemplateValidation);
      const activePhotoTemplate = this.getActivePhotoTemplate();
      const activePhotoTemplateId = this.activeCollageTemplateId || "";
      const validationBlocked = !skipPhotoTemplateValidation && !this.ensurePhotoTemplateReadyForExport();
      const itemCount = this.items.length;
      const textCount = this.items.filter((item) => item.type === "text").length;

      logPreviewExportEvent("start", {
        shouldDownload,
        itemCount,
        textCount,
        skipPhotoTemplateValidation,
        validationBlocked,
        activeCollageTemplateId: this.activeCollageTemplateId,
        activePhotoTemplateId,
        activePhotoTemplate: activePhotoTemplate ? activePhotoTemplate.id || activePhotoTemplate.name : null,
      });

      if (validationBlocked) {
        logPreviewExportEvent("blocked", {
          reason: "photo-template-missing-required-slot",
        });
        return "";
      }

      const canvas = document.createElement("canvas");
      const scale = 3;
      const ctx = canvas.getContext("2d");
      const preset = MODEL_PRESETS[this.model] || CAMERA_PRESETS.iphonePro;
      const modelImage = this.getModelImage();
      const maskSrc = modelImage?.maskSrc || MODEL_PHOTO_MASKS[this.model];
      const previewWidth = 420;
      const previewHeight = modelImage ? 420 : 840;
      const previewScene = this.getPreviewExportScene(modelImage, previewWidth, previewHeight);
      const useRasterMask = Boolean(modelImage && maskSrc && (options.cartThumbnail || !(await svgMaskHasPath(maskSrc))));

      canvas.width = previewWidth * scale;
      canvas.height = previewHeight * scale;
      ctx.scale(scale, scale);
      ctx.clearRect(0, 0, previewWidth, previewHeight);
      if (modelImage) {
        const image = await loadCanvasSafeImage(modelImage.src, {
          label: "phone mockup image",
          required: true,
          context: "exportPng",
        });
        ctx.drawImage(image, previewScene.modelX, previewScene.modelY, previewScene.modelW, previewScene.modelH);
        await drawPreviewBackground(ctx, this.caseBackground, this.model, previewScene.modelX, previewScene.modelY, previewScene.modelW, previewScene.modelH);
      } else {
        drawRoundedRect(ctx, 45, 24, 330, 792, preset.radius, "rgba(245,248,252,.92)", "rgba(31,35,40,.15)");
        drawRoundedRect(ctx, 62, 42, 296, 756, Math.max(26, preset.radius - 10), "rgba(255,255,255,.58)", "rgba(31,35,40,.08)");
        if (this.caseBackground.type === "color") {
          drawRoundedRect(
            ctx,
            62,
            42,
            296,
            756,
            Math.max(26, preset.radius - 10),
            backgroundColorPaint(this.caseBackground),
            "transparent",
          );
        } else if (this.caseBackground.type === "pattern" && this.caseBackground.pattern) {
          ctx.save();
          roundedRectPath(ctx, 62, 42, 296, 756, Math.max(26, preset.radius - 10));
          ctx.clip();
          await drawPatternBackground(ctx, this.caseBackground.pattern, 62, 42, 296, 756, this.caseBackground.patternScale, this.caseBackground.patternOffsetX, this.caseBackground.patternOffsetY, this.caseBackground.patternStretchX, this.caseBackground.patternStretchY);
          ctx.restore();
        }
      }

      const designCanvas = useRasterMask ? document.createElement("canvas") : null;
      const designCtx = designCanvas ? designCanvas.getContext("2d") : ctx;
      if (designCanvas) {
        designCanvas.width = canvas.width;
        designCanvas.height = canvas.height;
        designCtx.scale(scale, scale);
      }

      designCtx.save();
      if (!useRasterMask) await this.clipPreviewDesignArea(designCtx, previewScene, scale);
      for (const item of this.items) {
        if (item.hidden) continue;
        try {
          const bounds = this.getPreviewExportBounds(previewScene);
          const itemScale = bounds.scale || 1;
          const scaledItem = {
            ...item,
            size: item.size * itemScale,
            frameWidth: item.frameWidth ? item.frameWidth * itemScale : item.frameWidth,
            frameHeight: item.frameHeight ? item.frameHeight * itemScale : item.frameHeight,
          };
          const x = bounds.x + (item.x / 100) * bounds.w;
          const y = bounds.y + (item.y / 100) * bounds.h;
          designCtx.save();
          if (options.cartThumbnail) designCtx.globalAlpha = safeItemOpacity(item.opacity) / 100;
          if (item.type === "photo-slot") {
            if (!item.imageSrc) {
              logPreviewExportEvent("item-skipped", {
                itemId: item.uid,
                itemType: "photo-slot",
                reason: "missing-image-src",
              });
            }
            if (!this.hasValidPhotoSlotImage(item) && !this.isPhotoSlotItemRequired(item)) {
              logPreviewExportEvent("item-skipped", {
                itemId: item.uid,
                itemType: "photo-slot",
                reason: "optional-empty-slot",
                slotId: item.slotId,
              });
              designCtx.restore();
              continue;
            }
            const box = itemBoxSize(scaledItem);
            designCtx.translate(x, y);
            designCtx.rotate((item.rotation * Math.PI) / 180);
            if (options.cartThumbnail) designCtx.scale(item.flipX ? -1 : 1, item.flipY ? -1 : 1);
            await drawPhotoSlotImage(designCtx, scaledItem, box.width, box.height);
            designCtx.restore();
            continue;
          }
          designCtx.translate(x, y);
          designCtx.rotate((item.rotation * Math.PI) / 180);
          if (options.cartThumbnail) designCtx.scale(item.flipX ? -1 : 1, item.flipY ? -1 : 1);
          if (item.type === "text") {
            drawTextItem(designCtx, scaledItem, 1, "center");
          } else {
            const sticker = this.getSticker(item.stickerId);
            if (!sticker) {
              logPreviewExportEvent("item-skipped", {
                layer: this.getItemLabel(item),
                stickerId: item.stickerId,
                uid: item.uid,
                itemType: item.type || "sticker",
                reason: "missing-sticker",
              });
              designCtx.restore();
              continue;
            }
            const image = await stickerToImage(sticker);
            const box = itemBoxSize(scaledItem, sticker);
            drawStickerImage(designCtx, image, -box.width / 2, -box.height / 2, box.width, box.height, scaledItem);
          }
          designCtx.restore();
        } catch (error) {
          logPreviewExportEvent("item-skipped", {
            itemId: item.uid,
            itemType: item.type || "unknown",
            reason: "render-error",
            error: error?.message || String(error),
          });
          designCtx.restore();
          console.warn("Preview item skipped", this.getItemLabel(item), error);
          if (options.cartThumbnail) throw error;
        }
      }
      designCtx.restore();

      if (designCanvas) {
        // Thumbnail mask coordinates below are already in physical canvas pixels.
        if (options.cartThumbnail) designCtx.setTransform(1, 0, 0, 1, 0, 0);
        await applyRasterMaskToCanvas(
          designCanvas,
          maskSrc,
          previewScene.modelX * scale,
          previewScene.modelY * scale,
          previewScene.modelW * scale,
          previewScene.modelH * scale,
          "preview raster mask",
        );
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(designCanvas, 0, 0);
        ctx.restore();
      }

      if (!modelImage) drawCamera(ctx, preset);

      let dataUrl = "";
      try {
        dataUrl = canvas.toDataURL("image/png");
        logPreviewExportEvent("toDataURL.success", { length: dataUrl.length });
      } catch (error) {
        const isTainted = isCanvasTaintedError(error);
        if (isTainted) {
          console.warn("Preview export failed because canvas is tainted. Check image sources/CORS.");
          if (this.nodes.status) {
            this.nodes.status.textContent = "Peržiūros eksportas nepavyko: drobė užteršta (tainted). Patikrinkite paveikslėlių šaltinius ir CORS.";
          }
        } else if (this.nodes.status) {
          this.nodes.status.textContent = "Peržiūros eksportas nepavyko. Bandykite dar kartą.";
        }
        logPreviewExportEvent("toDataURL.failure", {
          errorName: error?.name || "",
          errorMessage: error?.message || String(error),
          isTainted,
        });
        return "";
      }

      if (options.auto && options.token !== this.previewRefreshToken) return dataUrl;

      const outputNode = this.nodes.output || null;
      const previewNodeBefore = {
        hasOutputNode: Boolean(outputNode),
        hasExistingSrc: Boolean(outputNode?.getAttribute?.("src")),
        hadClass: outputNode ? outputNode.classList.contains("is-visible") : false,
      };
      if (outputNode) {
        outputNode.src = dataUrl;
        outputNode.classList.add("is-visible");
        this.updateFinalPreviewPlaceholder();
      }
      logPreviewExportEvent("output", {
        hasDataUrl: Boolean(dataUrl),
        dataUrlLength: dataUrl.length,
        previewNodeBefore,
        previewNodeAfter: outputNode
          ? {
              hasSrc: Boolean(outputNode.getAttribute("src")),
              hasVisibleClass: outputNode.classList.contains("is-visible"),
            }
          : null,
      });

      if (shouldDownload) {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `sticker-case-${Date.now()}.png`;
        link.click();
      }

      return dataUrl;
    }

    async clipPreviewDesignArea(ctx, previewScene, scale) {
      const modelImage = this.getModelImage();
      const maskSrc = modelImage?.maskSrc || MODEL_PHOTO_MASKS[this.model];
      const clipPath = modelImage?.clipPath || MODEL_PHOTO_CLIP_PATHS[this.model];

      ctx.beginPath();
      if (typeof clipPath === "string" && clipPath.trim().startsWith("polygon(")) {
        const points = parsePolygonPoints(clipPath);
        if (points.length >= 3) {
          points.forEach(([px, py], index) => {
            const x = previewScene.stageX + px * previewScene.stageW;
            const y = previewScene.stageY + py * previewScene.stageH;
            if (index === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          });
          ctx.closePath();
          ctx.clip();
          return;
        }
      }

      if (maskSrc && await applyPreviewSvgMaskClip(ctx, maskSrc, previewScene.stageX, previewScene.stageY, previewScene.stageW, previewScene.stageH, scale)) {
        return;
      }

      const safeArea = modelImage?.safeArea || MODEL_PHOTO_SAFE_AREAS[this.model] || DEFAULT_SAFE_AREA;
      ctx.rect(
        previewScene.stageX + (safeArea.left / 100) * previewScene.stageW,
        previewScene.stageY + (safeArea.top / 100) * previewScene.stageH,
        (safeArea.width / 100) * previewScene.stageW,
        (safeArea.height / 100) * previewScene.stageH,
      );
      ctx.clip();
    }

    getPreviewExportScene(modelImage, previewWidth = 420, previewHeight = 840) {
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      const layerWidth = Math.max(1, layerRect?.width || this.getRenderedPhoneWidth(modelImage));
      const layerHeight = Math.max(1, layerRect?.height || layerWidth);
      if (!modelImage) {
        return { stageX: 45, stageY: 24, stageW: 330, stageH: 792, modelX: 45, modelY: 24, modelW: 330, modelH: 792, layerWidth, layerHeight };
      }

      const stageW = previewWidth;
      const stageH = Math.max(1, Math.min(previewHeight, stageW * (layerHeight / layerWidth)));
      const stageX = 0;
      const stageY = (previewHeight - stageH) / 2;
      const imageAspect = parseAspectRatio(modelImage.aspect) || 1;
      let modelW = stageW;
      let modelH = stageW / imageAspect;
      if (modelH > stageH) {
        modelH = stageH;
        modelW = stageH * imageAspect;
      }
      return {
        stageX,
        stageY,
        stageW,
        stageH,
        modelX: stageX + (stageW - modelW) / 2,
        modelY: stageY + (stageH - modelH) / 2,
        modelW,
        modelH,
        layerWidth,
        layerHeight,
      };
    }

    getPreviewExportBounds(previewScene) {
      if (!previewScene) return { x: 45, y: 24, w: 330, h: 792, scale: 1 };
      return {
        x: previewScene.modelX ?? previewScene.stageX,
        y: previewScene.modelY ?? previewScene.stageY,
        w: previewScene.modelW ?? previewScene.stageW,
        h: previewScene.modelH ?? previewScene.stageH,
        scale: (previewScene.modelW ?? previewScene.stageW) / Math.max(1, previewScene.layerWidth || previewScene.stageW),
      };
    }

    async exportPrintFile() {
      await window.StrayzyFontsReady;
      await document.fonts.ready;
      const modelImage = this.getModelImage();
      const supplierPrintSize = modelImage?.supplierPrintSize;
      const useSupplierPrintExport = Boolean(
        supplierPrintSize
        && Number.isFinite(supplierPrintSize.width)
        && Number.isFinite(supplierPrintSize.height)
        && supplierPrintSize.width > 0
        && supplierPrintSize.height > 0,
      );
      const canvas = document.createElement("canvas");
      const supplierOutputWidth = useSupplierPrintExport ? Math.round(supplierPrintSize.width) : 0;
      const supplierOutputHeight = useSupplierPrintExport ? Math.round(supplierPrintSize.height) : 0;
      const outputWidth = PRINT_EXPORT_WIDTH;
      const outputHeight = PRINT_EXPORT_HEIGHT;
      canvas.width = outputWidth;
      canvas.height = outputHeight;
      const ctx = canvas.getContext("2d");
      const printMaskSrc = resolvePrintMaskSrc(modelImage);
      if (!printMaskSrc) {
        throw new Error(`Spaudos maskė nerasta modeliui: ${this.model}.`);
      }
      const printMaskBounds = await getSvgMaskContentBounds(printMaskSrc);
      if (!isValidBounds(printMaskBounds)) {
        throw new Error(`Nepavyko perskaityti spaudos maskės ribų modeliui: ${this.model}.`);
      }
      const displayWidth = this.getRenderedPhoneWidth(modelImage);
      const printScene = useSupplierPrintExport
        ? this.getPrintExportAspectScene(modelImage, outputWidth, outputHeight)
        : await this.getPrintExportScene(modelImage, outputWidth, outputHeight, printMaskBounds);
      const itemMaskSrc = modelImage?.printItemMaskSrc || "";
      const supplierPrintMaskSrc = modelImage?.supplierPrintMaskSrc || itemMaskSrc;
      const supplierPrintItemMaskSrc = modelImage?.supplierPrintItemMaskSrc || "";
      const useSupplierPrintItemMask = useSupplierPrintExport && Boolean(supplierPrintItemMaskSrc);
      const useLayeredPrintMasks = useSupplierPrintItemMask
        || (!useSupplierPrintExport && Boolean(modelImage?.printMaskSrc && itemMaskSrc && modelImage.printMaskSrc !== itemMaskSrc));
      const designScene = !useSupplierPrintExport && modelImage?.fitPrintDesignToMaskBounds
        ? this.getPrintDesignScene(modelImage, printScene, printMaskBounds)
        : printScene;
      const sizeScale = designScene.width / displayWidth;
      const printBackgroundMetrics = this.getPatternBackgroundMetrics(this.caseBackground);
      const backgroundCanvas = useLayeredPrintMasks ? document.createElement("canvas") : null;
      const itemsCanvas = useLayeredPrintMasks ? document.createElement("canvas") : null;
      if (backgroundCanvas && itemsCanvas) {
        backgroundCanvas.width = outputWidth;
        backgroundCanvas.height = outputHeight;
        itemsCanvas.width = outputWidth;
        itemsCanvas.height = outputHeight;
      }
      const backgroundCtx = backgroundCanvas ? backgroundCanvas.getContext("2d") : ctx;
      const renderCtx = itemsCanvas ? itemsCanvas.getContext("2d") : ctx;
      const printItemDebug = [];

      ctx.clearRect(0, 0, outputWidth, outputHeight);
      backgroundCtx.clearRect(0, 0, outputWidth, outputHeight);
      if (itemsCanvas) renderCtx.clearRect(0, 0, outputWidth, outputHeight);
      renderCtx.save();

      try {
        await drawPrintBackground(
          backgroundCtx,
          this.caseBackground,
          designScene,
          printBackgroundMetrics,
          useSupplierPrintExport && modelImage.supplierOutputFromPreviewMask,
        );
      } catch (error) {
        console.warn("Print background skipped", error);
      }

      for (const item of this.items.filter((entry) => !entry.hidden)) {
        try {
          const sticker = item.type !== "text" && item.type !== "photo-slot"
            ? this.getSticker(item.stickerId)
            : null;
          const size = item.size * sizeScale;
          const scaledItem = {
            ...item,
            size,
            frameWidth: item.frameWidth ? item.frameWidth * sizeScale : item.frameWidth,
            frameHeight: item.frameHeight ? item.frameHeight * sizeScale : item.frameHeight,
          };
          const x = designScene.x + (item.x / 100) * designScene.width;
          const y = designScene.y + (item.y / 100) * designScene.height;
          renderCtx.save();
          renderCtx.translate(x, y);
          renderCtx.rotate((item.rotation * Math.PI) / 180);
          if (item.type === "photo-slot") {
            if (!this.hasValidPhotoSlotImage(item) && !this.isPhotoSlotItemRequired(item)) {
              renderCtx.restore();
              continue;
            }
            const box = itemBoxSize(scaledItem);
            await drawPhotoSlotImage(renderCtx, {
              ...scaledItem,
              frameWidth: box.width,
              frameHeight: box.height,
            }, box.width, box.height);
          } else if (item.type === "text") {
            drawTextItem(renderCtx, scaledItem, 1, "center");
          } else {
            if (!sticker) continue;
            const image = await this.getPrintableStickerImage(item, sticker);
            const box = itemBoxSize(scaledItem, sticker);
            if (printItemDebug.length < 2) {
              printItemDebug.push({
                label: this.getItemLabel(item),
                itemSize: Math.round(item.size),
                displayWidth: Math.round(displayWidth),
                designWidth: Math.round(designScene.width),
                sizeScale: Number(sizeScale.toFixed(4)),
                boxWidth: Math.round(box.width),
                boxHeight: Math.round(box.height),
              });
            }
            drawStickerImage(renderCtx, image, -box.width / 2, -box.height / 2, box.width, box.height, scaledItem);
          }
          renderCtx.restore();
        } catch (error) {
          console.warn("Item skipped in print export", this.getItemLabel(item), error);
        }
      }
      renderCtx.restore();

      if (useLayeredPrintMasks) {
        if (useSupplierPrintItemMask) {
          let itemMaskApplied = false;
          if (await svgMaskHasPath(supplierPrintItemMaskSrc)) {
            itemMaskApplied = await applySvgViewBoxMaskToCanvas(
              itemsCanvas,
              supplierPrintItemMaskSrc,
              printScene.x,
              printScene.y,
              printScene.width,
              printScene.height,
              "supplier print item mask",
            );
          } else {
            itemMaskApplied = await applyRasterMaskToCanvas(
              itemsCanvas,
              supplierPrintItemMaskSrc,
              printScene.x,
              printScene.y,
              printScene.width,
              printScene.height,
              "supplier print item mask",
            );
          }
          if (!itemMaskApplied) {
            throw new Error(`Nepavyko pritaikyti lipdukų spaudos maskės modeliui: ${this.model}.`);
          }
        } else {
          await this.applyPrintMaskToLayer(
            backgroundCanvas,
            printMaskSrc,
            printScene,
            modelImage,
            "print background mask",
          );
          await applyRasterMaskToCanvas(
            itemsCanvas,
            itemMaskSrc,
            printScene.x,
            printScene.y,
            printScene.width,
            printScene.height,
            "print item mask",
          );
        }
        ctx.clearRect(0, 0, outputWidth, outputHeight);
        ctx.drawImage(backgroundCanvas, 0, 0);
        ctx.drawImage(itemsCanvas, 0, 0);
      }

      if (!canvasHasVisiblePixels(canvas) && (this.items.some((item) => !item.hidden) || ["color", "pattern"].includes(this.caseBackground?.type))) {
        throw new Error("Spaudos failas tuščias. Nepavyko įkelti lipdukų arba fono į spaudos maketą.");
      }

      if (useSupplierPrintExport && modelImage?.supplierApplyMask !== false) {
        if (modelImage?.supplierUseSvgContentMask) {
          const maskedCanvas = await clipCroppedPrintCanvasToSvgPath(canvas, supplierPrintMaskSrc || printMaskSrc, 0);
          ctx.clearRect(0, 0, outputWidth, outputHeight);
          ctx.drawImage(maskedCanvas, 0, 0);
        } else if (modelImage?.supplierUseColorMask) {
          await applyRasterColorMaskToCanvas(
            canvas,
            supplierPrintMaskSrc,
            0,
            0,
            outputWidth,
            outputHeight,
            "supplier print color mask",
          );
        } else if (modelImage?.supplierFitMaskContent) {
          await applyRasterMaskContentToCanvas(
            canvas,
            supplierPrintMaskSrc,
            0,
            0,
            outputWidth,
            outputHeight,
            "supplier print mask",
            modelImage.supplierPrintMaskContentBounds,
          );
        } else {
          await applyRasterMaskToCanvas(
            canvas,
            supplierPrintMaskSrc,
            0,
            0,
            outputWidth,
            outputHeight,
            "supplier print mask",
          );
        }
      } else {
        if (!useSupplierPrintExport) {
          await this.applyPrintMaskToLayer(canvas, printMaskSrc, printScene, modelImage, "print export mask");
        }
      }
      if (!useSupplierPrintExport && modelImage?.printMaskViewBox && printMaskTouchesCanvasCorners(canvas)) {
        throw new Error("Spaudos maskė nepritaikyta: eksportas vis dar atrodo kaip stačiakampis.");
      }

      const outputBoundsSrc = modelImage?.supplierOutputBoundsSrc || "";
      const outputCanvas = useSupplierPrintExport && outputBoundsSrc
        ? await this.extractSupplierPrintOutput(canvas, outputBoundsSrc, printScene, modelImage, supplierPrintMaskSrc || printMaskSrc, supplierOutputWidth, supplierOutputHeight)
        : await this.prepareStandardPrintOutput(canvas, printMaskSrc, modelImage, useSupplierPrintExport, supplierPrintMaskSrc, supplierOutputWidth, supplierOutputHeight);
      const dataUrl = canvasToPngDataUrl(outputCanvas, useSupplierPrintExport ? modelImage.supplierPrintDpi : 0);

      this.printFileUrl = dataUrl;
      this.nodes.printDownload.href = dataUrl;
      this.nodes.printDownload.download = `print-maketas-${slugify(this.model)}-${Date.now()}.png`;
      this.nodes.printDownload.removeAttribute("target");
      this.nodes.printDownload.hidden = false;
      this.nodes.printOpen.href = dataUrl;
      this.nodes.printOpen.hidden = false;
      this.lastPrintExportSize = {
        width: outputCanvas.width,
        height: outputCanvas.height,
      };
      const debugText = printItemDebug.length
        ? ` Debug: ${this.model}; ${printItemDebug[0].label}; item ${printItemDebug[0].itemSize}px; display ${printItemDebug[0].displayWidth}px; design ${printItemDebug[0].designWidth}px; scale ${printItemDebug[0].sizeScale}; box ${printItemDebug[0].boxWidth}x${printItemDebug[0].boxHeight}px.`
        : "";
      this.nodes.status.textContent = `Spaudos maketas paruoštas (${outputCanvas.width} x ${outputCanvas.height} px).${debugText} Jei atsisiuntimas neveikia, spausk „Atidaryti PNG“ ir išsisaugok iš atsidariusio lango.`;
      return dataUrl;
    }

    async getPrintExportScene(modelImage, outputWidth = PRINT_EXPORT_WIDTH, outputHeight = PRINT_EXPORT_HEIGHT, printMaskBounds = null) {
      if (!modelImage) return { x: 0, y: 0, width: outputWidth, height: outputHeight };
      const sceneAspect = modelImage.printMaskViewBox && isValidBounds(printMaskBounds?.viewBox)
        ? printMaskBounds.viewBox.width / printMaskBounds.viewBox.height
        : parseAspectRatio(modelImage.aspect) || 1;
      let width = outputWidth;
      let height = outputHeight;
      if (sceneAspect > 0) {
        if (outputWidth / outputHeight > sceneAspect) {
          height = outputHeight;
          width = height * sceneAspect;
        } else {
          width = outputWidth;
          height = width / sceneAspect;
        }
      }
      return {
        x: (outputWidth - width) / 2,
        y: (outputHeight - height) / 2,
        width,
        height,
      };
    }

    getPrintExportAspectScene(modelImage, outputWidth = PRINT_EXPORT_WIDTH, outputHeight = PRINT_EXPORT_HEIGHT) {
      if (!modelImage) return { x: 0, y: 0, width: outputWidth, height: outputHeight };
      const sceneAspect = parseAspectRatio(modelImage.aspect) || 1;
      let width = outputWidth;
      let height = outputHeight;
      if (sceneAspect > 0) {
        if (outputWidth / outputHeight > sceneAspect) {
          height = outputHeight;
          width = height * sceneAspect;
        } else {
          width = outputWidth;
          height = width / sceneAspect;
        }
      }
      return {
        x: (outputWidth - width) / 2,
        y: (outputHeight - height) / 2,
        width,
        height,
      };
    }

    getPrintDesignScene(modelImage, printScene, printMaskBounds) {
      if (!modelImage?.fitPrintDesignToMaskBounds) return printScene;
      const designScene = svgBoundsToDestinationRect(printMaskBounds, printScene);
      return isValidBounds(designScene) ? designScene : printScene;
    }

    async prepareSupplierPrintOutput(sourceCanvas, maskSrc, width, height) {
      const outputCanvas = document.createElement("canvas");
      outputCanvas.width = Math.max(1, Math.round(width));
      outputCanvas.height = Math.max(1, Math.round(height));
      const outputCtx = outputCanvas.getContext("2d");
      outputCtx.clearRect(0, 0, outputCanvas.width, outputCanvas.height);
      const scale = Math.max(
        outputCanvas.width / Math.max(1, sourceCanvas.width),
        outputCanvas.height / Math.max(1, sourceCanvas.height),
      ) * 0.97;
      const drawWidth = sourceCanvas.width * scale;
      const drawHeight = sourceCanvas.height * scale;
      const drawX = (outputCanvas.width - drawWidth) / 2;
      const drawY = (outputCanvas.height - drawHeight) / 2;
      outputCtx.drawImage(sourceCanvas, drawX, drawY, drawWidth, drawHeight);
      if (!maskSrc) return outputCanvas;
      return clipCroppedPrintCanvasToSvgPath(outputCanvas, maskSrc, 0);
    }

    async prepareStandardPrintOutput(canvas, printMaskSrc, modelImage, useSupplierPrintExport, supplierPrintMaskSrc, supplierOutputWidth, supplierOutputHeight) {
      const croppedCanvas = cropCanvasToVisiblePixels(canvas, 72);
      const standardOutputCanvas = modelImage?.printMaskViewBox
        ? await clipCroppedPrintCanvasToSvgPath(croppedCanvas, printMaskSrc, 72)
        : croppedCanvas;
      return useSupplierPrintExport
        ? await this.prepareSupplierPrintOutput(standardOutputCanvas, supplierPrintMaskSrc || printMaskSrc, supplierOutputWidth, supplierOutputHeight)
        : standardOutputCanvas;
    }

    async extractSupplierPrintOutput(sourceCanvas, boundsSrc, printScene, modelImage, maskSrc, width, height) {
      const bleedMmPx = Math.ceil((modelImage?.supplierBleedMm || 0) * (modelImage?.supplierPrintDpi || 0) / 25.4);
      const bleedX = bleedMmPx || Math.max(0, Math.round(modelImage?.supplierBleedX || 0));
      const bleedY = bleedMmPx || Math.max(0, Math.round(modelImage?.supplierBleedY || 0));
      const outputCanvas = document.createElement("canvas");
      outputCanvas.width = Math.max(1, Math.round(width) + bleedX * 2);
      outputCanvas.height = Math.max(1, Math.round(height) + bleedY * 2);
      const outputCtx = outputCanvas.getContext("2d");
      outputCtx.clearRect(0, 0, outputCanvas.width, outputCanvas.height);

      const explicitBounds = modelImage?.supplierOutputBounds;
      const bounds = modelImage?.supplierOutputFromPreviewMask
        ? await this.getSupplierPreviewOutputBounds(boundsSrc, width, height)
        : isValidBounds(explicitBounds)
        ? { ...explicitBounds, viewBox: explicitBounds.viewBox || { x: 0, y: 0, width: 2500, height: 2500 } }
        : await getSvgMaskContentBounds(boundsSrc);
      const viewBox = bounds?.viewBox;
      if (!isValidBounds(bounds) || !isValidBounds(viewBox)) {
        return this.prepareSupplierPrintOutput(sourceCanvas, maskSrc, width, height);
      }
      let source = svgBoundsToDestinationRect(bounds, {
        x: printScene.x,
        y: printScene.y,
        width: printScene.width,
        height: printScene.height,
      });
      if (!isValidBounds(source)) {
        return this.prepareSupplierPrintOutput(sourceCanvas, maskSrc, width, height);
      }
      if (modelImage?.supplierFitOutputBoundsToCanvas) {
        const fittedSource = fitRectToAspectInside(
          { x: 0, y: 0, width: sourceCanvas.width, height: sourceCanvas.height },
          outputCanvas.width / Math.max(1, outputCanvas.height),
        );
        outputCtx.drawImage(
          sourceCanvas,
          fittedSource.x,
          fittedSource.y,
          fittedSource.width,
          fittedSource.height,
          0,
          0,
          outputCanvas.width,
          outputCanvas.height,
        );
        if (!maskSrc || modelImage?.supplierClipBleedOutput === false) return outputCanvas;
        return clipCroppedPrintCanvasToSvgPath(outputCanvas, maskSrc, 0);
      }
      if (modelImage?.supplierPreserveOutputAspect) {
        source = fitRectToAspectInside(source, width / Math.max(1, height));
      }
      // Screenshot-based supplier alignment; keep the trim outline and physical bleed fixed.
      const calibration = modelImage?.supplierPrintCalibration;
      if (calibration) {
        const scale = Number.isFinite(calibration.scale) && calibration.scale > 0 ? calibration.scale : 1;
        const offsetYmm = Number.isFinite(calibration.offsetYmm) ? calibration.offsetYmm : 0;
        const offsetYpx = offsetYmm * (modelImage.supplierPrintDpi || 0) / 25.4;
        source = {
          ...source,
          x: source.x + (source.width - source.width / scale) / 2,
          y: source.y + (source.height - source.height / scale) / 2 - offsetYpx * source.height / height / scale,
          width: source.width / scale,
          height: source.height / scale,
        };
      }
      const sourceBleedX = bleedX * (source.width / Math.max(1, width));
      const sourceBleedY = bleedY * (source.height / Math.max(1, height));
      outputCtx.drawImage(
        sourceCanvas,
        source.x - sourceBleedX,
        source.y - sourceBleedY,
        source.width + sourceBleedX * 2,
        source.height + sourceBleedY * 2,
        0,
        0,
        outputCanvas.width,
        outputCanvas.height,
      );
      if (!maskSrc || ((bleedX > 0 || bleedY > 0) && modelImage?.supplierClipBleedOutput === false)) return outputCanvas;
      if (bleedMmPx) return clipCroppedPrintCanvasToSvgPath(outputCanvas, maskSrc, bleedMmPx, bleedMmPx);
      return clipCroppedPrintCanvasToSvgPath(outputCanvas, maskSrc, 0);
    }

    async getSupplierPreviewOutputBounds(maskSrc, width, height) {
      const maskCanvas = document.createElement("canvas");
      const mask = await loadCanvasSafeImage(maskSrc, {
        label: "supplier preview mask bounds",
        required: true,
        context: "getSupplierPreviewOutputBounds",
      });
      // Measure intrinsic pixels before resampling the SVG into the export scene.
      maskCanvas.width = mask.naturalWidth;
      maskCanvas.height = mask.naturalHeight;
      maskCanvas.getContext("2d").drawImage(mask, 0, 0, maskCanvas.width, maskCanvas.height);
      const bounds = canvasAlphaBounds(maskCanvas);
      if (!isValidBounds(bounds)) {
        throw new Error(`Nepavyko nustatyti peržiūros kaukės ribų modeliui: ${this.model}.`);
      }
      // Keep the preview width and bottom; the full mask extends above the camera cutout.
      const fullHeight = bounds.width * height / width;
      return {
        x: bounds.x,
        y: bounds.y + bounds.height - fullHeight,
        width: bounds.width,
        height: fullHeight,
        viewBox: { x: 0, y: 0, width: maskCanvas.width, height: maskCanvas.height },
      };
    }

    async applyPrintMaskToLayer(canvas, printMaskSrc, printScene, modelImage, label = "print export mask") {
      if (modelImage?.fillPrintMaskHoles) {
        await applyRasterMaskWithFilledHolesToCanvas(
          canvas,
          printMaskSrc,
          printScene.x,
          printScene.y,
          printScene.width,
          printScene.height,
          label,
        );
      } else if (modelImage?.printMaskViewBox) {
        const applied = await applySvgViewBoxMaskToCanvas(
          canvas,
          printMaskSrc,
          printScene.x,
          printScene.y,
          printScene.width,
          printScene.height,
          label,
        );
        if (!applied) throw new Error(`Nepavyko pritaikyti SVG spaudos maskės: ${printMaskSrc}`);
      } else {
        await applyRasterMaskToCanvas(
          canvas,
          printMaskSrc,
          printScene.x,
          printScene.y,
          printScene.width,
          printScene.height,
          label,
        );
      }
    }

    getEditorLayoutRect(node) {
      return this.ui ? this.ui.layoutRect(node) : node?.getBoundingClientRect();
    }

    getRenderedPhoneWidth(modelImage) {
      const layerRect = this.getEditorLayoutRect(this.nodes.layer);
      if (layerRect && layerRect.width > 0) return layerRect.width;
      const artRect = this.getEditorLayoutRect(this.nodes.artLayer);
      if (artRect && artRect.width > 0) return artRect.width;
      const baseWidth = modelImage?.displayWidth || 520;
      return modelImage ? baseWidth * MODEL_PHOTO_SCREEN_ZOOM : baseWidth;
    }

    async getPrintableStickerImage(item, sticker) {
      try {
        return await stickerToImage(sticker, { print: true });
      } catch (error) {
        console.warn("Sticker source failed, trying rendered image", this.getItemLabel(item), error);
      }

        const artNode = this.nodes.artLayer.querySelector(`[data-art-uid="${cssEscape(item.uid)}"]`);
        const imageNode = artNode?.querySelector("img");
        if (imageNode?.complete && imageNode.naturalWidth && imageNode.naturalHeight) {
          const image = await loadCanvasSafeImage(imageNode.currentSrc || imageNode.src, {
            label: `rendered sticker (${this.getItemLabel(item)})`,
            required: true,
            context: "getPrintableStickerImage",
          });
          if (!image) {
            throw new Error(`Nepavyko paruošti atvaizdo: ${this.getItemLabel(item)}.`);
          }
          return image;
        }

      const svgNode = artNode?.querySelector("svg");
      if (svgNode) {
        const svg = new XMLSerializer().serializeToString(svgNode);
        return imageFromSource(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`);
      }

      throw new Error(`Nepavyko įkelti lipduko: ${this.getItemLabel(item)}`);
    }

    async downloadPrintFile() {
      if (!this.ensurePhotoTemplateReadyForExport()) return;
      if (!this.confirmPrintQualityIfNeeded()) return;
      try {
        await this.exportPrintFile();
        if (this.nodes.printDownload?.href) {
          this.nodes.printDownload.click();
        }
      } catch (error) {
        console.error(error);
        const message = readableError(error);
        const isLocalFileMode = window.location.protocol === "file:";
        const isCanvasSecurityError = /securityerror|tainted|spaudos failas tuščias|spaudos failas tuscias/i.test(message);
        this.nodes.status.textContent = isLocalFileMode && isCanvasSecurityError
          ? "Spaudos failui atidaryk projektą per localhost, ne per file://. Paleisk start-studio-server.bat ir naudok http://127.0.0.1:8787/index.html"
          : `Nepavyko paruošti maketo: ${message}.`;
      }
    }
  }

  function stickerMarkup(sticker, options = {}) {
    if (sticker.type === "svg") return sticker.src;
    let src = stickerImageSrc(sticker, options);
    if (options.thumbnail) {
      // Resize only gallery URLs; original artwork and export sources stay intact.
      try {
        const url = new URL(src, document.baseURI);
        if (/\.(png|jpe?g|webp)$/i.test(url.pathname) &&
            (url.hostname === 'cdn.shopify.com' ||
             (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/')))) {
          url.searchParams.set('width', '256');
          url.searchParams.set('height', '256');
          src = url.href;
        }
      } catch (_) { /* Keep local and user-uploaded preview sources as supplied. */ }
      return `<img src="${escapeAttribute(src)}" alt="" loading="lazy" decoding="async" fetchpriority="low">`;
    }
    return `<img src="${escapeAttribute(src)}" alt="">`;
  }

  function stickerImageSrc(sticker, options = {}) {
    if (!sticker) return "";
    if (options.thumbnail && sticker.thumbSrc) return sticker.thumbSrc;
    if (isExternalFileUrl(sticker.src) && sticker.thumbSrc) return sticker.thumbSrc;
    return sticker.src || sticker.thumbSrc || "";
  }

  function isExternalFileUrl(src) {
    const value = String(src || "");
    return value.slice(0, 5).toLowerCase() === "file:" && value.slice(5, 7) === "//";
  }

  function stickerTileClass(sticker) {
    const aspect = stickerAspect(sticker);
    const classes = [];
    if (COMPACT_PREVIEW_STICKER_IDS.has(sticker.id)) classes.push("is-compact-preview");
    if (sticker.subcategory === "Sarcastic") classes.push("is-zoomed-preview");
    if (aspect < 0.42) classes.push("is-extra-tall-preview");
    else if (aspect < 0.72) classes.push("is-tall-preview");
    if (aspect > 2.4) classes.push("is-extra-wide-preview");
    else if (aspect > 1.55) classes.push("is-wide-preview");
    return classes.join(" ");
  }

  function stickerPreviewStyle(sticker) {
    const measuredScale = Number(sticker?.previewScale);
    const scale = Number.isFinite(measuredScale) && measuredScale > 0
      ? clamp(measuredScale, 0.62, 2.25)
      : previewScaleForAspect(sticker);
    const shiftX = clamp(Number(sticker?.previewShiftX || 0), -16, 16);
    const shiftY = clamp(Number(sticker?.previewShiftY || 0), -16, 16);
    return `--preview-scale:${scale.toFixed(3)}; --preview-shift-x:${shiftX.toFixed(2)}%; --preview-shift-y:${shiftY.toFixed(2)}%;`;
  }

  function previewScaleForAspect(sticker) {
    const aspect = stickerAspect(sticker);
    if (COMPACT_PREVIEW_STICKER_IDS.has(sticker.id)) return 0.82;
    if (sticker.subcategory === "Sarcastic") return 1.05;
    if (aspect < 0.42) return 0.74;
    if (aspect < 0.72) return 0.84;
    if (aspect > 2.4) return 0.72;
    if (aspect > 1.55) return 0.82;
    return 0.94;
  }

  function textMarkup(item, options = {}) {
    const font = safeTextFont(item.font);
    const color = safeTextColor(item.color);
    const effect = safeTextEffect(item.effect);
    const effectColor = textEffectColor(effect, color);
    const align = safeTextAlign(item.align);
    const text = escapeHtml(item.text || "Tekstas");
    const controlClass = options.control ? " is-control-text" : "";
    const previewClass = options.preview ? " is-preview-text" : "";
    const weight = item.bold === false ? 500 : 800;
    const style = item.italic ? "italic" : "normal";
    const decoration = [item.underline ? "underline" : "", item.strike ? "line-through" : ""].filter(Boolean).join(" ") || "none";
    const typography = `letter-spacing:${clamp(Number(item.letterSpacing) || 0, -10, 50) / 100}em;${item.lineHeight != null ? `line-height:${clamp(Number(item.lineHeight) || 100, 70, 200) / 100};` : ""}`;
    return `<span class="case-text text-effect-${effect}${controlClass}${previewClass}" style="font-family:${font}; color:${effectColor}; --text-glow:${effectColor}; text-align:${align}; font-weight:${weight}; font-style:${style}; text-decoration:${decoration};${typography}">${text}</span>`;
  }

  function photoSlotMarkup(item, options = {}) {
    const shape = ["rect", "rounded", "circle", "custom"].includes(item.shape) ? item.shape : "rounded";
    const radius = shape === "circle" ? "50%" : `${Math.max(0, Number(item.radius) || 0)}px`;
    const clip = shape === "custom" && item.clipPath ? `clip-path:${escapeAttribute(item.clipPath)};` : "";
    const frameStyle = safePhotoFrameStyle(item.frameStyle);
    const frameColor = safeHexColor(item.frameColor, "");
    const frameBg = safeHexColor(item.frameBg, "");
    const frameWidth = Number.isFinite(Number(item.frameWidthPx)) ? clamp(Number(item.frameWidthPx), 0, 18) : null;
    const imageZoom = clamp(Number(item.imageZoom) || 100, 100, 300) / 100;
    const imageX = clamp(Number(item.imageX ?? 50), 0, 100);
    const imageY = clamp(Number(item.imageY ?? 50), 0, 100);
    const previewClass = options.preview ? " is-preview-slot" : "";
    const controlClass = options.control ? " is-control-slot" : "";
    const imageStateClass = item.imageSrc ? " has-image" : " is-empty";
    const styleVars = [
      `border-radius:${radius}`,
      `--photo-x:${imageX}%`,
      `--photo-y:${imageY}%`,
      `--photo-zoom:${imageZoom}`,
      frameColor ? `--photo-frame-color:${frameColor}` : "",
      frameBg ? `--photo-frame-bg:${frameBg}` : "",
      frameWidth !== null ? `--photo-frame-width:${frameWidth}px` : "",
      clip,
    ].filter(Boolean).join("; ");
    return `
      <span
        class="photo-slot-frame is-${shape} is-frame-${frameStyle}${previewClass}${controlClass}${imageStateClass}"
        style="${styleVars}"
      >
        ${
          item.imageSrc
            ? `<img src="${escapeAttribute(item.imageSrc)}" alt="">`
            : `<span class="photo-slot-empty"><span class="photo-slot-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="4" y="5" width="16" height="14" rx="2"></rect><path d="m7 16 4-4 3 3 2-2 3 3"></path><circle cx="9" cy="9" r="1.5"></circle></svg></span><small>${escapeHtml(item.name || "Nuotrauka")}</small></span>`
        }
      </span>
    `;
  }

  function safeTextFont(font) {
    return TEXT_FONTS.some((item) => item.value === font) || window.StrayzyStudioFonts?.some(item => item.family === font) ? font : TEXT_FONTS[0].value;
  }

  function safeTextColor(color) {
    return /^#[0-9a-f]{6}$/i.test(color || "") ? color : "#111111";
  }

  function safeHexColor(color, fallback = "#ffffff") {
    return /^#[0-9a-f]{6}$/i.test(color || "") ? color : fallback;
  }

  function safePhotoFrameStyle(style) {
    const value = String(style || "default").toLowerCase();
    return [
      "default",
      "clean",
      "polaroid",
      "black-film",
      "white-border",
      "pink-border",
      "black-border",
    ].includes(value) ? value : "default";
  }

  function safeBackgroundScale(value) {
    return Math.round(clamp(Number(value) || 100, 10, 350));
  }

  function patternBackgroundScale(containerWidth, containerHeight, imageWidth, imageHeight, patternScale = 100) {
    const coverScale = Math.max(containerWidth / imageWidth, containerHeight / imageHeight);
    const selectedScale = coverScale * (safeBackgroundScale(patternScale) / 100);
    const panReadyScale = Math.max(
      (containerWidth * BACKGROUND_PATTERN_PAN_OVERSCAN) / imageWidth,
      (containerHeight * BACKGROUND_PATTERN_PAN_OVERSCAN) / imageHeight,
    );
    // Preserve existing designs at 100% and above; allow proportional shrinking below it.
    return safeBackgroundScale(patternScale) < 100
      ? panReadyScale * (safeBackgroundScale(patternScale) / 100)
      : Math.max(selectedScale, panReadyScale);
  }

  function safeTextEffect(effect) {
    return TEXT_EFFECTS.some((item) => item.value === effect) ? effect : "none";
  }

  function safeStickerOutline(outline) {
    return outline === "white" ? "white" : "none";
  }

  function textEffectColor(effect, fallbackColor) {
    const colors = {
      "neon-cyan": "#00f5ff",
      "neon-pink": "#ff3edb",
      "neon-green": "#39ff88",
      "neon-gold": "#ffd447",
    };
    return colors[safeTextEffect(effect)] || safeTextColor(fallbackColor);
  }

  function safeTextAlign(align) {
    return ["left", "center", "right", "justify"].includes(align) ? align : "center";
  }

  function smartLayoutPosition(style, index, count, safe, centerX, centerY) {
    const slot = smartLayoutSlot(style, index, count);
    return {
      x: safe.left + safe.width * slot.x,
      y: safe.top + safe.height * slot.y,
    };
  }

  function smartLayoutScale(style, index, count) {
    return smartLayoutSlot(style, index, count).scale;
  }

  function smartAspectScale(sticker) {
    const aspect = stickerAspect(sticker);
    if (aspect > 2.4) return 0.58;
    if (aspect > 1.75) return 0.72;
    if (aspect < 0.42) return 0.62;
    if (aspect < 0.68) return 0.78;
    return 1;
  }

  function smartLayoutSlot(style, index, count) {
    const plans = {
      minimal: [
        { x: 0.50, y: 0.50, scale: 1.34, rotation: -3 },
        { x: 0.30, y: 0.30, scale: 0.58, rotation: 8 },
        { x: 0.70, y: 0.72, scale: 0.50, rotation: -7 },
      ],
      center: [
        { x: 0.50, y: 0.52, scale: 1.46, rotation: 0 },
        { x: 0.30, y: 0.34, scale: 0.66, rotation: -9 },
        { x: 0.70, y: 0.35, scale: 0.58, rotation: 10 },
        { x: 0.32, y: 0.70, scale: 0.48, rotation: 8 },
        { x: 0.70, y: 0.72, scale: 0.42, rotation: -11 },
      ],
      edges: [
        { x: 0.49, y: 0.50, scale: 1.12, rotation: -2 },
        { x: 0.24, y: 0.20, scale: 0.62, rotation: -12 },
        { x: 0.76, y: 0.22, scale: 0.56, rotation: 10 },
        { x: 0.79, y: 0.52, scale: 0.60, rotation: 7 },
        { x: 0.67, y: 0.82, scale: 0.58, rotation: -10 },
        { x: 0.27, y: 0.79, scale: 0.52, rotation: 12 },
        { x: 0.18, y: 0.52, scale: 0.44, rotation: -7 },
        { x: 0.52, y: 0.72, scale: 0.38, rotation: 8 },
      ],
      balanced: [
        { x: 0.47, y: 0.49, scale: 1.36, rotation: -4 },
        { x: 0.68, y: 0.31, scale: 0.72, rotation: 10 },
        { x: 0.30, y: 0.64, scale: 0.66, rotation: -10 },
        { x: 0.68, y: 0.70, scale: 0.46, rotation: 7 },
        { x: 0.29, y: 0.28, scale: 0.42, rotation: 12 },
      ],
      bomb: [
        { x: 0.46, y: 0.48, scale: 1.22, rotation: -7 },
        { x: 0.67, y: 0.30, scale: 0.72, rotation: 15 },
        { x: 0.30, y: 0.32, scale: 0.66, rotation: -16 },
        { x: 0.72, y: 0.66, scale: 0.54, rotation: -11 },
        { x: 0.29, y: 0.71, scale: 0.50, rotation: 13 },
        { x: 0.52, y: 0.79, scale: 0.40, rotation: 7 },
        { x: 0.18, y: 0.50, scale: 0.36, rotation: -10 },
        { x: 0.80, y: 0.48, scale: 0.34, rotation: 17 },
      ],
    };
    const plan = plans[style] || plans.balanced;
    if (index < plan.length) return plan[index];
    const extra = index - plan.length;
    const angle = extra * 2.399963229728653 - Math.PI / 2;
    const ring = 0.34 + (extra % 3) * 0.08;
    return {
      x: 0.5 + Math.cos(angle) * ring,
      y: 0.5 + Math.sin(angle) * ring * 0.92,
      scale: 0.36 + seededWave(index, 8) * 0.18,
      rotation: Math.round(-18 + seededWave(index, 9) * 36),
    };
  }

  function smartLayoutGeneratedCount(style, available) {
    const desired = {
      minimal: 5,
      center: 5,
      edges: 7,
      balanced: 5,
      bomb: 8,
    }[style] || 5;
    return Math.min(Math.max(available, 0), desired);
  }

  function smartLayoutDensity(style, count) {
    if (style === "minimal") return count <= 3 ? 2.55 : 3.05;
    if (style === "center") return count <= 5 ? 2.85 : 3.45;
    if (style === "edges") return count <= 7 ? 3.75 : 4.4;
    if (style === "bomb") return count <= 8 ? 4.05 : 4.85;
    return count <= 3 ? 2.75 : count <= 5 ? 3.3 : 4.2;
  }

  function cohesiveStickerPool(stickers, count, context = {}) {
    if (context.subcategory && context.subcategory !== "All") return [...stickers];
    if (context.category && context.category !== "All") {
      const bySubcategory = bestStickerGroup(stickers, "subcategory", count);
      return bySubcategory.length ? bySubcategory : [...stickers];
    }
    const bySubcategory = bestStickerGroup(stickers, "subcategory", count);
    if (bySubcategory.length >= Math.min(count, 4)) return bySubcategory;
    const byCategory = bestStickerGroup(stickers, "category", count);
    return byCategory.length ? byCategory : [...stickers];
  }

  function bestStickerGroup(stickers, key, count) {
    const groups = new Map();
    stickers.forEach((sticker) => {
      const value = sticker?.[key];
      if (!value) return;
      if (!groups.has(value)) groups.set(value, []);
      groups.get(value).push(sticker);
    });
    let best = [];
    let bestScore = -Infinity;
    groups.forEach((group) => {
      const usable = group.filter((sticker) => {
        const aspect = stickerAspect(sticker);
        return aspect > 0.28 && aspect < 3.2;
      });
      const heroFriendly = usable.some((sticker) => {
        const aspect = stickerAspect(sticker);
        return aspect >= 0.62 && aspect <= 1.75;
      });
      const enough = Math.min(usable.length, count);
      const score = enough * 3 + (heroFriendly ? 5 : 0) - Math.abs(count - usable.length) * 0.35;
      if (score > bestScore) {
        bestScore = score;
        best = usable.length ? usable : group;
      }
    });
    return best;
  }

  function pickSmartLayoutStickers(stickers, count, context = {}) {
    if (!Array.isArray(stickers) || !stickers.length || count <= 0) return [];
    const pool = cohesiveStickerPool(stickers, count, context);
    const picked = [];
    const heroIndex = pool.findIndex((sticker) => {
      const aspect = stickerAspect(sticker);
      return aspect >= 0.62 && aspect <= 1.75;
    });
    if (heroIndex >= 0) picked.push(pool.splice(heroIndex, 1)[0]);
    const step = Math.max(1, Math.floor(pool.length / count));
    let cursor = Math.floor(pool.length * 0.17);
    while (picked.length < count && pool.length) {
      const index = cursor % pool.length;
      picked.push(pool.splice(index, 1)[0]);
      cursor += step + 2;
    }
    return picked;
  }

  function pickTemplateStickers(stickers, template, count) {
    if (!Array.isArray(stickers) || !stickers.length || count <= 0) return [];
    if ((template.layout || []).some((slot) => slot.role || slot.terms?.length)) {
      return pickTemplateStickersForLayout(stickers, template);
    }
    const scored = stickers
      .map((sticker, index) => ({
        sticker,
        index,
        score: templateStickerScore(sticker, template),
      }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score || a.index - b.index);
    const source = scored.length
      ? scored
      : stickers.map((sticker, index) => ({ sticker, index, score: 0 }));
    const chosen = [];
    const used = new Set();
    source.forEach((entry) => {
      if (chosen.length >= count) return;
      const nameKey = normalizeSearchText(entry.sticker.name || entry.sticker.id);
      if (used.has(nameKey)) return;
      used.add(nameKey);
      chosen.push(entry.sticker);
    });
    return chosen;
  }

  function pickTemplateStickersForLayout(stickers, template) {
    const chosen = [];
    const used = new Set();
    (template.layout || []).forEach((slot) => {
      const match = pickTemplateStickerForSlot(stickers, template, slot, used);
      if (!match) return;
      used.add(stickerUniqueKey(match.sticker));
      chosen.push(match);
    });
    return chosen;
  }

  function pickTemplateStickerForSlot(stickers, template, slot, used) {
    const scored = stickers
      .map((sticker, index) => ({
        sticker,
        slot,
        index,
        score: templateStickerScore(sticker, template, slot),
      }))
      .filter((entry) => !used.has(stickerUniqueKey(entry.sticker)))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score || seededWave(a.index, slot.x || 1) - seededWave(b.index, slot.x || 1));

    if (scored.length) return scored[0];

    const fallback = stickers
      .map((sticker, index) => ({ sticker, slot, index, score: templateStickerScore(sticker, template) }))
      .filter((entry) => !used.has(stickerUniqueKey(entry.sticker)))
      .sort((a, b) => b.score - a.score || a.index - b.index);
    return fallback[0] || null;
  }

  function lastItem(items) {
    return Array.isArray(items) && items.length ? items[items.length - 1] : undefined;
  }

  function templateStickerScore(sticker, template, slot = null) {
    const subcategory = normalizeSearchText(sticker.subcategory || "");
    const haystack = stickerSearchHaystack(sticker);
    let score = 0;
    (template.subcategories || []).forEach((item) => {
      if (subcategory === normalizeSearchText(item)) score += 12;
    });
    (template.terms || []).forEach((term) => {
      if (haystack.includes(normalizeSearchText(term))) score += 3;
    });
    (slot?.terms || []).forEach((term) => {
      if (haystack.includes(normalizeSearchText(term))) score += 18;
    });
    templateRoleTerms(slot?.role).forEach((term) => {
      if (haystack.includes(term)) score += 7;
    });
    score += templateRoleShapeScore(sticker, slot?.role);
    return score;
  }

  function stickerSearchHaystack(sticker) {
    return normalizeSearchText([
      sticker.name,
      sticker.category,
      sticker.subcategory,
      ...groups.flatMap((group) => [categoryLabel(group.category), subcategoryLabel(group.subcategory)]),
      sticker.description,
      sticker.fileName,
      sticker.originalCategory,
      sticker.originalSubcategory,
      ...(sticker.tags || []),
      ...(sticker.keywords || []),
      ...(sticker.colors || []),
    ].filter(Boolean).join(" "));
  }

  function stickerUniqueKey(sticker) {
    const fileName = normalizeSearchText(sticker.fileName || sticker.originalFileName || "");
    if (fileName) return `file:${fileName}`;

    const name = normalizeSearchText(sticker.name || "");
    if (name) return `name:${name}`;

    const source = [sticker.printSrc, sticker.sourcePath, sticker.thumbSrc, sticker.src]
      .find((value) => value && !String(value).startsWith("data:"));
    if (source) return `src:${normalizeStickerSourceKey(source)}`;

    return normalizeSearchText(sticker.id || "");
  }

  function normalizeStickerSourceKey(value) {
    return String(value || "")
      .replace(/\\/g, "/")
      .replace(/^\.?\//, "")
      .replace(/\?.*$/, "")
      .trim()
      .toLowerCase();
  }

  function templateRoleTerms(role) {
    return {
      paper: ["paper", "torn", "note", "letter", "stamp", "ticket", "receipt", "map", "texture", "journal", "card"],
      hero: ["cat", "dog", "lion", "girl", "woman", "angel", "fairy", "animal", "flower", "tree", "wave", "lighthouse"],
      accent: ["star", "sparkle", "heart", "bow", "flower", "key", "clock", "shell", "anchor", "compass", "clover", "mushroom", "sun", "crown"],
      text: ["text", "word", "quote", "letters", "zodiac", "taurus", "aquarius", "leo", "sarcasm"],
    }[role] || [];
  }

  function templateRoleShapeScore(sticker, role) {
    if (!role) return 0;
    const aspect = stickerAspect(sticker);
    if (!Number.isFinite(aspect) || aspect <= 0) return 0;
    if (role === "paper") return aspect >= 0.85 && aspect <= 2.6 ? 4 : -2;
    if (role === "hero") return aspect >= 0.45 && aspect <= 1.9 ? 4 : 0;
    if (role === "text") return aspect >= 1.25 ? 5 : 0;
    if (role === "accent") return aspect >= 0.45 && aspect <= 2.2 ? 2 : 0;
    return 0;
  }

  function smartLayoutRotation(style, index) {
    return smartLayoutSlot(style, index).rotation;
  }

  function seededWave(index, salt = 1) {
    const value = Math.sin((index + 1) * (12.9898 + salt * 4.1414)) * 43758.5453;
    return value - Math.floor(value);
  }

  function autoLayoutLabel(style) {
    return {
      balanced: "Subalansuota",
      bomb: "Lipdukų bomba",
      center: "Centras",
      minimal: "Minimal",
      edges: "KraЕЎtai",
    }[style] || "Subalansuota";
  }

  function drawTextItem(ctx, item, scale = 1, align = "center") {
    const fontSize = item.size * scale;
    const weight = item.bold === false ? 500 : 800;
    const style = item.italic ? "italic" : "normal";
    ctx.font = `${style} ${weight} ${fontSize}px ${safeTextFont(item.font)}`;
    ctx.letterSpacing = `${fontSize * clamp(Number(item.letterSpacing) || 0, -10, 50) / 100}px`;
    const textAlign = safeTextAlign(item.align || align);
    const boxHalf = itemBoxSize({ ...item, size: fontSize }).width / 2;
    const drawX = textAlign === "left" ? -boxHalf : textAlign === "right" ? boxHalf : textAlign === "justify" ? -boxHalf : 0;
    ctx.textAlign = textAlign === "justify" ? "left" : textAlign;
    ctx._szJustifyWidth = textAlign === "justify" ? boxHalf * 2 : 0;
    ctx.textBaseline = "middle";
    ctx.lineJoin = "round";
    applyCanvasTextEffect(ctx, item, fontSize, drawX);
    ctx._szJustifyWidth = 0;
    ctx.wordSpacing = "0px";
  }

  function drawStickerImage(ctx, image, x, y, width, height = width, item) {
    if (safeStickerOutline(item.outline) === "white") {
      const outline = Math.max(1, Math.max(width, height) * 0.018);
      const maskCanvas = document.createElement("canvas");
      maskCanvas.width = Math.ceil(width);
      maskCanvas.height = Math.ceil(height);
      const maskCtx = maskCanvas.getContext("2d");
      maskCtx.drawImage(image, 0, 0, maskCanvas.width, maskCanvas.height);
      maskCtx.globalCompositeOperation = "source-in";
      maskCtx.fillStyle = "#ffffff";
      maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
      const steps = [
        [outline, 0],
        [-outline, 0],
        [0, outline],
        [0, -outline],
        [outline, outline],
        [-outline, outline],
        [outline, -outline],
        [-outline, -outline],
      ];
      steps.forEach(([dx, dy]) => ctx.drawImage(maskCanvas, x + dx, y + dy, width, height));
    }
    ctx.drawImage(image, x, y, width, height);
  }

  async function drawPhotoSlotImage(ctx, item, width, height) {
    const frame = photoFramePaint(item);
    ctx.save();
    photoSlotPath(ctx, item, -width / 2, -height / 2, width, height);
    ctx.clip();
    ctx.fillStyle = frame.bg || "#f4f4f5";
    ctx.fillRect(-width / 2, -height / 2, width, height);
    if (item.imageSrc) {
      const image = await loadCanvasSafeImage(item.imageSrc, {
        label: `photo slot image (${item.uid || "unknown"})`,
        required: item.required !== false,
        context: "drawPhotoSlotImage",
      });
      if (!image) {
        ctx.restore();
        return;
      }
      const zoom = clamp(Number(item.imageZoom) || 100, 100, 300) / 100;
      const cover = Math.max(width / image.width, height / image.height) * zoom;
      const drawWidth = image.width * cover;
      const drawHeight = image.height * cover;
      const maxShiftX = Math.max(0, (drawWidth - width) / 2);
      const maxShiftY = Math.max(0, (drawHeight - height) / 2);
      const offsetX = ((clamp(Number(item.imageX ?? 50), 0, 100) - 50) / 50) * maxShiftX;
      const offsetY = ((clamp(Number(item.imageY ?? 50), 0, 100) - 50) / 50) * maxShiftY;
      ctx.drawImage(image, -drawWidth / 2 + offsetX, -drawHeight / 2 + offsetY, drawWidth, drawHeight);
    }
    ctx.restore();
    if (frame.width > 0 && frame.color) {
      ctx.save();
      photoSlotPath(ctx, item, -width / 2, -height / 2, width, height);
      ctx.lineWidth = frame.width;
      ctx.strokeStyle = frame.color;
      ctx.stroke();
      ctx.restore();
    }
  }

  function photoFramePaint(item) {
    const style = safePhotoFrameStyle(item.frameStyle);
    const defaults = {
      default: { color: "rgba(255,255,255,0.92)", bg: "#ffffff", width: 2 },
      clean: { color: "", bg: "transparent", width: 0 },
      polaroid: { color: "#ffffff", bg: "#ffffff", width: 9 },
      "black-film": { color: "#111111", bg: "#111111", width: 9 },
      "white-border": { color: "#ffffff", bg: "transparent", width: 4 },
      "pink-border": { color: "#ff9fb0", bg: "transparent", width: 5 },
      "black-border": { color: "#111111", bg: "transparent", width: 3 },
    }[style] || { color: "rgba(255,255,255,0.92)", bg: "#ffffff", width: 2 };
    return {
      color: safeHexColor(item.frameColor, defaults.color),
      bg: safeHexColor(item.frameBg, defaults.bg),
      width: Number.isFinite(Number(item.frameWidthPx)) ? clamp(Number(item.frameWidthPx), 0, 18) : defaults.width,
    };
  }

  function photoSlotPath(ctx, item, x, y, width, height) {
    if (item.shape === "custom" && String(item.clipPath || "").trim().startsWith("polygon(")) {
      const points = String(item.clipPath)
        .replace(/^polygon\(/, "")
        .replace(/\)$/, "")
        .split(",")
        .map((point) => point.trim().split(/\s+/).map((value) => parseFloat(value) / 100))
        .filter((point) => point.length === 2 && point.every(Number.isFinite));
      if (points.length >= 3) {
        ctx.beginPath();
        points.forEach(([px, py], index) => {
          const nextX = x + px * width;
          const nextY = y + py * height;
          if (index === 0) ctx.moveTo(nextX, nextY);
          else ctx.lineTo(nextX, nextY);
        });
        ctx.closePath();
        return;
      }
    }
    if (item.shape === "circle") {
      ctx.beginPath();
      ctx.ellipse(x + width / 2, y + height / 2, width / 2, height / 2, 0, 0, Math.PI * 2);
      return;
    }
    const radius = item.shape === "rect" ? 0 : Math.min(width / 2, height / 2, Number(item.radius) || 0);
    roundedRectPath(ctx, x, y, width, height, radius);
  }

  function getModelBackgroundMaskSrc(model) {
    const modelImage = MODEL_IMAGES[model] || null;
    return modelImage?.backgroundMaskSrc || modelImage?.maskSrc || MODEL_PHOTO_MASKS[model] || "";
  }

  function resolvePrintMaskSrc(modelImage) {
    return modelImage?.printMaskSrc || modelImage?.maskSrc || "";
  }

  async function drawPreviewBackground(ctx, background, model, x, y, width, height = width) {
    if (!["color", "pattern"].includes(background?.type)) return;
    const maskSrc = getModelBackgroundMaskSrc(model);
    const backgroundCanvas = document.createElement("canvas");
    backgroundCanvas.width = Math.max(1, Math.round(width));
    backgroundCanvas.height = Math.max(1, Math.round(height));
    const backgroundCtx = backgroundCanvas.getContext("2d");
    if (background.type === "pattern" && background.pattern) {
      await drawPatternBackground(backgroundCtx, background.pattern, 0, 0, backgroundCanvas.width, backgroundCanvas.height, background.patternScale, background.patternOffsetX, background.patternOffsetY, background.patternStretchX, background.patternStretchY);
    } else {
      backgroundCtx.fillStyle = backgroundColorPaint(background);
      backgroundCtx.fillRect(0, 0, backgroundCanvas.width, backgroundCanvas.height);
    }
    if (maskSrc) {
      const mask = await loadCanvasSafeImage(maskSrc, {
        label: `phone mask (${model})`,
        required: false,
        context: "drawPreviewBackground",
        fallbackToDirect: true,
      });
      if (mask) {
        backgroundCtx.globalCompositeOperation = "destination-in";
        backgroundCtx.drawImage(mask, 0, 0, backgroundCanvas.width, backgroundCanvas.height);
      }
    }
    ctx.drawImage(backgroundCanvas, x, y, width, height);
  }

  async function drawPrintBackground(ctx, background, printRect, previewMetrics = null, extendPattern = false) {
    if (!["color", "pattern"].includes(background?.type)) return;
    ctx.save();
    const x = printRect.x;
    const y = printRect.y;
    const width = printRect.width;
    const height = printRect.height;
    if (background.type === "pattern" && background.pattern) {
      if (isValidPatternMetrics(previewMetrics)) {
        const image = await loadCanvasSafeImage(background.pattern, {
          label: "background pattern image",
          required: true,
          context: "drawPrintBackground",
        });
        ctx.beginPath();
        ctx.rect(x, y, width, height);
        ctx.clip();
        const scale = Math.max(width / previewMetrics.layerWidth, height / previewMetrics.layerHeight);
        const layerX = x + (width - previewMetrics.layerWidth * scale) / 2;
        const layerY = y + (height - previewMetrics.layerHeight * scale) / 2;
        if (extendPattern) {
          // Continue the pattern at its preview scale and phase into the full print outline.
          const pattern = ctx.createPattern(image, "repeat");
          pattern.setTransform(new DOMMatrix([
            previewMetrics.drawWidth * scale / image.naturalWidth, 0,
            0, previewMetrics.drawHeight * scale / image.naturalHeight,
            layerX + previewMetrics.left * scale,
            layerY + previewMetrics.top * scale,
          ]));
          ctx.fillStyle = pattern;
          ctx.fillRect(x, y, width, height);
        }
        ctx.drawImage(
          image,
          layerX + previewMetrics.left * scale,
          layerY + previewMetrics.top * scale,
          previewMetrics.drawWidth * scale,
          previewMetrics.drawHeight * scale,
        );
      } else {
        await drawPatternBackground(ctx, background.pattern, x, y, width, height, background.patternScale, background.patternOffsetX, background.patternOffsetY, background.patternStretchX, background.patternStretchY);
      }
    } else {
      ctx.fillStyle = backgroundColorPaint(background);
      ctx.fillRect(x, y, width, height);
    }
    ctx.restore();
  }

  function backgroundColorPaint(background) {
    const alpha = Math.round(clamp(background.colorOpacity ?? 100, 0, 100) * 255 / 100);
    return safeHexColor(background.color, "#ffffff") + alpha.toString(16).padStart(2, "0");
  }

  function safeBackgroundStretch(value) {
    return Number.isFinite(Number(value)) ? clamp(Number(value), 0.1, 5) : 1;
  }

  async function drawPatternBackground(ctx, src, x, y, width, height, patternScale = 100, offsetX = 0, offsetY = 0, stretchX = 1, stretchY = 1) {
    const image = await loadCanvasSafeImage(src, {
      label: "background pattern image",
      required: true,
      context: "drawPatternBackground",
    });
    const scale = patternBackgroundScale(width, height, image.naturalWidth, image.naturalHeight, patternScale);
    const drawWidth = image.naturalWidth * scale * safeBackgroundStretch(stretchX);
    const drawHeight = image.naturalHeight * scale * safeBackgroundStretch(stretchY);
    const safeOffsetX = Number.isFinite(Number(offsetX)) ? Number(offsetX) : 0;
    const safeOffsetY = Number.isFinite(Number(offsetY)) ? Number(offsetY) : 0;
    ctx.drawImage(image, x + (width - drawWidth) / 2 + safeOffsetX, y + (height - drawHeight) / 2 + safeOffsetY, drawWidth, drawHeight);
  }

  function applyCanvasTextEffect(ctx, item, fontSize, x = 0) {
    const lines = textLines(item.text);
    const effect = safeTextEffect(item.effect);
    const color = textEffectColor(effect, item.color);
    const outline = Math.max(2, fontSize * 0.055);
    const lineHeight = fontSize * (item.lineHeight == null ? 1.08 : clamp(Number(item.lineHeight) || 100, 70, 200) / 100);
    const startY = -((lines.length - 1) * lineHeight) / 2;

    ctx.fillStyle = color;
    ctx.shadowColor = "rgba(31, 35, 40, 0.14)";
    ctx.shadowBlur = Math.max(4, fontSize * 0.08);
    ctx.shadowOffsetY = Math.max(2, fontSize * 0.05);

    if (effect === "outline-white") {
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = outline * 1.4;
      drawCanvasTextLines(ctx, lines, x, startY, lineHeight, "stroke");
    }
    if (effect === "outline-black") {
      ctx.strokeStyle = "#111111";
      ctx.lineWidth = outline * 1.4;
      drawCanvasTextLines(ctx, lines, x, startY, lineHeight, "stroke");
    }
    if (effect === "glow") {
      ctx.shadowColor = color;
      ctx.shadowBlur = fontSize * 0.45;
      ctx.shadowOffsetY = 0;
    }
    if (effect.startsWith("neon-")) {
      ctx.shadowColor = color;
      ctx.shadowBlur = fontSize * 0.65;
      ctx.shadowOffsetY = 0;
      ctx.strokeStyle = color;
      ctx.lineWidth = Math.max(1, outline * 0.7);
      drawCanvasTextLines(ctx, lines, x, startY, lineHeight, "stroke");
    }

    drawCanvasTextLines(ctx, lines, x, startY, lineHeight, "fill");
    if (item.strike) {
      ctx.shadowBlur = 0;
      ctx.strokeStyle = color;
      ctx.lineWidth = Math.max(1, fontSize * 0.05);
      lines.forEach((line,index) => {
        const width = ctx._szJustifyWidth && index < lines.length - 1 && line.includes(" ") ? ctx._szJustifyWidth : ctx.measureText(line || " ").width;
        const left = ctx.textAlign === "left" ? x : ctx.textAlign === "right" ? x - width : x - width / 2;
        ctx.beginPath();ctx.moveTo(left,startY + index * lineHeight);ctx.lineTo(left+width,startY + index * lineHeight);ctx.stroke();
      });
    }
    if (item.underline) {
      ctx.shadowBlur = 0;
      ctx.strokeStyle = color;
      ctx.lineWidth = Math.max(2, fontSize * 0.055);
      lines.forEach((line, index) => {
        const metrics = ctx.measureText(line || " ");
        const width = ctx._szJustifyWidth && index < lines.length - 1 && line.includes(" ") ? ctx._szJustifyWidth : metrics.width;
        const y = startY + index * lineHeight + fontSize * 0.42;
        let start = -width / 2;
        let end = width / 2;
        if (ctx.textAlign === "left") {
          start = 0;
          end = width;
        } else if (ctx.textAlign === "right") {
          start = -width;
          end = 0;
        }
        ctx.beginPath();
        ctx.moveTo(start + x, y);
        ctx.lineTo(end + x, y);
        ctx.stroke();
      });
    }
  }

  function textLines(text) {
    const normalized = String(text || "Tekstas").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    return normalized.split("\n");
  }

  function drawCanvasTextLines(ctx, lines, x, startY, lineHeight, mode) {
    lines.forEach((line, index) => {
      const value = line || " ";
      const y = startY + index * lineHeight;
      let drawX = x;
      if (ctx._szJustifyWidth) {
        drawX = -ctx._szJustifyWidth / 2;
        ctx.wordSpacing = "0px";
        const spaces = (value.match(/ /g) || []).length;
        if (spaces && index < lines.length - 1) ctx.wordSpacing = `${Math.max(0,(ctx._szJustifyWidth-ctx.measureText(value).width)/spaces)}px`;
      }
      if (mode === "stroke") {
        ctx.strokeText(value, drawX, y);
      } else {
        ctx.fillText(value, drawX, y);
      }
    });
  }

  function categoryLabel(category) {
    const labels = {
      "All": "Visi",
      "Custom": "Įkelti",
      "Tech & Gadgets": "Technologijos ir įrenginiai",
      "Hearts & Love": "Širdelės ir meilė",
      "Stars & Space": "Žvaigždės ir kosmosas",
      "Bows & Butterflies": "Kaspinėliai ir drugeliai",
      "Flowers & Nature": "Gėlės ir gamta",
      "Animals & Characters": "Gyvūnai ir personažai",
      "Food & Drinks": "Maistas ir gėrimai",
      "Fashion & Beauty": "Mada ir grožis",
      "Decor & Objects": "Dekoras ir daiktai",
      "Abstract & Chrome": "Abstrakcijos ir chromas",
      "Text & Letters": "Tekstai ir raidės",
      "Retro & Y2K Mix": "Retro ir Y2K"
};
    return labels[category] || category;
  }

  function subcategoryLabel(subcategory) {
    const labels = {
      "Computers & Web": "Kompiuteriai ir internetas",
      "Music & Media": "Muzika ir medijos",
      "Phones": "Telefonai",
      "Games & Devices": "Žaidimai ir įrenginiai",
      "Cameras": "Fotoaparatai",
      "Hearts": "Širdelės",
      "Love & Romance": "Meilė ir romantika",
      "Stars": "Žvaigždės",
      "Angels & Wings": "Angelai ir sparnai",
      "Space": "Kosmosas",
      "Clouds": "Debesys",
      "Bows": "Kaspinėliai",
      "Butterflies": "Drugeliai",
      "Flowers": "Gėlės",
      "Plants": "Augalai",
      "Shells & Beach": "Kriauklės ir paplūdimys",
      "Characters & Toys": "Personažai ir žaislai",
      "Bears & Bunnies": "Meškiukai ir zuikučiai",
      "Cats & Dogs": "Katės ir šunys",
      "Other Animals": "Kiti gyvūnai",
      "Drinks": "Gėrimai",
      "Fruit": "Vaisiai",
      "Candy": "Saldainiai",
      "Desserts": "Desertai",
      "Snacks": "Užkandžiai",
      "Jewelry": "Papuošalai",
      "Bags & Accessories": "Rankinės ir aksesuarai",
      "Makeup & Beauty": "Makiažas ir grožis",
      "Shoes & Clothing": "Batai ir drabužiai",
      "Decor Objects": "Dekoratyviniai daiktai",
      "Frames & Paper": "Rėmeliai ir popierius",
      "Vehicles": "Transportas",
      "Shapes & Symbols": "Formos ir simboliai",
      "Chrome": "Chromas",
      "Holographic": "Holografiniai",
      "Sarcastic / Text Mix": "Sarkazmas ir tekstai",
      "Quotes & Phrases": "Citatos ir frazės",
      "Letters & Numbers": "Raidės ir skaičiai",
      "Vintage / Retro Mix": "Vintažas ir retro",
      "Pink / Girly Mix": "Rožiniai ir mergaitiški",
      "Dark / Alt Mix": "Tamsūs ir alternatyvūs",
      "Mixed Icons": "Įvairūs simboliai",
      "70s Retro": "70-ųjų retro",
      "Y2K TECH": "Y2K technologijos"
};
    return labels[subcategory] || String(subcategory || "").replace(/\s*Y2K\s*/gi, " ").trim();
  }

  function stickerMatchesSearch(sticker, query) {
    const normalizedQuery = normalizeSearchText(query);
    if (!normalizedQuery) return true;
    const queryParts = normalizedQuery.split(/\s+/).filter(Boolean);
    const groups = stickerGroups(sticker);
    const haystack = [
      sticker.name,
      sticker.fileName,
      sticker.category,
      sticker.subcategory,
      ...groups.flatMap((group) => [group.category, group.subcategory]),
      sticker.description,
      sticker.originalCategory,
      sticker.originalSubcategory,
      ...(Array.isArray(sticker.tags) ? sticker.tags : []),
      ...(Array.isArray(sticker.keywords) ? sticker.keywords : []),
      ...(Array.isArray(sticker.colors) ? sticker.colors : []),
    ]
      .filter(Boolean)
      .join(" ");
    const normalizedHaystack = normalizeSearchText(haystack);
    return queryParts.every((part) => normalizedHaystack.includes(part));
  }

  function uniqueStickersBySource(stickers) {
    const seen = new Set();
    return stickers.filter((sticker) => {
      const key = stickerUniqueKey(sticker);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function stickerGroups(sticker) {
    const groups = Array.isArray(sticker.groups) ? sticker.groups : [];
    const normalized = groups
      .map((group) => ({
        category: group?.category || "",
        subcategory: group?.subcategory || "",
      }))
      .filter((group) => group.category);
    if (!normalized.length) {
      return [{ category: sticker.category || "Custom", subcategory: sticker.subcategory || "" }];
    }
    return normalized;
  }

  function stickerCategories(sticker) {
    return [...new Set(stickerGroups(sticker).map((group) => group.category || "Custom"))];
  }

  function stickerSubcategoriesForCategory(sticker, category) {
    return [
      ...new Set(
        stickerGroups(sticker)
          .filter((group) => group.category === category)
          .map((group) => group.subcategory)
          .filter(Boolean),
      ),
    ];
  }

  function stickerBelongsToCategory(sticker, category) {
    if (category === "All") return true;
    return stickerGroups(sticker).some((group) => group.category === category);
  }

  function stickerBelongsToSubcategory(sticker, category, subcategory) {
    if (subcategory === "All") return true;
    return stickerGroups(sticker).some((group) => group.category === category && group.subcategory === subcategory);
  }

  function sortStickerCategory(a, b) {
    const indexA = STICKER_CATEGORY_ORDER.indexOf(a);
    const indexB = STICKER_CATEGORY_ORDER.indexOf(b);
    if (indexA !== -1 || indexB !== -1) {
      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    }
    return String(a).localeCompare(String(b));
  }

  function sortStickerSubcategory(a, b, stickers) {
    const countA = stickers.filter((sticker) => stickerGroups(sticker).some((group) => group.subcategory === a)).length;
    const countB = stickers.filter((sticker) => stickerGroups(sticker).some((group) => group.subcategory === b)).length;
    if (countA !== countB) return countB - countA;
    return String(a).localeCompare(String(b));
  }

  function normalizeSearchText(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function stickerPositionStyle(item, sticker) {
    const box = itemBoxSize(item, sticker);
    return `--x:${item.x}; --y:${item.y}; --size:${item.size}px; --box-width:${box.width}px; --box-height:${box.height}px; --rotation:${item.rotation}deg; --opacity:${safeItemOpacity(item.opacity) / 100}; --flip-x:${item.flipX ? -1 : 1}; --flip-y:${item.flipY ? -1 : 1}`;
  }

  function safeItemOpacity(opacity) {
    return clamp(Number.isFinite(Number(opacity)) ? Number(opacity) : 100, 10, 100);
  }

  function itemBoxSize(item, sticker) {
    if (item?.type === "text") {
      return textBoxSize(item);
    }
    if (item?.type === "photo-slot") {
      return {
        width: Math.max(24, Number(item.frameWidth) || Number(item.size) || 96),
        height: Math.max(24, Number(item.frameHeight) || Number(item.size) || 96),
      };
    }
    const aspect = stickerAspect(sticker);
    if (aspect >= 1) {
      return { width: item.size, height: item.size / aspect };
    }
    return { width: item.size * aspect, height: item.size };
  }

  function textBoxSize(item) {
    const fontSize = Number(item?.size) || 46;
    const lines = textLines(item?.text);
    const weight = item?.bold === false ? 500 : 800;
    const style = item?.italic ? "italic" : "normal";
    const family = safeTextFont(item?.font);
    const ctx = textMeasureContext();
    ctx.font = `${style} ${weight} ${fontSize}px ${family}`;
    ctx.letterSpacing = `${fontSize * clamp(Number(item.letterSpacing) || 0, -10, 50) / 100}px`;
    const maxWidth = lines.reduce((largest, line) => {
      const metrics = ctx.measureText(line || " ");
      return Math.max(largest, metrics.width || 0);
    }, 0);
    const lineHeight = fontSize * (item.lineHeight == null ? 1.12 : clamp(Number(item.lineHeight) || 100, 70, 200) / 100);
    const effect = safeTextEffect(item?.effect);
    const effectPad = effect === "none" ? fontSize * 0.12 : effect.startsWith("neon-") || effect === "glow" ? fontSize * 0.52 : fontSize * 0.24;
    return {
      width: Math.max(32, Math.ceil(maxWidth + effectPad * 2 + fontSize * 0.18)),
      height: Math.max(32, Math.ceil(lines.length * lineHeight + effectPad * 2)),
    };
  }

  function textMeasureContext() {
    if (!textMeasureContext.canvas) {
      textMeasureContext.canvas = document.createElement("canvas");
      textMeasureContext.ctx = textMeasureContext.canvas.getContext("2d");
    }
    return textMeasureContext.ctx;
  }

  function stickerAspect(sticker) {
    const width = Number(sticker?.width || sticker?.naturalWidth);
    const height = Number(sticker?.height || sticker?.naturalHeight);
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return 1;
    return width / height;
  }

  function parseAspectRatio(value) {
    if (typeof value === "number" && Number.isFinite(value) && value > 0) return value;
    const parts = String(value || "").split("/").map((part) => Number(part.trim()));
    if (parts.length === 2 && parts.every((part) => Number.isFinite(part) && part > 0)) {
      return parts[0] / parts[1];
    }
    return 1;
  }

  function cameraStyle(module) {
    return `left:${module.x}%; top:${module.y}%; width:${module.w}%; height:${module.h}%; border-radius:${module.r}px`;
  }

  function lensStyle(lens) {
    return `left:${lens.x}%; top:${lens.y}%; width:${lens.d}%; aspect-ratio:1; transform:translate(-50%, -50%)`;
  }

  function cameraToPercent(preset) {
    const toX = (mm) => (mm / preset.widthMm) * 100;
    const toY = (mm) => (mm / preset.heightMm) * 100;
    const avgScale = (preset.widthMm + preset.heightMm) / 2;
    const module = preset.module
      ? {
          x: toX(preset.module.xMm),
          y: toY(preset.module.yMm),
          w: toX(preset.module.wMm),
          h: toY(preset.module.hMm),
          r: Math.max(8, (preset.module.rMm / avgScale) * 720),
          style: preset.module.style,
        }
      : null;
    const lenses = preset.lenses.map((lens) => ({
      x: toX(lens.xMm),
      y: toY(lens.yMm),
      d: toX(lens.dMm),
    }));
    const sensors = (preset.sensors || []).map((sensor) => ({
      x: toX(sensor.xMm),
      y: toY(sensor.yMm),
      d: toX(sensor.dMm),
    }));
    const flash = preset.flash
      ? {
          x: toX(preset.flash.xMm),
          y: toY(preset.flash.yMm),
          d: toX(preset.flash.dMm),
      }
      : null;

    return { module, lenses, flash, sensors };
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function logPreviewExportEvent(event, payload = {}) {
    if (!DEBUG_PREVIEW_EXPORT) return;
    if (console?.log) {
      console.log(`[PreviewExport:${event}]`, payload);
    }
  }

  function isCanvasTaintedError(error) {
    return (
      error &&
      (error.name === "SecurityError" ||
        /tainted|tainted canvas|cross[- ]?origin|CORS/i.test(error.message || ""))
    );
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => {
      const map = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" };
      return map[char];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function loadCustomStickers() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function saveCustomStickers(stickers) {
    let limit = Math.min(80, stickers.length);
    while (limit >= 0) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(limit ? stickers.slice(-limit) : []));
        return true;
      } catch {
        limit = Math.floor(limit / 2);
      }
    }
    return false;
  }

  function loadBackgroundPatterns() {
    try {
      return JSON.parse(localStorage.getItem(BACKGROUND_PATTERNS_STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function saveBackgroundPatterns(patterns) {
    localStorage.setItem(BACKGROUND_PATTERNS_STORAGE_KEY, JSON.stringify(patterns.slice(-48)));
  }

  function loadFavorites() {
    try {
      return JSON.parse(localStorage.getItem(FAVORITES_STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function saveFavorites(ids) {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(ids));
  }

  function loadModelPhotos() {
    try {
      return JSON.parse(localStorage.getItem(MODEL_PHOTOS_STORAGE_KEY) || "{}");
    } catch {
      return {};
    }
  }

  function saveModelPhotos(photos) {
    localStorage.setItem(MODEL_PHOTOS_STORAGE_KEY, JSON.stringify(photos));
  }

  function loadDesignDraft() {
    try {
      const raw = localStorage.getItem(DESIGN_DRAFT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function saveDesignDraft(snapshot) {
    localStorage.setItem(DESIGN_DRAFT_STORAGE_KEY, JSON.stringify(snapshot));
  }

  function hasSavedDesignDraft() {
    try {
      return Boolean(localStorage.getItem(DESIGN_DRAFT_STORAGE_KEY));
    } catch {
      return false;
    }
  }

  function fileToSticker(file, options = {}) {
    return new Promise((resolve) => {
      if (!file.type.startsWith("image/")) {
        resolve(null);
        return;
      }

      const reader = new FileReader();
      reader.onload = async () => {
        const src = reader.result;
        let width = 0;
        let height = 0;
        try {
          const image = await imageFromSource(src);
          width = image.naturalWidth || image.width || 0;
          height = image.naturalHeight || image.height || 0;
        } catch {
          width = 0;
          height = 0;
        }
        const baseName = file.name.replace(/\.[^.]+$/, "");
        resolve({
          id: `custom-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          name: options.namePrefix ? `${options.namePrefix}: ${baseName}` : baseName,
          category: options.category || "Custom",
          subcategory: options.subcategory || "Mano įkelti",
          tags: options.tags || [baseName, options.subcategory || "Mano įkelti", "custom", "photo"],
          keywords: options.keywords || [baseName, options.subcategory || "Mano įkelti", "custom", "photo"],
          type: "image",
          src,
          printSrc: src,
          printSourceStatus: "uploaded",
          printQualityRole: options.printQualityRole || "",
          width,
          height,
          aspectRatio: width && height ? Number((width / height).toFixed(4)) : 1,
        });
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });
  }

  async function fileToCustomerPhotoSticker(file) {
    const validation = validateCustomerPhotoFile(file);
    if (validation) throw new Error(validation);
    let src = "";
    try {
      src = await fileToDataUrl(file);
    } catch {
      throw new Error("Nepavyko perskaityti failo. Pabandykite kitą nuotrauką.");
    }
    let width = 0;
    let height = 0;
    try {
      const image = await imageFromSource(src);
      width = image.naturalWidth || image.width || 0;
      height = image.naturalHeight || image.height || 0;
    } catch {
      throw new Error("Nepavyko įkelti nuotraukos. Failas gali būti sugadintas.");
    }
    if (!width || !height) {
      throw new Error("Nepavyko patikrinti nuotraukos dydžio. Pabandykite kitą failą.");
    }
    const baseName = file.name.replace(/\.[^.]+$/, "") || "Nuotrauka";
    return {
      id: `custom-photo-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      name: `Nuotrauka: ${baseName}`,
      originalFileName: file.name || baseName,
      category: "Custom",
      subcategory: "Mano nuotraukos",
      tags: [baseName, "nuotrauka", "photo", "uploaded", "custom"],
      keywords: [baseName, "nuotrauka", "photo", "uploaded", "custom"],
      type: "image",
      src,
      printSrc: src,
      printSourceStatus: "uploaded",
      printQualityRole: "photo",
      width,
      height,
      aspectRatio: width && height ? Number((width / height).toFixed(4)) : 1,
    };
  }

  function validateCustomerPhotoFile(file) {
    if (!file) return "Pasirinkite nuotraukos failą.";
    const type = String(file.type || "").toLowerCase();
    const supported = ["image/png", "image/jpeg", "image/webp"];
    if (!supported.includes(type)) {
      return "Nepalaikomas failo formatas. Įkelkite JPG, PNG arba WEBP.";
    }
    return "";
  }

  function uploadErrorMessage(error, fallback = "Nepavyko įkelti nuotraukos. Pabandykite kitą failą.") {
    const message = typeof error === "string" ? error : error?.message;
    return message || fallback;
  }

  function isCustomerPhotoSticker(sticker) {
    if (!sticker) return false;
    return sticker.printQualityRole === "photo" ||
      sticker.subcategory === "Mano nuotraukos" ||
      sticker.subcategory === "AI nuotraukos";
  }

  function cleanPhotoLabel(label) {
    return String(label || "Nuotrauka")
      .replace(/^Nuotrauka:\s*/i, "")
      .trim() || "Nuotrauka";
  }

  function fileToPattern(file) {
    return new Promise((resolve) => {
      if (!file.type.startsWith("image/")) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        resolve({
          id: `pattern-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          name: file.name.replace(/\.[^.]+$/, ""),
          src: reader.result,
        });
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function detectSafeArea(src) {
    const image = await imageFromSource(src);
    const canvas = document.createElement("canvas");
    const maxSize = 500;
    const scale = Math.min(1, maxSize / Math.max(image.naturalWidth, image.naturalHeight));
    canvas.width = Math.round(image.naturalWidth * scale);
    canvas.height = Math.round(image.naturalHeight * scale);
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let minX = width;
    let minY = height;
    let maxX = 0;
    let maxY = 0;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const index = (y * width + x) * 4;
        const r = data[index];
        const g = data[index + 1];
        const b = data[index + 2];
        const a = data[index + 3];
        const delta = Math.max(r, g, b) - Math.min(r, g, b);
        const isWhiteBackground = a < 16 || (r > 248 && g > 248 && b > 248 && delta < 8);
        if (isWhiteBackground) continue;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }

    if (minX >= maxX || minY >= maxY) return DEFAULT_SAFE_AREA;

    const paddingX = width * 0.035;
    const paddingY = height * 0.025;
    minX = clamp(minX - paddingX, 0, width);
    minY = clamp(minY - paddingY, 0, height);
    maxX = clamp(maxX + paddingX, 0, width);
    maxY = clamp(maxY + paddingY, 0, height);

    return {
      left: (minX / width) * 100,
      top: (minY / height) * 100,
      width: ((maxX - minX) / width) * 100,
      height: ((maxY - minY) / height) * 100,
    };
  }

  async function stickerToImage(sticker, options = {}) {
    if (sticker.type === "svg") {
      const svg = sticker.src.includes("xmlns=")
        ? sticker.src
        : sticker.src.replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"');
      return imageFromSource(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`);
    }
    const src = options.print ? stickerPrintImageSrc(sticker) : stickerImageSrc(sticker);
    return loadCanvasSafeImage(src, {
      label: `sticker image (${sticker.name || sticker.id || "unknown"})`,
      required: true,
      context: "stickerToImage",
    });
  }

  function stickerPrintImageSrc(sticker) {
    if (!sticker) return "";
    // TODO: populate printSrc with original high-resolution sticker art when those assets are added.
    return sticker.printSrc || sticker.sourcePath || sticker.src || sticker.thumbSrc || "";
  }

  function parsePolygonPoints(polygon) {
    return String(polygon)
      .replace(/^polygon\(/, "")
      .replace(/\)$/, "")
      .split(",")
      .map((point) => point.trim().split(/\s+/).map((value) => Number.parseFloat(value)))
      .filter(([x, y]) => Number.isFinite(x) && Number.isFinite(y))
      .map(([x, y]) => [x / 100, y / 100]);
  }

  function applyPolygonClip(ctx, polygon, width, height) {
    const points = parsePolygonPoints(polygon);
    if (!points.length) return;
    ctx.beginPath();
    points.forEach(([x, y], index) => {
      const px = x * width;
      const py = y * height;
      if (index === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    });
    ctx.closePath();
    ctx.clip();
  }

  async function applySvgMaskClip(ctx, maskSrc, width, height) {
    try {
      const mask = await loadSvgMaskPath(maskSrc);
      if (!mask?.path || !mask.viewBox?.width || !mask.viewBox?.height || typeof Path2D === "undefined") return false;
      const path = new Path2D(mask.path);
      ctx.scale(width / mask.viewBox.width, height / mask.viewBox.height);
      ctx.translate(-mask.viewBox.x, -mask.viewBox.y);
      ctx.clip(path);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      return true;
    } catch (error) {
      console.warn("SVG mask clip skipped", maskSrc, error);
      return false;
    }
  }

  async function applyPreviewSvgMaskClip(ctx, maskSrc, x, y, width, height, scale) {
    try {
      const mask = await loadSvgMaskPath(maskSrc);
      if (!mask?.path || !mask.viewBox?.width || !mask.viewBox?.height || typeof Path2D === "undefined") return false;
      const path = new Path2D(mask.path);
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      ctx.translate(x, y);
      ctx.scale(width / mask.viewBox.width, height / mask.viewBox.height);
      ctx.translate(-mask.viewBox.x, -mask.viewBox.y);
      ctx.clip(path);
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      return true;
    } catch (error) {
      console.warn("Preview SVG mask clip skipped", maskSrc, error);
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      return false;
    }
  }

  async function applySvgViewBoxMaskToCanvas(canvas, maskSrc, x, y, width, height, label = "print SVG viewBox mask") {
    try {
      const mask = await loadSvgMaskPath(maskSrc);
      if (!mask?.path || !mask.viewBox?.width || !mask.viewBox?.height) throw new Error("SVG mask path not found");

      const clippedCanvas = document.createElement("canvas");
      clippedCanvas.width = canvas.width;
      clippedCanvas.height = canvas.height;
      const clippedCtx = clippedCanvas.getContext("2d");
      clippedCtx.save();
      clippedCtx.translate(x, y);
      clippedCtx.scale(width / mask.viewBox.width, height / mask.viewBox.height);
      clippedCtx.translate(-mask.viewBox.x, -mask.viewBox.y);
      drawSvgPathToCanvas(clippedCtx, mask.path);
      clippedCtx.clip();
      clippedCtx.setTransform(1, 0, 0, 1, 0, 0);
      clippedCtx.drawImage(canvas, 0, 0);
      clippedCtx.restore();

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "source-over";
      ctx.drawImage(clippedCanvas, 0, 0);
      return true;
    } catch (error) {
      console.warn(`${label} exact SVG path skipped`, maskSrc, error);
      return applySvgBoundsRoundedMaskToCanvas(canvas, maskSrc, x, y, width, height, label);
    }
  }

  async function applySvgBoundsRoundedMaskToCanvas(canvas, maskSrc, x, y, width, height, label = "print rounded SVG bounds mask") {
    try {
      const bounds = await getSvgMaskContentBounds(maskSrc);
      const destination = svgBoundsToDestinationRect(bounds, { x, y, width, height });
      if (!isValidBounds(destination)) return false;

      const clippedCanvas = document.createElement("canvas");
      clippedCanvas.width = canvas.width;
      clippedCanvas.height = canvas.height;
      const clippedCtx = clippedCanvas.getContext("2d");
      const radius = Math.min(destination.width, destination.height) * 0.16;
      clippedCtx.save();
      roundedRectPath(clippedCtx, destination.x, destination.y, destination.width, destination.height, radius);
      clippedCtx.clip();
      clippedCtx.drawImage(canvas, 0, 0);
      clippedCtx.restore();

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "source-over";
      ctx.drawImage(clippedCanvas, 0, 0);
      return true;
    } catch (error) {
      console.warn(`${label} skipped`, maskSrc, error);
      return false;
    }
  }

  async function svgMaskHasPath(maskSrc) {
    try {
      const mask = await loadSvgMaskPath(maskSrc);
      return Boolean(mask?.path && mask?.viewBox?.width && mask?.viewBox?.height && typeof Path2D !== "undefined");
    } catch {
      return false;
    }
  }

  async function applyRasterMaskToCanvas(canvas, maskSrc, x, y, width, height, label = "raster mask") {
    const mask = await loadCanvasSafeImage(maskSrc, {
      label,
      required: true,
      context: "applyRasterMaskToCanvas",
      fallbackToDirect: true,
    });
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(mask, x, y, width, height);
    ctx.restore();
    return true;
  }

  async function applyRasterColorMaskToCanvas(canvas, maskSrc, x, y, width, height, label = "raster color mask") {
    const mask = await loadCanvasSafeImage(maskSrc, {
      label,
      required: true,
      context: "applyRasterColorMaskToCanvas",
      fallbackToDirect: true,
    });
    const maskCanvas = document.createElement("canvas");
    maskCanvas.width = Math.max(1, Math.round(width));
    maskCanvas.height = Math.max(1, Math.round(height));
    const maskCtx = maskCanvas.getContext("2d", { willReadFrequently: true });
    maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
    maskCtx.drawImage(mask, 0, 0, maskCanvas.width, maskCanvas.height);
    const imageData = maskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
    const { data } = imageData;
    for (let index = 0; index < data.length; index += 4) {
      const red = data[index];
      const green = data[index + 1];
      const blue = data[index + 2];
      const isMask = red > 120 && green < 140 && blue < 140 && red > green * 1.35 && red > blue * 1.35;
      data[index] = 0;
      data[index + 1] = 0;
      data[index + 2] = 0;
      data[index + 3] = isMask ? 255 : 0;
    }
    maskCtx.putImageData(imageData, 0, 0);
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(maskCanvas, x, y, width, height);
    ctx.restore();
    return true;
  }

  async function applyRasterMaskWithFilledHolesToCanvas(canvas, maskSrc, x, y, width, height, label = "raster mask filled holes") {
    const mask = await loadCanvasSafeImage(maskSrc, {
      label,
      required: true,
      context: "applyRasterMaskWithFilledHolesToCanvas",
      fallbackToDirect: true,
    });
    const maskCanvas = createFilledHoleMaskCanvas(mask, Math.max(1, Math.round(width)), Math.max(1, Math.round(height)));
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(maskCanvas, x, y, width, height);
    ctx.restore();
    return true;
  }

  async function applyRasterMaskContentToCanvas(canvas, maskSrc, x, y, width, height, label = "raster content mask", contentBounds = null) {
    const mask = await loadCanvasSafeImage(maskSrc, {
      label,
      required: true,
      context: "applyRasterMaskContentToCanvas",
      fallbackToDirect: true,
    });
    const maskWidth = mask.naturalWidth || mask.width || width;
    const maskHeight = mask.naturalHeight || mask.height || height;
    const svgBounds = contentBounds || await getSvgMaskContentBounds(maskSrc);
    const visibleBounds = svgBounds || getImageAlphaBounds(mask, maskWidth, maskHeight) || {
      x: 0,
      y: 0,
      width: maskWidth,
      height: maskHeight,
    };
    const sourceBounds = svgBounds?.viewBox
      ? svgBoundsToImageSourceBounds(svgBounds, maskWidth, maskHeight)
      : visibleBounds;
    if (!isValidBounds(sourceBounds)) {
      throw new Error(`Invalid print mask bounds: ${maskSrc}`);
    }
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.globalCompositeOperation = "destination-in";
    drawImageWithClampedSource(ctx, mask, sourceBounds, { x, y, width, height });
    ctx.restore();
    return true;
  }

  async function applyRasterMaskCoverToCanvas(canvas, maskSrc, x, y, width, height, label = "raster cover mask") {
    const mask = await loadCanvasSafeImage(maskSrc, {
      label,
      required: true,
      context: "applyRasterMaskCoverToCanvas",
      fallbackToDirect: true,
    });
    const maskWidth = mask.naturalWidth || mask.width || width;
    const maskHeight = mask.naturalHeight || mask.height || height;
    const visibleBounds = getImageAlphaBounds(mask, maskWidth, maskHeight) || {
      x: 0,
      y: 0,
      width: maskWidth,
      height: maskHeight,
    };
    const scale = Math.max(width / visibleBounds.width, height / visibleBounds.height);
    const drawWidth = visibleBounds.width * scale;
    const drawHeight = visibleBounds.height * scale;
    const drawX = x + (width - drawWidth) / 2;
    const drawY = y + height - drawHeight;
    const ctx = canvas.getContext("2d");
    ctx.save();
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(
      mask,
      visibleBounds.x,
      visibleBounds.y,
      visibleBounds.width,
      visibleBounds.height,
      drawX,
      drawY,
      drawWidth,
      drawHeight,
    );
    ctx.restore();
    return true;
  }

  function getImageAlphaBounds(image, width, height) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width));
    canvas.height = Math.max(1, Math.round(height));
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    try {
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let minX = canvas.width;
      let minY = canvas.height;
      let maxX = -1;
      let maxY = -1;
      for (let py = 0; py < canvas.height; py += 1) {
        for (let px = 0; px < canvas.width; px += 1) {
          const alpha = data[(py * canvas.width + px) * 4 + 3];
          if (alpha <= 8) continue;
          minX = Math.min(minX, px);
          minY = Math.min(minY, py);
          maxX = Math.max(maxX, px);
          maxY = Math.max(maxY, py);
        }
      }
      if (maxX < minX || maxY < minY) return null;
      return {
        x: minX,
        y: minY,
        width: maxX - minX + 1,
        height: maxY - minY + 1,
      };
    } catch (error) {
      console.warn("Mask alpha bounds skipped", error);
      return null;
    }
  }

  async function loadSvgMaskPath(maskSrc) {
    if (!loadSvgMaskPath.cache) loadSvgMaskPath.cache = new Map();
    if (loadSvgMaskPath.cache.has(maskSrc)) return loadSvgMaskPath.cache.get(maskSrc);

    const response = await fetch(maskSrc);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const svgText = await response.text();
    const viewBoxMatch = svgText.match(/viewBox=["']([^"']+)["']/i);
    const pathMatch = svgText.match(/<path\b[^>]*\sd=["']([^"']+)["']/i);
    if (!viewBoxMatch || !pathMatch) throw new Error("SVG mask path not found");

    const [x = 0, y = 0, width = 0, height = 0] = viewBoxMatch[1]
      .trim()
      .split(/[\s,]+/)
      .map((value) => Number.parseFloat(value));
    const result = {
      viewBox: { x, y, width, height },
      path: pathMatch[1],
    };
    loadSvgMaskPath.cache.set(maskSrc, result);
    return result;
  }

  async function getSvgMaskContentBounds(maskSrc) {
    if (!maskSrc) return null;
    if (!getSvgMaskContentBounds.cache) getSvgMaskContentBounds.cache = new Map();
    if (getSvgMaskContentBounds.cache.has(maskSrc)) return getSvgMaskContentBounds.cache.get(maskSrc);

    try {
      const response = await fetch(maskSrc);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const svgText = await response.text();
      const viewBox = parseSvgViewBox(svgText);
      const imageMatch = svgText.match(/<image\b[^>]*\bx=["']?([-\d.]+)["']?[^>]*\by=["']?([-\d.]+)["']?[^>]*\bwidth=["']?([-\d.]+)["']?[^>]*\bheight=["']?([-\d.]+)["']?/i);
      if (imageMatch) {
        const result = {
          x: Number.parseFloat(imageMatch[1]) || 0,
          y: Number.parseFloat(imageMatch[2]) || 0,
          width: Number.parseFloat(imageMatch[3]) || 0,
          height: Number.parseFloat(imageMatch[4]) || 0,
          viewBox,
        };
        getSvgMaskContentBounds.cache.set(maskSrc, result);
        return result;
      }

      const pathMatch = svgText.match(/<path\b[^>]*\sd=["']([^"']+)["']/i);
      const result = pathMatch ? pathDataBounds(pathMatch[1]) : null;
      if (result) result.viewBox = viewBox;
      getSvgMaskContentBounds.cache.set(maskSrc, result);
      return result;
    } catch (error) {
      console.warn("SVG mask bounds skipped", maskSrc, error);
      getSvgMaskContentBounds.cache.set(maskSrc, null);
      return null;
    }
  }

  function parseSvgViewBox(svgText) {
    const viewBoxMatch = svgText.match(/viewBox=["']([^"']+)["']/i);
    if (!viewBoxMatch) return null;
    const [x = 0, y = 0, width = 0, height = 0] = viewBoxMatch[1]
      .trim()
      .split(/[\s,]+/)
      .map((value) => Number.parseFloat(value));
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    return { x, y, width, height };
  }

  function isValidBounds(bounds) {
    return Boolean(
      bounds
      && Number.isFinite(bounds.x)
      && Number.isFinite(bounds.y)
      && Number.isFinite(bounds.width)
      && Number.isFinite(bounds.height)
      && bounds.width > 0
      && bounds.height > 0,
    );
  }

  function isValidPatternMetrics(metrics) {
    return Boolean(
      metrics
      && Number.isFinite(metrics.left)
      && Number.isFinite(metrics.top)
      && Number.isFinite(metrics.drawWidth)
      && Number.isFinite(metrics.drawHeight)
      && Number.isFinite(metrics.layerWidth)
      && Number.isFinite(metrics.layerHeight)
      && metrics.drawWidth > 0
      && metrics.drawHeight > 0
      && metrics.layerWidth > 0
      && metrics.layerHeight > 0,
    );
  }

  function svgBoundsToImageSourceBounds(bounds, imageWidth, imageHeight) {
    const viewBox = bounds?.viewBox;
    if (!isValidBounds(bounds) || !isValidBounds(viewBox)) return bounds;
    return {
      x: ((bounds.x - viewBox.x) / viewBox.width) * imageWidth,
      y: ((bounds.y - viewBox.y) / viewBox.height) * imageHeight,
      width: (bounds.width / viewBox.width) * imageWidth,
      height: (bounds.height / viewBox.height) * imageHeight,
    };
  }

  function svgBoundsToDestinationRect(bounds, destination) {
    const viewBox = bounds?.viewBox;
    if (!isValidBounds(bounds) || !isValidBounds(viewBox) || !isValidBounds(destination)) return null;
    return {
      x: destination.x + ((bounds.x - viewBox.x) / viewBox.width) * destination.width,
      y: destination.y + ((bounds.y - viewBox.y) / viewBox.height) * destination.height,
      width: (bounds.width / viewBox.width) * destination.width,
      height: (bounds.height / viewBox.height) * destination.height,
    };
  }

  function fitRectToAspectInside(rect, targetAspect) {
    if (!isValidBounds(rect) || !Number.isFinite(targetAspect) || targetAspect <= 0) return rect;
    const currentAspect = rect.width / rect.height;
    if (!Number.isFinite(currentAspect) || currentAspect <= 0) return rect;
    if (currentAspect > targetAspect) {
      const width = rect.height * targetAspect;
      return {
        x: rect.x + (rect.width - width) / 2,
        y: rect.y,
        width,
        height: rect.height,
      };
    }
    const height = rect.width / targetAspect;
    return {
      x: rect.x,
      y: rect.y + (rect.height - height) / 2,
      width: rect.width,
      height,
    };
  }

  function drawImageWithClampedSource(ctx, image, source, destination) {
    const imageWidth = image.naturalWidth || image.width || source.width;
    const imageHeight = image.naturalHeight || image.height || source.height;
    const sourceX = Math.max(0, source.x);
    const sourceY = Math.max(0, source.y);
    const sourceRight = Math.min(imageWidth, source.x + source.width);
    const sourceBottom = Math.min(imageHeight, source.y + source.height);
    const sourceWidth = sourceRight - sourceX;
    const sourceHeight = sourceBottom - sourceY;
    if (sourceWidth <= 0 || sourceHeight <= 0) {
      throw new Error("Print mask source bounds are outside the SVG image.");
    }
    const offsetX = ((sourceX - source.x) / source.width) * destination.width;
    const offsetY = ((sourceY - source.y) / source.height) * destination.height;
    const drawWidth = (sourceWidth / source.width) * destination.width;
    const drawHeight = (sourceHeight / source.height) * destination.height;
    ctx.drawImage(
      image,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      destination.x + offsetX,
      destination.y + offsetY,
      drawWidth,
      drawHeight,
    );
  }

  function pathDataBounds(pathData) {
    const tokens = String(pathData || "").match(/[a-zA-Z]|[-+]?\d*\.?\d+(?:e[-+]?\d+)?/g) || [];
    let command = "";
    let index = 0;
    let x = 0;
    let y = 0;
    let startX = 0;
    let startY = 0;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const isCommand = (value) => /^[a-zA-Z]$/.test(value);
    const number = () => Number.parseFloat(tokens[index++]);
    const include = (px, py) => {
      if (!Number.isFinite(px) || !Number.isFinite(py)) return;
      minX = Math.min(minX, px);
      minY = Math.min(minY, py);
      maxX = Math.max(maxX, px);
      maxY = Math.max(maxY, py);
    };

    while (index < tokens.length) {
      if (isCommand(tokens[index])) command = tokens[index++];
      if (!command) break;
      const relative = command === command.toLowerCase();
      const type = command.toUpperCase();
      if (type === "Z") {
        x = startX;
        y = startY;
        continue;
      }
      while (index < tokens.length && !isCommand(tokens[index])) {
        if (type === "M" || type === "L" || type === "T") {
          const nx = number();
          const ny = number();
          x = relative ? x + nx : nx;
          y = relative ? y + ny : ny;
          include(x, y);
          if (type === "M") {
            startX = x;
            startY = y;
            command = relative ? "l" : "L";
          }
        } else if (type === "H") {
          const nx = number();
          x = relative ? x + nx : nx;
          include(x, y);
        } else if (type === "V") {
          const ny = number();
          y = relative ? y + ny : ny;
          include(x, y);
        } else if (type === "C") {
          for (let point = 0; point < 3; point += 1) {
            const nx = number();
            const ny = number();
            const px = relative ? x + nx : nx;
            const py = relative ? y + ny : ny;
            include(px, py);
            if (point === 2) {
              x = px;
              y = py;
            }
          }
        } else if (type === "S" || type === "Q") {
          for (let point = 0; point < 2; point += 1) {
            const nx = number();
            const ny = number();
            const px = relative ? x + nx : nx;
            const py = relative ? y + ny : ny;
            include(px, py);
            if (point === 1) {
              x = px;
              y = py;
            }
          }
        } else {
          break;
        }
      }
    }

    if (!Number.isFinite(minX) || !Number.isFinite(minY) || maxX <= minX || maxY <= minY) return null;
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
  }

  function drawSvgPathToCanvas(ctx, pathData) {
    const tokens = String(pathData || "").match(/[a-zA-Z]|[-+]?\d*\.?\d+(?:e[-+]?\d+)?/g) || [];
    let command = "";
    let index = 0;
    let x = 0;
    let y = 0;
    let startX = 0;
    let startY = 0;
    let lastControlX = 0;
    let lastControlY = 0;
    let lastControlType = "";
    const isCommand = (value) => /^[a-zA-Z]$/.test(value);
    const number = () => Number.parseFloat(tokens[index++]);
    const point = (relative) => {
      const nx = number();
      const ny = number();
      return {
        x: relative ? x + nx : nx,
        y: relative ? y + ny : ny,
      };
    };

    ctx.beginPath();
    while (index < tokens.length) {
      if (isCommand(tokens[index])) command = tokens[index++];
      if (!command) break;
      const relative = command === command.toLowerCase();
      const type = command.toUpperCase();

      if (type === "Z") {
        ctx.closePath();
        x = startX;
        y = startY;
        lastControlType = "";
        continue;
      }

      while (index < tokens.length && !isCommand(tokens[index])) {
        if (type === "M") {
          const next = point(relative);
          x = next.x;
          y = next.y;
          startX = x;
          startY = y;
          ctx.moveTo(x, y);
          command = relative ? "l" : "L";
          lastControlType = "";
        } else if (type === "L") {
          const next = point(relative);
          x = next.x;
          y = next.y;
          ctx.lineTo(x, y);
          lastControlType = "";
        } else if (type === "H") {
          const nx = number();
          x = relative ? x + nx : nx;
          ctx.lineTo(x, y);
          lastControlType = "";
        } else if (type === "V") {
          const ny = number();
          y = relative ? y + ny : ny;
          ctx.lineTo(x, y);
          lastControlType = "";
        } else if (type === "C") {
          const c1 = point(relative);
          const c2 = point(relative);
          const end = point(relative);
          ctx.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, end.x, end.y);
          x = end.x;
          y = end.y;
          lastControlX = c2.x;
          lastControlY = c2.y;
          lastControlType = "C";
        } else if (type === "S") {
          const c1 = lastControlType === "C" || lastControlType === "S"
            ? { x: x * 2 - lastControlX, y: y * 2 - lastControlY }
            : { x, y };
          const c2 = point(relative);
          const end = point(relative);
          ctx.bezierCurveTo(c1.x, c1.y, c2.x, c2.y, end.x, end.y);
          x = end.x;
          y = end.y;
          lastControlX = c2.x;
          lastControlY = c2.y;
          lastControlType = "S";
        } else if (type === "Q") {
          const c = point(relative);
          const end = point(relative);
          ctx.quadraticCurveTo(c.x, c.y, end.x, end.y);
          x = end.x;
          y = end.y;
          lastControlX = c.x;
          lastControlY = c.y;
          lastControlType = "Q";
        } else if (type === "T") {
          const c = lastControlType === "Q" || lastControlType === "T"
            ? { x: x * 2 - lastControlX, y: y * 2 - lastControlY }
            : { x, y };
          const end = point(relative);
          ctx.quadraticCurveTo(c.x, c.y, end.x, end.y);
          x = end.x;
          y = end.y;
          lastControlX = c.x;
          lastControlY = c.y;
          lastControlType = "T";
        } else {
          throw new Error(`Unsupported SVG path command: ${type}`);
        }
      }
    }
  }

  function getPrintOuterRadius(scene) {
    return Math.max(48, Math.min(Math.min(scene.width, scene.height) * 0.095, 320));
  }

  function slugify(value) {
    return String(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function trimTransparentCanvas(sourceCanvas, padding = 0) {
    const ctx = sourceCanvas.getContext("2d", { willReadFrequently: true });
    const { width, height } = sourceCanvas;
    let data;
    try {
      data = ctx.getImageData(0, 0, width, height).data;
    } catch (error) {
      console.warn("Transparent trim skipped", error);
      return sourceCanvas;
    }
    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const alpha = data[(y * width + x) * 4 + 3];
        if (alpha === 0) continue;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }

    if (maxX < minX || maxY < minY) return sourceCanvas;

    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(width - 1, maxX + padding);
    maxY = Math.min(height - 1, maxY + padding);

    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = maxX - minX + 1;
    outputCanvas.height = maxY - minY + 1;
    outputCanvas
      .getContext("2d")
      .drawImage(sourceCanvas, minX, minY, outputCanvas.width, outputCanvas.height, 0, 0, outputCanvas.width, outputCanvas.height);
    return outputCanvas;
  }

  function canvasToPngDataUrl(canvas, dpi = 0) {
    try {
      const dataUrl = canvas.toDataURL("image/png");
      return dpi > 0 ? setPngPrintDensity(dataUrl, dpi) : dataUrl;
    } catch (error) {
      throw new Error(readableError(error));
    }
  }

  function setPngPrintDensity(dataUrl, dpi) {
    const binary = atob(dataUrl.slice(dataUrl.indexOf(",") + 1));
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    const view = new DataView(bytes.buffer);
    const density = new Uint8Array(21);
    const densityView = new DataView(density.buffer);
    densityView.setUint32(0, 9);
    density.set([112, 72, 89, 115], 4); // pHYs stores pixels per metre.
    densityView.setUint32(8, Math.round(dpi / 0.0254));
    densityView.setUint32(12, Math.round(dpi / 0.0254));
    density[16] = 1;
    let crc = 0xffffffff;
    for (let index = 4; index < 17; index += 1) {
      crc ^= density[index];
      for (let bit = 0; bit < 8; bit += 1) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
    }
    densityView.setUint32(17, (crc ^ 0xffffffff) >>> 0);
    const chunks = [bytes.subarray(0, 8)];
    for (let offset = 8; offset < bytes.length;) {
      const length = view.getUint32(offset) + 12;
      const type = view.getUint32(offset + 4);
      if (type !== 0x70485973) chunks.push(bytes.subarray(offset, offset + length));
      if (type === 0x49484452) chunks.push(density);
      offset += length;
    }
    const encoded = [];
    for (const chunk of chunks) {
      for (let offset = 0; offset < chunk.length; offset += 32768) {
        encoded.push(String.fromCharCode(...chunk.subarray(offset, offset + 32768)));
      }
    }
    return `data:image/png;base64,${btoa(encoded.join(""))}`;
  }

  function cloneCanvas(sourceCanvas) {
    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = sourceCanvas.width;
    outputCanvas.height = sourceCanvas.height;
    outputCanvas.getContext("2d").drawImage(sourceCanvas, 0, 0);
    return outputCanvas;
  }

  function canvasHasVisiblePixels(canvas) {
    try {
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
      for (let index = 3; index < data.length; index += 4) {
        if (data[index] > 0) return true;
      }
      return false;
    } catch (error) {
      console.warn("Canvas visibility check skipped", error);
      return true;
    }
  }

  function printMaskTouchesCanvasCorners(canvas) {
    try {
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      const sample = Math.max(12, Math.round(Math.min(canvas.width, canvas.height) * 0.025));
      const corners = [
        [sample, sample],
        [canvas.width - sample - 1, sample],
        [sample, canvas.height - sample - 1],
        [canvas.width - sample - 1, canvas.height - sample - 1],
      ];
      return corners.some(([x, y]) => {
        const alpha = ctx.getImageData(x, y, 1, 1).data[3];
        return alpha > 8;
      });
    } catch (error) {
      console.warn("Print mask corner check skipped", error);
      return false;
    }
  }

  async function clipCroppedPrintCanvasToSvgPath(sourceCanvas, maskSrc, padding = 0, bleed = 0) {
    try {
      const mask = await loadSvgMaskPath(maskSrc);
      const bounds = await getSvgMaskContentBounds(maskSrc);
      if (!mask?.path || !isValidBounds(bounds)) throw new Error("SVG mask path bounds not found");

      const outputCanvas = document.createElement("canvas");
      outputCanvas.width = sourceCanvas.width;
      outputCanvas.height = sourceCanvas.height;
      const ctx = outputCanvas.getContext("2d");
      const x = Math.max(0, padding);
      const y = Math.max(0, padding);
      const width = Math.max(1, sourceCanvas.width - padding * 2);
      const height = Math.max(1, sourceCanvas.height - padding * 2);
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(width / bounds.width, height / bounds.height);
      ctx.translate(-bounds.x, -bounds.y);
      drawSvgPathToCanvas(ctx, mask.path);
      if (bleed > 0) {
        // Offset the contour in output pixels without scaling the finished design.
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.fillStyle = "#000000";
        ctx.strokeStyle = "#000000";
        ctx.lineWidth = bleed * 2;
        ctx.lineJoin = "round";
        ctx.fill();
        ctx.stroke();
        ctx.globalCompositeOperation = "source-in";
      } else {
        ctx.clip();
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(sourceCanvas, 0, 0);
      ctx.restore();
      return outputCanvas;
    } catch (error) {
      console.warn("Exact cropped print SVG clip skipped", maskSrc, error);
      return clipCroppedPrintCanvasToCase(sourceCanvas, padding);
    }
  }

  function clipCroppedPrintCanvasToCase(sourceCanvas, padding = 0) {
    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = sourceCanvas.width;
    outputCanvas.height = sourceCanvas.height;
    const ctx = outputCanvas.getContext("2d");
    const x = Math.max(0, padding);
    const y = Math.max(0, padding);
    const width = Math.max(1, sourceCanvas.width - padding * 2);
    const height = Math.max(1, sourceCanvas.height - padding * 2);
    const radius = Math.min(width, height) * 0.16;
    ctx.save();
    roundedRectPath(ctx, x, y, width, height, radius);
    ctx.clip();
    ctx.drawImage(sourceCanvas, 0, 0);
    ctx.restore();
    return outputCanvas;
  }

  function cropCanvasToVisiblePixels(sourceCanvas, padding = 0) {
    try {
      const bounds = canvasAlphaBounds(sourceCanvas);
      if (!isValidBounds(bounds)) return sourceCanvas;
      const minX = Math.max(0, bounds.x - padding);
      const minY = Math.max(0, bounds.y - padding);
      const maxX = Math.min(sourceCanvas.width - 1, bounds.x + bounds.width - 1 + padding);
      const maxY = Math.min(sourceCanvas.height - 1, bounds.y + bounds.height - 1 + padding);
      const width = maxX - minX + 1;
      const height = maxY - minY + 1;
      const outputCanvas = document.createElement("canvas");
      outputCanvas.width = width;
      outputCanvas.height = height;
      outputCanvas.getContext("2d").drawImage(
        sourceCanvas,
        minX,
        minY,
        width,
        height,
        0,
        0,
        width,
        height,
      );
      return outputCanvas;
    } catch (error) {
      console.warn("Print crop skipped", error);
      return sourceCanvas;
    }
  }

  function canvasAlphaBounds(sourceCanvas) {
    const sourceCtx = sourceCanvas.getContext("2d", { willReadFrequently: true });
    const { data } = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
    let minX = sourceCanvas.width;
    let minY = sourceCanvas.height;
    let maxX = -1;
    let maxY = -1;
    for (let y = 0; y < sourceCanvas.height; y += 1) {
      for (let x = 0; x < sourceCanvas.width; x += 1) {
        const alpha = data[(y * sourceCanvas.width + x) * 4 + 3];
        if (alpha <= 8) continue;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }
    if (maxX < minX || maxY < minY) return null;
    return {
      x: minX,
      y: minY,
      width: maxX - minX + 1,
      height: maxY - minY + 1,
    };
  }

  function createFilledHoleMaskCanvas(mask, width, height) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(mask, 0, 0, width, height);
    const imageData = ctx.getImageData(0, 0, width, height);
    const { data } = imageData;
    const outside = new Uint8Array(width * height);
    const queue = [];

    const enqueue = (x, y) => {
      if (x < 0 || y < 0 || x >= width || y >= height) return;
      const index = y * width + x;
      if (outside[index] || data[index * 4 + 3] > 8) return;
      outside[index] = 1;
      queue.push(index);
    };

    for (let x = 0; x < width; x += 1) {
      enqueue(x, 0);
      enqueue(x, height - 1);
    }
    for (let y = 0; y < height; y += 1) {
      enqueue(0, y);
      enqueue(width - 1, y);
    }

    for (let cursor = 0; cursor < queue.length; cursor += 1) {
      const index = queue[cursor];
      const x = index % width;
      const y = Math.floor(index / width);
      enqueue(x + 1, y);
      enqueue(x - 1, y);
      enqueue(x, y + 1);
      enqueue(x, y - 1);
    }

    for (let index = 0; index < width * height; index += 1) {
      const alphaIndex = index * 4 + 3;
      if (data[alphaIndex] > 8 || outside[index]) continue;
      data[index * 4] = 255;
      data[index * 4 + 1] = 255;
      data[index * 4 + 2] = 255;
      data[alphaIndex] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
  }

  function whiteMatteTransparentPixels(sourceCanvas) {
    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = sourceCanvas.width;
    outputCanvas.height = sourceCanvas.height;
    const outputCtx = outputCanvas.getContext("2d", { willReadFrequently: true });
    outputCtx.drawImage(sourceCanvas, 0, 0);
    try {
      const imageData = outputCtx.getImageData(0, 0, outputCanvas.width, outputCanvas.height);
      const { data } = imageData;
      for (let index = 0; index < data.length; index += 4) {
        if (data[index + 3] !== 0) continue;
        data[index] = 255;
        data[index + 1] = 255;
        data[index + 2] = 255;
      }
      outputCtx.putImageData(imageData, 0, 0);
    } catch (error) {
      console.warn("Transparent pixel matte skipped", error);
    }
    return outputCanvas;
  }

  function readableError(error) {
    if (!error) return "nezinoma klaida";
    if (typeof error === "string") return error;
    const name = error.name || "";
    const message = error.message || "";
    if (message) return name ? `${name}: ${message}` : message;
    if (name) return name;
    if (error.type) return String(error.type);
    return "nezinoma klaida";
  }

  async function sourceToExportableDataUrl(src) {
    const value = String(src || "");
    if (!value || value.startsWith("data:")) return value;
    try {
      const response = await fetch(value);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      return await blobToDataUrl(blob);
    } catch (error) {
      console.warn("Fetch export conversion failed; trying XHR", value, error);
    }

    try {
      return await xhrImageToDataUrl(value);
    } catch (error) {
      console.warn("Could not convert image to export-safe data URL", value, error);
      throw new Error(`Nepavyko paruošti paveikslėlio spaudai: ${value.slice(0, 120)}`);
    }
  }

  async function loadCanvasSafeImage(src, options = {}) {
    const value = String(src || "").trim();
    const label = options.label || "image";
    const context = options.context || "unknown";
    const required = Boolean(options.required);
    const fallbackToDirect = Boolean(options.fallbackToDirect);

    if (!value) {
      if (required) {
        throw new Error(`Trūksta ${label} šaltinio (${context}).`);
      }
      return null;
    }

    if (/^[a-zA-Z]:[\\/]/.test(value) || value.startsWith("file://")) {
      const message = `Netinkamas canvas šaltinis (${context}) ${label}: ${value.slice(0, 140)}`;
      console.warn(message);
      if (required) throw new Error(message);
      return null;
    }

    const resolvedSrc = resolveCanvasImageSrc(value);
    const isLocalCanvasSource = isSameOriginCanvasSource(resolvedSrc);

    try {
      if (isLocalCanvasSource) {
        try {
          return await imageFromSource(resolvedSrc, { crossOrigin: false });
        } catch (directError) {
          const safeSrc = value.startsWith("data:") || value.startsWith("blob:")
            ? value
            : await sourceToExportableDataUrl(resolvedSrc);
          return await imageFromSource(safeSrc, { crossOrigin: false });
        }
      }
      const safeSrc = value.startsWith("data:") ? value : await sourceToExportableDataUrl(resolvedSrc);
      return await imageFromSource(safeSrc);
    } catch (error) {
      if (!isLocalCanvasSource) {
        try {
          const safeSrc = value.startsWith("data:") ? value : await sourceToExportableDataUrl(resolvedSrc);
          return await imageFromSource(safeSrc);
        } catch {
          // Keep the original error below; it is usually closer to the source that failed.
        }
      }
      const message = `Nepavyko paruošti canvas saugaus paveiksliuko (${context}) ${label}: ${readableError(error)}`;
      if (required) {
        throw new Error(message);
      }
      console.warn(message);
      if (fallbackToDirect) {
        try {
          return await imageFromSource(resolvedSrc, { crossOrigin: false });
        } catch (fallbackError) {
          console.warn(`Fallback į tiesioginį įkėlimą nepavyko (${context}) ${label}`, fallbackError);
        }
      }
      return null;
    }
  }

  function resolveCanvasImageSrc(src) {
    const value = String(src || "").trim();
    if (!value || value.startsWith("data:") || value.startsWith("blob:")) return value;
    try {
      return new URL(value, window.location.href).href;
    } catch {
      return value;
    }
  }

  function isSameOriginCanvasSource(src) {
    const value = String(src || "").trim();
    if (!value || value.startsWith("data:") || value.startsWith("blob:")) return true;
    try {
      return new URL(value, window.location.href).origin === window.location.origin;
    } catch {
      return false;
    }
  }

  async function imageSourceToPngDataUrl(src, maxSize = 1024) {
    const safeSrc = await sourceToExportableDataUrl(src);
    const image = await imageFromSource(safeSrc);
    const width = image.naturalWidth || image.width || maxSize;
    const height = image.naturalHeight || image.height || maxSize;
    const scale = Math.min(1, maxSize / Math.max(width, height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/png");
  }

  function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  function xhrImageToDataUrl(src) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open("GET", src, true);
      request.responseType = "blob";
      request.onload = () => {
        if (request.status && request.status >= 400) {
          reject(new Error(`HTTP ${request.status}`));
          return;
        }
        blobToDataUrl(request.response).then(resolve, reject);
      };
      request.onerror = reject;
      request.send();
    });
  }

  function imageFromSource(src, options = {}) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const shouldUseCors = options.crossOrigin !== false && /^https?:\/\//i.test(String(src || ""));
      if (shouldUseCors) image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`Nepavyko įkelti paveikslėlio: ${String(src || "").slice(0, 120)}`));
      image.src = src;
    });
  }

  function drawRoundedRect(ctx, x, y, width, height, radius, fill, stroke) {
    roundedRectPath(ctx, x, y, width, height, radius);
    ctx.fillStyle = fill;
    ctx.fill();
    ctx.strokeStyle = stroke;
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  function roundedRectPath(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  }

  function drawCamera(ctx, preset) {
    const camera = cameraToPercent(preset);

    if (camera.module) {
      drawRoundedRect(
        ctx,
        45 + (camera.module.x / 100) * 330,
        24 + (camera.module.y / 100) * 792,
        (camera.module.w / 100) * 330,
        (camera.module.h / 100) * 792,
        camera.module.r,
        "rgba(238,244,251,.78)",
        "rgba(31,35,40,.1)",
      );
    }

    ctx.fillStyle = "rgba(31,35,40,.74)";
    camera.lenses.forEach((lens) => {
      ctx.beginPath();
      ctx.arc(
        45 + (lens.x / 100) * 330,
        24 + (lens.y / 100) * 792,
        ((lens.d / 2) / 100) * 330,
        0,
        Math.PI * 2,
      );
      ctx.fill();
    });

    if (camera.flash) {
      ctx.fillStyle = "rgba(244,185,66,.85)";
      ctx.beginPath();
      ctx.arc(
        45 + (camera.flash.x / 100) * 330,
        24 + (camera.flash.y / 100) * 792,
        ((camera.flash.d / 2) / 100) * 330,
        0,
        Math.PI * 2,
      );
      ctx.fill();
    }

    ctx.fillStyle = "rgba(35,43,55,.82)";
    camera.sensors.forEach((sensor) => {
      ctx.beginPath();
      ctx.arc(
        45 + (sensor.x / 100) * 330,
        24 + (sensor.y / 100) * 792,
        ((sensor.d / 2) / 100) * 330,
        0,
        Math.PI * 2,
      );
      ctx.fill();
    });
  }

  function hydrateProductModelOptions() {
    const select = document.querySelector("[data-sticker-case-model]");
    if (!select) return;
    select.innerHTML = MODEL_GROUPS.map((group) => {
      const options = group.models.map(([model]) => `<option>${model}</option>`).join("");
      return `<optgroup label="${group.label}">${options}</optgroup>`;
    }).join("");
  }

  hydrateProductModelOptions();

  document.querySelectorAll("[data-sticker-case-studio]").forEach((root) => {
    new StickerCaseStudio(root);
  });
})();
